;(function (l, r) {
  typeof exports == "object" && typeof module < "u"
    ? r(exports, require("react"), require("react-dom"))
    : typeof define == "function" && define.amd
    ? define(["exports", "react", "react-dom"], r)
    : ((l = typeof globalThis < "u" ? globalThis : l || self),
      r((l.VeinliteQuiz = {}), l.React, l.ReactDOM))
})(this, function (l, r, gM) {
  "use strict"
  var sM = { exports: {} },
    _1 = {}
  /**
   * @license React
   * react-jsx-runtime.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */ var LM = r,
    fM = Symbol.for("react.element"),
    wM = Symbol.for("react.fragment"),
    IM = Object.prototype.hasOwnProperty,
    CM =
      LM.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,
    bM = { key: !0, ref: !0, __self: !0, __source: !0 }
  function uM(t, a, c) {
    var d,
      y = {},
      i = null,
      p = null
    c !== void 0 && (i = "" + c),
      a.key !== void 0 && (i = "" + a.key),
      a.ref !== void 0 && (p = a.ref)
    for (d in a) IM.call(a, d) && !bM.hasOwnProperty(d) && (y[d] = a[d])
    if (t && t.defaultProps)
      for (d in ((a = t.defaultProps), a)) y[d] === void 0 && (y[d] = a[d])
    return {
      $$typeof: fM,
      type: t,
      key: i,
      ref: p,
      props: y,
      _owner: CM.current,
    }
  }
  ;(_1.Fragment = wM), (_1.jsx = uM), (_1.jsxs = uM), (sM.exports = _1)
  var h = sM.exports,
    MM,
    vM = gM
  ;(MM = vM.createRoot), vM.hydrateRoot
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ var SM = {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
  }
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const qM = (t) =>
      t
        .replace(/([a-z0-9])([A-Z])/g, "$1-$2")
        .toLowerCase()
        .trim(),
    e = (t, a) => {
      const c = r.forwardRef(
        (
          {
            color: d = "currentColor",
            size: y = 24,
            strokeWidth: i = 2,
            absoluteStrokeWidth: p,
            className: u = "",
            children: o,
            ...M
          },
          w
        ) =>
          r.createElement(
            "svg",
            {
              ref: w,
              ...SM,
              width: y,
              height: y,
              stroke: d,
              strokeWidth: p ? (Number(i) * 24) / Number(y) : i,
              className: ["lucide", `lucide-${qM(t)}`, u].join(" "),
              ...M,
            },
            [
              ...a.map(([U1, K1]) => r.createElement(U1, K1)),
              ...(Array.isArray(o) ? o : [o]),
            ]
          )
      )
      return (c.displayName = `${t}`), c
    }
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const J1 = e("AArrowDown", [
    ["path", { d: "M3.5 13h6", key: "p1my2r" }],
    ["path", { d: "m2 16 4.5-9 4.5 9", key: "ndf0b3" }],
    ["path", { d: "M18 7v9", key: "pknjwm" }],
    ["path", { d: "m14 12 4 4 4-4", key: "buelq4" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Q1 = e("AArrowUp", [
    ["path", { d: "M3.5 13h6", key: "p1my2r" }],
    ["path", { d: "m2 16 4.5-9 4.5 9", key: "ndf0b3" }],
    ["path", { d: "M18 16V7", key: "ty0viw" }],
    ["path", { d: "m14 11 4-4 4 4", key: "1pu57t" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Y1 = e("ALargeSmall", [
    ["path", { d: "M21 14h-5", key: "1vh23k" }],
    ["path", { d: "M16 16v-3.5a2.5 2.5 0 0 1 5 0V16", key: "1wh10o" }],
    ["path", { d: "M4.5 13h6", key: "dfilno" }],
    ["path", { d: "m3 16 4.5-9 4.5 9", key: "2dxa0e" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const $1 = e("Accessibility", [
    ["circle", { cx: "16", cy: "4", r: "1", key: "1grugj" }],
    ["path", { d: "m18 19 1-7-6 1", key: "r0i19z" }],
    ["path", { d: "m5 8 3-3 5.5 3-2.36 3.5", key: "9ptxx2" }],
    ["path", { d: "M4.24 14.5a5 5 0 0 0 6.88 6", key: "10kmtu" }],
    ["path", { d: "M13.76 17.5a5 5 0 0 0-6.88-6", key: "2qq6rc" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const e2 = e("ActivitySquare", [
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" },
    ],
    ["path", { d: "M17 12h-2l-2 5-2-10-2 5H7", key: "15hlnc" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const a2 = e("Activity", [
    ["path", { d: "M22 12h-4l-3 9L9 3l-3 9H2", key: "d5dnw9" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const t2 = e("AirVent", [
    [
      "path",
      {
        d: "M6 12H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2",
        key: "larmp2",
      },
    ],
    ["path", { d: "M6 8h12", key: "6g4wlu" }],
    [
      "path",
      {
        d: "M18.3 17.7a2.5 2.5 0 0 1-3.16 3.83 2.53 2.53 0 0 1-1.14-2V12",
        key: "1bo8pg",
      },
    ],
    ["path", { d: "M6.6 15.6A2 2 0 1 0 10 17v-5", key: "t9h90c" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const c2 = e("Airplay", [
    [
      "path",
      {
        d: "M5 17H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1",
        key: "ns4c3b",
      },
    ],
    ["polygon", { points: "12 15 17 21 7 21 12 15", key: "1sy95i" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const I = e("AlarmClockCheck", [
    ["circle", { cx: "12", cy: "13", r: "8", key: "3y4lt7" }],
    ["path", { d: "M5 3 2 6", key: "18tl5t" }],
    ["path", { d: "m22 6-3-3", key: "1opdir" }],
    ["path", { d: "M6.38 18.7 4 21", key: "17xu3x" }],
    ["path", { d: "M17.64 18.67 20 21", key: "kv2oe2" }],
    ["path", { d: "m9 13 2 2 4-4", key: "6343dt" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const C = e("AlarmClockMinus", [
    ["circle", { cx: "12", cy: "13", r: "8", key: "3y4lt7" }],
    ["path", { d: "M5 3 2 6", key: "18tl5t" }],
    ["path", { d: "m22 6-3-3", key: "1opdir" }],
    ["path", { d: "M6.38 18.7 4 21", key: "17xu3x" }],
    ["path", { d: "M17.64 18.67 20 21", key: "kv2oe2" }],
    ["path", { d: "M9 13h6", key: "1uhe8q" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const h2 = e("AlarmClockOff", [
    ["path", { d: "M6.87 6.87a8 8 0 1 0 11.26 11.26", key: "3on8tj" }],
    ["path", { d: "M19.9 14.25a8 8 0 0 0-9.15-9.15", key: "15ghsc" }],
    ["path", { d: "m22 6-3-3", key: "1opdir" }],
    ["path", { d: "M6.26 18.67 4 21", key: "yzmioq" }],
    ["path", { d: "m2 2 20 20", key: "1ooewy" }],
    ["path", { d: "M4 4 2 6", key: "1ycko6" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const b = e("AlarmClockPlus", [
    ["circle", { cx: "12", cy: "13", r: "8", key: "3y4lt7" }],
    ["path", { d: "M5 3 2 6", key: "18tl5t" }],
    ["path", { d: "m22 6-3-3", key: "1opdir" }],
    ["path", { d: "M6.38 18.7 4 21", key: "17xu3x" }],
    ["path", { d: "M17.64 18.67 20 21", key: "kv2oe2" }],
    ["path", { d: "M12 10v6", key: "1bos4e" }],
    ["path", { d: "M9 13h6", key: "1uhe8q" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const d2 = e("AlarmClock", [
    ["circle", { cx: "12", cy: "13", r: "8", key: "3y4lt7" }],
    ["path", { d: "M12 9v4l2 2", key: "1c63tq" }],
    ["path", { d: "M5 3 2 6", key: "18tl5t" }],
    ["path", { d: "m22 6-3-3", key: "1opdir" }],
    ["path", { d: "M6.38 18.7 4 21", key: "17xu3x" }],
    ["path", { d: "M17.64 18.67 20 21", key: "kv2oe2" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const o2 = e("AlarmSmoke", [
    ["path", { d: "M4 8a2 2 0 0 1-2-2V3h20v3a2 2 0 0 1-2 2Z", key: "2c4fvq" }],
    [
      "path",
      {
        d: "m19 8-.8 3c-.1.6-.6 1-1.2 1H7c-.6 0-1.1-.4-1.2-1L5 8",
        key: "1vrndv",
      },
    ],
    ["path", { d: "M16 21c0-2.5 2-2.5 2-5", key: "1o3eny" }],
    ["path", { d: "M11 21c0-2.5 2-2.5 2-5", key: "1sicvv" }],
    ["path", { d: "M6 21c0-2.5 2-2.5 2-5", key: "i3w1gp" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const y2 = e("Album", [
    [
      "rect",
      {
        width: "18",
        height: "18",
        x: "3",
        y: "3",
        rx: "2",
        ry: "2",
        key: "1m3agn",
      },
    ],
    ["polyline", { points: "11 3 11 11 14 8 17 11 17 3", key: "1wcwz3" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const i2 = e("AlertCircle", [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["line", { x1: "12", x2: "12", y1: "8", y2: "12", key: "1pkeuh" }],
    ["line", { x1: "12", x2: "12.01", y1: "16", y2: "16", key: "4dfq90" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const n2 = e("AlertOctagon", [
    [
      "polygon",
      {
        points:
          "7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2",
        key: "h1p8hx",
      },
    ],
    ["line", { x1: "12", x2: "12", y1: "8", y2: "12", key: "1pkeuh" }],
    ["line", { x1: "12", x2: "12.01", y1: "16", y2: "16", key: "4dfq90" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const r2 = e("AlertTriangle", [
    [
      "path",
      {
        d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z",
        key: "c3ski4",
      },
    ],
    ["path", { d: "M12 9v4", key: "juzpu7" }],
    ["path", { d: "M12 17h.01", key: "p32p05" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const k2 = e("AlignCenterHorizontal", [
    ["path", { d: "M2 12h20", key: "9i4pu4" }],
    ["path", { d: "M10 16v4a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-4", key: "11f1s0" }],
    ["path", { d: "M10 8V4a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v4", key: "t14dx9" }],
    [
      "path",
      { d: "M20 16v1a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-1", key: "1w07xs" },
    ],
    ["path", { d: "M14 8V7c0-1.1.9-2 2-2h2a2 2 0 0 1 2 2v1", key: "1apec2" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const p2 = e("AlignCenterVertical", [
    ["path", { d: "M12 2v20", key: "t6zp3m" }],
    ["path", { d: "M8 10H4a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h4", key: "14d6g8" }],
    ["path", { d: "M16 10h4a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-4", key: "1e2lrw" }],
    ["path", { d: "M8 20H7a2 2 0 0 1-2-2v-2c0-1.1.9-2 2-2h1", key: "1fkdwx" }],
    ["path", { d: "M16 14h1a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-1", key: "1euafb" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const l2 = e("AlignCenter", [
    ["line", { x1: "21", x2: "3", y1: "6", y2: "6", key: "1fp77t" }],
    ["line", { x1: "17", x2: "7", y1: "12", y2: "12", key: "rsh8ii" }],
    ["line", { x1: "19", x2: "5", y1: "18", y2: "18", key: "1t0tuv" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const s2 = e("AlignEndHorizontal", [
    [
      "rect",
      { width: "6", height: "16", x: "4", y: "2", rx: "2", key: "z5wdxg" },
    ],
    [
      "rect",
      { width: "6", height: "9", x: "14", y: "9", rx: "2", key: "um7a8w" },
    ],
    ["path", { d: "M22 22H2", key: "19qnx5" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const u2 = e("AlignEndVertical", [
    [
      "rect",
      { width: "16", height: "6", x: "2", y: "4", rx: "2", key: "10wcwx" },
    ],
    [
      "rect",
      { width: "9", height: "6", x: "9", y: "14", rx: "2", key: "4p5bwg" },
    ],
    ["path", { d: "M22 22V2", key: "12ipfv" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const M2 = e("AlignHorizontalDistributeCenter", [
    [
      "rect",
      { width: "6", height: "14", x: "4", y: "5", rx: "2", key: "1wwnby" },
    ],
    [
      "rect",
      { width: "6", height: "10", x: "14", y: "7", rx: "2", key: "1fe6j6" },
    ],
    ["path", { d: "M17 22v-5", key: "4b6g73" }],
    ["path", { d: "M17 7V2", key: "hnrr36" }],
    ["path", { d: "M7 22v-3", key: "1r4jpn" }],
    ["path", { d: "M7 5V2", key: "liy1u9" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const v2 = e("AlignHorizontalDistributeEnd", [
    [
      "rect",
      { width: "6", height: "14", x: "4", y: "5", rx: "2", key: "1wwnby" },
    ],
    [
      "rect",
      { width: "6", height: "10", x: "14", y: "7", rx: "2", key: "1fe6j6" },
    ],
    ["path", { d: "M10 2v20", key: "uyc634" }],
    ["path", { d: "M20 2v20", key: "1tx262" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const m2 = e("AlignHorizontalDistributeStart", [
    [
      "rect",
      { width: "6", height: "14", x: "4", y: "5", rx: "2", key: "1wwnby" },
    ],
    [
      "rect",
      { width: "6", height: "10", x: "14", y: "7", rx: "2", key: "1fe6j6" },
    ],
    ["path", { d: "M4 2v20", key: "gtpd5x" }],
    ["path", { d: "M14 2v20", key: "tg6bpw" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const x2 = e("AlignHorizontalJustifyCenter", [
    [
      "rect",
      { width: "6", height: "14", x: "2", y: "5", rx: "2", key: "dy24zr" },
    ],
    [
      "rect",
      { width: "6", height: "10", x: "16", y: "7", rx: "2", key: "13zkjt" },
    ],
    ["path", { d: "M12 2v20", key: "t6zp3m" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const g2 = e("AlignHorizontalJustifyEnd", [
    [
      "rect",
      { width: "6", height: "14", x: "2", y: "5", rx: "2", key: "dy24zr" },
    ],
    [
      "rect",
      { width: "6", height: "10", x: "12", y: "7", rx: "2", key: "1ht384" },
    ],
    ["path", { d: "M22 2v20", key: "40qfg1" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const L2 = e("AlignHorizontalJustifyStart", [
    [
      "rect",
      { width: "6", height: "14", x: "6", y: "5", rx: "2", key: "hsirpf" },
    ],
    [
      "rect",
      { width: "6", height: "10", x: "16", y: "7", rx: "2", key: "13zkjt" },
    ],
    ["path", { d: "M2 2v20", key: "1ivd8o" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const f2 = e("AlignHorizontalSpaceAround", [
    [
      "rect",
      { width: "6", height: "10", x: "9", y: "7", rx: "2", key: "yn7j0q" },
    ],
    ["path", { d: "M4 22V2", key: "tsjzd3" }],
    ["path", { d: "M20 22V2", key: "1bnhr8" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const w2 = e("AlignHorizontalSpaceBetween", [
    [
      "rect",
      { width: "6", height: "14", x: "3", y: "5", rx: "2", key: "j77dae" },
    ],
    [
      "rect",
      { width: "6", height: "10", x: "15", y: "7", rx: "2", key: "bq30hj" },
    ],
    ["path", { d: "M3 2v20", key: "1d2pfg" }],
    ["path", { d: "M21 2v20", key: "p059bm" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const I2 = e("AlignJustify", [
    ["line", { x1: "3", x2: "21", y1: "6", y2: "6", key: "4m8b97" }],
    ["line", { x1: "3", x2: "21", y1: "12", y2: "12", key: "10d38w" }],
    ["line", { x1: "3", x2: "21", y1: "18", y2: "18", key: "kwyyxn" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const C2 = e("AlignLeft", [
    ["line", { x1: "21", x2: "3", y1: "6", y2: "6", key: "1fp77t" }],
    ["line", { x1: "15", x2: "3", y1: "12", y2: "12", key: "v6grx8" }],
    ["line", { x1: "17", x2: "3", y1: "18", y2: "18", key: "1awlsn" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const b2 = e("AlignRight", [
    ["line", { x1: "21", x2: "3", y1: "6", y2: "6", key: "1fp77t" }],
    ["line", { x1: "21", x2: "9", y1: "12", y2: "12", key: "1uyos4" }],
    ["line", { x1: "21", x2: "7", y1: "18", y2: "18", key: "1g9eri" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const S2 = e("AlignStartHorizontal", [
    [
      "rect",
      { width: "6", height: "16", x: "4", y: "6", rx: "2", key: "1n4dg1" },
    ],
    [
      "rect",
      { width: "6", height: "9", x: "14", y: "6", rx: "2", key: "17khns" },
    ],
    ["path", { d: "M22 2H2", key: "fhrpnj" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const q2 = e("AlignStartVertical", [
    [
      "rect",
      { width: "9", height: "6", x: "6", y: "14", rx: "2", key: "lpm2y7" },
    ],
    [
      "rect",
      { width: "16", height: "6", x: "6", y: "4", rx: "2", key: "rdj6ps" },
    ],
    ["path", { d: "M2 2v20", key: "1ivd8o" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const H2 = e("AlignVerticalDistributeCenter", [
    [
      "rect",
      { width: "14", height: "6", x: "5", y: "14", rx: "2", key: "jmoj9s" },
    ],
    [
      "rect",
      { width: "10", height: "6", x: "7", y: "4", rx: "2", key: "aza5on" },
    ],
    ["path", { d: "M22 7h-5", key: "o2endc" }],
    ["path", { d: "M7 7H1", key: "105l6j" }],
    ["path", { d: "M22 17h-3", key: "1lwga1" }],
    ["path", { d: "M5 17H2", key: "1gx9xc" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const z2 = e("AlignVerticalDistributeEnd", [
    [
      "rect",
      { width: "14", height: "6", x: "5", y: "14", rx: "2", key: "jmoj9s" },
    ],
    [
      "rect",
      { width: "10", height: "6", x: "7", y: "4", rx: "2", key: "aza5on" },
    ],
    ["path", { d: "M2 20h20", key: "owomy5" }],
    ["path", { d: "M2 10h20", key: "1ir3d8" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const A2 = e("AlignVerticalDistributeStart", [
    [
      "rect",
      { width: "14", height: "6", x: "5", y: "14", rx: "2", key: "jmoj9s" },
    ],
    [
      "rect",
      { width: "10", height: "6", x: "7", y: "4", rx: "2", key: "aza5on" },
    ],
    ["path", { d: "M2 14h20", key: "myj16y" }],
    ["path", { d: "M2 4h20", key: "mda7wb" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const j2 = e("AlignVerticalJustifyCenter", [
    [
      "rect",
      { width: "14", height: "6", x: "5", y: "16", rx: "2", key: "1i8z2d" },
    ],
    [
      "rect",
      { width: "10", height: "6", x: "7", y: "2", rx: "2", key: "ypihtt" },
    ],
    ["path", { d: "M2 12h20", key: "9i4pu4" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const V2 = e("AlignVerticalJustifyEnd", [
    [
      "rect",
      { width: "14", height: "6", x: "5", y: "12", rx: "2", key: "4l4tp2" },
    ],
    [
      "rect",
      { width: "10", height: "6", x: "7", y: "2", rx: "2", key: "ypihtt" },
    ],
    ["path", { d: "M2 22h20", key: "272qi7" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const P2 = e("AlignVerticalJustifyStart", [
    [
      "rect",
      { width: "14", height: "6", x: "5", y: "16", rx: "2", key: "1i8z2d" },
    ],
    [
      "rect",
      { width: "10", height: "6", x: "7", y: "6", rx: "2", key: "13squh" },
    ],
    ["path", { d: "M2 2h20", key: "1ennik" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const F2 = e("AlignVerticalSpaceAround", [
    [
      "rect",
      { width: "10", height: "6", x: "7", y: "9", rx: "2", key: "b1zbii" },
    ],
    ["path", { d: "M22 20H2", key: "1p1f7z" }],
    ["path", { d: "M22 4H2", key: "1b7qnq" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const B2 = e("AlignVerticalSpaceBetween", [
    [
      "rect",
      { width: "14", height: "6", x: "5", y: "15", rx: "2", key: "1w91an" },
    ],
    [
      "rect",
      { width: "10", height: "6", x: "7", y: "3", rx: "2", key: "17wqzy" },
    ],
    ["path", { d: "M2 21h20", key: "1nyx9w" }],
    ["path", { d: "M2 3h20", key: "91anmk" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const D2 = e("Ambulance", [
    ["path", { d: "M10 10H6", key: "1bsnug" }],
    [
      "path",
      {
        d: "M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2",
        key: "wrbu53",
      },
    ],
    [
      "path",
      {
        d: "M19 18h2a1 1 0 0 0 1-1v-3.28a1 1 0 0 0-.684-.948l-1.923-.641a1 1 0 0 1-.578-.502l-1.539-3.076A1 1 0 0 0 16.382 8H14",
        key: "lrkjwd",
      },
    ],
    ["path", { d: "M8 8v4", key: "1fwk8c" }],
    ["path", { d: "M9 18h6", key: "x1upvd" }],
    ["circle", { cx: "17", cy: "18", r: "2", key: "332jqn" }],
    ["circle", { cx: "7", cy: "18", r: "2", key: "19iecd" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const R2 = e("Ampersand", [
    [
      "path",
      {
        d: "M17.5 12c0 4.4-3.6 8-8 8A4.5 4.5 0 0 1 5 15.5c0-6 8-4 8-8.5a3 3 0 1 0-6 0c0 3 2.5 8.5 12 13",
        key: "1o9ehi",
      },
    ],
    ["path", { d: "M16 12h3", key: "4uvgyw" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const T2 = e("Ampersands", [
    [
      "path",
      {
        d: "M10 17c-5-3-7-7-7-9a2 2 0 0 1 4 0c0 2.5-5 2.5-5 6 0 1.7 1.3 3 3 3 2.8 0 5-2.2 5-5",
        key: "12lh1k",
      },
    ],
    [
      "path",
      {
        d: "M22 17c-5-3-7-7-7-9a2 2 0 0 1 4 0c0 2.5-5 2.5-5 6 0 1.7 1.3 3 3 3 2.8 0 5-2.2 5-5",
        key: "173c68",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const U2 = e("Anchor", [
    ["path", { d: "M12 22V8", key: "qkxhtm" }],
    ["path", { d: "M5 12H2a10 10 0 0 0 20 0h-3", key: "1hv3nh" }],
    ["circle", { cx: "12", cy: "5", r: "3", key: "rqqgnr" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Z2 = e("Angry", [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["path", { d: "M16 16s-1.5-2-4-2-4 2-4 2", key: "epbg0q" }],
    ["path", { d: "M7.5 8 10 9", key: "olxxln" }],
    ["path", { d: "m14 9 2.5-1", key: "1j6cij" }],
    ["path", { d: "M9 10h0", key: "1vxvly" }],
    ["path", { d: "M15 10h0", key: "1j6oav" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const O2 = e("Annoyed", [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["path", { d: "M8 15h8", key: "45n4r" }],
    ["path", { d: "M8 9h2", key: "1g203m" }],
    ["path", { d: "M14 9h2", key: "116p9w" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const G2 = e("Antenna", [
    ["path", { d: "M2 12 7 2", key: "117k30" }],
    ["path", { d: "m7 12 5-10", key: "1tvx22" }],
    ["path", { d: "m12 12 5-10", key: "ev1o1a" }],
    ["path", { d: "m17 12 5-10", key: "1e4ti3" }],
    ["path", { d: "M4.5 7h15", key: "vlsxkz" }],
    ["path", { d: "M12 16v6", key: "c8a4gj" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const E2 = e("Anvil", [
    ["path", { d: "M7 10H6a4 4 0 0 1-4-4 1 1 0 0 1 1-1h4", key: "1hjpb6" }],
    [
      "path",
      {
        d: "M7 5a1 1 0 0 1 1-1h13a1 1 0 0 1 1 1 7 7 0 0 1-7 7H8a1 1 0 0 1-1-1z",
        key: "1qn45f",
      },
    ],
    ["path", { d: "M9 12v5", key: "3anwtq" }],
    ["path", { d: "M15 12v5", key: "5xh3zn" }],
    [
      "path",
      {
        d: "M5 20a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3 1 1 0 0 1-1 1H6a1 1 0 0 1-1-1",
        key: "1fi4x8",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const W2 = e("Aperture", [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["path", { d: "m14.31 8 5.74 9.94", key: "1y6ab4" }],
    ["path", { d: "M9.69 8h11.48", key: "1wxppr" }],
    ["path", { d: "m7.38 12 5.74-9.94", key: "1grp0k" }],
    ["path", { d: "M9.69 16 3.95 6.06", key: "libnyf" }],
    ["path", { d: "M14.31 16H2.83", key: "x5fava" }],
    ["path", { d: "m16.62 12-5.74 9.94", key: "1vwawt" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const N2 = e("AppWindow", [
    [
      "rect",
      { x: "2", y: "4", width: "20", height: "16", rx: "2", key: "izxlao" },
    ],
    ["path", { d: "M10 4v4", key: "pp8u80" }],
    ["path", { d: "M2 8h20", key: "d11cs7" }],
    ["path", { d: "M6 4v4", key: "1svtjw" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const X2 = e("Apple", [
    [
      "path",
      {
        d: "M12 20.94c1.5 0 2.75 1.06 4 1.06 3 0 6-8 6-12.22A4.91 4.91 0 0 0 17 5c-2.22 0-4 1.44-5 2-1-.56-2.78-2-5-2a4.9 4.9 0 0 0-5 4.78C2 14 5 22 8 22c1.25 0 2.5-1.06 4-1.06Z",
        key: "3s7exb",
      },
    ],
    ["path", { d: "M10 2c1 .5 2 2 2 5", key: "fcco2y" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const K2 = e("ArchiveRestore", [
    [
      "rect",
      { width: "20", height: "5", x: "2", y: "3", rx: "1", key: "1wp1u1" },
    ],
    ["path", { d: "M4 8v11a2 2 0 0 0 2 2h2", key: "tvwodi" }],
    ["path", { d: "M20 8v11a2 2 0 0 1-2 2h-2", key: "1gkqxj" }],
    ["path", { d: "m9 15 3-3 3 3", key: "1pd0qc" }],
    ["path", { d: "M12 12v9", key: "192myk" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const _2 = e("ArchiveX", [
    [
      "rect",
      { width: "20", height: "5", x: "2", y: "3", rx: "1", key: "1wp1u1" },
    ],
    ["path", { d: "M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8", key: "1s80jp" }],
    ["path", { d: "m9.5 17 5-5", key: "nakeu6" }],
    ["path", { d: "m9.5 12 5 5", key: "1hccrj" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const J2 = e("Archive", [
    [
      "rect",
      { width: "20", height: "5", x: "2", y: "3", rx: "1", key: "1wp1u1" },
    ],
    ["path", { d: "M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8", key: "1s80jp" }],
    ["path", { d: "M10 12h4", key: "a56b0p" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Q2 = e("AreaChart", [
    ["path", { d: "M3 3v18h18", key: "1s2lah" }],
    ["path", { d: "M7 12v5h12V8l-5 5-4-4Z", key: "zxz28u" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Y2 = e("Armchair", [
    ["path", { d: "M19 9V6a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v3", key: "irtipd" }],
    [
      "path",
      {
        d: "M3 16a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-5a2 2 0 0 0-4 0v2H7v-2a2 2 0 0 0-4 0Z",
        key: "1e01m0",
      },
    ],
    ["path", { d: "M5 18v2", key: "ppbyun" }],
    ["path", { d: "M19 18v2", key: "gy7782" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const $2 = e("ArrowBigDownDash", [
    ["path", { d: "M15 5H9", key: "1tp3ed" }],
    ["path", { d: "M15 9v3h4l-7 7-7-7h4V9z", key: "ncdc4b" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ee = e("ArrowBigDown", [
    ["path", { d: "M15 6v6h4l-7 7-7-7h4V6h6z", key: "1thax2" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ae = e("ArrowBigLeftDash", [
    ["path", { d: "M19 15V9", key: "1hci5f" }],
    ["path", { d: "M15 15h-3v4l-7-7 7-7v4h3v6z", key: "16tjna" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const te = e("ArrowBigLeft", [
    ["path", { d: "M18 15h-6v4l-7-7 7-7v4h6v6z", key: "lbrdak" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ce = e("ArrowBigRightDash", [
    ["path", { d: "M5 9v6", key: "158jrl" }],
    ["path", { d: "M9 9h3V5l7 7-7 7v-4H9V9z", key: "1sg2xn" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const he = e("ArrowBigRight", [
    ["path", { d: "M6 9h6V5l7 7-7 7v-4H6V9z", key: "7fvt9c" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const de = e("ArrowBigUpDash", [
    ["path", { d: "M9 19h6", key: "456am0" }],
    ["path", { d: "M9 15v-3H5l7-7 7 7h-4v3H9z", key: "1r2uve" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const oe = e("ArrowBigUp", [
    ["path", { d: "M9 18v-6H5l7-7 7 7h-4v6H9z", key: "1x06kx" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ye = e("ArrowDown01", [
    ["path", { d: "m3 16 4 4 4-4", key: "1co6wj" }],
    ["path", { d: "M7 20V4", key: "1yoxec" }],
    [
      "rect",
      { x: "15", y: "4", width: "4", height: "6", ry: "2", key: "1bwicg" },
    ],
    ["path", { d: "M17 20v-6h-2", key: "1qp1so" }],
    ["path", { d: "M15 20h4", key: "1j968p" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ie = e("ArrowDown10", [
    ["path", { d: "m3 16 4 4 4-4", key: "1co6wj" }],
    ["path", { d: "M7 20V4", key: "1yoxec" }],
    ["path", { d: "M17 10V4h-2", key: "zcsr5x" }],
    ["path", { d: "M15 10h4", key: "id2lce" }],
    [
      "rect",
      { x: "15", y: "14", width: "4", height: "6", ry: "2", key: "33xykx" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const S = e("ArrowDownAZ", [
    ["path", { d: "m3 16 4 4 4-4", key: "1co6wj" }],
    ["path", { d: "M7 20V4", key: "1yoxec" }],
    ["path", { d: "M20 8h-5", key: "1vsyxs" }],
    ["path", { d: "M15 10V6.5a2.5 2.5 0 0 1 5 0V10", key: "ag13bf" }],
    ["path", { d: "M15 14h5l-5 6h5", key: "ur5jdg" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ne = e("ArrowDownCircle", [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["path", { d: "M12 8v8", key: "napkw2" }],
    ["path", { d: "m8 12 4 4 4-4", key: "k98ssh" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const re = e("ArrowDownFromLine", [
    ["path", { d: "M19 3H5", key: "1236rx" }],
    ["path", { d: "M12 21V7", key: "gj6g52" }],
    ["path", { d: "m6 15 6 6 6-6", key: "h15q88" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ke = e("ArrowDownLeftFromCircle", [
    ["path", { d: "M2 12a10 10 0 1 1 10 10", key: "1yn6ov" }],
    ["path", { d: "m2 22 10-10", key: "28ilpk" }],
    ["path", { d: "M8 22H2v-6", key: "sulq54" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const pe = e("ArrowDownLeftFromSquare", [
    [
      "path",
      {
        d: "M13 21h6a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v6",
        key: "14qz4y",
      },
    ],
    ["path", { d: "m3 21 9-9", key: "1jfql5" }],
    ["path", { d: "M9 21H3v-6", key: "wtvkvv" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const le = e("ArrowDownLeftSquare", [
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" },
    ],
    ["path", { d: "m16 8-8 8", key: "166keh" }],
    ["path", { d: "M16 16H8V8", key: "1w2ppm" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const se = e("ArrowDownLeft", [
    ["path", { d: "M17 7 7 17", key: "15tmo1" }],
    ["path", { d: "M17 17H7V7", key: "1org7z" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ue = e("ArrowDownNarrowWide", [
    ["path", { d: "m3 16 4 4 4-4", key: "1co6wj" }],
    ["path", { d: "M7 20V4", key: "1yoxec" }],
    ["path", { d: "M11 4h4", key: "6d7r33" }],
    ["path", { d: "M11 8h7", key: "djye34" }],
    ["path", { d: "M11 12h10", key: "1438ji" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Me = e("ArrowDownRightFromCircle", [
    ["path", { d: "M12 22a10 10 0 1 1 10-10", key: "130bv5" }],
    ["path", { d: "M22 22 12 12", key: "131aw7" }],
    ["path", { d: "M22 16v6h-6", key: "1gvm70" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ve = e("ArrowDownRightFromSquare", [
    [
      "path",
      {
        d: "M21 11V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h6",
        key: "14rsvq",
      },
    ],
    ["path", { d: "m21 21-9-9", key: "1et2py" }],
    ["path", { d: "M21 15v6h-6", key: "1jko0i" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const me = e("ArrowDownRightSquare", [
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" },
    ],
    ["path", { d: "m8 8 8 8", key: "1imecy" }],
    ["path", { d: "M16 8v8H8", key: "1lbpgo" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const xe = e("ArrowDownRight", [
    ["path", { d: "m7 7 10 10", key: "1fmybs" }],
    ["path", { d: "M17 7v10H7", key: "6fjiku" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ge = e("ArrowDownSquare", [
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" },
    ],
    ["path", { d: "M12 8v8", key: "napkw2" }],
    ["path", { d: "m8 12 4 4 4-4", key: "k98ssh" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Le = e("ArrowDownToDot", [
    ["path", { d: "M12 2v14", key: "jyx4ut" }],
    ["path", { d: "m19 9-7 7-7-7", key: "1oe3oy" }],
    ["circle", { cx: "12", cy: "21", r: "1", key: "o0uj5v" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const fe = e("ArrowDownToLine", [
    ["path", { d: "M12 17V3", key: "1cwfxf" }],
    ["path", { d: "m6 11 6 6 6-6", key: "12ii2o" }],
    ["path", { d: "M19 21H5", key: "150jfl" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const we = e("ArrowDownUp", [
    ["path", { d: "m3 16 4 4 4-4", key: "1co6wj" }],
    ["path", { d: "M7 20V4", key: "1yoxec" }],
    ["path", { d: "m21 8-4-4-4 4", key: "1c9v7m" }],
    ["path", { d: "M17 4v16", key: "7dpous" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const q = e("ArrowDownWideNarrow", [
    ["path", { d: "m3 16 4 4 4-4", key: "1co6wj" }],
    ["path", { d: "M7 20V4", key: "1yoxec" }],
    ["path", { d: "M11 4h10", key: "1w87gc" }],
    ["path", { d: "M11 8h7", key: "djye34" }],
    ["path", { d: "M11 12h4", key: "q8tih4" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const H = e("ArrowDownZA", [
    ["path", { d: "m3 16 4 4 4-4", key: "1co6wj" }],
    ["path", { d: "M7 4v16", key: "1glfcx" }],
    ["path", { d: "M15 4h5l-5 6h5", key: "8asdl1" }],
    ["path", { d: "M15 20v-3.5a2.5 2.5 0 0 1 5 0V20", key: "r6l5cz" }],
    ["path", { d: "M20 18h-5", key: "18j1r2" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ie = e("ArrowDown", [
    ["path", { d: "M12 5v14", key: "s699le" }],
    ["path", { d: "m19 12-7 7-7-7", key: "1idqje" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ce = e("ArrowLeftCircle", [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["path", { d: "M16 12H8", key: "1fr5h0" }],
    ["path", { d: "m12 8-4 4 4 4", key: "15vm53" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const be = e("ArrowLeftFromLine", [
    ["path", { d: "m9 6-6 6 6 6", key: "7v63n9" }],
    ["path", { d: "M3 12h14", key: "13k4hi" }],
    ["path", { d: "M21 19V5", key: "b4bplr" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Se = e("ArrowLeftRight", [
    ["path", { d: "M8 3 4 7l4 4", key: "9rb6wj" }],
    ["path", { d: "M4 7h16", key: "6tx8e3" }],
    ["path", { d: "m16 21 4-4-4-4", key: "siv7j2" }],
    ["path", { d: "M20 17H4", key: "h6l3hr" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const qe = e("ArrowLeftSquare", [
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" },
    ],
    ["path", { d: "m12 8-4 4 4 4", key: "15vm53" }],
    ["path", { d: "M16 12H8", key: "1fr5h0" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const He = e("ArrowLeftToLine", [
    ["path", { d: "M3 19V5", key: "rwsyhb" }],
    ["path", { d: "m13 6-6 6 6 6", key: "1yhaz7" }],
    ["path", { d: "M7 12h14", key: "uoisry" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ze = e("ArrowLeft", [
    ["path", { d: "m12 19-7-7 7-7", key: "1l729n" }],
    ["path", { d: "M19 12H5", key: "x3x0zl" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ae = e("ArrowRightCircle", [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["path", { d: "M8 12h8", key: "1wcyev" }],
    ["path", { d: "m12 16 4-4-4-4", key: "1i9zcv" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const je = e("ArrowRightFromLine", [
    ["path", { d: "M3 5v14", key: "1nt18q" }],
    ["path", { d: "M21 12H7", key: "13ipq5" }],
    ["path", { d: "m15 18 6-6-6-6", key: "6tx3qv" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ve = e("ArrowRightLeft", [
    ["path", { d: "m16 3 4 4-4 4", key: "1x1c3m" }],
    ["path", { d: "M20 7H4", key: "zbl0bi" }],
    ["path", { d: "m8 21-4-4 4-4", key: "h9nckh" }],
    ["path", { d: "M4 17h16", key: "g4d7ey" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Pe = e("ArrowRightSquare", [
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" },
    ],
    ["path", { d: "M8 12h8", key: "1wcyev" }],
    ["path", { d: "m12 16 4-4-4-4", key: "1i9zcv" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Fe = e("ArrowRightToLine", [
    ["path", { d: "M17 12H3", key: "8awo09" }],
    ["path", { d: "m11 18 6-6-6-6", key: "8c2y43" }],
    ["path", { d: "M21 5v14", key: "nzette" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const G1 = e("ArrowRight", [
    ["path", { d: "M5 12h14", key: "1ays0h" }],
    ["path", { d: "m12 5 7 7-7 7", key: "xquz4c" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Be = e("ArrowUp01", [
    ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
    ["path", { d: "M7 4v16", key: "1glfcx" }],
    [
      "rect",
      { x: "15", y: "4", width: "4", height: "6", ry: "2", key: "1bwicg" },
    ],
    ["path", { d: "M17 20v-6h-2", key: "1qp1so" }],
    ["path", { d: "M15 20h4", key: "1j968p" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const De = e("ArrowUp10", [
    ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
    ["path", { d: "M7 4v16", key: "1glfcx" }],
    ["path", { d: "M17 10V4h-2", key: "zcsr5x" }],
    ["path", { d: "M15 10h4", key: "id2lce" }],
    [
      "rect",
      { x: "15", y: "14", width: "4", height: "6", ry: "2", key: "33xykx" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const z = e("ArrowUpAZ", [
    ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
    ["path", { d: "M7 4v16", key: "1glfcx" }],
    ["path", { d: "M20 8h-5", key: "1vsyxs" }],
    ["path", { d: "M15 10V6.5a2.5 2.5 0 0 1 5 0V10", key: "ag13bf" }],
    ["path", { d: "M15 14h5l-5 6h5", key: "ur5jdg" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Re = e("ArrowUpCircle", [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["path", { d: "m16 12-4-4-4 4", key: "177agl" }],
    ["path", { d: "M12 16V8", key: "1sbj14" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Te = e("ArrowUpDown", [
    ["path", { d: "m21 16-4 4-4-4", key: "f6ql7i" }],
    ["path", { d: "M17 20V4", key: "1ejh1v" }],
    ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
    ["path", { d: "M7 4v16", key: "1glfcx" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ue = e("ArrowUpFromDot", [
    ["path", { d: "m5 9 7-7 7 7", key: "1hw5ic" }],
    ["path", { d: "M12 16V2", key: "ywoabb" }],
    ["circle", { cx: "12", cy: "21", r: "1", key: "o0uj5v" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ze = e("ArrowUpFromLine", [
    ["path", { d: "m18 9-6-6-6 6", key: "kcunyi" }],
    ["path", { d: "M12 3v14", key: "7cf3v8" }],
    ["path", { d: "M5 21h14", key: "11awu3" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Oe = e("ArrowUpLeftFromCircle", [
    ["path", { d: "M2 8V2h6", key: "hiwtdz" }],
    ["path", { d: "m2 2 10 10", key: "1oh8rs" }],
    ["path", { d: "M12 2A10 10 0 1 1 2 12", key: "rrk4fa" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ge = e("ArrowUpLeftFromSquare", [
    [
      "path",
      {
        d: "M13 3h6a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-6",
        key: "14mv1t",
      },
    ],
    ["path", { d: "m3 3 9 9", key: "rks13r" }],
    ["path", { d: "M3 9V3h6", key: "ira0h2" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ee = e("ArrowUpLeftSquare", [
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" },
    ],
    ["path", { d: "M8 16V8h8", key: "19xb1h" }],
    ["path", { d: "M16 16 8 8", key: "1qdy8n" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const We = e("ArrowUpLeft", [
    ["path", { d: "M7 17V7h10", key: "11bw93" }],
    ["path", { d: "M17 17 7 7", key: "2786uv" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const A = e("ArrowUpNarrowWide", [
    ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
    ["path", { d: "M7 4v16", key: "1glfcx" }],
    ["path", { d: "M11 12h4", key: "q8tih4" }],
    ["path", { d: "M11 16h7", key: "uosisv" }],
    ["path", { d: "M11 20h10", key: "jvxblo" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ne = e("ArrowUpRightFromCircle", [
    ["path", { d: "M22 12A10 10 0 1 1 12 2", key: "1fm58d" }],
    ["path", { d: "M22 2 12 12", key: "yg2myt" }],
    ["path", { d: "M16 2h6v6", key: "zan5cs" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Xe = e("ArrowUpRightFromSquare", [
    [
      "path",
      {
        d: "M21 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h6",
        key: "y09zxi",
      },
    ],
    ["path", { d: "m21 3-9 9", key: "mpx6sq" }],
    ["path", { d: "M15 3h6v6", key: "1q9fwt" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ke = e("ArrowUpRightSquare", [
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" },
    ],
    ["path", { d: "M8 8h8v8", key: "b65dnt" }],
    ["path", { d: "m8 16 8-8", key: "13b9ih" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const _e = e("ArrowUpRight", [
    ["path", { d: "M7 7h10v10", key: "1tivn9" }],
    ["path", { d: "M7 17 17 7", key: "1vkiza" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Je = e("ArrowUpSquare", [
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" },
    ],
    ["path", { d: "m16 12-4-4-4 4", key: "177agl" }],
    ["path", { d: "M12 16V8", key: "1sbj14" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Qe = e("ArrowUpToLine", [
    ["path", { d: "M5 3h14", key: "7usisc" }],
    ["path", { d: "m18 13-6-6-6 6", key: "1kf1n9" }],
    ["path", { d: "M12 7v14", key: "1akyts" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ye = e("ArrowUpWideNarrow", [
    ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
    ["path", { d: "M7 4v16", key: "1glfcx" }],
    ["path", { d: "M11 12h10", key: "1438ji" }],
    ["path", { d: "M11 16h7", key: "uosisv" }],
    ["path", { d: "M11 20h4", key: "1krc32" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const j = e("ArrowUpZA", [
    ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
    ["path", { d: "M7 4v16", key: "1glfcx" }],
    ["path", { d: "M15 4h5l-5 6h5", key: "8asdl1" }],
    ["path", { d: "M15 20v-3.5a2.5 2.5 0 0 1 5 0V20", key: "r6l5cz" }],
    ["path", { d: "M20 18h-5", key: "18j1r2" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const $e = e("ArrowUp", [
    ["path", { d: "m5 12 7-7 7 7", key: "hav0vg" }],
    ["path", { d: "M12 19V5", key: "x0mq9r" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ea = e("ArrowsUpFromLine", [
    ["path", { d: "m4 6 3-3 3 3", key: "9aidw8" }],
    ["path", { d: "M7 17V3", key: "19qxw1" }],
    ["path", { d: "m14 6 3-3 3 3", key: "6iy689" }],
    ["path", { d: "M17 17V3", key: "o0fmgi" }],
    ["path", { d: "M4 21h16", key: "1h09gz" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const V = e("AsteriskSquare", [
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" },
    ],
    ["path", { d: "M12 8v8", key: "napkw2" }],
    ["path", { d: "m8.5 14 7-4", key: "12hpby" }],
    ["path", { d: "m8.5 10 7 4", key: "wwy2dy" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const aa = e("Asterisk", [
    ["path", { d: "M12 6v12", key: "1vza4d" }],
    ["path", { d: "M17.196 9 6.804 15", key: "1ah31z" }],
    ["path", { d: "m6.804 9 10.392 6", key: "1b6pxd" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ta = e("AtSign", [
    ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
    ["path", { d: "M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-4 8", key: "7n84p3" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ca = e("Atom", [
    ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
    [
      "path",
      {
        d: "M20.2 20.2c2.04-2.03.02-7.36-4.5-11.9-4.54-4.52-9.87-6.54-11.9-4.5-2.04 2.03-.02 7.36 4.5 11.9 4.54 4.52 9.87 6.54 11.9 4.5Z",
        key: "1l2ple",
      },
    ],
    [
      "path",
      {
        d: "M15.7 15.7c4.52-4.54 6.54-9.87 4.5-11.9-2.03-2.04-7.36-.02-11.9 4.5-4.52 4.54-6.54 9.87-4.5 11.9 2.03 2.04 7.36.02 11.9-4.5Z",
        key: "1wam0m",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ha = e("AudioLines", [
    ["path", { d: "M2 10v3", key: "1fnikh" }],
    ["path", { d: "M6 6v11", key: "11sgs0" }],
    ["path", { d: "M10 3v18", key: "yhl04a" }],
    ["path", { d: "M14 8v7", key: "3a1oy3" }],
    ["path", { d: "M18 5v13", key: "123xd1" }],
    ["path", { d: "M22 10v3", key: "154ddg" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const da = e("AudioWaveform", [
    [
      "path",
      {
        d: "M2 13a2 2 0 0 0 2-2V7a2 2 0 0 1 4 0v13a2 2 0 0 0 4 0V4a2 2 0 0 1 4 0v13a2 2 0 0 0 4 0v-4a2 2 0 0 1 2-2",
        key: "57tc96",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const oa = e("Award", [
    ["circle", { cx: "12", cy: "8", r: "6", key: "1vp47v" }],
    ["path", { d: "M15.477 12.89 17 22l-5-3-5 3 1.523-9.11", key: "em7aur" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ya = e("Axe", [
    ["path", { d: "m14 12-8.5 8.5a2.12 2.12 0 1 1-3-3L11 9", key: "csbz4o" }],
    ["path", { d: "M15 13 9 7l4-4 6 6h3a8 8 0 0 1-7 7z", key: "113wfo" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const P = e("Axis3d", [
    ["path", { d: "M4 4v16h16", key: "1s015l" }],
    ["path", { d: "m4 20 7-7", key: "17qe9y" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ia = e("Baby", [
    ["path", { d: "M9 12h.01", key: "157uk2" }],
    ["path", { d: "M15 12h.01", key: "1k8ypt" }],
    ["path", { d: "M10 16c.5.3 1.2.5 2 .5s1.5-.2 2-.5", key: "1u7htd" }],
    [
      "path",
      {
        d: "M19 6.3a9 9 0 0 1 1.8 3.9 2 2 0 0 1 0 3.6 9 9 0 0 1-17.6 0 2 2 0 0 1 0-3.6A9 9 0 0 1 12 3c2 0 3.5 1.1 3.5 2.5s-.9 2.5-2 2.5c-.8 0-1.5-.4-1.5-1",
        key: "5yv0yz",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const na = e("Backpack", [
    [
      "path",
      {
        d: "M4 10a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2Z",
        key: "wvr1b5",
      },
    ],
    ["path", { d: "M9 6V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2", key: "donm21" }],
    ["path", { d: "M8 21v-5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v5", key: "xk3gvk" }],
    ["path", { d: "M8 10h8", key: "c7uz4u" }],
    ["path", { d: "M8 18h8", key: "1no2b1" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ra = e("BadgeAlert", [
    [
      "path",
      {
        d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
        key: "3c2336",
      },
    ],
    ["line", { x1: "12", x2: "12", y1: "8", y2: "12", key: "1pkeuh" }],
    ["line", { x1: "12", x2: "12.01", y1: "16", y2: "16", key: "4dfq90" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ka = e("BadgeCent", [
    [
      "path",
      {
        d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
        key: "3c2336",
      },
    ],
    ["path", { d: "M12 7v10", key: "jspqdw" }],
    ["path", { d: "M15.4 10a4 4 0 1 0 0 4", key: "2eqtx8" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const F = e("BadgeCheck", [
    [
      "path",
      {
        d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
        key: "3c2336",
      },
    ],
    ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const pa = e("BadgeDollarSign", [
    [
      "path",
      {
        d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
        key: "3c2336",
      },
    ],
    ["path", { d: "M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8", key: "1h4pet" }],
    ["path", { d: "M12 18V6", key: "zqpxq5" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const la = e("BadgeEuro", [
    [
      "path",
      {
        d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
        key: "3c2336",
      },
    ],
    ["path", { d: "M7 12h5", key: "gblrwe" }],
    ["path", { d: "M15 9.4a4 4 0 1 0 0 5.2", key: "1makmb" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const sa = e("BadgeHelp", [
    [
      "path",
      {
        d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
        key: "3c2336",
      },
    ],
    ["path", { d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3", key: "1u773s" }],
    ["line", { x1: "12", x2: "12.01", y1: "17", y2: "17", key: "io3f8k" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ua = e("BadgeIndianRupee", [
    [
      "path",
      {
        d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
        key: "3c2336",
      },
    ],
    ["path", { d: "M8 8h8", key: "1bis0t" }],
    ["path", { d: "M8 12h8", key: "1wcyev" }],
    ["path", { d: "m13 17-5-1h1a4 4 0 0 0 0-8", key: "nu2bwa" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ma = e("BadgeInfo", [
    [
      "path",
      {
        d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
        key: "3c2336",
      },
    ],
    ["line", { x1: "12", x2: "12", y1: "16", y2: "12", key: "1y1yb1" }],
    ["line", { x1: "12", x2: "12.01", y1: "8", y2: "8", key: "110wyk" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const va = e("BadgeJapaneseYen", [
    [
      "path",
      {
        d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
        key: "3c2336",
      },
    ],
    ["path", { d: "m9 8 3 3v7", key: "17yadx" }],
    ["path", { d: "m12 11 3-3", key: "p4cfq1" }],
    ["path", { d: "M9 12h6", key: "1c52cq" }],
    ["path", { d: "M9 16h6", key: "8wimt3" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ma = e("BadgeMinus", [
    [
      "path",
      {
        d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
        key: "3c2336",
      },
    ],
    ["line", { x1: "8", x2: "16", y1: "12", y2: "12", key: "1jonct" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const xa = e("BadgePercent", [
    [
      "path",
      {
        d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
        key: "3c2336",
      },
    ],
    ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
    ["path", { d: "M9 9h.01", key: "1q5me6" }],
    ["path", { d: "M15 15h.01", key: "lqbp3k" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ga = e("BadgePlus", [
    [
      "path",
      {
        d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
        key: "3c2336",
      },
    ],
    ["line", { x1: "12", x2: "12", y1: "8", y2: "16", key: "10p56q" }],
    ["line", { x1: "8", x2: "16", y1: "12", y2: "12", key: "1jonct" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const La = e("BadgePoundSterling", [
    [
      "path",
      {
        d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
        key: "3c2336",
      },
    ],
    ["path", { d: "M8 12h4", key: "qz6y1c" }],
    ["path", { d: "M10 16V9.5a2.5 2.5 0 0 1 5 0", key: "3mlbjk" }],
    ["path", { d: "M8 16h7", key: "sbedsn" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const fa = e("BadgeRussianRuble", [
    [
      "path",
      {
        d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
        key: "3c2336",
      },
    ],
    ["path", { d: "M9 16h5", key: "1syiyw" }],
    ["path", { d: "M9 12h5a2 2 0 1 0 0-4h-3v9", key: "1ge9c1" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const wa = e("BadgeSwissFranc", [
    [
      "path",
      {
        d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
        key: "3c2336",
      },
    ],
    ["path", { d: "M11 17V8h4", key: "1bfq6y" }],
    ["path", { d: "M11 12h3", key: "2eqnfz" }],
    ["path", { d: "M9 16h4", key: "1skf3a" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ia = e("BadgeX", [
    [
      "path",
      {
        d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
        key: "3c2336",
      },
    ],
    ["line", { x1: "15", x2: "9", y1: "9", y2: "15", key: "f7djnv" }],
    ["line", { x1: "9", x2: "15", y1: "9", y2: "15", key: "1shsy8" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ca = e("Badge", [
    [
      "path",
      {
        d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
        key: "3c2336",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ba = e("BaggageClaim", [
    ["path", { d: "M22 18H6a2 2 0 0 1-2-2V7a2 2 0 0 0-2-2", key: "4irg2o" }],
    [
      "path",
      { d: "M17 14V4a2 2 0 0 0-2-2h-1a2 2 0 0 0-2 2v10", key: "14fcyx" },
    ],
    [
      "rect",
      { width: "13", height: "8", x: "8", y: "6", rx: "1", key: "o6oiis" },
    ],
    ["circle", { cx: "18", cy: "20", r: "2", key: "t9985n" }],
    ["circle", { cx: "9", cy: "20", r: "2", key: "e5v82j" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Sa = e("Ban", [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["path", { d: "m4.9 4.9 14.2 14.2", key: "1m5liu" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const qa = e("Banana", [
    ["path", { d: "M4 13c3.5-2 8-2 10 2a5.5 5.5 0 0 1 8 5", key: "1cscit" }],
    [
      "path",
      {
        d: "M5.15 17.89c5.52-1.52 8.65-6.89 7-12C11.55 4 11.5 2 13 2c3.22 0 5 5.5 5 8 0 6.5-4.2 12-10.49 12C5.11 22 2 22 2 20c0-1.5 1.14-1.55 3.15-2.11Z",
        key: "1y1nbv",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ha = e("Banknote", [
    [
      "rect",
      { width: "20", height: "12", x: "2", y: "6", rx: "2", key: "9lu3g6" },
    ],
    ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }],
    ["path", { d: "M6 12h.01M18 12h.01", key: "113zkx" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const za = e("BarChart2", [
    ["line", { x1: "18", x2: "18", y1: "20", y2: "10", key: "1xfpm4" }],
    ["line", { x1: "12", x2: "12", y1: "20", y2: "4", key: "be30l9" }],
    ["line", { x1: "6", x2: "6", y1: "20", y2: "14", key: "1r4le6" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Aa = e("BarChart3", [
    ["path", { d: "M3 3v18h18", key: "1s2lah" }],
    ["path", { d: "M18 17V9", key: "2bz60n" }],
    ["path", { d: "M13 17V5", key: "1frdt8" }],
    ["path", { d: "M8 17v-3", key: "17ska0" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ja = e("BarChart4", [
    ["path", { d: "M3 3v18h18", key: "1s2lah" }],
    ["path", { d: "M13 17V9", key: "1fwyjl" }],
    ["path", { d: "M18 17V5", key: "sfb6ij" }],
    ["path", { d: "M8 17v-3", key: "17ska0" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Va = e("BarChartBig", [
    ["path", { d: "M3 3v18h18", key: "1s2lah" }],
    [
      "rect",
      { width: "4", height: "7", x: "7", y: "10", rx: "1", key: "14u6mf" },
    ],
    [
      "rect",
      { width: "4", height: "12", x: "15", y: "5", rx: "1", key: "b3pek6" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Pa = e("BarChartHorizontalBig", [
    ["path", { d: "M3 3v18h18", key: "1s2lah" }],
    [
      "rect",
      { width: "12", height: "4", x: "7", y: "5", rx: "1", key: "936jl1" },
    ],
    [
      "rect",
      { width: "7", height: "4", x: "7", y: "13", rx: "1", key: "jqfkpy" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Fa = e("BarChartHorizontal", [
    ["path", { d: "M3 3v18h18", key: "1s2lah" }],
    ["path", { d: "M7 16h8", key: "srdodz" }],
    ["path", { d: "M7 11h12", key: "127s9w" }],
    ["path", { d: "M7 6h3", key: "w9rmul" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ba = e("BarChart", [
    ["line", { x1: "12", x2: "12", y1: "20", y2: "10", key: "1vz5eb" }],
    ["line", { x1: "18", x2: "18", y1: "20", y2: "4", key: "cun8e5" }],
    ["line", { x1: "6", x2: "6", y1: "20", y2: "16", key: "hq0ia6" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Da = e("Barcode", [
    ["path", { d: "M3 5v14", key: "1nt18q" }],
    ["path", { d: "M8 5v14", key: "1ybrkv" }],
    ["path", { d: "M12 5v14", key: "s699le" }],
    ["path", { d: "M17 5v14", key: "ycjyhj" }],
    ["path", { d: "M21 5v14", key: "nzette" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ra = e("Baseline", [
    ["path", { d: "M4 20h16", key: "14thso" }],
    ["path", { d: "m6 16 6-12 6 12", key: "1b4byz" }],
    ["path", { d: "M8 12h8", key: "1wcyev" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ta = e("Bath", [
    [
      "path",
      {
        d: "M9 6 6.5 3.5a1.5 1.5 0 0 0-1-.5C4.683 3 4 3.683 4 4.5V17a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-5",
        key: "1r8yf5",
      },
    ],
    ["line", { x1: "10", x2: "8", y1: "5", y2: "7", key: "h5g8z4" }],
    ["line", { x1: "2", x2: "22", y1: "12", y2: "12", key: "1dnqot" }],
    ["line", { x1: "7", x2: "7", y1: "19", y2: "21", key: "16jp00" }],
    ["line", { x1: "17", x2: "17", y1: "19", y2: "21", key: "1pxrnk" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ua = e("BatteryCharging", [
    ["path", { d: "M15 7h1a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-2", key: "1sdynx" }],
    ["path", { d: "M6 7H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h1", key: "1gkd3k" }],
    ["path", { d: "m11 7-3 5h4l-3 5", key: "b4a64w" }],
    ["line", { x1: "22", x2: "22", y1: "11", y2: "13", key: "4dh1rd" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Za = e("BatteryFull", [
    [
      "rect",
      {
        width: "16",
        height: "10",
        x: "2",
        y: "7",
        rx: "2",
        ry: "2",
        key: "1w10f2",
      },
    ],
    ["line", { x1: "22", x2: "22", y1: "11", y2: "13", key: "4dh1rd" }],
    ["line", { x1: "6", x2: "6", y1: "11", y2: "13", key: "1wd6dw" }],
    ["line", { x1: "10", x2: "10", y1: "11", y2: "13", key: "haxvl5" }],
    ["line", { x1: "14", x2: "14", y1: "11", y2: "13", key: "c6fn6x" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Oa = e("BatteryLow", [
    [
      "rect",
      {
        width: "16",
        height: "10",
        x: "2",
        y: "7",
        rx: "2",
        ry: "2",
        key: "1w10f2",
      },
    ],
    ["line", { x1: "22", x2: "22", y1: "11", y2: "13", key: "4dh1rd" }],
    ["line", { x1: "6", x2: "6", y1: "11", y2: "13", key: "1wd6dw" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ga = e("BatteryMedium", [
    [
      "rect",
      {
        width: "16",
        height: "10",
        x: "2",
        y: "7",
        rx: "2",
        ry: "2",
        key: "1w10f2",
      },
    ],
    ["line", { x1: "22", x2: "22", y1: "11", y2: "13", key: "4dh1rd" }],
    ["line", { x1: "6", x2: "6", y1: "11", y2: "13", key: "1wd6dw" }],
    ["line", { x1: "10", x2: "10", y1: "11", y2: "13", key: "haxvl5" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ea = e("BatteryWarning", [
    ["path", { d: "M14 7h2a2 2 0 0 1 2 2v6c0 1-1 2-2 2h-2", key: "1if82c" }],
    ["path", { d: "M6 7H4a2 2 0 0 0-2 2v6c0 1 1 2 2 2h2", key: "2pdlyl" }],
    ["line", { x1: "22", x2: "22", y1: "11", y2: "13", key: "4dh1rd" }],
    ["line", { x1: "10", x2: "10", y1: "7", y2: "13", key: "1uzyus" }],
    ["line", { x1: "10", x2: "10", y1: "17", y2: "17.01", key: "1y8k4g" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Wa = e("Battery", [
    [
      "rect",
      {
        width: "16",
        height: "10",
        x: "2",
        y: "7",
        rx: "2",
        ry: "2",
        key: "1w10f2",
      },
    ],
    ["line", { x1: "22", x2: "22", y1: "11", y2: "13", key: "4dh1rd" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Na = e("Beaker", [
    ["path", { d: "M4.5 3h15", key: "c7n0jr" }],
    ["path", { d: "M6 3v16a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V3", key: "m1uhx7" }],
    ["path", { d: "M6 14h12", key: "4cwo0f" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Xa = e("BeanOff", [
    [
      "path",
      {
        d: "M9 9c-.64.64-1.521.954-2.402 1.165A6 6 0 0 0 8 22a13.96 13.96 0 0 0 9.9-4.1",
        key: "bq3udt",
      },
    ],
    [
      "path",
      {
        d: "M10.75 5.093A6 6 0 0 1 22 8c0 2.411-.61 4.68-1.683 6.66",
        key: "17ccse",
      },
    ],
    [
      "path",
      {
        d: "M5.341 10.62a4 4 0 0 0 6.487 1.208M10.62 5.341a4.015 4.015 0 0 1 2.039 2.04",
        key: "18zqgq",
      },
    ],
    ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ka = e("Bean", [
    [
      "path",
      {
        d: "M10.165 6.598C9.954 7.478 9.64 8.36 9 9c-.64.64-1.521.954-2.402 1.165A6 6 0 0 0 8 22c7.732 0 14-6.268 14-14a6 6 0 0 0-11.835-1.402Z",
        key: "1tvzk7",
      },
    ],
    ["path", { d: "M5.341 10.62a4 4 0 1 0 5.279-5.28", key: "2cyri2" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const _a = e("BedDouble", [
    ["path", { d: "M2 20v-8a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v8", key: "1k78r4" }],
    ["path", { d: "M4 10V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4", key: "fb3tl2" }],
    ["path", { d: "M12 4v6", key: "1dcgq2" }],
    ["path", { d: "M2 18h20", key: "ajqnye" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ja = e("BedSingle", [
    ["path", { d: "M3 20v-8a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v8", key: "1wm6mi" }],
    ["path", { d: "M5 10V6a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v4", key: "4k93s5" }],
    ["path", { d: "M3 18h18", key: "1h113x" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Qa = e("Bed", [
    ["path", { d: "M2 4v16", key: "vw9hq8" }],
    ["path", { d: "M2 8h18a2 2 0 0 1 2 2v10", key: "1dgv2r" }],
    ["path", { d: "M2 17h20", key: "18nfp3" }],
    ["path", { d: "M6 8v9", key: "1yriud" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ya = e("Beef", [
    ["circle", { cx: "12.5", cy: "8.5", r: "2.5", key: "9738u8" }],
    [
      "path",
      {
        d: "M12.5 2a6.5 6.5 0 0 0-6.22 4.6c-1.1 3.13-.78 3.9-3.18 6.08A3 3 0 0 0 5 18c4 0 8.4-1.8 11.4-4.3A6.5 6.5 0 0 0 12.5 2Z",
        key: "o0f6za",
      },
    ],
    [
      "path",
      {
        d: "m18.5 6 2.19 4.5a6.48 6.48 0 0 1 .31 2 6.49 6.49 0 0 1-2.6 5.2C15.4 20.2 11 22 7 22a3 3 0 0 1-2.68-1.66L2.4 16.5",
        key: "k7p6i0",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const $a = e("Beer", [
    ["path", { d: "M17 11h1a3 3 0 0 1 0 6h-1", key: "1yp76v" }],
    ["path", { d: "M9 12v6", key: "1u1cab" }],
    ["path", { d: "M13 12v6", key: "1sugkk" }],
    [
      "path",
      {
        d: "M14 7.5c-1 0-1.44.5-3 .5s-2-.5-3-.5-1.72.5-2.5.5a2.5 2.5 0 0 1 0-5c.78 0 1.57.5 2.5.5S9.44 2 11 2s2 1.5 3 1.5 1.72-.5 2.5-.5a2.5 2.5 0 0 1 0 5c-.78 0-1.5-.5-2.5-.5Z",
        key: "1510fo",
      },
    ],
    ["path", { d: "M5 8v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V8", key: "19jb7n" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const e0 = e("BellDot", [
    [
      "path",
      {
        d: "M19.4 14.9C20.2 16.4 21 17 21 17H3s3-2 3-9c0-3.3 2.7-6 6-6 .7 0 1.3.1 1.9.3",
        key: "xcehk",
      },
    ],
    ["path", { d: "M10.3 21a1.94 1.94 0 0 0 3.4 0", key: "qgo35s" }],
    ["circle", { cx: "18", cy: "8", r: "3", key: "1g0gzu" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const a0 = e("BellElectric", [
    ["path", { d: "M18.8 4A6.3 8.7 0 0 1 20 9", key: "xve1fh" }],
    ["path", { d: "M9 9h.01", key: "1q5me6" }],
    ["circle", { cx: "9", cy: "9", r: "7", key: "p2h5vp" }],
    [
      "rect",
      { width: "10", height: "6", x: "4", y: "16", rx: "2", key: "17f3te" },
    ],
    ["path", { d: "M14 19c3 0 4.6-1.6 4.6-1.6", key: "n7odp6" }],
    ["circle", { cx: "20", cy: "16", r: "2", key: "1v9bxh" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const t0 = e("BellMinus", [
    [
      "path",
      {
        d: "M18.4 12c.8 3.8 2.6 5 2.6 5H3s3-2 3-9c0-3.3 2.7-6 6-6 1.8 0 3.4.8 4.5 2",
        key: "eck70s",
      },
    ],
    ["path", { d: "M10.3 21a1.94 1.94 0 0 0 3.4 0", key: "qgo35s" }],
    ["path", { d: "M15 8h6", key: "8ybuxh" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const c0 = e("BellOff", [
    [
      "path",
      { d: "M8.7 3A6 6 0 0 1 18 8a21.3 21.3 0 0 0 .6 5", key: "o7mx20" },
    ],
    ["path", { d: "M17 17H3s3-2 3-9a4.67 4.67 0 0 1 .3-1.7", key: "16f1lm" }],
    ["path", { d: "M10.3 21a1.94 1.94 0 0 0 3.4 0", key: "qgo35s" }],
    ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const h0 = e("BellPlus", [
    [
      "path",
      {
        d: "M19.3 14.8C20.1 16.4 21 17 21 17H3s3-2 3-9c0-3.3 2.7-6 6-6 1 0 1.9.2 2.8.7",
        key: "guizqy",
      },
    ],
    ["path", { d: "M10.3 21a1.94 1.94 0 0 0 3.4 0", key: "qgo35s" }],
    ["path", { d: "M15 8h6", key: "8ybuxh" }],
    ["path", { d: "M18 5v6", key: "g5ayrv" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const d0 = e("BellRing", [
    ["path", { d: "M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9", key: "1qo2s2" }],
    ["path", { d: "M10.3 21a1.94 1.94 0 0 0 3.4 0", key: "qgo35s" }],
    ["path", { d: "M4 2C2.8 3.7 2 5.7 2 8", key: "tap9e0" }],
    ["path", { d: "M22 8c0-2.3-.8-4.3-2-6", key: "5bb3ad" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const o0 = e("Bell", [
    ["path", { d: "M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9", key: "1qo2s2" }],
    ["path", { d: "M10.3 21a1.94 1.94 0 0 0 3.4 0", key: "qgo35s" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const B = e("BetweenHorizontalEnd", [
    [
      "rect",
      { width: "13", height: "7", x: "3", y: "3", rx: "1", key: "11xb64" },
    ],
    ["path", { d: "m22 15-3-3 3-3", key: "26chmm" }],
    [
      "rect",
      { width: "13", height: "7", x: "3", y: "14", rx: "1", key: "k6ky7n" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const D = e("BetweenHorizontalStart", [
    [
      "rect",
      { width: "13", height: "7", x: "8", y: "3", rx: "1", key: "pkso9a" },
    ],
    ["path", { d: "m2 9 3 3-3 3", key: "1agib5" }],
    [
      "rect",
      { width: "13", height: "7", x: "8", y: "14", rx: "1", key: "1q5fc1" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const y0 = e("BetweenVerticalEnd", [
    [
      "rect",
      { width: "7", height: "13", x: "3", y: "3", rx: "1", key: "1fdu0f" },
    ],
    ["path", { d: "m9 22 3-3 3 3", key: "17z65a" }],
    [
      "rect",
      { width: "7", height: "13", x: "14", y: "3", rx: "1", key: "1squn4" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const i0 = e("BetweenVerticalStart", [
    [
      "rect",
      { width: "7", height: "13", x: "3", y: "8", rx: "1", key: "1fjrkv" },
    ],
    ["path", { d: "m15 2-3 3-3-3", key: "1uh6eb" }],
    [
      "rect",
      { width: "7", height: "13", x: "14", y: "8", rx: "1", key: "w3fjg8" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const n0 = e("Bike", [
    ["circle", { cx: "18.5", cy: "17.5", r: "3.5", key: "15x4ox" }],
    ["circle", { cx: "5.5", cy: "17.5", r: "3.5", key: "1noe27" }],
    ["circle", { cx: "15", cy: "5", r: "1", key: "19l28e" }],
    ["path", { d: "M12 17.5V14l-3-3 4-3 2 3h2", key: "1npguv" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const r0 = e("Binary", [
    [
      "rect",
      { x: "14", y: "14", width: "4", height: "6", rx: "2", key: "p02svl" },
    ],
    [
      "rect",
      { x: "6", y: "4", width: "4", height: "6", rx: "2", key: "xm4xkj" },
    ],
    ["path", { d: "M6 20h4", key: "1i6q5t" }],
    ["path", { d: "M14 10h4", key: "ru81e7" }],
    ["path", { d: "M6 14h2v6", key: "16z9wg" }],
    ["path", { d: "M14 4h2v6", key: "1idq9u" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const k0 = e("Biohazard", [
    ["circle", { cx: "12", cy: "11.9", r: "2", key: "e8h31w" }],
    [
      "path",
      {
        d: "M6.7 3.4c-.9 2.5 0 5.2 2.2 6.7C6.5 9 3.7 9.6 2 11.6",
        key: "17bolr",
      },
    ],
    ["path", { d: "m8.9 10.1 1.4.8", key: "15ezny" }],
    [
      "path",
      {
        d: "M17.3 3.4c.9 2.5 0 5.2-2.2 6.7 2.4-1.2 5.2-.6 6.9 1.5",
        key: "wtwa5u",
      },
    ],
    ["path", { d: "m15.1 10.1-1.4.8", key: "1r0b28" }],
    [
      "path",
      {
        d: "M16.7 20.8c-2.6-.4-4.6-2.6-4.7-5.3-.2 2.6-2.1 4.8-4.7 5.2",
        key: "m7qszh",
      },
    ],
    ["path", { d: "M12 13.9v1.6", key: "zfyyim" }],
    ["path", { d: "M13.5 5.4c-1-.2-2-.2-3 0", key: "1bi9q0" }],
    ["path", { d: "M17 16.4c.7-.7 1.2-1.6 1.5-2.5", key: "1rhjqw" }],
    ["path", { d: "M5.5 13.9c.3.9.8 1.8 1.5 2.5", key: "8gsud3" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const p0 = e("Bird", [
    ["path", { d: "M16 7h.01", key: "1kdx03" }],
    [
      "path",
      {
        d: "M3.4 18H12a8 8 0 0 0 8-8V7a4 4 0 0 0-7.28-2.3L2 20",
        key: "oj1oa8",
      },
    ],
    ["path", { d: "m20 7 2 .5-2 .5", key: "12nv4d" }],
    ["path", { d: "M10 18v3", key: "1yea0a" }],
    ["path", { d: "M14 17.75V21", key: "1pymcb" }],
    ["path", { d: "M7 18a6 6 0 0 0 3.84-10.61", key: "1npnn0" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const l0 = e("Bitcoin", [
    [
      "path",
      {
        d: "M11.767 19.089c4.924.868 6.14-6.025 1.216-6.894m-1.216 6.894L5.86 18.047m5.908 1.042-.347 1.97m1.563-8.864c4.924.869 6.14-6.025 1.215-6.893m-1.215 6.893-3.94-.694m5.155-6.2L8.29 4.26m5.908 1.042.348-1.97M7.48 20.364l3.126-17.727",
        key: "yr8idg",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const s0 = e("Blend", [
    ["circle", { cx: "9", cy: "9", r: "7", key: "p2h5vp" }],
    ["circle", { cx: "15", cy: "15", r: "7", key: "19ennj" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const u0 = e("Blinds", [
    ["path", { d: "M3 3h18", key: "o7r712" }],
    ["path", { d: "M20 7H8", key: "gd2fo2" }],
    ["path", { d: "M20 11H8", key: "1ynp89" }],
    ["path", { d: "M10 19h10", key: "19hjk5" }],
    ["path", { d: "M8 15h12", key: "1yqzne" }],
    ["path", { d: "M4 3v14", key: "fggqzn" }],
    ["circle", { cx: "4", cy: "19", r: "2", key: "p3m9r0" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const M0 = e("Blocks", [
    [
      "rect",
      { width: "7", height: "7", x: "14", y: "3", rx: "1", key: "6d4xhi" },
    ],
    [
      "path",
      {
        d: "M10 21V8a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1H3",
        key: "1fpvtg",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const v0 = e("BluetoothConnected", [
    ["path", { d: "m7 7 10 10-5 5V2l5 5L7 17", key: "1q5490" }],
    ["line", { x1: "18", x2: "21", y1: "12", y2: "12", key: "1rsjjs" }],
    ["line", { x1: "3", x2: "6", y1: "12", y2: "12", key: "11yl8c" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const m0 = e("BluetoothOff", [
    ["path", { d: "m17 17-5 5V12l-5 5", key: "v5aci6" }],
    ["path", { d: "m2 2 20 20", key: "1ooewy" }],
    ["path", { d: "M14.5 9.5 17 7l-5-5v4.5", key: "1kddfz" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const x0 = e("BluetoothSearching", [
    ["path", { d: "m7 7 10 10-5 5V2l5 5L7 17", key: "1q5490" }],
    ["path", { d: "M20.83 14.83a4 4 0 0 0 0-5.66", key: "k8tn1j" }],
    ["path", { d: "M18 12h.01", key: "yjnet6" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const g0 = e("Bluetooth", [
    ["path", { d: "m7 7 10 10-5 5V2l5 5L7 17", key: "1q5490" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const L0 = e("Bold", [
    ["path", { d: "M14 12a4 4 0 0 0 0-8H6v8", key: "v2sylx" }],
    ["path", { d: "M15 20a4 4 0 0 0 0-8H6v8Z", key: "1ef5ya" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const f0 = e("Bolt", [
    [
      "path",
      {
        d: "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z",
        key: "yt0hxn",
      },
    ],
    ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const w0 = e("Bomb", [
    ["circle", { cx: "11", cy: "13", r: "9", key: "hd149" }],
    [
      "path",
      {
        d: "M14.35 4.65 16.3 2.7a2.41 2.41 0 0 1 3.4 0l1.6 1.6a2.4 2.4 0 0 1 0 3.4l-1.95 1.95",
        key: "jp4j1b",
      },
    ],
    ["path", { d: "m22 2-1.5 1.5", key: "ay92ug" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const I0 = e("Bone", [
    [
      "path",
      {
        d: "M17 10c.7-.7 1.69 0 2.5 0a2.5 2.5 0 1 0 0-5 .5.5 0 0 1-.5-.5 2.5 2.5 0 1 0-5 0c0 .81.7 1.8 0 2.5l-7 7c-.7.7-1.69 0-2.5 0a2.5 2.5 0 0 0 0 5c.28 0 .5.22.5.5a2.5 2.5 0 1 0 5 0c0-.81-.7-1.8 0-2.5Z",
        key: "w610uw",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const C0 = e("BookA", [
    [
      "path",
      {
        d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20",
        key: "t4utmx",
      },
    ],
    ["path", { d: "m8 13 4-7 4 7", key: "4rari8" }],
    ["path", { d: "M9.1 11h5.7", key: "1gkovt" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const b0 = e("BookAudio", [
    [
      "path",
      {
        d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20",
        key: "t4utmx",
      },
    ],
    ["path", { d: "M8 8v3", key: "1qzp49" }],
    ["path", { d: "M12 6v7", key: "1f6ttz" }],
    ["path", { d: "M16 8v3", key: "gejaml" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const S0 = e("BookCheck", [
    [
      "path",
      {
        d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20",
        key: "t4utmx",
      },
    ],
    ["path", { d: "m9 9.5 2 2 4-4", key: "1dth82" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const q0 = e("BookCopy", [
    ["path", { d: "M2 16V4a2 2 0 0 1 2-2h11", key: "spzkk5" }],
    ["path", { d: "M5 14H4a2 2 0 1 0 0 4h1", key: "16gqf9" }],
    [
      "path",
      { d: "M22 18H11a2 2 0 1 0 0 4h11V6H11a2 2 0 0 0-2 2v12", key: "1owzki" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const R = e("BookDashed", [
    ["path", { d: "M20 22h-2", key: "1rpnb6" }],
    ["path", { d: "M20 15v2h-2", key: "fph276" }],
    ["path", { d: "M4 19.5V15", key: "6gr39e" }],
    ["path", { d: "M20 8v3", key: "deu0bs" }],
    ["path", { d: "M18 2h2v2", key: "180o53" }],
    ["path", { d: "M4 11V9", key: "v3xsx8" }],
    ["path", { d: "M12 2h2", key: "cvn524" }],
    ["path", { d: "M12 22h2", key: "kn7ki6" }],
    ["path", { d: "M12 17h2", key: "13u4lk" }],
    ["path", { d: "M8 22H6.5a2.5 2.5 0 0 1 0-5H8", key: "fiseg2" }],
    ["path", { d: "M4 5v-.5A2.5 2.5 0 0 1 6.5 2H8", key: "wywhs9" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const H0 = e("BookDown", [
    [
      "path",
      {
        d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20",
        key: "t4utmx",
      },
    ],
    ["path", { d: "M12 13V7", key: "h0r20n" }],
    ["path", { d: "m9 10 3 3 3-3", key: "zt5b4y" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const z0 = e("BookHeadphones", [
    [
      "path",
      {
        d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20",
        key: "t4utmx",
      },
    ],
    ["circle", { cx: "9", cy: "12", r: "1", key: "1vctgf" }],
    ["path", { d: "M8 12v-2a4 4 0 0 1 8 0v2", key: "1vsqkj" }],
    ["circle", { cx: "15", cy: "12", r: "1", key: "1tmaij" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const A0 = e("BookHeart", [
    [
      "path",
      {
        d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20",
        key: "t4utmx",
      },
    ],
    [
      "path",
      {
        d: "M16 8.2C16 7 15 6 13.8 6c-.8 0-1.4.3-1.8.9-.4-.6-1-.9-1.8-.9C9 6 8 7 8 8.2c0 .6.3 1.2.7 1.6h0C10 11.1 12 13 12 13s2-1.9 3.3-3.1h0c.4-.4.7-1 .7-1.7z",
        key: "1dlbw1",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const j0 = e("BookImage", [
    [
      "path",
      {
        d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20",
        key: "t4utmx",
      },
    ],
    ["circle", { cx: "10", cy: "8", r: "2", key: "2qkj4p" }],
    ["path", { d: "m20 13.7-2.1-2.1c-.8-.8-2-.8-2.8 0L9.7 17", key: "160say" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const V0 = e("BookKey", [
    ["path", { d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H14", key: "1gfsgw" }],
    ["path", { d: "M20 8v14H6.5a2.5 2.5 0 0 1 0-5H20", key: "zb0ngp" }],
    ["circle", { cx: "14", cy: "8", r: "2", key: "u49eql" }],
    ["path", { d: "m20 2-4.5 4.5", key: "1sppr8" }],
    ["path", { d: "m19 3 1 1", key: "ze14oc" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const P0 = e("BookLock", [
    ["path", { d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H10", key: "18wgow" }],
    ["path", { d: "M20 15v7H6.5a2.5 2.5 0 0 1 0-5H20", key: "dpch1j" }],
    [
      "rect",
      { width: "8", height: "5", x: "12", y: "6", rx: "1", key: "9nqwug" },
    ],
    ["path", { d: "M18 6V4a2 2 0 1 0-4 0v2", key: "1aquzs" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const F0 = e("BookMarked", [
    [
      "path",
      {
        d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20",
        key: "t4utmx",
      },
    ],
    ["polyline", { points: "10 2 10 10 13 7 16 10 16 2", key: "13o6vz" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const B0 = e("BookMinus", [
    [
      "path",
      {
        d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20",
        key: "t4utmx",
      },
    ],
    ["path", { d: "M9 10h6", key: "9gxzsh" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const D0 = e("BookOpenCheck", [
    [
      "path",
      { d: "M8 3H2v15h7c1.7 0 3 1.3 3 3V7c0-2.2-1.8-4-4-4Z", key: "1i8u0n" },
    ],
    ["path", { d: "m16 12 2 2 4-4", key: "mdajum" }],
    [
      "path",
      {
        d: "M22 6V3h-6c-2.2 0-4 1.8-4 4v14c0-1.7 1.3-3 3-3h7v-2.3",
        key: "jb5l51",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const R0 = e("BookOpenText", [
    ["path", { d: "M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z", key: "vv98re" }],
    [
      "path",
      { d: "M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z", key: "1cyq3y" },
    ],
    ["path", { d: "M6 8h2", key: "30oboj" }],
    ["path", { d: "M6 12h2", key: "32wvfc" }],
    ["path", { d: "M16 8h2", key: "msurwy" }],
    ["path", { d: "M16 12h2", key: "7q9ll5" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const T0 = e("BookOpen", [
    ["path", { d: "M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z", key: "vv98re" }],
    [
      "path",
      { d: "M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z", key: "1cyq3y" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const U0 = e("BookPlus", [
    [
      "path",
      {
        d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20",
        key: "t4utmx",
      },
    ],
    ["path", { d: "M9 10h6", key: "9gxzsh" }],
    ["path", { d: "M12 7v6", key: "lw1j43" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Z0 = e("BookText", [
    [
      "path",
      {
        d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20",
        key: "t4utmx",
      },
    ],
    ["path", { d: "M8 7h6", key: "1f0q6e" }],
    ["path", { d: "M8 11h8", key: "vwpz6n" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const O0 = e("BookType", [
    [
      "path",
      {
        d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20",
        key: "t4utmx",
      },
    ],
    ["path", { d: "M16 8V6H8v2", key: "x8j6u4" }],
    ["path", { d: "M12 6v7", key: "1f6ttz" }],
    ["path", { d: "M10 13h4", key: "ytezjc" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const G0 = e("BookUp2", [
    ["path", { d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2", key: "1lorq7" }],
    ["path", { d: "M18 2h2v20H6.5a2.5 2.5 0 0 1 0-5H20", key: "1nfm9i" }],
    ["path", { d: "M12 13V7", key: "h0r20n" }],
    ["path", { d: "m9 10 3-3 3 3", key: "11gsxs" }],
    ["path", { d: "m9 5 3-3 3 3", key: "l8vdw6" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const E0 = e("BookUp", [
    [
      "path",
      {
        d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20",
        key: "t4utmx",
      },
    ],
    ["path", { d: "M12 13V7", key: "h0r20n" }],
    ["path", { d: "m9 10 3-3 3 3", key: "11gsxs" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const W0 = e("BookUser", [
    [
      "path",
      {
        d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20",
        key: "t4utmx",
      },
    ],
    ["circle", { cx: "12", cy: "8", r: "2", key: "1822b1" }],
    ["path", { d: "M15 13a3 3 0 1 0-6 0", key: "10j68g" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const N0 = e("BookX", [
    [
      "path",
      {
        d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20",
        key: "t4utmx",
      },
    ],
    ["path", { d: "m14.5 7-5 5", key: "dy991v" }],
    ["path", { d: "m9.5 7 5 5", key: "s45iea" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const X0 = e("Book", [
    [
      "path",
      {
        d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20",
        key: "t4utmx",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const K0 = e("BookmarkCheck", [
    [
      "path",
      { d: "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2Z", key: "169p4p" },
    ],
    ["path", { d: "m9 10 2 2 4-4", key: "1gnqz4" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const _0 = e("BookmarkMinus", [
    [
      "path",
      {
        d: "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z",
        key: "1fy3hk",
      },
    ],
    ["line", { x1: "15", x2: "9", y1: "10", y2: "10", key: "1gty7f" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const J0 = e("BookmarkPlus", [
    [
      "path",
      {
        d: "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z",
        key: "1fy3hk",
      },
    ],
    ["line", { x1: "12", x2: "12", y1: "7", y2: "13", key: "1cppfj" }],
    ["line", { x1: "15", x2: "9", y1: "10", y2: "10", key: "1gty7f" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Q0 = e("BookmarkX", [
    [
      "path",
      { d: "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2Z", key: "169p4p" },
    ],
    ["path", { d: "m14.5 7.5-5 5", key: "3lb6iw" }],
    ["path", { d: "m9.5 7.5 5 5", key: "ko136h" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Y0 = e("Bookmark", [
    [
      "path",
      {
        d: "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z",
        key: "1fy3hk",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const $0 = e("BoomBox", [
    ["path", { d: "M4 9V5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4", key: "vvzvr1" }],
    ["path", { d: "M8 8v1", key: "xcqmfk" }],
    ["path", { d: "M12 8v1", key: "1rj8u4" }],
    ["path", { d: "M16 8v1", key: "1q12zr" }],
    [
      "rect",
      { width: "20", height: "12", x: "2", y: "9", rx: "2", key: "igpb89" },
    ],
    ["circle", { cx: "8", cy: "15", r: "2", key: "fa4a8s" }],
    ["circle", { cx: "16", cy: "15", r: "2", key: "14c3ya" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const et = e("BotMessageSquare", [
    ["path", { d: "M12 6V2H8", key: "1155em" }],
    [
      "path",
      {
        d: "m8 18-4 4V8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2Z",
        key: "w2lp3e",
      },
    ],
    ["path", { d: "M2 12h2", key: "1t8f8n" }],
    ["path", { d: "M9 11v2", key: "1ueba0" }],
    ["path", { d: "M15 11v2", key: "i11awn" }],
    ["path", { d: "M20 12h2", key: "1q8mjw" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const at = e("Bot", [
    ["path", { d: "M12 8V4H8", key: "hb8ula" }],
    [
      "rect",
      { width: "16", height: "12", x: "4", y: "8", rx: "2", key: "enze0r" },
    ],
    ["path", { d: "M2 14h2", key: "vft8re" }],
    ["path", { d: "M20 14h2", key: "4cs60a" }],
    ["path", { d: "M15 13v2", key: "1xurst" }],
    ["path", { d: "M9 13v2", key: "rq6x2g" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const tt = e("BoxSelect", [
    ["path", { d: "M5 3a2 2 0 0 0-2 2", key: "y57alp" }],
    ["path", { d: "M19 3a2 2 0 0 1 2 2", key: "18rm91" }],
    ["path", { d: "M21 19a2 2 0 0 1-2 2", key: "1j7049" }],
    ["path", { d: "M5 21a2 2 0 0 1-2-2", key: "sbafld" }],
    ["path", { d: "M9 3h1", key: "1yesri" }],
    ["path", { d: "M9 21h1", key: "15o7lz" }],
    ["path", { d: "M14 3h1", key: "1ec4yj" }],
    ["path", { d: "M14 21h1", key: "v9vybs" }],
    ["path", { d: "M3 9v1", key: "1r0deq" }],
    ["path", { d: "M21 9v1", key: "mxsmne" }],
    ["path", { d: "M3 14v1", key: "vnatye" }],
    ["path", { d: "M21 14v1", key: "169vum" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ct = e("Box", [
    [
      "path",
      {
        d: "M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z",
        key: "hh9hay",
      },
    ],
    ["path", { d: "m3.3 7 8.7 5 8.7-5", key: "g66t2b" }],
    ["path", { d: "M12 22V12", key: "d0xqtd" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ht = e("Boxes", [
    [
      "path",
      {
        d: "M2.97 12.92A2 2 0 0 0 2 14.63v3.24a2 2 0 0 0 .97 1.71l3 1.8a2 2 0 0 0 2.06 0L12 19v-5.5l-5-3-4.03 2.42Z",
        key: "lc1i9w",
      },
    ],
    ["path", { d: "m7 16.5-4.74-2.85", key: "1o9zyk" }],
    ["path", { d: "m7 16.5 5-3", key: "va8pkn" }],
    ["path", { d: "M7 16.5v5.17", key: "jnp8gn" }],
    [
      "path",
      {
        d: "M12 13.5V19l3.97 2.38a2 2 0 0 0 2.06 0l3-1.8a2 2 0 0 0 .97-1.71v-3.24a2 2 0 0 0-.97-1.71L17 10.5l-5 3Z",
        key: "8zsnat",
      },
    ],
    ["path", { d: "m17 16.5-5-3", key: "8arw3v" }],
    ["path", { d: "m17 16.5 4.74-2.85", key: "8rfmw" }],
    ["path", { d: "M17 16.5v5.17", key: "k6z78m" }],
    [
      "path",
      {
        d: "M7.97 4.42A2 2 0 0 0 7 6.13v4.37l5 3 5-3V6.13a2 2 0 0 0-.97-1.71l-3-1.8a2 2 0 0 0-2.06 0l-3 1.8Z",
        key: "1xygjf",
      },
    ],
    ["path", { d: "M12 8 7.26 5.15", key: "1vbdud" }],
    ["path", { d: "m12 8 4.74-2.85", key: "3rx089" }],
    ["path", { d: "M12 13.5V8", key: "1io7kd" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const T = e("Braces", [
    [
      "path",
      {
        d: "M8 3H7a2 2 0 0 0-2 2v5a2 2 0 0 1-2 2 2 2 0 0 1 2 2v5c0 1.1.9 2 2 2h1",
        key: "ezmyqa",
      },
    ],
    [
      "path",
      {
        d: "M16 21h1a2 2 0 0 0 2-2v-5c0-1.1.9-2 2-2a2 2 0 0 1-2-2V5a2 2 0 0 0-2-2h-1",
        key: "e1hn23",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const dt = e("Brackets", [
    ["path", { d: "M16 3h3v18h-3", key: "1yor1f" }],
    ["path", { d: "M8 21H5V3h3", key: "1qrfwo" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ot = e("BrainCircuit", [
    [
      "path",
      {
        d: "M12 5a3 3 0 1 0-5.997.125 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.588A4 4 0 1 0 12 18Z",
        key: "l5xja",
      },
    ],
    ["path", { d: "M9 13a4.5 4.5 0 0 0 3-4", key: "10igwf" }],
    ["path", { d: "M6.003 5.125A3 3 0 0 0 6.401 6.5", key: "105sqy" }],
    ["path", { d: "M3.477 10.896a4 4 0 0 1 .585-.396", key: "ql3yin" }],
    ["path", { d: "M6 18a4 4 0 0 1-1.967-.516", key: "2e4loj" }],
    ["path", { d: "M12 13h4", key: "1ku699" }],
    ["path", { d: "M12 18h6a2 2 0 0 1 2 2v1", key: "105ag5" }],
    ["path", { d: "M12 8h8", key: "1lhi5i" }],
    ["path", { d: "M16 8V5a2 2 0 0 1 2-2", key: "u6izg6" }],
    ["circle", { cx: "16", cy: "13", r: ".5", key: "ry7gng" }],
    ["circle", { cx: "18", cy: "3", r: ".5", key: "1aiba7" }],
    ["circle", { cx: "20", cy: "21", r: ".5", key: "yhc1fs" }],
    ["circle", { cx: "20", cy: "8", r: ".5", key: "1e43v0" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const yt = e("BrainCog", [
    [
      "path",
      {
        d: "M12 5a3 3 0 1 0-5.997.142 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.588 4 4 0 0 0 7.636 2.106 3.2 3.2 0 0 0 .164-.546c.028-.13.306-.13.335 0a3.2 3.2 0 0 0 .163.546 4 4 0 0 0 7.636-2.106 4 4 0 0 0 .556-6.588 4 4 0 0 0-2.526-5.77A3 3 0 1 0 12 5",
        key: "1kgmhc",
      },
    ],
    ["path", { d: "M17.599 6.5a3 3 0 0 0 .399-1.375", key: "tmeiqw" }],
    ["path", { d: "M6.003 5.125A3 3 0 0 0 6.401 6.5", key: "105sqy" }],
    ["path", { d: "M3.477 10.896a4 4 0 0 1 .585-.396", key: "ql3yin" }],
    ["path", { d: "M19.938 10.5a4 4 0 0 1 .585.396", key: "1qfode" }],
    ["path", { d: "M6 18a4 4 0 0 1-1.967-.516", key: "2e4loj" }],
    ["path", { d: "M19.967 17.484A4 4 0 0 1 18 18", key: "159ez6" }],
    ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
    ["path", { d: "m15.7 10.4-.9.4", key: "ayzo6p" }],
    ["path", { d: "m9.2 13.2-.9.4", key: "1uzb3g" }],
    ["path", { d: "m13.6 15.7-.4-.9", key: "11ifqf" }],
    ["path", { d: "m10.8 9.2-.4-.9", key: "1pmk2v" }],
    ["path", { d: "m15.7 13.5-.9-.4", key: "7ng02m" }],
    ["path", { d: "m9.2 10.9-.9-.4", key: "1x66zd" }],
    ["path", { d: "m10.5 15.7.4-.9", key: "3js94g" }],
    ["path", { d: "m13.1 9.2.4-.9", key: "18n7mc" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const it = e("Brain", [
    [
      "path",
      {
        d: "M12 5a3 3 0 1 0-5.997.125 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.588A4 4 0 1 0 12 18Z",
        key: "l5xja",
      },
    ],
    [
      "path",
      {
        d: "M12 5a3 3 0 1 1 5.997.125 4 4 0 0 1 2.526 5.77 4 4 0 0 1-.556 6.588A4 4 0 1 1 12 18Z",
        key: "ep3f8r",
      },
    ],
    [
      "path",
      { d: "M15 13a4.5 4.5 0 0 1-3-4 4.5 4.5 0 0 1-3 4", key: "1p4c4q" },
    ],
    ["path", { d: "M17.599 6.5a3 3 0 0 0 .399-1.375", key: "tmeiqw" }],
    ["path", { d: "M6.003 5.125A3 3 0 0 0 6.401 6.5", key: "105sqy" }],
    ["path", { d: "M3.477 10.896a4 4 0 0 1 .585-.396", key: "ql3yin" }],
    ["path", { d: "M19.938 10.5a4 4 0 0 1 .585.396", key: "1qfode" }],
    ["path", { d: "M6 18a4 4 0 0 1-1.967-.516", key: "2e4loj" }],
    ["path", { d: "M19.967 17.484A4 4 0 0 1 18 18", key: "159ez6" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const nt = e("BrickWall", [
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" },
    ],
    ["path", { d: "M12 9v6", key: "199k2o" }],
    ["path", { d: "M16 15v6", key: "8rj2es" }],
    ["path", { d: "M16 3v6", key: "1j6rpj" }],
    ["path", { d: "M3 15h18", key: "5xshup" }],
    ["path", { d: "M3 9h18", key: "1pudct" }],
    ["path", { d: "M8 15v6", key: "1stoo3" }],
    ["path", { d: "M8 3v6", key: "vlvjmk" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const rt = e("Briefcase", [
    [
      "rect",
      {
        width: "20",
        height: "14",
        x: "2",
        y: "7",
        rx: "2",
        ry: "2",
        key: "eto64e",
      },
    ],
    [
      "path",
      { d: "M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16", key: "zwj3tp" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const kt = e("BringToFront", [
    [
      "rect",
      { x: "8", y: "8", width: "8", height: "8", rx: "2", key: "yj20xf" },
    ],
    [
      "path",
      {
        d: "M4 10a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2",
        key: "1ltk23",
      },
    ],
    [
      "path",
      {
        d: "M14 20a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2",
        key: "1q24h9",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const pt = e("Brush", [
    [
      "path",
      {
        d: "m9.06 11.9 8.07-8.06a2.85 2.85 0 1 1 4.03 4.03l-8.06 8.08",
        key: "1styjt",
      },
    ],
    [
      "path",
      {
        d: "M7.07 14.94c-1.66 0-3 1.35-3 3.02 0 1.33-2.5 1.52-2 2.02 1.08 1.1 2.49 2.02 4 2.02 2.2 0 4-1.8 4-4.04a3.01 3.01 0 0 0-3-3.02z",
        key: "z0l1mu",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const lt = e("BugOff", [
    ["path", { d: "M15 7.13V6a3 3 0 0 0-5.14-2.1L8 2", key: "vl8zik" }],
    ["path", { d: "M14.12 3.88 16 2", key: "qol33r" }],
    ["path", { d: "M22 13h-4v-2a4 4 0 0 0-4-4h-1.3", key: "1ou0bd" }],
    ["path", { d: "M20.97 5c0 2.1-1.6 3.8-3.5 4", key: "18gb23" }],
    ["path", { d: "m2 2 20 20", key: "1ooewy" }],
    [
      "path",
      { d: "M7.7 7.7A4 4 0 0 0 6 11v3a6 6 0 0 0 11.13 3.13", key: "1njkjs" },
    ],
    ["path", { d: "M12 20v-8", key: "i3yub9" }],
    ["path", { d: "M6 13H2", key: "82j7cp" }],
    ["path", { d: "M3 21c0-2.1 1.7-3.9 3.8-4", key: "4p0ekp" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const st = e("BugPlay", [
    ["path", { d: "m8 2 1.88 1.88", key: "fmnt4t" }],
    ["path", { d: "M14.12 3.88 16 2", key: "qol33r" }],
    ["path", { d: "M9 7.13v-1a3.003 3.003 0 1 1 6 0v1", key: "d7y7pr" }],
    [
      "path",
      {
        d: "M18 11a4 4 0 0 0-4-4h-4a4 4 0 0 0-4 4v3a6.1 6.1 0 0 0 2 4.5",
        key: "1tjixy",
      },
    ],
    ["path", { d: "M6.53 9C4.6 8.8 3 7.1 3 5", key: "32zzws" }],
    ["path", { d: "M6 13H2", key: "82j7cp" }],
    ["path", { d: "M3 21c0-2.1 1.7-3.9 3.8-4", key: "4p0ekp" }],
    ["path", { d: "M20.97 5c0 2.1-1.6 3.8-3.5 4", key: "18gb23" }],
    ["path", { d: "m12 12 8 5-8 5Z", key: "1ydf81" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ut = e("Bug", [
    ["path", { d: "m8 2 1.88 1.88", key: "fmnt4t" }],
    ["path", { d: "M14.12 3.88 16 2", key: "qol33r" }],
    ["path", { d: "M9 7.13v-1a3.003 3.003 0 1 1 6 0v1", key: "d7y7pr" }],
    [
      "path",
      {
        d: "M12 20c-3.3 0-6-2.7-6-6v-3a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v3c0 3.3-2.7 6-6 6",
        key: "xs1cw7",
      },
    ],
    ["path", { d: "M12 20v-9", key: "1qisl0" }],
    ["path", { d: "M6.53 9C4.6 8.8 3 7.1 3 5", key: "32zzws" }],
    ["path", { d: "M6 13H2", key: "82j7cp" }],
    ["path", { d: "M3 21c0-2.1 1.7-3.9 3.8-4", key: "4p0ekp" }],
    ["path", { d: "M20.97 5c0 2.1-1.6 3.8-3.5 4", key: "18gb23" }],
    ["path", { d: "M22 13h-4", key: "1jl80f" }],
    ["path", { d: "M17.2 17c2.1.1 3.8 1.9 3.8 4", key: "k3fwyw" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Mt = e("Building2", [
    ["path", { d: "M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z", key: "1b4qmf" }],
    ["path", { d: "M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2", key: "i71pzd" }],
    ["path", { d: "M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2", key: "10jefs" }],
    ["path", { d: "M10 6h4", key: "1itunk" }],
    ["path", { d: "M10 10h4", key: "tcdvrf" }],
    ["path", { d: "M10 14h4", key: "kelpxr" }],
    ["path", { d: "M10 18h4", key: "1ulq68" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const vt = e("Building", [
    [
      "rect",
      {
        width: "16",
        height: "20",
        x: "4",
        y: "2",
        rx: "2",
        ry: "2",
        key: "76otgf",
      },
    ],
    ["path", { d: "M9 22v-4h6v4", key: "r93iot" }],
    ["path", { d: "M8 6h.01", key: "1dz90k" }],
    ["path", { d: "M16 6h.01", key: "1x0f13" }],
    ["path", { d: "M12 6h.01", key: "1vi96p" }],
    ["path", { d: "M12 10h.01", key: "1nrarc" }],
    ["path", { d: "M12 14h.01", key: "1etili" }],
    ["path", { d: "M16 10h.01", key: "1m94wz" }],
    ["path", { d: "M16 14h.01", key: "1gbofw" }],
    ["path", { d: "M8 10h.01", key: "19clt8" }],
    ["path", { d: "M8 14h.01", key: "6423bh" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const mt = e("BusFront", [
    ["path", { d: "M4 6 2 7", key: "1mqr15" }],
    ["path", { d: "M10 6h4", key: "1itunk" }],
    ["path", { d: "m22 7-2-1", key: "1umjhc" }],
    [
      "rect",
      { width: "16", height: "16", x: "4", y: "3", rx: "2", key: "1wxw4b" },
    ],
    ["path", { d: "M4 11h16", key: "mpoxn0" }],
    ["path", { d: "M8 15h.01", key: "a7atzg" }],
    ["path", { d: "M16 15h.01", key: "rnfrdf" }],
    ["path", { d: "M6 19v2", key: "1loha6" }],
    ["path", { d: "M18 21v-2", key: "sqyl04" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const xt = e("Bus", [
    ["path", { d: "M8 6v6", key: "18i7km" }],
    ["path", { d: "M15 6v6", key: "1sg6z9" }],
    ["path", { d: "M2 12h19.6", key: "de5uta" }],
    [
      "path",
      {
        d: "M18 18h3s.5-1.7.8-2.8c.1-.4.2-.8.2-1.2 0-.4-.1-.8-.2-1.2l-1.4-5C20.1 6.8 19.1 6 18 6H4a2 2 0 0 0-2 2v10h3",
        key: "1wwztk",
      },
    ],
    ["circle", { cx: "7", cy: "18", r: "2", key: "19iecd" }],
    ["path", { d: "M9 18h5", key: "lrx6i" }],
    ["circle", { cx: "16", cy: "18", r: "2", key: "1v4tcr" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const gt = e("CableCar", [
    ["path", { d: "M10 3h.01", key: "lbucoy" }],
    ["path", { d: "M14 2h.01", key: "1k8aa1" }],
    ["path", { d: "m2 9 20-5", key: "1kz0j5" }],
    ["path", { d: "M12 12V6.5", key: "1vbrij" }],
    [
      "rect",
      { width: "16", height: "10", x: "4", y: "12", rx: "3", key: "if91er" },
    ],
    ["path", { d: "M9 12v5", key: "3anwtq" }],
    ["path", { d: "M15 12v5", key: "5xh3zn" }],
    ["path", { d: "M4 17h16", key: "g4d7ey" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Lt = e("Cable", [
    ["path", { d: "M4 9a2 2 0 0 1-2-2V5h6v2a2 2 0 0 1-2 2Z", key: "1s6oa5" }],
    ["path", { d: "M3 5V3", key: "1k5hjh" }],
    ["path", { d: "M7 5V3", key: "1t1388" }],
    [
      "path",
      {
        d: "M19 15V6.5a3.5 3.5 0 0 0-7 0v11a3.5 3.5 0 0 1-7 0V9",
        key: "1ytv72",
      },
    ],
    ["path", { d: "M17 21v-2", key: "ds4u3f" }],
    ["path", { d: "M21 21v-2", key: "eo0ou" }],
    [
      "path",
      { d: "M22 19h-6v-2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2Z", key: "sdz6o8" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ft = e("CakeSlice", [
    ["circle", { cx: "9", cy: "7", r: "2", key: "1305pl" }],
    [
      "path",
      {
        d: "M7.2 7.9 3 11v9c0 .6.4 1 1 1h16c.6 0 1-.4 1-1v-9c0-2-3-6-7-8l-3.6 2.6",
        key: "xle13f",
      },
    ],
    ["path", { d: "M16 13H3", key: "1wpj08" }],
    ["path", { d: "M16 17H3", key: "3lvfcd" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const wt = e("Cake", [
    ["path", { d: "M20 21v-8a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8", key: "1w3rig" }],
    [
      "path",
      {
        d: "M4 16s.5-1 2-1 2.5 2 4 2 2.5-2 4-2 2.5 2 4 2 2-1 2-1",
        key: "n2jgmb",
      },
    ],
    ["path", { d: "M2 21h20", key: "1nyx9w" }],
    ["path", { d: "M7 8v3", key: "1qtyvj" }],
    ["path", { d: "M12 8v3", key: "hwp4zt" }],
    ["path", { d: "M17 8v3", key: "1i6e5u" }],
    ["path", { d: "M7 4h0.01", key: "hsw7lv" }],
    ["path", { d: "M12 4h0.01", key: "1e3d8f" }],
    ["path", { d: "M17 4h0.01", key: "p7cxgy" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const It = e("Calculator", [
    [
      "rect",
      { width: "16", height: "20", x: "4", y: "2", rx: "2", key: "1nb95v" },
    ],
    ["line", { x1: "8", x2: "16", y1: "6", y2: "6", key: "x4nwl0" }],
    ["line", { x1: "16", x2: "16", y1: "14", y2: "18", key: "wjye3r" }],
    ["path", { d: "M16 10h.01", key: "1m94wz" }],
    ["path", { d: "M12 10h.01", key: "1nrarc" }],
    ["path", { d: "M8 10h.01", key: "19clt8" }],
    ["path", { d: "M12 14h.01", key: "1etili" }],
    ["path", { d: "M8 14h.01", key: "6423bh" }],
    ["path", { d: "M12 18h.01", key: "mhygvu" }],
    ["path", { d: "M8 18h.01", key: "lrp35t" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ct = e("CalendarCheck2", [
    ["path", { d: "M8 2v4", key: "1cmpym" }],
    ["path", { d: "M16 2v4", key: "4m81vk" }],
    [
      "path",
      {
        d: "M21 14V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8",
        key: "bce9hv",
      },
    ],
    ["path", { d: "M3 10h18", key: "8toen8" }],
    ["path", { d: "m16 20 2 2 4-4", key: "13tcca" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const bt = e("CalendarCheck", [
    ["path", { d: "M8 2v4", key: "1cmpym" }],
    ["path", { d: "M16 2v4", key: "4m81vk" }],
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" },
    ],
    ["path", { d: "M3 10h18", key: "8toen8" }],
    ["path", { d: "m9 16 2 2 4-4", key: "19s6y9" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const St = e("CalendarClock", [
    [
      "path",
      {
        d: "M21 7.5V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h3.5",
        key: "1osxxc",
      },
    ],
    ["path", { d: "M16 2v4", key: "4m81vk" }],
    ["path", { d: "M8 2v4", key: "1cmpym" }],
    ["path", { d: "M3 10h5", key: "r794hk" }],
    ["path", { d: "M17.5 17.5 16 16.3V14", key: "akvzfd" }],
    ["circle", { cx: "16", cy: "16", r: "6", key: "qoo3c4" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const qt = e("CalendarDays", [
    ["path", { d: "M8 2v4", key: "1cmpym" }],
    ["path", { d: "M16 2v4", key: "4m81vk" }],
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" },
    ],
    ["path", { d: "M3 10h18", key: "8toen8" }],
    ["path", { d: "M8 14h.01", key: "6423bh" }],
    ["path", { d: "M12 14h.01", key: "1etili" }],
    ["path", { d: "M16 14h.01", key: "1gbofw" }],
    ["path", { d: "M8 18h.01", key: "lrp35t" }],
    ["path", { d: "M12 18h.01", key: "mhygvu" }],
    ["path", { d: "M16 18h.01", key: "kzsmim" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ht = e("CalendarFold", [
    ["path", { d: "M8 2v4", key: "1cmpym" }],
    ["path", { d: "M16 2v4", key: "4m81vk" }],
    [
      "path",
      {
        d: "M21 17V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h11Z",
        key: "kg77oy",
      },
    ],
    ["path", { d: "M3 10h18", key: "8toen8" }],
    ["path", { d: "M15 22v-4a2 2 0 0 1 2-2h4", key: "1gnbqr" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const zt = e("CalendarHeart", [
    [
      "path",
      {
        d: "M3 10h18V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7",
        key: "136lmk",
      },
    ],
    ["path", { d: "M8 2v4", key: "1cmpym" }],
    ["path", { d: "M16 2v4", key: "4m81vk" }],
    [
      "path",
      {
        d: "M21.29 14.7a2.43 2.43 0 0 0-2.65-.52c-.3.12-.57.3-.8.53l-.34.34-.35-.34a2.43 2.43 0 0 0-2.65-.53c-.3.12-.56.3-.79.53-.95.94-1 2.53.2 3.74L17.5 22l3.6-3.55c1.2-1.21 1.14-2.8.19-3.74Z",
        key: "1t7hil",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const At = e("CalendarMinus2", [
    ["path", { d: "M8 2v4", key: "1cmpym" }],
    ["path", { d: "M16 2v4", key: "4m81vk" }],
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" },
    ],
    ["path", { d: "M3 10h18", key: "8toen8" }],
    ["path", { d: "M10 16h4", key: "17e571" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const jt = e("CalendarMinus", [
    ["path", { d: "M8 2v4", key: "1cmpym" }],
    ["path", { d: "M16 2v4", key: "4m81vk" }],
    [
      "path",
      {
        d: "M21 13V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8",
        key: "3spt84",
      },
    ],
    ["path", { d: "M3 10h18", key: "8toen8" }],
    ["path", { d: "M16 19h6", key: "xwg31i" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Vt = e("CalendarOff", [
    [
      "path",
      {
        d: "M4.2 4.2A2 2 0 0 0 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 1.82-1.18",
        key: "16swn3",
      },
    ],
    ["path", { d: "M21 15.5V6a2 2 0 0 0-2-2H9.5", key: "yhw86o" }],
    ["path", { d: "M16 2v4", key: "4m81vk" }],
    ["path", { d: "M3 10h7", key: "1wap6i" }],
    ["path", { d: "M21 10h-5.5", key: "quycpq" }],
    ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Pt = e("CalendarPlus2", [
    ["path", { d: "M8 2v4", key: "1cmpym" }],
    ["path", { d: "M16 2v4", key: "4m81vk" }],
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" },
    ],
    ["path", { d: "M3 10h18", key: "8toen8" }],
    ["path", { d: "M10 16h4", key: "17e571" }],
    ["path", { d: "M12 14v4", key: "1thi36" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ft = e("CalendarPlus", [
    ["path", { d: "M8 2v4", key: "1cmpym" }],
    ["path", { d: "M16 2v4", key: "4m81vk" }],
    [
      "path",
      {
        d: "M21 13V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8",
        key: "3spt84",
      },
    ],
    ["path", { d: "M3 10h18", key: "8toen8" }],
    ["path", { d: "M16 19h6", key: "xwg31i" }],
    ["path", { d: "M19 16v6", key: "tddt3s" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Bt = e("CalendarRange", [
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" },
    ],
    ["path", { d: "M16 2v4", key: "4m81vk" }],
    ["path", { d: "M3 10h18", key: "8toen8" }],
    ["path", { d: "M8 2v4", key: "1cmpym" }],
    ["path", { d: "M17 14h-6", key: "bkmgh3" }],
    ["path", { d: "M13 18H7", key: "bb0bb7" }],
    ["path", { d: "M7 14h.01", key: "1qa3f1" }],
    ["path", { d: "M17 18h.01", key: "1bdyru" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Dt = e("CalendarSearch", [
    [
      "path",
      {
        d: "M21 12V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7.5",
        key: "1e09qw",
      },
    ],
    ["path", { d: "M16 2v4", key: "4m81vk" }],
    ["path", { d: "M8 2v4", key: "1cmpym" }],
    ["path", { d: "M3 10h18", key: "8toen8" }],
    ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
    ["path", { d: "m22 22-1.5-1.5", key: "1x83k4" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Rt = e("CalendarX2", [
    ["path", { d: "M8 2v4", key: "1cmpym" }],
    ["path", { d: "M16 2v4", key: "4m81vk" }],
    [
      "path",
      {
        d: "M21 13V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8",
        key: "3spt84",
      },
    ],
    ["path", { d: "M3 10h18", key: "8toen8" }],
    ["path", { d: "m17 22 5-5", key: "1k6ppv" }],
    ["path", { d: "m17 17 5 5", key: "p7ous7" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Tt = e("CalendarX", [
    ["path", { d: "M8 2v4", key: "1cmpym" }],
    ["path", { d: "M16 2v4", key: "4m81vk" }],
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" },
    ],
    ["path", { d: "M3 10h18", key: "8toen8" }],
    ["path", { d: "m14 14-4 4", key: "rymu2i" }],
    ["path", { d: "m10 14 4 4", key: "3sz06r" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ut = e("Calendar", [
    ["path", { d: "M8 2v4", key: "1cmpym" }],
    ["path", { d: "M16 2v4", key: "4m81vk" }],
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" },
    ],
    ["path", { d: "M3 10h18", key: "8toen8" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Zt = e("CameraOff", [
    ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }],
    ["path", { d: "M7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16", key: "qmtpty" }],
    ["path", { d: "M9.5 4h5L17 7h3a2 2 0 0 1 2 2v7.5", key: "1ufyfc" }],
    ["path", { d: "M14.121 15.121A3 3 0 1 1 9.88 10.88", key: "11zox6" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ot = e("Camera", [
    [
      "path",
      {
        d: "M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z",
        key: "1tc9qg",
      },
    ],
    ["circle", { cx: "12", cy: "13", r: "3", key: "1vg3eu" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Gt = e("CandlestickChart", [
    ["path", { d: "M9 5v4", key: "14uxtq" }],
    [
      "rect",
      { width: "4", height: "6", x: "7", y: "9", rx: "1", key: "f4fvz0" },
    ],
    ["path", { d: "M9 15v2", key: "r5rk32" }],
    ["path", { d: "M17 3v2", key: "1l2re6" }],
    [
      "rect",
      { width: "4", height: "8", x: "15", y: "5", rx: "1", key: "z38je5" },
    ],
    ["path", { d: "M17 13v3", key: "5l0wba" }],
    ["path", { d: "M3 3v18h18", key: "1s2lah" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Et = e("CandyCane", [
    [
      "path",
      {
        d: "M5.7 21a2 2 0 0 1-3.5-2l8.6-14a6 6 0 0 1 10.4 6 2 2 0 1 1-3.464-2 2 2 0 1 0-3.464-2Z",
        key: "isaq8g",
      },
    ],
    ["path", { d: "M17.75 7 15 2.1", key: "12x7e8" }],
    ["path", { d: "M10.9 4.8 13 9", key: "100a87" }],
    ["path", { d: "m7.9 9.7 2 4.4", key: "ntfhaj" }],
    ["path", { d: "M4.9 14.7 7 18.9", key: "1x43jy" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Wt = e("CandyOff", [
    ["path", { d: "m8.5 8.5-1 1a4.95 4.95 0 0 0 7 7l1-1", key: "1ff4ui" }],
    [
      "path",
      {
        d: "M11.843 6.187A4.947 4.947 0 0 1 16.5 7.5a4.947 4.947 0 0 1 1.313 4.657",
        key: "1sbrv4",
      },
    ],
    ["path", { d: "M14 16.5V14", key: "1maf8j" }],
    ["path", { d: "M14 6.5v1.843", key: "1a6u6t" }],
    ["path", { d: "M10 10v7.5", key: "80pj65" }],
    [
      "path",
      {
        d: "m16 7 1-5 1.367.683A3 3 0 0 0 19.708 3H21v1.292a3 3 0 0 0 .317 1.341L22 7l-5 1",
        key: "11a9mt",
      },
    ],
    [
      "path",
      {
        d: "m8 17-1 5-1.367-.683A3 3 0 0 0 4.292 21H3v-1.292a3 3 0 0 0-.317-1.341L2 17l5-1",
        key: "3mjmon",
      },
    ],
    ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Nt = e("Candy", [
    [
      "path",
      {
        d: "m9.5 7.5-2 2a4.95 4.95 0 1 0 7 7l2-2a4.95 4.95 0 1 0-7-7Z",
        key: "ue6khb",
      },
    ],
    ["path", { d: "M14 6.5v10", key: "5xnk7c" }],
    ["path", { d: "M10 7.5v10", key: "1uew51" }],
    [
      "path",
      {
        d: "m16 7 1-5 1.37.68A3 3 0 0 0 19.7 3H21v1.3c0 .46.1.92.32 1.33L22 7l-5 1",
        key: "b9cp6k",
      },
    ],
    [
      "path",
      {
        d: "m8 17-1 5-1.37-.68A3 3 0 0 0 4.3 21H3v-1.3a3 3 0 0 0-.32-1.33L2 17l5-1",
        key: "5lney8",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Xt = e("CaptionsOff", [
    ["path", { d: "M10.5 5H19a2 2 0 0 1 2 2v8.5", key: "jqtk4d" }],
    ["path", { d: "M17 11h-.5", key: "1961ue" }],
    ["path", { d: "M19 19H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2", key: "1keqsi" }],
    ["path", { d: "m2 2 20 20", key: "1ooewy" }],
    ["path", { d: "M7 11h4", key: "1o1z6v" }],
    ["path", { d: "M7 15h2.5", key: "1ina1g" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const U = e("Captions", [
    [
      "rect",
      {
        width: "18",
        height: "14",
        x: "3",
        y: "5",
        rx: "2",
        ry: "2",
        key: "12ruh7",
      },
    ],
    ["path", { d: "M7 15h4M15 15h2M7 11h2M13 11h4", key: "1ueiar" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Kt = e("CarFront", [
    [
      "path",
      {
        d: "m21 8-2 2-1.5-3.7A2 2 0 0 0 15.646 5H8.4a2 2 0 0 0-1.903 1.257L5 10 3 8",
        key: "1imjwt",
      },
    ],
    ["path", { d: "M7 14h.01", key: "1qa3f1" }],
    ["path", { d: "M17 14h.01", key: "7oqj8z" }],
    [
      "rect",
      { width: "18", height: "8", x: "3", y: "10", rx: "2", key: "a7itu8" },
    ],
    ["path", { d: "M5 18v2", key: "ppbyun" }],
    ["path", { d: "M19 18v2", key: "gy7782" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const _t = e("CarTaxiFront", [
    ["path", { d: "M10 2h4", key: "n1abiw" }],
    [
      "path",
      {
        d: "m21 8-2 2-1.5-3.7A2 2 0 0 0 15.646 5H8.4a2 2 0 0 0-1.903 1.257L5 10 3 8",
        key: "1imjwt",
      },
    ],
    ["path", { d: "M7 14h.01", key: "1qa3f1" }],
    ["path", { d: "M17 14h.01", key: "7oqj8z" }],
    [
      "rect",
      { width: "18", height: "8", x: "3", y: "10", rx: "2", key: "a7itu8" },
    ],
    ["path", { d: "M5 18v2", key: "ppbyun" }],
    ["path", { d: "M19 18v2", key: "gy7782" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Jt = e("Car", [
    [
      "path",
      {
        d: "M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9A3.7 3.7 0 0 0 2 12v4c0 .6.4 1 1 1h2",
        key: "5owen",
      },
    ],
    ["circle", { cx: "7", cy: "17", r: "2", key: "u2ysq9" }],
    ["path", { d: "M9 17h6", key: "r8uit2" }],
    ["circle", { cx: "17", cy: "17", r: "2", key: "axvx0g" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Qt = e("Caravan", [
    ["rect", { width: "4", height: "4", x: "2", y: "9", key: "1vcvhd" }],
    ["rect", { width: "4", height: "10", x: "10", y: "9", key: "1b7ev2" }],
    [
      "path",
      {
        d: "M18 19V9a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v8a2 2 0 0 0 2 2h2",
        key: "19jm3t",
      },
    ],
    ["circle", { cx: "8", cy: "19", r: "2", key: "t8fc5s" }],
    ["path", { d: "M10 19h12v-2", key: "1yu2qx" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Yt = e("Carrot", [
    [
      "path",
      {
        d: "M2.27 21.7s9.87-3.5 12.73-6.36a4.5 4.5 0 0 0-6.36-6.37C5.77 11.84 2.27 21.7 2.27 21.7zM8.64 14l-2.05-2.04M15.34 15l-2.46-2.46",
        key: "rfqxbe",
      },
    ],
    [
      "path",
      {
        d: "M22 9s-1.33-2-3.5-2C16.86 7 15 9 15 9s1.33 2 3.5 2S22 9 22 9z",
        key: "6b25w4",
      },
    ],
    [
      "path",
      {
        d: "M15 2s-2 1.33-2 3.5S15 9 15 9s2-1.84 2-3.5C17 3.33 15 2 15 2z",
        key: "fn65lo",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const $t = e("CaseLower", [
    ["circle", { cx: "7", cy: "12", r: "3", key: "12clwm" }],
    ["path", { d: "M10 9v6", key: "17i7lo" }],
    ["circle", { cx: "17", cy: "12", r: "3", key: "gl7c2s" }],
    ["path", { d: "M14 7v8", key: "dl84cr" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ec = e("CaseSensitive", [
    ["path", { d: "m3 15 4-8 4 8", key: "1vwr6u" }],
    ["path", { d: "M4 13h6", key: "1r9ots" }],
    ["circle", { cx: "18", cy: "12", r: "3", key: "1kchzo" }],
    ["path", { d: "M21 9v6", key: "anns31" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ac = e("CaseUpper", [
    ["path", { d: "m3 15 4-8 4 8", key: "1vwr6u" }],
    ["path", { d: "M4 13h6", key: "1r9ots" }],
    [
      "path",
      { d: "M15 11h4.5a2 2 0 0 1 0 4H15V7h4a2 2 0 0 1 0 4", key: "1sqfas" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const tc = e("CassetteTape", [
    [
      "rect",
      { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" },
    ],
    ["circle", { cx: "8", cy: "10", r: "2", key: "1xl4ub" }],
    ["path", { d: "M8 12h8", key: "1wcyev" }],
    ["circle", { cx: "16", cy: "10", r: "2", key: "r14t7q" }],
    [
      "path",
      {
        d: "m6 20 .7-2.9A1.4 1.4 0 0 1 8.1 16h7.8a1.4 1.4 0 0 1 1.4 1l.7 3",
        key: "l01ucn",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const cc = e("Cast", [
    [
      "path",
      {
        d: "M2 8V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-6",
        key: "3zrzxg",
      },
    ],
    ["path", { d: "M2 12a9 9 0 0 1 8 8", key: "g6cvee" }],
    ["path", { d: "M2 16a5 5 0 0 1 4 4", key: "1y1dii" }],
    ["line", { x1: "2", x2: "2.01", y1: "20", y2: "20", key: "xu2jvo" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const hc = e("Castle", [
    [
      "path",
      { d: "M22 20v-9H2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2Z", key: "109fe4" },
    ],
    ["path", { d: "M18 11V4H6v7", key: "mon5oj" }],
    ["path", { d: "M15 22v-4a3 3 0 0 0-3-3v0a3 3 0 0 0-3 3v4", key: "jdggr9" }],
    ["path", { d: "M22 11V9", key: "3zbp94" }],
    ["path", { d: "M2 11V9", key: "1x5rnq" }],
    ["path", { d: "M6 4V2", key: "1rsq15" }],
    ["path", { d: "M18 4V2", key: "1jsdo1" }],
    ["path", { d: "M10 4V2", key: "75d9ly" }],
    ["path", { d: "M14 4V2", key: "8nj3z6" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const dc = e("Cat", [
    [
      "path",
      {
        d: "M12 5c.67 0 1.35.09 2 .26 1.78-2 5.03-2.84 6.42-2.26 1.4.58-.42 7-.42 7 .57 1.07 1 2.24 1 3.44C21 17.9 16.97 21 12 21s-9-3-9-7.56c0-1.25.5-2.4 1-3.44 0 0-1.89-6.42-.5-7 1.39-.58 4.72.23 6.5 2.23A9.04 9.04 0 0 1 12 5Z",
        key: "x6xyqk",
      },
    ],
    ["path", { d: "M8 14v.5", key: "1nzgdb" }],
    ["path", { d: "M16 14v.5", key: "1lajdz" }],
    ["path", { d: "M11.25 16.25h1.5L12 17l-.75-.75Z", key: "12kq1m" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const oc = e("Cctv", [
    ["path", { d: "M7 9h.01", key: "19b3jx" }],
    ["path", { d: "M16.75 12H22l-3.5 7-3.09-4.32", key: "1h9vqe" }],
    [
      "path",
      {
        d: "M18 9.5l-4 8-10.39-5.2a2.92 2.92 0 0 1-1.3-3.91L3.69 5.6a2.92 2.92 0 0 1 3.92-1.3Z",
        key: "q5d122",
      },
    ],
    ["path", { d: "M2 19h3.76a2 2 0 0 0 1.8-1.1L9 15", key: "19bib8" }],
    ["path", { d: "M2 21v-4", key: "l40lih" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const yc = e("CheckCheck", [
    ["path", { d: "M18 6 7 17l-5-5", key: "116fxf" }],
    ["path", { d: "m22 10-7.5 7.5L13 16", key: "ke71qq" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ic = e("CheckCircle2", [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Z1 = e("CheckCircle", [
    ["path", { d: "M22 11.08V12a10 10 0 1 1-5.93-9.14", key: "g774vq" }],
    ["path", { d: "m9 11 3 3L22 4", key: "1pflzl" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const nc = e("CheckSquare2", [
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" },
    ],
    ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const rc = e("CheckSquare", [
    ["path", { d: "m9 11 3 3L22 4", key: "1pflzl" }],
    [
      "path",
      {
        d: "M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11",
        key: "1jnkn4",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const kc = e("Check", [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const pc = e("ChefHat", [
    [
      "path",
      {
        d: "M6 13.87A4 4 0 0 1 7.41 6a5.11 5.11 0 0 1 1.05-1.54 5 5 0 0 1 7.08 0A5.11 5.11 0 0 1 16.59 6 4 4 0 0 1 18 13.87V21H6Z",
        key: "z3ra2g",
      },
    ],
    ["line", { x1: "6", x2: "18", y1: "17", y2: "17", key: "12q60k" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const lc = e("Cherry", [
    [
      "path",
      {
        d: "M2 17a5 5 0 0 0 10 0c0-2.76-2.5-5-5-3-2.5-2-5 .24-5 3Z",
        key: "cvxqlc",
      },
    ],
    [
      "path",
      {
        d: "M12 17a5 5 0 0 0 10 0c0-2.76-2.5-5-5-3-2.5-2-5 .24-5 3Z",
        key: "1ostrc",
      },
    ],
    [
      "path",
      {
        d: "M7 14c3.22-2.91 4.29-8.75 5-12 1.66 2.38 4.94 9 5 12",
        key: "hqx58h",
      },
    ],
    [
      "path",
      { d: "M22 9c-4.29 0-7.14-2.33-10-7 5.71 0 10 4.67 10 7Z", key: "eykp1o" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const sc = e("ChevronDownCircle", [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["path", { d: "m16 10-4 4-4-4", key: "894hmk" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const uc = e("ChevronDownSquare", [
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" },
    ],
    ["path", { d: "m16 10-4 4-4-4", key: "894hmk" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Mc = e("ChevronDown", [
    ["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const vc = e("ChevronFirst", [
    ["path", { d: "m17 18-6-6 6-6", key: "1yerx2" }],
    ["path", { d: "M7 6v12", key: "1p53r6" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const mc = e("ChevronLast", [
    ["path", { d: "m7 18 6-6-6-6", key: "lwmzdw" }],
    ["path", { d: "M17 6v12", key: "1o0aio" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const xc = e("ChevronLeftCircle", [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["path", { d: "m14 16-4-4 4-4", key: "ojs7w8" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const gc = e("ChevronLeftSquare", [
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" },
    ],
    ["path", { d: "m14 16-4-4 4-4", key: "ojs7w8" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Lc = e("ChevronLeft", [
    ["path", { d: "m15 18-6-6 6-6", key: "1wnfg3" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const fc = e("ChevronRightCircle", [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["path", { d: "m10 8 4 4-4 4", key: "1wy4r4" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const wc = e("ChevronRightSquare", [
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" },
    ],
    ["path", { d: "m10 8 4 4-4 4", key: "1wy4r4" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ic = e("ChevronRight", [
    ["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Cc = e("ChevronUpCircle", [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["path", { d: "m8 14 4-4 4 4", key: "fy2ptz" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const bc = e("ChevronUpSquare", [
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" },
    ],
    ["path", { d: "m8 14 4-4 4 4", key: "fy2ptz" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Sc = e("ChevronUp", [
    ["path", { d: "m18 15-6-6-6 6", key: "153udz" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const qc = e("ChevronsDownUp", [
    ["path", { d: "m7 20 5-5 5 5", key: "13a0gw" }],
    ["path", { d: "m7 4 5 5 5-5", key: "1kwcof" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Hc = e("ChevronsDown", [
    ["path", { d: "m7 6 5 5 5-5", key: "1lc07p" }],
    ["path", { d: "m7 13 5 5 5-5", key: "1d48rs" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const zc = e("ChevronsLeftRight", [
    ["path", { d: "m9 7-5 5 5 5", key: "j5w590" }],
    ["path", { d: "m15 7 5 5-5 5", key: "1bl6da" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ac = e("ChevronsLeft", [
    ["path", { d: "m11 17-5-5 5-5", key: "13zhaf" }],
    ["path", { d: "m18 17-5-5 5-5", key: "h8a8et" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const jc = e("ChevronsRightLeft", [
    ["path", { d: "m20 17-5-5 5-5", key: "30x0n2" }],
    ["path", { d: "m4 17 5-5-5-5", key: "16spf4" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Vc = e("ChevronsRight", [
    ["path", { d: "m6 17 5-5-5-5", key: "xnjwq" }],
    ["path", { d: "m13 17 5-5-5-5", key: "17xmmf" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Pc = e("ChevronsUpDown", [
    ["path", { d: "m7 15 5 5 5-5", key: "1hf1tw" }],
    ["path", { d: "m7 9 5-5 5 5", key: "sgt6xg" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Fc = e("ChevronsUp", [
    ["path", { d: "m17 11-5-5-5 5", key: "e8nh98" }],
    ["path", { d: "m17 18-5-5-5 5", key: "2avn1x" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Bc = e("Chrome", [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
    ["line", { x1: "21.17", x2: "12", y1: "8", y2: "8", key: "a0cw5f" }],
    ["line", { x1: "3.95", x2: "8.54", y1: "6.06", y2: "14", key: "1kftof" }],
    [
      "line",
      { x1: "10.88", x2: "15.46", y1: "21.94", y2: "14", key: "1ymyh8" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Dc = e("Church", [
    [
      "path",
      { d: "m18 7 4 2v11a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9l4-2", key: "gy5gyo" },
    ],
    ["path", { d: "M14 22v-4a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v4", key: "cpkuc4" }],
    ["path", { d: "M18 22V5l-6-3-6 3v17", key: "1hsnhq" }],
    ["path", { d: "M12 7v5", key: "ma6bk" }],
    ["path", { d: "M10 9h4", key: "u4k05v" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Rc = e("CigaretteOff", [
    ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }],
    ["path", { d: "M12 12H2v4h14", key: "91gsaq" }],
    ["path", { d: "M22 12v4", key: "142cbu" }],
    ["path", { d: "M18 12h-.5", key: "12ymji" }],
    ["path", { d: "M7 12v4", key: "jqww69" }],
    ["path", { d: "M18 8c0-2.5-2-2.5-2-5", key: "1il607" }],
    ["path", { d: "M22 8c0-2.5-2-2.5-2-5", key: "1gah44" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Tc = e("Cigarette", [
    ["path", { d: "M18 12H2v4h16", key: "2rt1hm" }],
    ["path", { d: "M22 12v4", key: "142cbu" }],
    ["path", { d: "M7 12v4", key: "jqww69" }],
    ["path", { d: "M18 8c0-2.5-2-2.5-2-5", key: "1il607" }],
    ["path", { d: "M22 8c0-2.5-2-2.5-2-5", key: "1gah44" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Uc = e("CircleDashed", [
    ["path", { d: "M10.1 2.182a10 10 0 0 1 3.8 0", key: "5ilxe3" }],
    ["path", { d: "M13.9 21.818a10 10 0 0 1-3.8 0", key: "11zvb9" }],
    ["path", { d: "M17.609 3.721a10 10 0 0 1 2.69 2.7", key: "1iw5b2" }],
    ["path", { d: "M2.182 13.9a10 10 0 0 1 0-3.8", key: "c0bmvh" }],
    ["path", { d: "M20.279 17.609a10 10 0 0 1-2.7 2.69", key: "1ruxm7" }],
    ["path", { d: "M21.818 10.1a10 10 0 0 1 0 3.8", key: "qkgqxc" }],
    ["path", { d: "M3.721 6.391a10 10 0 0 1 2.7-2.69", key: "1mcia2" }],
    ["path", { d: "M6.391 20.279a10 10 0 0 1-2.69-2.7", key: "1fvljs" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Zc = e("CircleDollarSign", [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["path", { d: "M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8", key: "1h4pet" }],
    ["path", { d: "M12 18V6", key: "zqpxq5" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Oc = e("CircleDotDashed", [
    ["path", { d: "M10.1 2.18a9.93 9.93 0 0 1 3.8 0", key: "1qdqn0" }],
    ["path", { d: "M17.6 3.71a9.95 9.95 0 0 1 2.69 2.7", key: "1bq7p6" }],
    ["path", { d: "M21.82 10.1a9.93 9.93 0 0 1 0 3.8", key: "1rlaqf" }],
    ["path", { d: "M20.29 17.6a9.95 9.95 0 0 1-2.7 2.69", key: "1xk03u" }],
    ["path", { d: "M13.9 21.82a9.94 9.94 0 0 1-3.8 0", key: "l7re25" }],
    ["path", { d: "M6.4 20.29a9.95 9.95 0 0 1-2.69-2.7", key: "1v18p6" }],
    ["path", { d: "M2.18 13.9a9.93 9.93 0 0 1 0-3.8", key: "xdo6bj" }],
    ["path", { d: "M3.71 6.4a9.95 9.95 0 0 1 2.7-2.69", key: "1jjmaz" }],
    ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Gc = e("CircleDot", [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ec = e("CircleEllipsis", [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["path", { d: "M17 12h.01", key: "1m0b6t" }],
    ["path", { d: "M12 12h.01", key: "1mp3jc" }],
    ["path", { d: "M7 12h.01", key: "eqddd0" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Wc = e("CircleEqual", [
    ["path", { d: "M7 10h10", key: "1101jm" }],
    ["path", { d: "M7 14h10", key: "1mhdw3" }],
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Nc = e("CircleFadingPlus", [
    ["path", { d: "M12 2a10 10 0 0 1 7.38 16.75", key: "175t95" }],
    ["path", { d: "M12 8v8", key: "napkw2" }],
    ["path", { d: "M16 12H8", key: "1fr5h0" }],
    ["path", { d: "M2.5 8.875a10 10 0 0 0-.5 3", key: "1vce0s" }],
    ["path", { d: "M2.83 16a10 10 0 0 0 2.43 3.4", key: "o3fkw4" }],
    ["path", { d: "M4.636 5.235a10 10 0 0 1 .891-.857", key: "1szpfk" }],
    ["path", { d: "M8.644 21.42a10 10 0 0 0 7.631-.38", key: "9yhvd4" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Xc = e("CircleOff", [
    ["path", { d: "m2 2 20 20", key: "1ooewy" }],
    ["path", { d: "M8.35 2.69A10 10 0 0 1 21.3 15.65", key: "1pfsoa" }],
    ["path", { d: "M19.08 19.08A10 10 0 1 1 4.92 4.92", key: "1ablyi" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Z = e("CircleSlash2", [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["path", { d: "M22 2 2 22", key: "y4kqgn" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Kc = e("CircleSlash", [
    ["line", { x1: "9", x2: "15", y1: "15", y2: "9", key: "1dfufj" }],
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const O = e("CircleUserRound", [
    ["path", { d: "M18 20a6 6 0 0 0-12 0", key: "1qehca" }],
    ["circle", { cx: "12", cy: "10", r: "4", key: "1h16sb" }],
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const G = e("CircleUser", [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }],
    [
      "path",
      { d: "M7 20.662V19a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v1.662", key: "154egf" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const _c = e("Circle", [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Jc = e("CircuitBoard", [
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" },
    ],
    ["path", { d: "M11 9h4a2 2 0 0 0 2-2V3", key: "1ve2rv" }],
    ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }],
    ["path", { d: "M7 21v-4a2 2 0 0 1 2-2h4", key: "1fwkro" }],
    ["circle", { cx: "15", cy: "15", r: "2", key: "3i40o0" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Qc = e("Citrus", [
    [
      "path",
      {
        d: "M21.66 17.67a1.08 1.08 0 0 1-.04 1.6A12 12 0 0 1 4.73 2.38a1.1 1.1 0 0 1 1.61-.04z",
        key: "4ite01",
      },
    ],
    ["path", { d: "M19.65 15.66A8 8 0 0 1 8.35 4.34", key: "1gxipu" }],
    ["path", { d: "m14 10-5.5 5.5", key: "92pfem" }],
    ["path", { d: "M14 17.85V10H6.15", key: "xqmtsk" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Yc = e("Clapperboard", [
    [
      "path",
      {
        d: "M20.2 6 3 11l-.9-2.4c-.3-1.1.3-2.2 1.3-2.5l13.5-4c1.1-.3 2.2.3 2.5 1.3Z",
        key: "1tn4o7",
      },
    ],
    ["path", { d: "m6.2 5.3 3.1 3.9", key: "iuk76l" }],
    ["path", { d: "m12.4 3.4 3.1 4", key: "6hsd6n" }],
    ["path", { d: "M3 11h18v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Z", key: "ltgou9" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const $c = e("ClipboardCheck", [
    [
      "rect",
      {
        width: "8",
        height: "4",
        x: "8",
        y: "2",
        rx: "1",
        ry: "1",
        key: "tgr4d6",
      },
    ],
    [
      "path",
      {
        d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
        key: "116196",
      },
    ],
    ["path", { d: "m9 14 2 2 4-4", key: "df797q" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const eh = e("ClipboardCopy", [
    [
      "rect",
      {
        width: "8",
        height: "4",
        x: "8",
        y: "2",
        rx: "1",
        ry: "1",
        key: "tgr4d6",
      },
    ],
    [
      "path",
      {
        d: "M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2",
        key: "4jdomd",
      },
    ],
    ["path", { d: "M16 4h2a2 2 0 0 1 2 2v4", key: "3hqy98" }],
    ["path", { d: "M21 14H11", key: "1bme5i" }],
    ["path", { d: "m15 10-4 4 4 4", key: "5dvupr" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ah = e("ClipboardList", [
    [
      "rect",
      {
        width: "8",
        height: "4",
        x: "8",
        y: "2",
        rx: "1",
        ry: "1",
        key: "tgr4d6",
      },
    ],
    [
      "path",
      {
        d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
        key: "116196",
      },
    ],
    ["path", { d: "M12 11h4", key: "1jrz19" }],
    ["path", { d: "M12 16h4", key: "n85exb" }],
    ["path", { d: "M8 11h.01", key: "1dfujw" }],
    ["path", { d: "M8 16h.01", key: "18s6g9" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const th = e("ClipboardMinus", [
    [
      "rect",
      {
        width: "8",
        height: "4",
        x: "8",
        y: "2",
        rx: "1",
        ry: "1",
        key: "tgr4d6",
      },
    ],
    [
      "path",
      {
        d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
        key: "116196",
      },
    ],
    ["path", { d: "M9 14h6", key: "159ibu" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ch = e("ClipboardPaste", [
    [
      "path",
      {
        d: "M15 2H9a1 1 0 0 0-1 1v2c0 .6.4 1 1 1h6c.6 0 1-.4 1-1V3c0-.6-.4-1-1-1Z",
        key: "1pp7kr",
      },
    ],
    [
      "path",
      {
        d: "M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2M16 4h2a2 2 0 0 1 2 2v2M11 14h10",
        key: "2ik1ml",
      },
    ],
    ["path", { d: "m17 10 4 4-4 4", key: "vp2hj1" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const E = e("ClipboardPenLine", [
    [
      "rect",
      { width: "8", height: "4", x: "8", y: "2", rx: "1", key: "1oijnt" },
    ],
    [
      "path",
      {
        d: "M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-.5",
        key: "1but9f",
      },
    ],
    ["path", { d: "M16 4h2a2 2 0 0 1 1.73 1", key: "1p8n7l" }],
    ["path", { d: "M8 18h1", key: "13wk12" }],
    ["path", { d: "M18.4 9.6a2 2 0 0 1 3 3L17 17l-4 1 1-4Z", key: "yg2pdb" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const W = e("ClipboardPen", [
    [
      "rect",
      { width: "8", height: "4", x: "8", y: "2", rx: "1", key: "1oijnt" },
    ],
    ["path", { d: "M10.4 12.6a2 2 0 0 1 3 3L8 21l-4 1 1-4Z", key: "hnx206" }],
    [
      "path",
      { d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-5.5", key: "cereej" },
    ],
    ["path", { d: "M4 13.5V6a2 2 0 0 1 2-2h2", key: "5ua5vh" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const hh = e("ClipboardPlus", [
    [
      "rect",
      {
        width: "8",
        height: "4",
        x: "8",
        y: "2",
        rx: "1",
        ry: "1",
        key: "tgr4d6",
      },
    ],
    [
      "path",
      {
        d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
        key: "116196",
      },
    ],
    ["path", { d: "M9 14h6", key: "159ibu" }],
    ["path", { d: "M12 17v-6", key: "1y8rbf" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const dh = e("ClipboardType", [
    [
      "rect",
      {
        width: "8",
        height: "4",
        x: "8",
        y: "2",
        rx: "1",
        ry: "1",
        key: "tgr4d6",
      },
    ],
    [
      "path",
      {
        d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
        key: "116196",
      },
    ],
    ["path", { d: "M9 12v-1h6v1", key: "iehl6m" }],
    ["path", { d: "M11 17h2", key: "12w5me" }],
    ["path", { d: "M12 11v6", key: "1bwqyc" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const oh = e("ClipboardX", [
    [
      "rect",
      {
        width: "8",
        height: "4",
        x: "8",
        y: "2",
        rx: "1",
        ry: "1",
        key: "tgr4d6",
      },
    ],
    [
      "path",
      {
        d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
        key: "116196",
      },
    ],
    ["path", { d: "m15 11-6 6", key: "1toa9n" }],
    ["path", { d: "m9 11 6 6", key: "wlibny" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const yh = e("Clipboard", [
    [
      "rect",
      {
        width: "8",
        height: "4",
        x: "8",
        y: "2",
        rx: "1",
        ry: "1",
        key: "tgr4d6",
      },
    ],
    [
      "path",
      {
        d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
        key: "116196",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ih = e("Clock1", [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["polyline", { points: "12 6 12 12 14.5 8", key: "12zbmj" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const nh = e("Clock10", [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["polyline", { points: "12 6 12 12 8 10", key: "atfzqc" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const rh = e("Clock11", [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["polyline", { points: "12 6 12 12 9.5 8", key: "l5bg6f" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const kh = e("Clock12", [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["polyline", { points: "12 6 12 12", key: "1fub01" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ph = e("Clock2", [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["polyline", { points: "12 6 12 12 16 10", key: "1g230d" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const lh = e("Clock3", [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["polyline", { points: "12 6 12 12 16.5 12", key: "1aq6pp" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const sh = e("Clock4", [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["polyline", { points: "12 6 12 12 16 14", key: "68esgv" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const uh = e("Clock5", [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["polyline", { points: "12 6 12 12 14.5 16", key: "1pcbox" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Mh = e("Clock6", [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["polyline", { points: "12 6 12 12 12 16.5", key: "hb2qv6" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const vh = e("Clock7", [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["polyline", { points: "12 6 12 12 9.5 16", key: "ka3394" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const mh = e("Clock8", [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["polyline", { points: "12 6 12 12 8 14", key: "tmc9b4" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const xh = e("Clock9", [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["polyline", { points: "12 6 12 12 7.5 12", key: "1k60p0" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const gh = e("Clock", [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["polyline", { points: "12 6 12 12 16 14", key: "68esgv" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Lh = e("CloudCog", [
    ["circle", { cx: "12", cy: "17", r: "3", key: "1spfwm" }],
    [
      "path",
      {
        d: "M4.2 15.1A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.2",
        key: "zaobp",
      },
    ],
    ["path", { d: "m15.7 18.4-.9-.3", key: "4qxpbn" }],
    ["path", { d: "m9.2 15.9-.9-.3", key: "17q7o2" }],
    ["path", { d: "m10.6 20.7.3-.9", key: "1pf4s2" }],
    ["path", { d: "m13.1 14.2.3-.9", key: "1mnuqm" }],
    ["path", { d: "m13.6 20.7-.4-1", key: "1jpd1m" }],
    ["path", { d: "m10.8 14.3-.4-1", key: "17ugyy" }],
    ["path", { d: "m8.3 18.6 1-.4", key: "s42vdx" }],
    ["path", { d: "m14.7 15.8 1-.4", key: "2wizun" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const fh = e("CloudDrizzle", [
    [
      "path",
      {
        d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242",
        key: "1pljnt",
      },
    ],
    ["path", { d: "M8 19v1", key: "1dk2by" }],
    ["path", { d: "M8 14v1", key: "84yxot" }],
    ["path", { d: "M16 19v1", key: "v220m7" }],
    ["path", { d: "M16 14v1", key: "g12gj6" }],
    ["path", { d: "M12 21v1", key: "q8vafk" }],
    ["path", { d: "M12 16v1", key: "1mx6rx" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const wh = e("CloudFog", [
    [
      "path",
      {
        d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242",
        key: "1pljnt",
      },
    ],
    ["path", { d: "M16 17H7", key: "pygtm1" }],
    ["path", { d: "M17 21H9", key: "1u2q02" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ih = e("CloudHail", [
    [
      "path",
      {
        d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242",
        key: "1pljnt",
      },
    ],
    ["path", { d: "M16 14v2", key: "a1is7l" }],
    ["path", { d: "M8 14v2", key: "1e9m6t" }],
    ["path", { d: "M16 20h.01", key: "xwek51" }],
    ["path", { d: "M8 20h.01", key: "1vjney" }],
    ["path", { d: "M12 16v2", key: "z66u1j" }],
    ["path", { d: "M12 22h.01", key: "1urd7a" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ch = e("CloudLightning", [
    [
      "path",
      {
        d: "M6 16.326A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 .5 8.973",
        key: "1cez44",
      },
    ],
    ["path", { d: "m13 12-3 5h4l-3 5", key: "1t22er" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const bh = e("CloudMoonRain", [
    [
      "path",
      {
        d: "M10.083 9A6.002 6.002 0 0 1 16 4a4.243 4.243 0 0 0 6 6c0 2.22-1.206 4.16-3 5.197",
        key: "u82z8m",
      },
    ],
    ["path", { d: "M3 20a5 5 0 1 1 8.9-4H13a3 3 0 0 1 2 5.24", key: "1qmrp3" }],
    ["path", { d: "M11 20v2", key: "174qtz" }],
    ["path", { d: "M7 19v2", key: "12npes" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Sh = e("CloudMoon", [
    ["path", { d: "M13 16a3 3 0 1 1 0 6H7a5 5 0 1 1 4.9-6Z", key: "p44pc9" }],
    [
      "path",
      {
        d: "M10.1 9A6 6 0 0 1 16 4a4.24 4.24 0 0 0 6 6 6 6 0 0 1-3 5.197",
        key: "16nha0",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const qh = e("CloudOff", [
    ["path", { d: "m2 2 20 20", key: "1ooewy" }],
    [
      "path",
      {
        d: "M5.782 5.782A7 7 0 0 0 9 19h8.5a4.5 4.5 0 0 0 1.307-.193",
        key: "yfwify",
      },
    ],
    [
      "path",
      {
        d: "M21.532 16.5A4.5 4.5 0 0 0 17.5 10h-1.79A7.008 7.008 0 0 0 10 5.07",
        key: "jlfiyv",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Hh = e("CloudRainWind", [
    [
      "path",
      {
        d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242",
        key: "1pljnt",
      },
    ],
    ["path", { d: "m9.2 22 3-7", key: "sb5f6j" }],
    ["path", { d: "m9 13-3 7", key: "500co5" }],
    ["path", { d: "m17 13-3 7", key: "8t2fiy" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const zh = e("CloudRain", [
    [
      "path",
      {
        d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242",
        key: "1pljnt",
      },
    ],
    ["path", { d: "M16 14v6", key: "1j4efv" }],
    ["path", { d: "M8 14v6", key: "17c4r9" }],
    ["path", { d: "M12 16v6", key: "c8a4gj" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ah = e("CloudSnow", [
    [
      "path",
      {
        d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242",
        key: "1pljnt",
      },
    ],
    ["path", { d: "M8 15h.01", key: "a7atzg" }],
    ["path", { d: "M8 19h.01", key: "puxtts" }],
    ["path", { d: "M12 17h.01", key: "p32p05" }],
    ["path", { d: "M12 21h.01", key: "h35vbk" }],
    ["path", { d: "M16 15h.01", key: "rnfrdf" }],
    ["path", { d: "M16 19h.01", key: "1vcnzz" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const jh = e("CloudSunRain", [
    ["path", { d: "M12 2v2", key: "tus03m" }],
    ["path", { d: "m4.93 4.93 1.41 1.41", key: "149t6j" }],
    ["path", { d: "M20 12h2", key: "1q8mjw" }],
    ["path", { d: "m19.07 4.93-1.41 1.41", key: "1shlcs" }],
    ["path", { d: "M15.947 12.65a4 4 0 0 0-5.925-4.128", key: "dpwdj0" }],
    ["path", { d: "M3 20a5 5 0 1 1 8.9-4H13a3 3 0 0 1 2 5.24", key: "1qmrp3" }],
    ["path", { d: "M11 20v2", key: "174qtz" }],
    ["path", { d: "M7 19v2", key: "12npes" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Vh = e("CloudSun", [
    ["path", { d: "M12 2v2", key: "tus03m" }],
    ["path", { d: "m4.93 4.93 1.41 1.41", key: "149t6j" }],
    ["path", { d: "M20 12h2", key: "1q8mjw" }],
    ["path", { d: "m19.07 4.93-1.41 1.41", key: "1shlcs" }],
    ["path", { d: "M15.947 12.65a4 4 0 0 0-5.925-4.128", key: "dpwdj0" }],
    [
      "path",
      { d: "M13 22H7a5 5 0 1 1 4.9-6H13a3 3 0 0 1 0 6Z", key: "s09mg5" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ph = e("Cloud", [
    [
      "path",
      {
        d: "M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z",
        key: "p7xjir",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Fh = e("Cloudy", [
    [
      "path",
      {
        d: "M17.5 21H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z",
        key: "gqqjvc",
      },
    ],
    [
      "path",
      {
        d: "M22 10a3 3 0 0 0-3-3h-2.207a5.502 5.502 0 0 0-10.702.5",
        key: "1p2s76",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Bh = e("Clover", [
    ["path", { d: "M16.17 7.83 2 22", key: "t58vo8" }],
    [
      "path",
      {
        d: "M4.02 12a2.827 2.827 0 1 1 3.81-4.17A2.827 2.827 0 1 1 12 4.02a2.827 2.827 0 1 1 4.17 3.81A2.827 2.827 0 1 1 19.98 12a2.827 2.827 0 1 1-3.81 4.17A2.827 2.827 0 1 1 12 19.98a2.827 2.827 0 1 1-4.17-3.81A1 1 0 1 1 4 12",
        key: "17k36q",
      },
    ],
    ["path", { d: "m7.83 7.83 8.34 8.34", key: "1d7sxk" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Dh = e("Club", [
    [
      "path",
      {
        d: "M17.28 9.05a5.5 5.5 0 1 0-10.56 0A5.5 5.5 0 1 0 12 17.66a5.5 5.5 0 1 0 5.28-8.6Z",
        key: "27yuqz",
      },
    ],
    ["path", { d: "M12 17.66L12 22", key: "ogfahf" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Rh = e("Code2", [
    ["path", { d: "m18 16 4-4-4-4", key: "1inbqp" }],
    ["path", { d: "m6 8-4 4 4 4", key: "15zrgr" }],
    ["path", { d: "m14.5 4-5 16", key: "e7oirm" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const N = e("CodeSquare", [
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" },
    ],
    ["path", { d: "m10 10-2 2 2 2", key: "p6et6i" }],
    ["path", { d: "m14 14 2-2-2-2", key: "m075q2" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Th = e("Code", [
    ["polyline", { points: "16 18 22 12 16 6", key: "z7tu5w" }],
    ["polyline", { points: "8 6 2 12 8 18", key: "1eg1df" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Uh = e("Codepen", [
    [
      "polygon",
      { points: "12 2 22 8.5 22 15.5 12 22 2 15.5 2 8.5 12 2", key: "srzb37" },
    ],
    ["line", { x1: "12", x2: "12", y1: "22", y2: "15.5", key: "1t73f2" }],
    ["polyline", { points: "22 8.5 12 15.5 2 8.5", key: "ajlxae" }],
    ["polyline", { points: "2 15.5 12 8.5 22 15.5", key: "susrui" }],
    ["line", { x1: "12", x2: "12", y1: "2", y2: "8.5", key: "2cldga" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Zh = e("Codesandbox", [
    [
      "path",
      {
        d: "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z",
        key: "yt0hxn",
      },
    ],
    ["polyline", { points: "7.5 4.21 12 6.81 16.5 4.21", key: "fabo96" }],
    ["polyline", { points: "7.5 19.79 7.5 14.6 3 12", key: "z377f1" }],
    ["polyline", { points: "21 12 16.5 14.6 16.5 19.79", key: "9nrev1" }],
    ["polyline", { points: "3.27 6.96 12 12.01 20.73 6.96", key: "1180pa" }],
    ["line", { x1: "12", x2: "12", y1: "22.08", y2: "12", key: "3z3uq6" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Oh = e("Coffee", [
    ["path", { d: "M17 8h1a4 4 0 1 1 0 8h-1", key: "jx4kbh" }],
    ["path", { d: "M3 8h14v9a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4Z", key: "1bxrl0" }],
    ["line", { x1: "6", x2: "6", y1: "2", y2: "4", key: "1cr9l3" }],
    ["line", { x1: "10", x2: "10", y1: "2", y2: "4", key: "170wym" }],
    ["line", { x1: "14", x2: "14", y1: "2", y2: "4", key: "1c5f70" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Gh = e("Cog", [
    ["path", { d: "M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z", key: "sobvz5" }],
    ["path", { d: "M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z", key: "11i496" }],
    ["path", { d: "M12 2v2", key: "tus03m" }],
    ["path", { d: "M12 22v-2", key: "1osdcq" }],
    ["path", { d: "m17 20.66-1-1.73", key: "eq3orb" }],
    ["path", { d: "M11 10.27 7 3.34", key: "16pf9h" }],
    ["path", { d: "m20.66 17-1.73-1", key: "sg0v6f" }],
    ["path", { d: "m3.34 7 1.73 1", key: "1ulond" }],
    ["path", { d: "M14 12h8", key: "4f43i9" }],
    ["path", { d: "M2 12h2", key: "1t8f8n" }],
    ["path", { d: "m20.66 7-1.73 1", key: "1ow05n" }],
    ["path", { d: "m3.34 17 1.73-1", key: "nuk764" }],
    ["path", { d: "m17 3.34-1 1.73", key: "2wel8s" }],
    ["path", { d: "m11 13.73-4 6.93", key: "794ttg" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Eh = e("Coins", [
    ["circle", { cx: "8", cy: "8", r: "6", key: "3yglwk" }],
    ["path", { d: "M18.09 10.37A6 6 0 1 1 10.34 18", key: "t5s6rm" }],
    ["path", { d: "M7 6h1v4", key: "1obek4" }],
    ["path", { d: "m16.71 13.88.7.71-2.82 2.82", key: "1rbuyh" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const X = e("Columns2", [
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" },
    ],
    ["path", { d: "M12 3v18", key: "108xh3" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const K = e("Columns3", [
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" },
    ],
    ["path", { d: "M9 3v18", key: "fh3hqa" }],
    ["path", { d: "M15 3v18", key: "14nvp0" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Wh = e("Columns4", [
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" },
    ],
    ["path", { d: "M7.5 3v18", key: "w0wo6v" }],
    ["path", { d: "M12 3v18", key: "108xh3" }],
    ["path", { d: "M16.5 3v18", key: "10tjh1" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Nh = e("Combine", [
    [
      "rect",
      { width: "8", height: "8", x: "2", y: "2", rx: "2", key: "z1hh3n" },
    ],
    ["path", { d: "M14 2c1.1 0 2 .9 2 2v4c0 1.1-.9 2-2 2", key: "83orz6" }],
    ["path", { d: "M20 2c1.1 0 2 .9 2 2v4c0 1.1-.9 2-2 2", key: "k86dmt" }],
    ["path", { d: "M10 18H5c-1.7 0-3-1.3-3-3v-1", key: "6vokjl" }],
    ["polyline", { points: "7 21 10 18 7 15", key: "1k02g0" }],
    [
      "rect",
      { width: "8", height: "8", x: "14", y: "14", rx: "2", key: "1fa9i4" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Xh = e("Command", [
    [
      "path",
      {
        d: "M15 6v12a3 3 0 1 0 3-3H6a3 3 0 1 0 3 3V6a3 3 0 1 0-3 3h12a3 3 0 1 0-3-3",
        key: "11bfej",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Kh = e("Compass", [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    [
      "polygon",
      {
        points: "16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76",
        key: "m9r19z",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const _h = e("Component", [
    ["path", { d: "M5.5 8.5 9 12l-3.5 3.5L2 12l3.5-3.5Z", key: "1kciei" }],
    ["path", { d: "m12 2 3.5 3.5L12 9 8.5 5.5 12 2Z", key: "1ome0g" }],
    ["path", { d: "M18.5 8.5 22 12l-3.5 3.5L15 12l3.5-3.5Z", key: "vbupec" }],
    ["path", { d: "m12 15 3.5 3.5L12 22l-3.5-3.5L12 15Z", key: "16csic" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Jh = e("Computer", [
    [
      "rect",
      { width: "14", height: "8", x: "5", y: "2", rx: "2", key: "wc9tft" },
    ],
    [
      "rect",
      { width: "20", height: "8", x: "2", y: "14", rx: "2", key: "w68u3i" },
    ],
    ["path", { d: "M6 18h2", key: "rwmk9e" }],
    ["path", { d: "M12 18h6", key: "aqd8w3" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Qh = e("ConciergeBell", [
    [
      "path",
      {
        d: "M3 20a1 1 0 0 1-1-1v-1a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v1a1 1 0 0 1-1 1Z",
        key: "1pvr1r",
      },
    ],
    ["path", { d: "M20 16a8 8 0 1 0-16 0", key: "1pa543" }],
    ["path", { d: "M12 4v4", key: "1bq03y" }],
    ["path", { d: "M10 4h4", key: "1xpv9s" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Yh = e("Cone", [
    [
      "path",
      { d: "m20.9 18.55-8-15.98a1 1 0 0 0-1.8 0l-8 15.98", key: "53pte7" },
    ],
    ["ellipse", { cx: "12", cy: "19", rx: "9", ry: "3", key: "1ji25f" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const $h = e("Construction", [
    [
      "rect",
      { x: "2", y: "6", width: "20", height: "8", rx: "1", key: "1estib" },
    ],
    ["path", { d: "M17 14v7", key: "7m2elx" }],
    ["path", { d: "M7 14v7", key: "1cm7wv" }],
    ["path", { d: "M17 3v3", key: "1v4jwn" }],
    ["path", { d: "M7 3v3", key: "7o6guu" }],
    ["path", { d: "M10 14 2.3 6.3", key: "1023jk" }],
    ["path", { d: "m14 6 7.7 7.7", key: "1s8pl2" }],
    ["path", { d: "m8 6 8 8", key: "hl96qh" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ed = e("Contact2", [
    ["path", { d: "M16 18a4 4 0 0 0-8 0", key: "1lzouq" }],
    ["circle", { cx: "12", cy: "11", r: "3", key: "itu57m" }],
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" },
    ],
    ["line", { x1: "8", x2: "8", y1: "2", y2: "4", key: "1ff9gb" }],
    ["line", { x1: "16", x2: "16", y1: "2", y2: "4", key: "1ufoma" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ad = e("Contact", [
    ["path", { d: "M17 18a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2", key: "1mghuy" }],
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" },
    ],
    ["circle", { cx: "12", cy: "10", r: "2", key: "1yojzk" }],
    ["line", { x1: "8", x2: "8", y1: "2", y2: "4", key: "1ff9gb" }],
    ["line", { x1: "16", x2: "16", y1: "2", y2: "4", key: "1ufoma" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const td = e("Container", [
    [
      "path",
      {
        d: "M22 7.7c0-.6-.4-1.2-.8-1.5l-6.3-3.9a1.72 1.72 0 0 0-1.7 0l-10.3 6c-.5.2-.9.8-.9 1.4v6.6c0 .5.4 1.2.8 1.5l6.3 3.9a1.72 1.72 0 0 0 1.7 0l10.3-6c.5-.3.9-1 .9-1.5Z",
        key: "1t2lqe",
      },
    ],
    ["path", { d: "M10 21.9V14L2.1 9.1", key: "o7czzq" }],
    ["path", { d: "m10 14 11.9-6.9", key: "zm5e20" }],
    ["path", { d: "M14 19.8v-8.1", key: "159ecu" }],
    ["path", { d: "M18 17.5V9.4", key: "11uown" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const cd = e("Contrast", [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["path", { d: "M12 18a6 6 0 0 0 0-12v12z", key: "j4l70d" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const hd = e("Cookie", [
    [
      "path",
      {
        d: "M12 2a10 10 0 1 0 10 10 4 4 0 0 1-5-5 4 4 0 0 1-5-5",
        key: "laymnq",
      },
    ],
    ["path", { d: "M8.5 8.5v.01", key: "ue8clq" }],
    ["path", { d: "M16 15.5v.01", key: "14dtrp" }],
    ["path", { d: "M12 12v.01", key: "u5ubse" }],
    ["path", { d: "M11 17v.01", key: "1hyl5a" }],
    ["path", { d: "M7 14v.01", key: "uct60s" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const dd = e("CookingPot", [
    ["path", { d: "M2 12h20", key: "9i4pu4" }],
    ["path", { d: "M20 12v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-8", key: "u0tga0" }],
    ["path", { d: "m4 8 16-4", key: "16g0ng" }],
    [
      "path",
      {
        d: "m8.86 6.78-.45-1.81a2 2 0 0 1 1.45-2.43l1.94-.48a2 2 0 0 1 2.43 1.46l.45 1.8",
        key: "12cejc",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const od = e("CopyCheck", [
    ["path", { d: "m12 15 2 2 4-4", key: "2c609p" }],
    [
      "rect",
      {
        width: "14",
        height: "14",
        x: "8",
        y: "8",
        rx: "2",
        ry: "2",
        key: "17jyea",
      },
    ],
    [
      "path",
      {
        d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2",
        key: "zix9uf",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const yd = e("CopyMinus", [
    ["line", { x1: "12", x2: "18", y1: "15", y2: "15", key: "1nscbv" }],
    [
      "rect",
      {
        width: "14",
        height: "14",
        x: "8",
        y: "8",
        rx: "2",
        ry: "2",
        key: "17jyea",
      },
    ],
    [
      "path",
      {
        d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2",
        key: "zix9uf",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const id = e("CopyPlus", [
    ["line", { x1: "15", x2: "15", y1: "12", y2: "18", key: "1p7wdc" }],
    ["line", { x1: "12", x2: "18", y1: "15", y2: "15", key: "1nscbv" }],
    [
      "rect",
      {
        width: "14",
        height: "14",
        x: "8",
        y: "8",
        rx: "2",
        ry: "2",
        key: "17jyea",
      },
    ],
    [
      "path",
      {
        d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2",
        key: "zix9uf",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const nd = e("CopySlash", [
    ["line", { x1: "12", x2: "18", y1: "18", y2: "12", key: "ebkxgr" }],
    [
      "rect",
      {
        width: "14",
        height: "14",
        x: "8",
        y: "8",
        rx: "2",
        ry: "2",
        key: "17jyea",
      },
    ],
    [
      "path",
      {
        d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2",
        key: "zix9uf",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const rd = e("CopyX", [
    ["line", { x1: "12", x2: "18", y1: "12", y2: "18", key: "1rg63v" }],
    ["line", { x1: "12", x2: "18", y1: "18", y2: "12", key: "ebkxgr" }],
    [
      "rect",
      {
        width: "14",
        height: "14",
        x: "8",
        y: "8",
        rx: "2",
        ry: "2",
        key: "17jyea",
      },
    ],
    [
      "path",
      {
        d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2",
        key: "zix9uf",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const kd = e("Copy", [
    [
      "rect",
      {
        width: "14",
        height: "14",
        x: "8",
        y: "8",
        rx: "2",
        ry: "2",
        key: "17jyea",
      },
    ],
    [
      "path",
      {
        d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2",
        key: "zix9uf",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const pd = e("Copyleft", [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["path", { d: "M9.17 14.83a4 4 0 1 0 0-5.66", key: "1sveal" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ld = e("Copyright", [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["path", { d: "M14.83 14.83a4 4 0 1 1 0-5.66", key: "1i56pz" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const sd = e("CornerDownLeft", [
    ["polyline", { points: "9 10 4 15 9 20", key: "r3jprv" }],
    ["path", { d: "M20 4v7a4 4 0 0 1-4 4H4", key: "6o5b7l" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ud = e("CornerDownRight", [
    ["polyline", { points: "15 10 20 15 15 20", key: "1q7qjw" }],
    ["path", { d: "M4 4v7a4 4 0 0 0 4 4h12", key: "z08zvw" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Md = e("CornerLeftDown", [
    ["polyline", { points: "14 15 9 20 4 15", key: "nkc4i" }],
    ["path", { d: "M20 4h-7a4 4 0 0 0-4 4v12", key: "nbpdq2" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const vd = e("CornerLeftUp", [
    ["polyline", { points: "14 9 9 4 4 9", key: "m9oyvo" }],
    ["path", { d: "M20 20h-7a4 4 0 0 1-4-4V4", key: "1blwi3" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const md = e("CornerRightDown", [
    ["polyline", { points: "10 15 15 20 20 15", key: "axus6l" }],
    ["path", { d: "M4 4h7a4 4 0 0 1 4 4v12", key: "wcbgct" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const xd = e("CornerRightUp", [
    ["polyline", { points: "10 9 15 4 20 9", key: "1lr6px" }],
    ["path", { d: "M4 20h7a4 4 0 0 0 4-4V4", key: "1plgdj" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const gd = e("CornerUpLeft", [
    ["polyline", { points: "9 14 4 9 9 4", key: "881910" }],
    ["path", { d: "M20 20v-7a4 4 0 0 0-4-4H4", key: "1nkjon" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ld = e("CornerUpRight", [
    ["polyline", { points: "15 14 20 9 15 4", key: "1tbx3s" }],
    ["path", { d: "M4 20v-7a4 4 0 0 1 4-4h12", key: "1lu4f8" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const fd = e("Cpu", [
    [
      "rect",
      { x: "4", y: "4", width: "16", height: "16", rx: "2", key: "1vbyd7" },
    ],
    ["rect", { x: "9", y: "9", width: "6", height: "6", key: "o3kz5p" }],
    ["path", { d: "M15 2v2", key: "13l42r" }],
    ["path", { d: "M15 20v2", key: "15mkzm" }],
    ["path", { d: "M2 15h2", key: "1gxd5l" }],
    ["path", { d: "M2 9h2", key: "1bbxkp" }],
    ["path", { d: "M20 15h2", key: "19e6y8" }],
    ["path", { d: "M20 9h2", key: "19tzq7" }],
    ["path", { d: "M9 2v2", key: "165o2o" }],
    ["path", { d: "M9 20v2", key: "i2bqo8" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const wd = e("CreativeCommons", [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    [
      "path",
      {
        d: "M10 9.3a2.8 2.8 0 0 0-3.5 1 3.1 3.1 0 0 0 0 3.4 2.7 2.7 0 0 0 3.5 1",
        key: "1ss3eq",
      },
    ],
    [
      "path",
      {
        d: "M17 9.3a2.8 2.8 0 0 0-3.5 1 3.1 3.1 0 0 0 0 3.4 2.7 2.7 0 0 0 3.5 1",
        key: "1od56t",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Id = e("CreditCard", [
    [
      "rect",
      { width: "20", height: "14", x: "2", y: "5", rx: "2", key: "ynyp8z" },
    ],
    ["line", { x1: "2", x2: "22", y1: "10", y2: "10", key: "1b3vmo" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Cd = e("Croissant", [
    [
      "path",
      {
        d: "m4.6 13.11 5.79-3.21c1.89-1.05 4.79 1.78 3.71 3.71l-3.22 5.81C8.8 23.16.79 15.23 4.6 13.11Z",
        key: "1ozxlb",
      },
    ],
    [
      "path",
      {
        d: "m10.5 9.5-1-2.29C9.2 6.48 8.8 6 8 6H4.5C2.79 6 2 6.5 2 8.5a7.71 7.71 0 0 0 2 4.83",
        key: "ffuyb5",
      },
    ],
    ["path", { d: "M8 6c0-1.55.24-4-2-4-2 0-2.5 2.17-2.5 4", key: "osnpzi" }],
    [
      "path",
      {
        d: "m14.5 13.5 2.29 1c.73.3 1.21.7 1.21 1.5v3.5c0 1.71-.5 2.5-2.5 2.5a7.71 7.71 0 0 1-4.83-2",
        key: "1vubaw",
      },
    ],
    [
      "path",
      { d: "M18 16c1.55 0 4-.24 4 2 0 2-2.17 2.5-4 2.5", key: "wxr772" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const bd = e("Crop", [
    ["path", { d: "M6 2v14a2 2 0 0 0 2 2h14", key: "ron5a4" }],
    ["path", { d: "M18 22V8a2 2 0 0 0-2-2H2", key: "7s9ehn" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Sd = e("Cross", [
    [
      "path",
      {
        d: "M11 2a2 2 0 0 0-2 2v5H4a2 2 0 0 0-2 2v2c0 1.1.9 2 2 2h5v5c0 1.1.9 2 2 2h2a2 2 0 0 0 2-2v-5h5a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2h-5V4a2 2 0 0 0-2-2h-2z",
        key: "1t5g7j",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const qd = e("Crosshair", [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["line", { x1: "22", x2: "18", y1: "12", y2: "12", key: "l9bcsi" }],
    ["line", { x1: "6", x2: "2", y1: "12", y2: "12", key: "13hhkx" }],
    ["line", { x1: "12", x2: "12", y1: "6", y2: "2", key: "10w3f3" }],
    ["line", { x1: "12", x2: "12", y1: "22", y2: "18", key: "15g9kq" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Hd = e("Crown", [
    [
      "path",
      { d: "m2 4 3 12h14l3-12-6 7-4-7-4 7-6-7zm3 16h14", key: "zkxr6b" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const zd = e("Cuboid", [
    [
      "path",
      {
        d: "m21.12 6.4-6.05-4.06a2 2 0 0 0-2.17-.05L2.95 8.41a2 2 0 0 0-.95 1.7v5.82a2 2 0 0 0 .88 1.66l6.05 4.07a2 2 0 0 0 2.17.05l9.95-6.12a2 2 0 0 0 .95-1.7V8.06a2 2 0 0 0-.88-1.66Z",
        key: "1u2ovd",
      },
    ],
    ["path", { d: "M10 22v-8L2.25 9.15", key: "11pn4q" }],
    ["path", { d: "m10 14 11.77-6.87", key: "1kt1wh" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ad = e("CupSoda", [
    [
      "path",
      {
        d: "m6 8 1.75 12.28a2 2 0 0 0 2 1.72h4.54a2 2 0 0 0 2-1.72L18 8",
        key: "8166m8",
      },
    ],
    ["path", { d: "M5 8h14", key: "pcz4l3" }],
    [
      "path",
      { d: "M7 15a6.47 6.47 0 0 1 5 0 6.47 6.47 0 0 0 5 0", key: "yjz344" },
    ],
    ["path", { d: "m12 8 1-6h2", key: "3ybfa4" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const jd = e("Currency", [
    ["circle", { cx: "12", cy: "12", r: "8", key: "46899m" }],
    ["line", { x1: "3", x2: "6", y1: "3", y2: "6", key: "1jkytn" }],
    ["line", { x1: "21", x2: "18", y1: "3", y2: "6", key: "14zfjt" }],
    ["line", { x1: "3", x2: "6", y1: "21", y2: "18", key: "iusuec" }],
    ["line", { x1: "21", x2: "18", y1: "21", y2: "18", key: "yj2dd7" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Vd = e("Cylinder", [
    ["ellipse", { cx: "12", cy: "5", rx: "9", ry: "3", key: "msslwz" }],
    ["path", { d: "M3 5v14a9 3 0 0 0 18 0V5", key: "aqi0yr" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Pd = e("DatabaseBackup", [
    ["ellipse", { cx: "12", cy: "5", rx: "9", ry: "3", key: "msslwz" }],
    ["path", { d: "M3 12a9 3 0 0 0 5 2.69", key: "1ui2ym" }],
    ["path", { d: "M21 9.3V5", key: "6k6cib" }],
    ["path", { d: "M3 5v14a9 3 0 0 0 6.47 2.88", key: "i62tjy" }],
    ["path", { d: "M12 12v4h4", key: "1bxaet" }],
    [
      "path",
      {
        d: "M13 20a5 5 0 0 0 9-3 4.5 4.5 0 0 0-4.5-4.5c-1.33 0-2.54.54-3.41 1.41L12 16",
        key: "1f4ei9",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Fd = e("DatabaseZap", [
    ["ellipse", { cx: "12", cy: "5", rx: "9", ry: "3", key: "msslwz" }],
    ["path", { d: "M3 5V19A9 3 0 0 0 15 21.84", key: "14ibmq" }],
    ["path", { d: "M21 5V8", key: "1marbg" }],
    ["path", { d: "M21 12L18 17H22L19 22", key: "zafso" }],
    ["path", { d: "M3 12A9 3 0 0 0 14.59 14.87", key: "1y4wr8" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Bd = e("Database", [
    ["ellipse", { cx: "12", cy: "5", rx: "9", ry: "3", key: "msslwz" }],
    ["path", { d: "M3 5V19A9 3 0 0 0 21 19V5", key: "1wlel7" }],
    ["path", { d: "M3 12A9 3 0 0 0 21 12", key: "mv7ke4" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Dd = e("Delete", [
    [
      "path",
      {
        d: "M20 5H9l-7 7 7 7h11a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2Z",
        key: "1oy587",
      },
    ],
    ["line", { x1: "18", x2: "12", y1: "9", y2: "15", key: "1olkx5" }],
    ["line", { x1: "12", x2: "18", y1: "9", y2: "15", key: "1n50pc" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Rd = e("Dessert", [
    ["circle", { cx: "12", cy: "4", r: "2", key: "muu5ef" }],
    [
      "path",
      {
        d: "M10.2 3.2C5.5 4 2 8.1 2 13a2 2 0 0 0 4 0v-1a2 2 0 0 1 4 0v4a2 2 0 0 0 4 0v-4a2 2 0 0 1 4 0v1a2 2 0 0 0 4 0c0-4.9-3.5-9-8.2-9.8",
        key: "lfo06j",
      },
    ],
    ["path", { d: "M3.2 14.8a9 9 0 0 0 17.6 0", key: "12xarc" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Td = e("Diameter", [
    ["circle", { cx: "19", cy: "19", r: "2", key: "17f5cg" }],
    ["circle", { cx: "5", cy: "5", r: "2", key: "1gwv83" }],
    ["path", { d: "M6.48 3.66a10 10 0 0 1 13.86 13.86", key: "xr8kdq" }],
    ["path", { d: "m6.41 6.41 11.18 11.18", key: "uhpjw7" }],
    ["path", { d: "M3.66 6.48a10 10 0 0 0 13.86 13.86", key: "cldpwv" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ud = e("Diamond", [
    [
      "path",
      {
        d: "M2.7 10.3a2.41 2.41 0 0 0 0 3.41l7.59 7.59a2.41 2.41 0 0 0 3.41 0l7.59-7.59a2.41 2.41 0 0 0 0-3.41l-7.59-7.59a2.41 2.41 0 0 0-3.41 0Z",
        key: "1f1r0c",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Zd = e("Dice1", [
    [
      "rect",
      {
        width: "18",
        height: "18",
        x: "3",
        y: "3",
        rx: "2",
        ry: "2",
        key: "1m3agn",
      },
    ],
    ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Od = e("Dice2", [
    [
      "rect",
      {
        width: "18",
        height: "18",
        x: "3",
        y: "3",
        rx: "2",
        ry: "2",
        key: "1m3agn",
      },
    ],
    ["path", { d: "M15 9h.01", key: "x1ddxp" }],
    ["path", { d: "M9 15h.01", key: "fzyn71" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Gd = e("Dice3", [
    [
      "rect",
      {
        width: "18",
        height: "18",
        x: "3",
        y: "3",
        rx: "2",
        ry: "2",
        key: "1m3agn",
      },
    ],
    ["path", { d: "M16 8h.01", key: "cr5u4v" }],
    ["path", { d: "M12 12h.01", key: "1mp3jc" }],
    ["path", { d: "M8 16h.01", key: "18s6g9" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ed = e("Dice4", [
    [
      "rect",
      {
        width: "18",
        height: "18",
        x: "3",
        y: "3",
        rx: "2",
        ry: "2",
        key: "1m3agn",
      },
    ],
    ["path", { d: "M16 8h.01", key: "cr5u4v" }],
    ["path", { d: "M8 8h.01", key: "1e4136" }],
    ["path", { d: "M8 16h.01", key: "18s6g9" }],
    ["path", { d: "M16 16h.01", key: "1f9h7w" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Wd = e("Dice5", [
    [
      "rect",
      {
        width: "18",
        height: "18",
        x: "3",
        y: "3",
        rx: "2",
        ry: "2",
        key: "1m3agn",
      },
    ],
    ["path", { d: "M16 8h.01", key: "cr5u4v" }],
    ["path", { d: "M8 8h.01", key: "1e4136" }],
    ["path", { d: "M8 16h.01", key: "18s6g9" }],
    ["path", { d: "M16 16h.01", key: "1f9h7w" }],
    ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Nd = e("Dice6", [
    [
      "rect",
      {
        width: "18",
        height: "18",
        x: "3",
        y: "3",
        rx: "2",
        ry: "2",
        key: "1m3agn",
      },
    ],
    ["path", { d: "M16 8h.01", key: "cr5u4v" }],
    ["path", { d: "M16 12h.01", key: "1l6xoz" }],
    ["path", { d: "M16 16h.01", key: "1f9h7w" }],
    ["path", { d: "M8 8h.01", key: "1e4136" }],
    ["path", { d: "M8 12h.01", key: "czm47f" }],
    ["path", { d: "M8 16h.01", key: "18s6g9" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Xd = e("Dices", [
    [
      "rect",
      {
        width: "12",
        height: "12",
        x: "2",
        y: "10",
        rx: "2",
        ry: "2",
        key: "6agr2n",
      },
    ],
    [
      "path",
      {
        d: "m17.92 14 3.5-3.5a2.24 2.24 0 0 0 0-3l-5-4.92a2.24 2.24 0 0 0-3 0L10 6",
        key: "1o487t",
      },
    ],
    ["path", { d: "M6 18h.01", key: "uhywen" }],
    ["path", { d: "M10 14h.01", key: "ssrbsk" }],
    ["path", { d: "M15 6h.01", key: "cblpky" }],
    ["path", { d: "M18 9h.01", key: "2061c0" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Kd = e("Diff", [
    ["path", { d: "M12 3v14", key: "7cf3v8" }],
    ["path", { d: "M5 10h14", key: "elsbfy" }],
    ["path", { d: "M5 21h14", key: "11awu3" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const _d = e("Disc2", [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
    ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Jd = e("Disc3", [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["path", { d: "M6 12c0-1.7.7-3.2 1.8-4.2", key: "oqkarx" }],
    ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }],
    ["path", { d: "M18 12c0 1.7-.7 3.2-1.8 4.2", key: "1eah9h" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Qd = e("DiscAlbum", [
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" },
    ],
    ["circle", { cx: "12", cy: "12", r: "5", key: "nd82uf" }],
    ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Yd = e("Disc", [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const $d = e("DivideCircle", [
    ["line", { x1: "8", x2: "16", y1: "12", y2: "12", key: "1jonct" }],
    ["line", { x1: "12", x2: "12", y1: "16", y2: "16", key: "aqc6ln" }],
    ["line", { x1: "12", x2: "12", y1: "8", y2: "8", key: "1mkcni" }],
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const eo = e("DivideSquare", [
    [
      "rect",
      {
        width: "18",
        height: "18",
        x: "3",
        y: "3",
        rx: "2",
        ry: "2",
        key: "1m3agn",
      },
    ],
    ["line", { x1: "8", x2: "16", y1: "12", y2: "12", key: "1jonct" }],
    ["line", { x1: "12", x2: "12", y1: "16", y2: "16", key: "aqc6ln" }],
    ["line", { x1: "12", x2: "12", y1: "8", y2: "8", key: "1mkcni" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ao = e("Divide", [
    ["circle", { cx: "12", cy: "6", r: "1", key: "1bh7o1" }],
    ["line", { x1: "5", x2: "19", y1: "12", y2: "12", key: "13b5wn" }],
    ["circle", { cx: "12", cy: "18", r: "1", key: "lqb9t5" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const to = e("DnaOff", [
    [
      "path",
      {
        d: "M15 2c-1.35 1.5-2.092 3-2.5 4.5M9 22c1.35-1.5 2.092-3 2.5-4.5",
        key: "sxiaad",
      },
    ],
    [
      "path",
      {
        d: "M2 15c3.333-3 6.667-3 10-3m10-3c-1.5 1.35-3 2.092-4.5 2.5",
        key: "yn4bs1",
      },
    ],
    ["path", { d: "m17 6-2.5-2.5", key: "5cdfhj" }],
    ["path", { d: "m14 8-1.5-1.5", key: "1ohn8i" }],
    ["path", { d: "m7 18 2.5 2.5", key: "16tu1a" }],
    ["path", { d: "m3.5 14.5.5.5", key: "hapbhd" }],
    ["path", { d: "m20 9 .5.5", key: "1n7z02" }],
    ["path", { d: "m6.5 12.5 1 1", key: "cs35ky" }],
    ["path", { d: "m16.5 10.5 1 1", key: "696xn5" }],
    ["path", { d: "m10 16 1.5 1.5", key: "11lckj" }],
    ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const co = e("Dna", [
    ["path", { d: "M2 15c6.667-6 13.333 0 20-6", key: "1pyr53" }],
    ["path", { d: "M9 22c1.798-1.998 2.518-3.995 2.807-5.993", key: "q3hbxp" }],
    [
      "path",
      { d: "M15 2c-1.798 1.998-2.518 3.995-2.807 5.993", key: "80uv8i" },
    ],
    ["path", { d: "m17 6-2.5-2.5", key: "5cdfhj" }],
    ["path", { d: "m14 8-1-1", key: "15nbz5" }],
    ["path", { d: "m7 18 2.5 2.5", key: "16tu1a" }],
    ["path", { d: "m3.5 14.5.5.5", key: "hapbhd" }],
    ["path", { d: "m20 9 .5.5", key: "1n7z02" }],
    ["path", { d: "m6.5 12.5 1 1", key: "cs35ky" }],
    ["path", { d: "m16.5 10.5 1 1", key: "696xn5" }],
    ["path", { d: "m10 16 1.5 1.5", key: "11lckj" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ho = e("Dog", [
    [
      "path",
      {
        d: "M10 5.172C10 3.782 8.423 2.679 6.5 3c-2.823.47-4.113 6.006-4 7 .08.703 1.725 1.722 3.656 1 1.261-.472 1.96-1.45 2.344-2.5",
        key: "19br0u",
      },
    ],
    [
      "path",
      {
        d: "M14.267 5.172c0-1.39 1.577-2.493 3.5-2.172 2.823.47 4.113 6.006 4 7-.08.703-1.725 1.722-3.656 1-1.261-.472-1.855-1.45-2.239-2.5",
        key: "11n1an",
      },
    ],
    ["path", { d: "M8 14v.5", key: "1nzgdb" }],
    ["path", { d: "M16 14v.5", key: "1lajdz" }],
    ["path", { d: "M11.25 16.25h1.5L12 17l-.75-.75Z", key: "12kq1m" }],
    [
      "path",
      {
        d: "M4.42 11.247A13.152 13.152 0 0 0 4 14.556C4 18.728 7.582 21 12 21s8-2.272 8-6.444c0-1.061-.162-2.2-.493-3.309m-9.243-6.082A8.801 8.801 0 0 1 12 5c.78 0 1.5.108 2.161.306",
        key: "wsu29d",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const oo = e("DollarSign", [
    ["line", { x1: "12", x2: "12", y1: "2", y2: "22", key: "7eqyqh" }],
    [
      "path",
      { d: "M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6", key: "1b0p4s" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const yo = e("Donut", [
    [
      "path",
      {
        d: "M20.5 10a2.5 2.5 0 0 1-2.4-3H18a2.95 2.95 0 0 1-2.6-4.4 10 10 0 1 0 6.3 7.1c-.3.2-.8.3-1.2.3",
        key: "19sr3x",
      },
    ],
    ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const io = e("DoorClosed", [
    ["path", { d: "M18 20V6a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v14", key: "36qu9e" }],
    ["path", { d: "M2 20h20", key: "owomy5" }],
    ["path", { d: "M14 12v.01", key: "xfcn54" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const no = e("DoorOpen", [
    ["path", { d: "M13 4h3a2 2 0 0 1 2 2v14", key: "hrm0s9" }],
    ["path", { d: "M2 20h3", key: "1gaodv" }],
    ["path", { d: "M13 20h9", key: "s90cdi" }],
    ["path", { d: "M10 12v.01", key: "vx6srw" }],
    [
      "path",
      {
        d: "M13 4.562v16.157a1 1 0 0 1-1.242.97L5 20V5.562a2 2 0 0 1 1.515-1.94l4-1A2 2 0 0 1 13 4.561Z",
        key: "199qr4",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const _ = e("DotSquare", [
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" },
    ],
    ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ro = e("Dot", [
    ["circle", { cx: "12.1", cy: "12.1", r: "1", key: "18d7e5" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ko = e("DownloadCloud", [
    [
      "path",
      {
        d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242",
        key: "1pljnt",
      },
    ],
    ["path", { d: "M12 12v9", key: "192myk" }],
    ["path", { d: "m8 17 4 4 4-4", key: "1ul180" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const po = e("Download", [
    ["path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4", key: "ih7n3h" }],
    ["polyline", { points: "7 10 12 15 17 10", key: "2ggqvy" }],
    ["line", { x1: "12", x2: "12", y1: "15", y2: "3", key: "1vk2je" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const lo = e("DraftingCompass", [
    ["circle", { cx: "12", cy: "5", r: "2", key: "f1ur92" }],
    ["path", { d: "m3 21 8.02-14.26", key: "1ssaw4" }],
    ["path", { d: "m12.99 6.74 1.93 3.44", key: "iwagvd" }],
    ["path", { d: "M19 12c-3.87 4-10.13 4-14 0", key: "1tsu18" }],
    ["path", { d: "m21 21-2.16-3.84", key: "vylbct" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const so = e("Drama", [
    ["path", { d: "M10 11h.01", key: "d2at3l" }],
    ["path", { d: "M14 6h.01", key: "k028ub" }],
    ["path", { d: "M18 6h.01", key: "1v4wsw" }],
    ["path", { d: "M6.5 13.1h.01", key: "1748ia" }],
    [
      "path",
      { d: "M22 5c0 9-4 12-6 12s-6-3-6-12c0-2 2-3 6-3s6 1 6 3", key: "172yzv" },
    ],
    ["path", { d: "M17.4 9.9c-.8.8-2 .8-2.8 0", key: "1obv0w" }],
    [
      "path",
      {
        d: "M10.1 7.1C9 7.2 7.7 7.7 6 8.6c-3.5 2-4.7 3.9-3.7 5.6 4.5 7.8 9.5 8.4 11.2 7.4.9-.5 1.9-2.1 1.9-4.7",
        key: "rqjl8i",
      },
    ],
    ["path", { d: "M9.1 16.5c.3-1.1 1.4-1.7 2.4-1.4", key: "1mr6wy" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const uo = e("Dribbble", [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["path", { d: "M19.13 5.09C15.22 9.14 10 10.44 2.25 10.94", key: "hpej1" }],
    [
      "path",
      { d: "M21.75 12.84c-6.62-1.41-12.14 1-16.38 6.32", key: "1tr44o" },
    ],
    ["path", { d: "M8.56 2.75c4.37 6 6 9.42 8 17.72", key: "kbh691" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Mo = e("Drill", [
    [
      "path",
      {
        d: "M14 9c0 .6-.4 1-1 1H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9c.6 0 1 .4 1 1Z",
        key: "b6nnkj",
      },
    ],
    ["path", { d: "M18 6h4", key: "66u95g" }],
    ["path", { d: "M14 4h3a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-3", key: "105ega" }],
    ["path", { d: "m5 10-2 8", key: "xt2lic" }],
    ["path", { d: "M12 10v3c0 .6-.4 1-1 1H8", key: "mwpjnk" }],
    ["path", { d: "m7 18 2-8", key: "1bzku2" }],
    [
      "path",
      {
        d: "M5 22c-1.7 0-3-1.3-3-3 0-.6.4-1 1-1h7c.6 0 1 .4 1 1v2c0 .6-.4 1-1 1Z",
        key: "117add",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const vo = e("Droplet", [
    [
      "path",
      {
        d: "M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-6.5c-.5 2.5-2 4.9-4 6.5C6 11.1 5 13 5 15a7 7 0 0 0 7 7z",
        key: "c7niix",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const mo = e("Droplets", [
    [
      "path",
      {
        d: "M7 16.3c2.2 0 4-1.83 4-4.05 0-1.16-.57-2.26-1.71-3.19S7.29 6.75 7 5.3c-.29 1.45-1.14 2.84-2.29 3.76S3 11.1 3 12.25c0 2.22 1.8 4.05 4 4.05z",
        key: "1ptgy4",
      },
    ],
    [
      "path",
      {
        d: "M12.56 6.6A10.97 10.97 0 0 0 14 3.02c.5 2.5 2 4.9 4 6.5s3 3.5 3 5.5a6.98 6.98 0 0 1-11.91 4.97",
        key: "1sl1rz",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const xo = e("Drum", [
    ["path", { d: "m2 2 8 8", key: "1v6059" }],
    ["path", { d: "m22 2-8 8", key: "173r8a" }],
    ["ellipse", { cx: "12", cy: "9", rx: "10", ry: "5", key: "liohsx" }],
    ["path", { d: "M7 13.4v7.9", key: "1yi6u9" }],
    ["path", { d: "M12 14v8", key: "1tn2tj" }],
    ["path", { d: "M17 13.4v7.9", key: "eqz2v3" }],
    ["path", { d: "M2 9v8a10 5 0 0 0 20 0V9", key: "1750ul" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const go = e("Drumstick", [
    [
      "path",
      {
        d: "M15.45 15.4c-2.13.65-4.3.32-5.7-1.1-2.29-2.27-1.76-6.5 1.17-9.42 2.93-2.93 7.15-3.46 9.43-1.18 1.41 1.41 1.74 3.57 1.1 5.71-1.4-.51-3.26-.02-4.64 1.36-1.38 1.38-1.87 3.23-1.36 4.63z",
        key: "1o96s0",
      },
    ],
    [
      "path",
      {
        d: "m11.25 15.6-2.16 2.16a2.5 2.5 0 1 1-4.56 1.73 2.49 2.49 0 0 1-1.41-4.24 2.5 2.5 0 0 1 3.14-.32l2.16-2.16",
        key: "14vv5h",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Lo = e("Dumbbell", [
    ["path", { d: "m6.5 6.5 11 11", key: "f7oqzb" }],
    ["path", { d: "m21 21-1-1", key: "cpc6if" }],
    ["path", { d: "m3 3 1 1", key: "d3rpuf" }],
    ["path", { d: "m18 22 4-4", key: "1e32o6" }],
    ["path", { d: "m2 6 4-4", key: "189tqz" }],
    ["path", { d: "m3 10 7-7", key: "1bxui2" }],
    ["path", { d: "m14 21 7-7", key: "16x78n" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const fo = e("EarOff", [
    [
      "path",
      {
        d: "M6 18.5a3.5 3.5 0 1 0 7 0c0-1.57.92-2.52 2.04-3.46",
        key: "1qngmn",
      },
    ],
    ["path", { d: "M6 8.5c0-.75.13-1.47.36-2.14", key: "b06bma" }],
    [
      "path",
      {
        d: "M8.8 3.15A6.5 6.5 0 0 1 19 8.5c0 1.63-.44 2.81-1.09 3.76",
        key: "g10hsz",
      },
    ],
    [
      "path",
      {
        d: "M12.5 6A2.5 2.5 0 0 1 15 8.5M10 13a2 2 0 0 0 1.82-1.18",
        key: "ygzou7",
      },
    ],
    ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const wo = e("Ear", [
    [
      "path",
      {
        d: "M6 8.5a6.5 6.5 0 1 1 13 0c0 6-6 6-6 10a3.5 3.5 0 1 1-7 0",
        key: "1dfaln",
      },
    ],
    ["path", { d: "M15 8.5a2.5 2.5 0 0 0-5 0v1a2 2 0 1 1 0 4", key: "1qnva7" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Io = e("EarthLock", [
    ["path", { d: "M7 3.34V5a3 3 0 0 0 3 3", key: "w732o8" }],
    [
      "path",
      {
        d: "M11 21.95V18a2 2 0 0 0-2-2 2 2 0 0 1-2-2v-1a2 2 0 0 0-2-2H2.05",
        key: "f02343",
      },
    ],
    ["path", { d: "M21.54 15H17a2 2 0 0 0-2 2v4.54", key: "1djwo0" }],
    ["path", { d: "M12 2a10 10 0 1 0 9.54 13", key: "zjsr6q" }],
    ["path", { d: "M20 6V4a2 2 0 1 0-4 0v2", key: "1of5e8" }],
    [
      "rect",
      { width: "8", height: "5", x: "14", y: "6", rx: "1", key: "1fmf51" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const J = e("Earth", [
    ["path", { d: "M21.54 15H17a2 2 0 0 0-2 2v4.54", key: "1djwo0" }],
    [
      "path",
      {
        d: "M7 3.34V5a3 3 0 0 0 3 3v0a2 2 0 0 1 2 2v0c0 1.1.9 2 2 2v0a2 2 0 0 0 2-2v0c0-1.1.9-2 2-2h3.17",
        key: "1fi5u6",
      },
    ],
    [
      "path",
      {
        d: "M11 21.95V18a2 2 0 0 0-2-2v0a2 2 0 0 1-2-2v-1a2 2 0 0 0-2-2H2.05",
        key: "xsiumc",
      },
    ],
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Co = e("Eclipse", [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["path", { d: "M12 2a7 7 0 1 0 10 10", key: "1yuj32" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const bo = e("EggFried", [
    ["circle", { cx: "11.5", cy: "12.5", r: "3.5", key: "1cl1mi" }],
    [
      "path",
      {
        d: "M3 8c0-3.5 2.5-6 6.5-6 5 0 4.83 3 7.5 5s5 2 5 6c0 4.5-2.5 6.5-7 6.5-2.5 0-2.5 2.5-6 2.5s-7-2-7-5.5c0-3 1.5-3 1.5-5C3.5 10 3 9 3 8Z",
        key: "165ef9",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const So = e("EggOff", [
    [
      "path",
      {
        d: "M6.399 6.399C5.362 8.157 4.65 10.189 4.5 12c-.37 4.43 1.27 9.95 7.5 10 3.256-.026 5.259-1.547 6.375-3.625",
        key: "6et380",
      },
    ],
    [
      "path",
      {
        d: "M19.532 13.875A14.07 14.07 0 0 0 19.5 12c-.36-4.34-3.95-9.96-7.5-10-1.04.012-2.082.502-3.046 1.297",
        key: "gcdc3f",
      },
    ],
    ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const qo = e("Egg", [
    [
      "path",
      {
        d: "M12 22c6.23-.05 7.87-5.57 7.5-10-.36-4.34-3.95-9.96-7.5-10-3.55.04-7.14 5.66-7.5 10-.37 4.43 1.27 9.95 7.5 10z",
        key: "1c39pg",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ho = e("EqualNot", [
    ["line", { x1: "5", x2: "19", y1: "9", y2: "9", key: "1nwqeh" }],
    ["line", { x1: "5", x2: "19", y1: "15", y2: "15", key: "g8yjpy" }],
    ["line", { x1: "19", x2: "5", y1: "5", y2: "19", key: "1x9vlm" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Q = e("EqualSquare", [
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" },
    ],
    ["path", { d: "M7 10h10", key: "1101jm" }],
    ["path", { d: "M7 14h10", key: "1mhdw3" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const zo = e("Equal", [
    ["line", { x1: "5", x2: "19", y1: "9", y2: "9", key: "1nwqeh" }],
    ["line", { x1: "5", x2: "19", y1: "15", y2: "15", key: "g8yjpy" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ao = e("Eraser", [
    [
      "path",
      {
        d: "m7 21-4.3-4.3c-1-1-1-2.5 0-3.4l9.6-9.6c1-1 2.5-1 3.4 0l5.6 5.6c1 1 1 2.5 0 3.4L13 21",
        key: "182aya",
      },
    ],
    ["path", { d: "M22 21H7", key: "t4ddhn" }],
    ["path", { d: "m5 11 9 9", key: "1mo9qw" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const jo = e("Euro", [
    ["path", { d: "M4 10h12", key: "1y6xl8" }],
    ["path", { d: "M4 14h9", key: "1loblj" }],
    [
      "path",
      {
        d: "M19 6a7.7 7.7 0 0 0-5.2-2A7.9 7.9 0 0 0 6 12c0 4.4 3.5 8 7.8 8 2 0 3.8-.8 5.2-2",
        key: "1j6lzo",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Vo = e("Expand", [
    ["path", { d: "m21 21-6-6m6 6v-4.8m0 4.8h-4.8", key: "1c15vz" }],
    ["path", { d: "M3 16.2V21m0 0h4.8M3 21l6-6", key: "1fsnz2" }],
    ["path", { d: "M21 7.8V3m0 0h-4.8M21 3l-6 6", key: "hawz9i" }],
    ["path", { d: "M3 7.8V3m0 0h4.8M3 3l6 6", key: "u9ee12" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Po = e("ExternalLink", [
    ["path", { d: "M15 3h6v6", key: "1q9fwt" }],
    ["path", { d: "M10 14 21 3", key: "gplh6r" }],
    [
      "path",
      {
        d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6",
        key: "a6xqqp",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Fo = e("EyeOff", [
    ["path", { d: "M9.88 9.88a3 3 0 1 0 4.24 4.24", key: "1jxqfv" }],
    [
      "path",
      {
        d: "M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68",
        key: "9wicm4",
      },
    ],
    [
      "path",
      {
        d: "M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61",
        key: "1jreej",
      },
    ],
    ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Bo = e("Eye", [
    [
      "path",
      { d: "M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z", key: "rwhkz3" },
    ],
    ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Do = e("Facebook", [
    [
      "path",
      {
        d: "M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z",
        key: "1jg4f8",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ro = e("Factory", [
    [
      "path",
      {
        d: "M2 20a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8l-7 5V8l-7 5V4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
        key: "159hny",
      },
    ],
    ["path", { d: "M17 18h1", key: "uldtlt" }],
    ["path", { d: "M12 18h1", key: "s9uhes" }],
    ["path", { d: "M7 18h1", key: "1neino" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const To = e("Fan", [
    [
      "path",
      {
        d: "M10.827 16.379a6.082 6.082 0 0 1-8.618-7.002l5.412 1.45a6.082 6.082 0 0 1 7.002-8.618l-1.45 5.412a6.082 6.082 0 0 1 8.618 7.002l-5.412-1.45a6.082 6.082 0 0 1-7.002 8.618l1.45-5.412Z",
        key: "484a7f",
      },
    ],
    ["path", { d: "M12 12v.01", key: "u5ubse" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Uo = e("FastForward", [
    ["polygon", { points: "13 19 22 12 13 5 13 19", key: "587y9g" }],
    ["polygon", { points: "2 19 11 12 2 5 2 19", key: "3pweh0" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Zo = e("Feather", [
    [
      "path",
      { d: "M20.24 12.24a6 6 0 0 0-8.49-8.49L5 10.5V19h8.5z", key: "u4sw5n" },
    ],
    ["line", { x1: "16", x2: "2", y1: "8", y2: "22", key: "1c47m2" }],
    ["line", { x1: "17.5", x2: "9", y1: "15", y2: "15", key: "2fj3pr" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Oo = e("Fence", [
    [
      "path",
      { d: "M4 3 2 5v15c0 .6.4 1 1 1h2c.6 0 1-.4 1-1V5Z", key: "1n2rgs" },
    ],
    ["path", { d: "M6 8h4", key: "utf9t1" }],
    ["path", { d: "M6 18h4", key: "12yh4b" }],
    [
      "path",
      { d: "m12 3-2 2v15c0 .6.4 1 1 1h2c.6 0 1-.4 1-1V5Z", key: "3ha7mj" },
    ],
    ["path", { d: "M14 8h4", key: "1r8wg2" }],
    ["path", { d: "M14 18h4", key: "1t3kbu" }],
    [
      "path",
      { d: "m20 3-2 2v15c0 .6.4 1 1 1h2c.6 0 1-.4 1-1V5Z", key: "dfd4e2" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Go = e("FerrisWheel", [
    ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }],
    ["path", { d: "M12 2v4", key: "3427ic" }],
    ["path", { d: "m6.8 15-3.5 2", key: "hjy98k" }],
    ["path", { d: "m20.7 7-3.5 2", key: "f08gto" }],
    ["path", { d: "M6.8 9 3.3 7", key: "1aevh4" }],
    ["path", { d: "m20.7 17-3.5-2", key: "1liqo3" }],
    ["path", { d: "m9 22 3-8 3 8", key: "wees03" }],
    ["path", { d: "M8 22h8", key: "rmew8v" }],
    ["path", { d: "M18 18.7a9 9 0 1 0-12 0", key: "dhzg4g" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Eo = e("Figma", [
    [
      "path",
      {
        d: "M5 5.5A3.5 3.5 0 0 1 8.5 2H12v7H8.5A3.5 3.5 0 0 1 5 5.5z",
        key: "1340ok",
      },
    ],
    ["path", { d: "M12 2h3.5a3.5 3.5 0 1 1 0 7H12V2z", key: "1hz3m3" }],
    [
      "path",
      { d: "M12 12.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 1 1-7 0z", key: "1oz8n2" },
    ],
    [
      "path",
      {
        d: "M5 19.5A3.5 3.5 0 0 1 8.5 16H12v3.5a3.5 3.5 0 1 1-7 0z",
        key: "1ff65i",
      },
    ],
    [
      "path",
      {
        d: "M5 12.5A3.5 3.5 0 0 1 8.5 9H12v7H8.5A3.5 3.5 0 0 1 5 12.5z",
        key: "pdip6e",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Wo = e("FileArchive", [
    [
      "path",
      { d: "M16 22h2a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v18", key: "1oywqq" },
    ],
    ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
    ["circle", { cx: "10", cy: "20", r: "2", key: "1xzdoj" }],
    ["path", { d: "M10 7V6", key: "dljcrl" }],
    ["path", { d: "M10 12v-1", key: "v7bkov" }],
    ["path", { d: "M10 18v-2", key: "1cjy8d" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const No = e("FileAudio2", [
    [
      "path",
      { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v2", key: "17k7jt" },
    ],
    ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
    ["circle", { cx: "3", cy: "17", r: "1", key: "vo6nti" }],
    ["path", { d: "M2 17v-3a4 4 0 0 1 8 0v3", key: "1ggdre" }],
    ["circle", { cx: "9", cy: "17", r: "1", key: "bc1fq4" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Xo = e("FileAudio", [
    [
      "path",
      {
        d: "M17.5 22h.5a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3",
        key: "rslqgf",
      },
    ],
    ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
    [
      "path",
      {
        d: "M2 19a2 2 0 1 1 4 0v1a2 2 0 1 1-4 0v-4a6 6 0 0 1 12 0v4a2 2 0 1 1-4 0v-1a2 2 0 1 1 4 0",
        key: "9f7x3i",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Y = e("FileAxis3d", [
    [
      "path",
      {
        d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z",
        key: "1rqfz7",
      },
    ],
    ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
    ["path", { d: "m8 18 4-4", key: "12zab0" }],
    ["path", { d: "M8 10v8h8", key: "tlaukw" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ko = e("FileBadge2", [
    [
      "path",
      {
        d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z",
        key: "1rqfz7",
      },
    ],
    ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }],
    ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
    ["path", { d: "m14 12.5 1 5.5-3-1-3 1 1-5.5", key: "14xlky" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const _o = e("FileBadge", [
    [
      "path",
      { d: "M12 22h6a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3", key: "12ixgl" },
    ],
    ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
    ["path", { d: "M5 17a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z", key: "u0c8gj" }],
    ["path", { d: "M7 16.5 8 22l-3-1-3 1 1-5.5", key: "5gm2nr" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Jo = e("FileBarChart2", [
    [
      "path",
      {
        d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z",
        key: "1rqfz7",
      },
    ],
    ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
    ["path", { d: "M8 18v-1", key: "zg0ygc" }],
    ["path", { d: "M12 18v-6", key: "17g6i2" }],
    ["path", { d: "M16 18v-3", key: "j5jt4h" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Qo = e("FileBarChart", [
    [
      "path",
      {
        d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z",
        key: "1rqfz7",
      },
    ],
    ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
    ["path", { d: "M8 18v-2", key: "qcmpov" }],
    ["path", { d: "M12 18v-4", key: "q1q25u" }],
    ["path", { d: "M16 18v-6", key: "15y0np" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Yo = e("FileBox", [
    [
      "path",
      {
        d: "M14.5 22H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4",
        key: "16lz6z",
      },
    ],
    ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
    [
      "path",
      {
        d: "M3 13.1a2 2 0 0 0-1 1.76v3.24a2 2 0 0 0 .97 1.78L6 21.7a2 2 0 0 0 2.03.01L11 19.9a2 2 0 0 0 1-1.76V14.9a2 2 0 0 0-.97-1.78L8 11.3a2 2 0 0 0-2.03-.01Z",
        key: "99pj1s",
      },
    ],
    ["path", { d: "M7 17v5", key: "1yj1jh" }],
    ["path", { d: "M11.7 14.2 7 17l-4.7-2.8", key: "1yk8tc" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const $o = e("FileCheck2", [
    [
      "path",
      { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" },
    ],
    ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
    ["path", { d: "m3 15 2 2 4-4", key: "1lhrkk" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ey = e("FileCheck", [
    [
      "path",
      {
        d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z",
        key: "1rqfz7",
      },
    ],
    ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
    ["path", { d: "m9 15 2 2 4-4", key: "1grp1n" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ay = e("FileClock", [
    [
      "path",
      { d: "M16 22h2a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3", key: "37hlfg" },
    ],
    ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
    ["circle", { cx: "8", cy: "16", r: "6", key: "10v15b" }],
    ["path", { d: "M9.5 17.5 8 16.25V14", key: "1o80t2" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ty = e("FileCode2", [
    [
      "path",
      { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" },
    ],
    ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
    ["path", { d: "m5 12-3 3 3 3", key: "oke12k" }],
    ["path", { d: "m9 18 3-3-3-3", key: "112psh" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const cy = e("FileCode", [
    [
      "path",
      {
        d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z",
        key: "1rqfz7",
      },
    ],
    ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
    ["path", { d: "m10 13-2 2 2 2", key: "17smn8" }],
    ["path", { d: "m14 17 2-2-2-2", key: "14mezr" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const $ = e("FileCog", [
    [
      "path",
      { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v2", key: "17k7jt" },
    ],
    ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
    ["circle", { cx: "6", cy: "14", r: "3", key: "a1xfv6" }],
    ["path", { d: "M6 10v1", key: "xs0f9j" }],
    ["path", { d: "M6 17v1", key: "idyhc0" }],
    ["path", { d: "M10 14H9", key: "m5fm2q" }],
    ["path", { d: "M3 14H2", key: "19ot09" }],
    ["path", { d: "m9 11-.88.88", key: "lhul2b" }],
    ["path", { d: "M3.88 16.12 3 17", key: "169z9n" }],
    ["path", { d: "m9 17-.88-.88", key: "5io96w" }],
    ["path", { d: "M3.88 11.88 3 11", key: "1ynhy1" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const hy = e("FileDiff", [
    [
      "path",
      {
        d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z",
        key: "1rqfz7",
      },
    ],
    ["path", { d: "M9 10h6", key: "9gxzsh" }],
    ["path", { d: "M12 13V7", key: "h0r20n" }],
    ["path", { d: "M9 17h6", key: "r8uit2" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const dy = e("FileDigit", [
    [
      "path",
      { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" },
    ],
    ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
    [
      "rect",
      { width: "4", height: "6", x: "2", y: "12", rx: "2", key: "jm304g" },
    ],
    ["path", { d: "M10 12h2v6", key: "12zw74" }],
    ["path", { d: "M10 18h4", key: "1ulq68" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const oy = e("FileDown", [
    [
      "path",
      {
        d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z",
        key: "1rqfz7",
      },
    ],
    ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
    ["path", { d: "M12 18v-6", key: "17g6i2" }],
    ["path", { d: "m9 15 3 3 3-3", key: "1npd3o" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const yy = e("FileHeart", [
    [
      "path",
      { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v2", key: "17k7jt" },
    ],
    ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
    [
      "path",
      {
        d: "M10.29 10.7a2.43 2.43 0 0 0-2.66-.52c-.29.12-.56.3-.78.53l-.35.34-.35-.34a2.43 2.43 0 0 0-2.65-.53c-.3.12-.56.3-.79.53-.95.94-1 2.53.2 3.74L6.5 18l3.6-3.55c1.2-1.21 1.14-2.8.19-3.74Z",
        key: "1c1fso",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const iy = e("FileImage", [
    [
      "path",
      {
        d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z",
        key: "1rqfz7",
      },
    ],
    ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
    ["circle", { cx: "10", cy: "12", r: "2", key: "737tya" }],
    [
      "path",
      { d: "m20 17-1.296-1.296a2.41 2.41 0 0 0-3.408 0L9 22", key: "wt3hpn" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ny = e("FileInput", [
    [
      "path",
      { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" },
    ],
    ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
    ["path", { d: "M2 15h10", key: "jfw4w8" }],
    ["path", { d: "m9 18 3-3-3-3", key: "112psh" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ry = e("FileJson2", [
    [
      "path",
      { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" },
    ],
    ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
    [
      "path",
      {
        d: "M4 12a1 1 0 0 0-1 1v1a1 1 0 0 1-1 1 1 1 0 0 1 1 1v1a1 1 0 0 0 1 1",
        key: "fq0c9t",
      },
    ],
    [
      "path",
      {
        d: "M8 18a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1 1 1 0 0 1-1-1v-1a1 1 0 0 0-1-1",
        key: "4gibmv",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ky = e("FileJson", [
    [
      "path",
      {
        d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z",
        key: "1rqfz7",
      },
    ],
    ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
    [
      "path",
      {
        d: "M10 12a1 1 0 0 0-1 1v1a1 1 0 0 1-1 1 1 1 0 0 1 1 1v1a1 1 0 0 0 1 1",
        key: "1oajmo",
      },
    ],
    [
      "path",
      {
        d: "M14 18a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1 1 1 0 0 1-1-1v-1a1 1 0 0 0-1-1",
        key: "mpwhp6",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const py = e("FileKey2", [
    [
      "path",
      { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v6", key: "rc0qvx" },
    ],
    ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
    ["circle", { cx: "4", cy: "16", r: "2", key: "1ehqvc" }],
    ["path", { d: "m10 10-4.5 4.5", key: "7fwrp6" }],
    ["path", { d: "m9 11 1 1", key: "wa6s5q" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ly = e("FileKey", [
    [
      "path",
      {
        d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z",
        key: "1rqfz7",
      },
    ],
    ["circle", { cx: "10", cy: "16", r: "2", key: "4ckbqe" }],
    ["path", { d: "m16 10-4.5 4.5", key: "7p3ebg" }],
    ["path", { d: "m15 11 1 1", key: "1bsyx3" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const sy = e("FileLineChart", [
    [
      "path",
      {
        d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z",
        key: "1rqfz7",
      },
    ],
    ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
    ["path", { d: "m16 13-3.5 3.5-2-2L8 17", key: "zz7yod" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const uy = e("FileLock2", [
    [
      "path",
      { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v1", key: "jmtmu2" },
    ],
    ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
    [
      "rect",
      { width: "8", height: "5", x: "2", y: "13", rx: "1", key: "10y5wo" },
    ],
    ["path", { d: "M8 13v-2a2 2 0 1 0-4 0v2", key: "1pdxzg" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const My = e("FileLock", [
    [
      "path",
      {
        d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z",
        key: "1rqfz7",
      },
    ],
    [
      "rect",
      { width: "8", height: "6", x: "8", y: "12", rx: "1", key: "3yr8at" },
    ],
    ["path", { d: "M10 12v-2a2 2 0 1 1 4 0v2", key: "j4i8d" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const vy = e("FileMinus2", [
    [
      "path",
      { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" },
    ],
    ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
    ["path", { d: "M3 15h6", key: "4e2qda" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const my = e("FileMinus", [
    [
      "path",
      {
        d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z",
        key: "1rqfz7",
      },
    ],
    ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
    ["path", { d: "M9 15h6", key: "cctwl0" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const xy = e("FileMusic", [
    ["circle", { cx: "14", cy: "16", r: "2", key: "1bzzi3" }],
    ["circle", { cx: "6", cy: "18", r: "2", key: "1fncim" }],
    [
      "path",
      {
        d: "M4 12.4V4a2 2 0 0 1 2-2h8.5L20 7.5V20a2 2 0 0 1-2 2h-7.5",
        key: "skc018",
      },
    ],
    ["path", { d: "M8 18v-7.7L16 9v7", key: "1oie6o" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const gy = e("FileOutput", [
    ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
    ["path", { d: "M4 7V4a2 2 0 0 1 2-2 2 2 0 0 0-2 2", key: "1vk7w2" }],
    [
      "path",
      {
        d: "M4.063 20.999a2 2 0 0 0 2 1L18 22a2 2 0 0 0 2-2V7l-5-5H6",
        key: "1jink5",
      },
    ],
    ["path", { d: "m5 11-3 3", key: "1dgrs4" }],
    ["path", { d: "m5 17-3-3h10", key: "1mvvaf" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const e1 = e("FilePenLine", [
    [
      "path",
      {
        d: "m18 5-3-3H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2",
        key: "h0fsxq",
      },
    ],
    ["path", { d: "M8 18h1", key: "13wk12" }],
    ["path", { d: "M18.4 9.6a2 2 0 1 1 3 3L17 17l-4 1 1-4Z", key: "dyo8mm" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const a1 = e("FilePen", [
    [
      "path",
      { d: "M12 22h6a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v10", key: "x7tsz2" },
    ],
    ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
    ["path", { d: "M10.4 12.6a2 2 0 1 1 3 3L8 21l-4 1 1-4Z", key: "o3xyfb" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ly = e("FilePieChart", [
    [
      "path",
      { d: "M16 22h2a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3", key: "37hlfg" },
    ],
    ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
    ["path", { d: "M4 11.5a6.02 6.02 0 1 0 8.5 8.5", key: "unkkko" }],
    ["path", { d: "M14 16c0-3.3-2.7-6-6-6v6Z", key: "bym002" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const fy = e("FilePlus2", [
    [
      "path",
      { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" },
    ],
    ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
    ["path", { d: "M3 15h6", key: "4e2qda" }],
    ["path", { d: "M6 12v6", key: "1u72j0" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const wy = e("FilePlus", [
    [
      "path",
      {
        d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z",
        key: "1rqfz7",
      },
    ],
    ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
    ["path", { d: "M9 15h6", key: "cctwl0" }],
    ["path", { d: "M12 18v-6", key: "17g6i2" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Iy = e("FileQuestion", [
    [
      "path",
      {
        d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z",
        key: "1rqfz7",
      },
    ],
    [
      "path",
      {
        d: "M10 10.3c.2-.4.5-.8.9-1a2.1 2.1 0 0 1 2.6.4c.3.4.5.8.5 1.3 0 1.3-2 2-2 2",
        key: "1umxtm",
      },
    ],
    ["path", { d: "M12 17h.01", key: "p32p05" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Cy = e("FileScan", [
    [
      "path",
      { d: "M20 10V7l-5-5H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h4", key: "1rdf37" },
    ],
    ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
    ["path", { d: "M16 14a2 2 0 0 0-2 2", key: "ceaadl" }],
    ["path", { d: "M20 14a2 2 0 0 1 2 2", key: "1ny6zw" }],
    ["path", { d: "M20 22a2 2 0 0 0 2-2", key: "1l9q4k" }],
    ["path", { d: "M16 22a2 2 0 0 1-2-2", key: "1wqh5n" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const by = e("FileSearch2", [
    [
      "path",
      {
        d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z",
        key: "1rqfz7",
      },
    ],
    ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
    ["circle", { cx: "11.5", cy: "14.5", r: "2.5", key: "1bq0ko" }],
    ["path", { d: "M13.3 16.3 15 18", key: "2quom7" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Sy = e("FileSearch", [
    [
      "path",
      { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3", key: "1vg67v" },
    ],
    ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
    ["circle", { cx: "5", cy: "14", r: "3", key: "ufru5t" }],
    ["path", { d: "m9 18-1.5-1.5", key: "1j6qii" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const qy = e("FileSliders", [
    [
      "path",
      {
        d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z",
        key: "1rqfz7",
      },
    ],
    ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
    ["path", { d: "M8 12h8", key: "1wcyev" }],
    ["path", { d: "M10 11v2", key: "1s651w" }],
    ["path", { d: "M8 17h8", key: "wh5c61" }],
    ["path", { d: "M14 16v2", key: "12fp5e" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Hy = e("FileSpreadsheet", [
    [
      "path",
      {
        d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z",
        key: "1rqfz7",
      },
    ],
    ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
    ["path", { d: "M8 13h2", key: "yr2amv" }],
    ["path", { d: "M14 13h2", key: "un5t4a" }],
    ["path", { d: "M8 17h2", key: "2yhykz" }],
    ["path", { d: "M14 17h2", key: "10kma7" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const zy = e("FileStack", [
    ["path", { d: "M21 7h-3a2 2 0 0 1-2-2V2", key: "9rb54x" }],
    [
      "path",
      {
        d: "M21 6v6.5c0 .8-.7 1.5-1.5 1.5h-7c-.8 0-1.5-.7-1.5-1.5v-9c0-.8.7-1.5 1.5-1.5H17Z",
        key: "1059l0",
      },
    ],
    ["path", { d: "M7 8v8.8c0 .3.2.6.4.8.2.2.5.4.8.4H15", key: "16874u" }],
    ["path", { d: "M3 12v8.8c0 .3.2.6.4.8.2.2.5.4.8.4H11", key: "k2ox98" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ay = e("FileSymlink", [
    ["path", { d: "m10 18 3-3-3-3", key: "18f6ys" }],
    ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
    [
      "path",
      {
        d: "M4 11V4a2 2 0 0 1 2-2h9l5 5v13a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h7",
        key: "50q2rw",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const jy = e("FileTerminal", [
    [
      "path",
      {
        d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z",
        key: "1rqfz7",
      },
    ],
    ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
    ["path", { d: "m8 16 2-2-2-2", key: "10vzyd" }],
    ["path", { d: "M12 18h4", key: "1wd2n7" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Vy = e("FileText", [
    [
      "path",
      {
        d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z",
        key: "1rqfz7",
      },
    ],
    ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
    ["path", { d: "M10 9H8", key: "b1mrlr" }],
    ["path", { d: "M16 13H8", key: "t4e002" }],
    ["path", { d: "M16 17H8", key: "z1uh3a" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Py = e("FileType2", [
    [
      "path",
      { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" },
    ],
    ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
    ["path", { d: "M2 13v-1h6v1", key: "1dh9dg" }],
    ["path", { d: "M5 12v6", key: "150t9c" }],
    ["path", { d: "M4 18h2", key: "1xrofg" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Fy = e("FileType", [
    [
      "path",
      {
        d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z",
        key: "1rqfz7",
      },
    ],
    ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
    ["path", { d: "M9 13v-1h6v1", key: "1bb014" }],
    ["path", { d: "M12 12v6", key: "3ahymv" }],
    ["path", { d: "M11 18h2", key: "12mj7e" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const By = e("FileUp", [
    [
      "path",
      {
        d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z",
        key: "1rqfz7",
      },
    ],
    ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
    ["path", { d: "M12 12v6", key: "3ahymv" }],
    ["path", { d: "m15 15-3-3-3 3", key: "15xj92" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Dy = e("FileVideo2", [
    [
      "path",
      { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" },
    ],
    ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
    [
      "rect",
      { width: "8", height: "6", x: "2", y: "12", rx: "1", key: "1a6c1e" },
    ],
    ["path", { d: "m10 15.5 4 2.5v-6l-4 2.5", key: "t7cp39" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ry = e("FileVideo", [
    [
      "path",
      {
        d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z",
        key: "1rqfz7",
      },
    ],
    ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
    ["path", { d: "m10 11 5 3-5 3v-6Z", key: "7ntvm4" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ty = e("FileVolume2", [
    [
      "path",
      {
        d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z",
        key: "1rqfz7",
      },
    ],
    ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
    ["path", { d: "M8 15h.01", key: "a7atzg" }],
    ["path", { d: "M11.5 13.5a2.5 2.5 0 0 1 0 3", key: "1fccat" }],
    ["path", { d: "M15 12a5 5 0 0 1 0 6", key: "ps46cm" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Uy = e("FileVolume", [
    [
      "path",
      { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3", key: "1vg67v" },
    ],
    ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
    ["path", { d: "m7 10-3 2H2v4h2l3 2Z", key: "fiq8l4" }],
    ["path", { d: "M11 11a5 5 0 0 1 0 6", key: "193qb2" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Zy = e("FileWarning", [
    [
      "path",
      {
        d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z",
        key: "1rqfz7",
      },
    ],
    ["path", { d: "M12 9v4", key: "juzpu7" }],
    ["path", { d: "M12 17h.01", key: "p32p05" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Oy = e("FileX2", [
    [
      "path",
      { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" },
    ],
    ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
    ["path", { d: "m8 12.5-5 5", key: "b853mi" }],
    ["path", { d: "m3 12.5 5 5", key: "1qls4r" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Gy = e("FileX", [
    [
      "path",
      {
        d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z",
        key: "1rqfz7",
      },
    ],
    ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
    ["path", { d: "m14.5 12.5-5 5", key: "b62r18" }],
    ["path", { d: "m9.5 12.5 5 5", key: "1rk7el" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ey = e("File", [
    [
      "path",
      {
        d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z",
        key: "1rqfz7",
      },
    ],
    ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Wy = e("Files", [
    ["path", { d: "M20 7h-3a2 2 0 0 1-2-2V2", key: "x099mo" }],
    [
      "path",
      {
        d: "M9 18a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h7l4 4v10a2 2 0 0 1-2 2Z",
        key: "18t6ie",
      },
    ],
    ["path", { d: "M3 7.6v12.8A1.6 1.6 0 0 0 4.6 22h9.8", key: "1nja0z" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ny = e("Film", [
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" },
    ],
    ["path", { d: "M7 3v18", key: "bbkbws" }],
    ["path", { d: "M3 7.5h4", key: "zfgn84" }],
    ["path", { d: "M3 12h18", key: "1i2n21" }],
    ["path", { d: "M3 16.5h4", key: "1230mu" }],
    ["path", { d: "M17 3v18", key: "in4fa5" }],
    ["path", { d: "M17 7.5h4", key: "myr1c1" }],
    ["path", { d: "M17 16.5h4", key: "go4c1d" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Xy = e("FilterX", [
    ["path", { d: "M13.013 3H2l8 9.46V19l4 2v-8.54l.9-1.055", key: "1fi1da" }],
    ["path", { d: "m22 3-5 5", key: "12jva0" }],
    ["path", { d: "m17 3 5 5", key: "k36vhe" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ky = e("Filter", [
    [
      "polygon",
      { points: "22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3", key: "1yg77f" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const _y = e("Fingerprint", [
    ["path", { d: "M2 12C2 6.5 6.5 2 12 2a10 10 0 0 1 8 4", key: "1jc9o5" }],
    [
      "path",
      { d: "M5 19.5C5.5 18 6 15 6 12c0-.7.12-1.37.34-2", key: "1mxgy1" },
    ],
    ["path", { d: "M17.29 21.02c.12-.6.43-2.3.5-3.02", key: "ptglia" }],
    ["path", { d: "M12 10a2 2 0 0 0-2 2c0 1.02-.1 2.51-.26 4", key: "1nerag" }],
    ["path", { d: "M8.65 22c.21-.66.45-1.32.57-2", key: "13wd9y" }],
    ["path", { d: "M14 13.12c0 2.38 0 6.38-1 8.88", key: "o46ks0" }],
    ["path", { d: "M2 16h.01", key: "1gqxmh" }],
    ["path", { d: "M21.8 16c.2-2 .131-5.354 0-6", key: "drycrb" }],
    ["path", { d: "M9 6.8a6 6 0 0 1 9 5.2c0 .47 0 1.17-.02 2", key: "1fgabc" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Jy = e("FireExtinguisher", [
    [
      "path",
      { d: "M15 6.5V3a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v3.5", key: "sqyvz" },
    ],
    ["path", { d: "M9 18h8", key: "i7pszb" }],
    ["path", { d: "M18 3h-3", key: "7idoqj" }],
    ["path", { d: "M11 3a6 6 0 0 0-6 6v11", key: "1v5je3" }],
    ["path", { d: "M5 13h4", key: "svpcxo" }],
    [
      "path",
      {
        d: "M17 10a4 4 0 0 0-8 0v10a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2Z",
        key: "vsjego",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Qy = e("FishOff", [
    [
      "path",
      {
        d: "M18 12.47v.03m0-.5v.47m-.475 5.056A6.744 6.744 0 0 1 15 18c-3.56 0-7.56-2.53-8.5-6 .348-1.28 1.114-2.433 2.121-3.38m3.444-2.088A8.802 8.802 0 0 1 15 6c3.56 0 6.06 2.54 7 6-.309 1.14-.786 2.177-1.413 3.058",
        key: "1j1hse",
      },
    ],
    [
      "path",
      {
        d: "M7 10.67C7 8 5.58 5.97 2.73 5.5c-1 1.5-1 5 .23 6.5-1.24 1.5-1.24 5-.23 6.5C5.58 18.03 7 16 7 13.33m7.48-4.372A9.77 9.77 0 0 1 16 6.07m0 11.86a9.77 9.77 0 0 1-1.728-3.618",
        key: "1q46z8",
      },
    ],
    [
      "path",
      {
        d: "m16.01 17.93-.23 1.4A2 2 0 0 1 13.8 21H9.5a5.96 5.96 0 0 0 1.49-3.98M8.53 3h5.27a2 2 0 0 1 1.98 1.67l.23 1.4M2 2l20 20",
        key: "1407gh",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Yy = e("FishSymbol", [
    ["path", { d: "M2 16s9-15 20-4C11 23 2 8 2 8", key: "h4oh4o" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const $y = e("Fish", [
    [
      "path",
      {
        d: "M6.5 12c.94-3.46 4.94-6 8.5-6 3.56 0 6.06 2.54 7 6-.94 3.47-3.44 6-7 6s-7.56-2.53-8.5-6Z",
        key: "15baut",
      },
    ],
    ["path", { d: "M18 12v.5", key: "18hhni" }],
    ["path", { d: "M16 17.93a9.77 9.77 0 0 1 0-11.86", key: "16dt7o" }],
    [
      "path",
      {
        d: "M7 10.67C7 8 5.58 5.97 2.73 5.5c-1 1.5-1 5 .23 6.5-1.24 1.5-1.24 5-.23 6.5C5.58 18.03 7 16 7 13.33",
        key: "l9di03",
      },
    ],
    [
      "path",
      {
        d: "M10.46 7.26C10.2 5.88 9.17 4.24 8 3h5.8a2 2 0 0 1 1.98 1.67l.23 1.4",
        key: "1kjonw",
      },
    ],
    [
      "path",
      {
        d: "m16.01 17.93-.23 1.4A2 2 0 0 1 13.8 21H9.5a5.96 5.96 0 0 0 1.49-3.98",
        key: "1zlm23",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ei = e("FlagOff", [
    ["path", { d: "M8 2c3 0 5 2 8 2s4-1 4-1v11", key: "9rwyz9" }],
    ["path", { d: "M4 22V4", key: "1plyxx" }],
    ["path", { d: "M4 15s1-1 4-1 5 2 8 2", key: "1myooe" }],
    ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ai = e("FlagTriangleLeft", [
    ["path", { d: "M17 22V2L7 7l10 5", key: "1rmf0r" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ti = e("FlagTriangleRight", [
    ["path", { d: "M7 22V2l10 5-10 5", key: "17n18y" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ci = e("Flag", [
    [
      "path",
      {
        d: "M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z",
        key: "i9b6wo",
      },
    ],
    ["line", { x1: "4", x2: "4", y1: "22", y2: "15", key: "1cm3nv" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const hi = e("FlameKindling", [
    [
      "path",
      {
        d: "M12 2c1 3 2.5 3.5 3.5 4.5A5 5 0 0 1 17 10a5 5 0 1 1-10 0c0-.3 0-.6.1-.9a2 2 0 1 0 3.3-2C8 4.5 11 2 12 2Z",
        key: "1ir223",
      },
    ],
    ["path", { d: "m5 22 14-4", key: "1brv4h" }],
    ["path", { d: "m5 18 14 4", key: "lgyyje" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const di = e("Flame", [
    [
      "path",
      {
        d: "M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z",
        key: "96xj49",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const oi = e("FlashlightOff", [
    [
      "path",
      {
        d: "M16 16v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V10c0-2-2-2-2-4",
        key: "1r120k",
      },
    ],
    ["path", { d: "M7 2h11v4c0 2-2 2-2 4v1", key: "dz1920" }],
    ["line", { x1: "11", x2: "18", y1: "6", y2: "6", key: "bi1vpe" }],
    ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const yi = e("Flashlight", [
    [
      "path",
      {
        d: "M18 6c0 2-2 2-2 4v10a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V10c0-2-2-2-2-4V2h12z",
        key: "1orkel",
      },
    ],
    ["line", { x1: "6", x2: "18", y1: "6", y2: "6", key: "1z11jq" }],
    ["line", { x1: "12", x2: "12", y1: "12", y2: "12", key: "1f4yc1" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ii = e("FlaskConicalOff", [
    [
      "path",
      {
        d: "M10 10 4.72 20.55a1 1 0 0 0 .9 1.45h12.76a1 1 0 0 0 .9-1.45l-1.272-2.542",
        key: "59ek9y",
      },
    ],
    ["path", { d: "M10 2v2.343", key: "15t272" }],
    ["path", { d: "M14 2v6.343", key: "sxr80q" }],
    ["path", { d: "M8.5 2h7", key: "csnxdl" }],
    ["path", { d: "M7 16h9", key: "t5njau" }],
    ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ni = e("FlaskConical", [
    [
      "path",
      {
        d: "M10 2v7.527a2 2 0 0 1-.211.896L4.72 20.55a1 1 0 0 0 .9 1.45h12.76a1 1 0 0 0 .9-1.45l-5.069-10.127A2 2 0 0 1 14 9.527V2",
        key: "pzvekw",
      },
    ],
    ["path", { d: "M8.5 2h7", key: "csnxdl" }],
    ["path", { d: "M7 16h10", key: "wp8him" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ri = e("FlaskRound", [
    ["path", { d: "M10 2v7.31", key: "5d1hyh" }],
    ["path", { d: "M14 9.3V1.99", key: "14k4l0" }],
    ["path", { d: "M8.5 2h7", key: "csnxdl" }],
    ["path", { d: "M14 9.3a6.5 6.5 0 1 1-4 0", key: "1r8fvy" }],
    ["path", { d: "M5.52 16h12.96", key: "46hh1i" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ki = e("FlipHorizontal2", [
    ["path", { d: "m3 7 5 5-5 5V7", key: "couhi7" }],
    ["path", { d: "m21 7-5 5 5 5V7", key: "6ouia7" }],
    ["path", { d: "M12 20v2", key: "1lh1kg" }],
    ["path", { d: "M12 14v2", key: "8jcxud" }],
    ["path", { d: "M12 8v2", key: "1woqiv" }],
    ["path", { d: "M12 2v2", key: "tus03m" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const pi = e("FlipHorizontal", [
    ["path", { d: "M8 3H5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h3", key: "1i73f7" }],
    ["path", { d: "M16 3h3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-3", key: "saxlbk" }],
    ["path", { d: "M12 20v2", key: "1lh1kg" }],
    ["path", { d: "M12 14v2", key: "8jcxud" }],
    ["path", { d: "M12 8v2", key: "1woqiv" }],
    ["path", { d: "M12 2v2", key: "tus03m" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const li = e("FlipVertical2", [
    ["path", { d: "m17 3-5 5-5-5h10", key: "1ftt6x" }],
    ["path", { d: "m17 21-5-5-5 5h10", key: "1m0wmu" }],
    ["path", { d: "M4 12H2", key: "rhcxmi" }],
    ["path", { d: "M10 12H8", key: "s88cx1" }],
    ["path", { d: "M16 12h-2", key: "10asgb" }],
    ["path", { d: "M22 12h-2", key: "14jgyd" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const si = e("FlipVertical", [
    ["path", { d: "M21 8V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v3", key: "14bfxa" }],
    ["path", { d: "M21 16v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-3", key: "14rx03" }],
    ["path", { d: "M4 12H2", key: "rhcxmi" }],
    ["path", { d: "M10 12H8", key: "s88cx1" }],
    ["path", { d: "M16 12h-2", key: "10asgb" }],
    ["path", { d: "M22 12h-2", key: "14jgyd" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ui = e("Flower2", [
    [
      "path",
      {
        d: "M12 5a3 3 0 1 1 3 3m-3-3a3 3 0 1 0-3 3m3-3v1M9 8a3 3 0 1 0 3 3M9 8h1m5 0a3 3 0 1 1-3 3m3-3h-1m-2 3v-1",
        key: "3pnvol",
      },
    ],
    ["circle", { cx: "12", cy: "8", r: "2", key: "1822b1" }],
    ["path", { d: "M12 10v12", key: "6ubwww" }],
    [
      "path",
      { d: "M12 22c4.2 0 7-1.667 7-5-4.2 0-7 1.667-7 5Z", key: "9hd38g" },
    ],
    [
      "path",
      { d: "M12 22c-4.2 0-7-1.667-7-5 4.2 0 7 1.667 7 5Z", key: "ufn41s" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Mi = e("Flower", [
    ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
    [
      "path",
      {
        d: "M12 16.5A4.5 4.5 0 1 1 7.5 12 4.5 4.5 0 1 1 12 7.5a4.5 4.5 0 1 1 4.5 4.5 4.5 4.5 0 1 1-4.5 4.5",
        key: "14wa3c",
      },
    ],
    ["path", { d: "M12 7.5V9", key: "1oy5b0" }],
    ["path", { d: "M7.5 12H9", key: "eltsq1" }],
    ["path", { d: "M16.5 12H15", key: "vk5kw4" }],
    ["path", { d: "M12 16.5V15", key: "k7eayi" }],
    ["path", { d: "m8 8 1.88 1.88", key: "nxy4qf" }],
    ["path", { d: "M14.12 9.88 16 8", key: "1lst6k" }],
    ["path", { d: "m8 16 1.88-1.88", key: "h2eex1" }],
    ["path", { d: "M14.12 14.12 16 16", key: "uqkrx3" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const vi = e("Focus", [
    ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
    ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
    ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
    ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
    ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const mi = e("FoldHorizontal", [
    ["path", { d: "M2 12h6", key: "1wqiqv" }],
    ["path", { d: "M22 12h-6", key: "1eg9hc" }],
    ["path", { d: "M12 2v2", key: "tus03m" }],
    ["path", { d: "M12 8v2", key: "1woqiv" }],
    ["path", { d: "M12 14v2", key: "8jcxud" }],
    ["path", { d: "M12 20v2", key: "1lh1kg" }],
    ["path", { d: "m19 9-3 3 3 3", key: "12ol22" }],
    ["path", { d: "m5 15 3-3-3-3", key: "1kdhjc" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const xi = e("FoldVertical", [
    ["path", { d: "M12 22v-6", key: "6o8u61" }],
    ["path", { d: "M12 8V2", key: "1wkif3" }],
    ["path", { d: "M4 12H2", key: "rhcxmi" }],
    ["path", { d: "M10 12H8", key: "s88cx1" }],
    ["path", { d: "M16 12h-2", key: "10asgb" }],
    ["path", { d: "M22 12h-2", key: "14jgyd" }],
    ["path", { d: "m15 19-3-3-3 3", key: "e37ymu" }],
    ["path", { d: "m15 5-3 3-3-3", key: "19d6lf" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const gi = e("FolderArchive", [
    ["circle", { cx: "15", cy: "19", r: "2", key: "u2pros" }],
    [
      "path",
      {
        d: "M20.9 19.8A2 2 0 0 0 22 18V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h5.1",
        key: "1jj40k",
      },
    ],
    ["path", { d: "M15 11v-1", key: "cntcp" }],
    ["path", { d: "M15 17v-2", key: "1279jj" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Li = e("FolderCheck", [
    [
      "path",
      {
        d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
        key: "1kt360",
      },
    ],
    ["path", { d: "m9 13 2 2 4-4", key: "6343dt" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const fi = e("FolderClock", [
    ["circle", { cx: "16", cy: "16", r: "6", key: "qoo3c4" }],
    [
      "path",
      {
        d: "M7 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2",
        key: "1urifu",
      },
    ],
    ["path", { d: "M16 14v2l1 1", key: "xth2jh" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const wi = e("FolderClosed", [
    [
      "path",
      {
        d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
        key: "1kt360",
      },
    ],
    ["path", { d: "M2 10h20", key: "1ir3d8" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const t1 = e("FolderCog", [
    ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
    [
      "path",
      {
        d: "M10.3 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v3.3",
        key: "1k8050",
      },
    ],
    ["path", { d: "m21.7 19.4-.9-.3", key: "1qgwi9" }],
    ["path", { d: "m15.2 16.9-.9-.3", key: "1t7mvx" }],
    ["path", { d: "m16.6 21.7.3-.9", key: "1j67ps" }],
    ["path", { d: "m19.1 15.2.3-.9", key: "18r7jp" }],
    ["path", { d: "m19.6 21.7-.4-1", key: "z2vh2" }],
    ["path", { d: "m16.8 15.3-.4-1", key: "1ei7r6" }],
    ["path", { d: "m14.3 19.6 1-.4", key: "11sv9r" }],
    ["path", { d: "m20.7 16.8 1-.4", key: "19m87a" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ii = e("FolderDot", [
    [
      "path",
      {
        d: "M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z",
        key: "1fr9dc",
      },
    ],
    ["circle", { cx: "12", cy: "13", r: "1", key: "49l61u" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ci = e("FolderDown", [
    [
      "path",
      {
        d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
        key: "1kt360",
      },
    ],
    ["path", { d: "M12 10v6", key: "1bos4e" }],
    ["path", { d: "m15 13-3 3-3-3", key: "6j2sf0" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const bi = e("FolderGit2", [
    [
      "path",
      {
        d: "M9 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v5",
        key: "1w6njk",
      },
    ],
    ["circle", { cx: "13", cy: "12", r: "2", key: "1j92g6" }],
    ["path", { d: "M18 19c-2.8 0-5-2.2-5-5v8", key: "pkpw2h" }],
    ["circle", { cx: "20", cy: "19", r: "2", key: "1obnsp" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Si = e("FolderGit", [
    ["circle", { cx: "12", cy: "13", r: "2", key: "1c1ljs" }],
    [
      "path",
      {
        d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
        key: "1kt360",
      },
    ],
    ["path", { d: "M14 13h3", key: "1dgedf" }],
    ["path", { d: "M7 13h3", key: "1pygq7" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const qi = e("FolderHeart", [
    [
      "path",
      {
        d: "M11 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v1.5",
        key: "6hud8k",
      },
    ],
    [
      "path",
      {
        d: "M13.9 17.45c-1.2-1.2-1.14-2.8-.2-3.73a2.43 2.43 0 0 1 3.44 0l.36.34.34-.34a2.43 2.43 0 0 1 3.45-.01v0c.95.95 1 2.53-.2 3.74L17.5 21Z",
        key: "vgq86i",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Hi = e("FolderInput", [
    [
      "path",
      {
        d: "M2 9V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-1",
        key: "fm4g5t",
      },
    ],
    ["path", { d: "M2 13h10", key: "pgb2dq" }],
    ["path", { d: "m9 16 3-3-3-3", key: "6m91ic" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const zi = e("FolderKanban", [
    [
      "path",
      {
        d: "M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z",
        key: "1fr9dc",
      },
    ],
    ["path", { d: "M8 10v4", key: "tgpxqk" }],
    ["path", { d: "M12 10v2", key: "hh53o1" }],
    ["path", { d: "M16 10v6", key: "1d6xys" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ai = e("FolderKey", [
    ["circle", { cx: "16", cy: "20", r: "2", key: "1vifvg" }],
    [
      "path",
      {
        d: "M10 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v2",
        key: "3hgo9p",
      },
    ],
    ["path", { d: "m22 14-4.5 4.5", key: "1ef6z8" }],
    ["path", { d: "m21 15 1 1", key: "1ejcpy" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ji = e("FolderLock", [
    [
      "rect",
      { width: "8", height: "5", x: "14", y: "17", rx: "1", key: "19aais" },
    ],
    [
      "path",
      {
        d: "M10 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v2.5",
        key: "1w6v7t",
      },
    ],
    ["path", { d: "M20 17v-2a2 2 0 1 0-4 0v2", key: "pwaxnr" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Vi = e("FolderMinus", [
    ["path", { d: "M9 13h6", key: "1uhe8q" }],
    [
      "path",
      {
        d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
        key: "1kt360",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Pi = e("FolderOpenDot", [
    [
      "path",
      {
        d: "m6 14 1.45-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.55 6a2 2 0 0 1-1.94 1.5H4a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h3.93a2 2 0 0 1 1.66.9l.82 1.2a2 2 0 0 0 1.66.9H18a2 2 0 0 1 2 2v2",
        key: "1nmvlm",
      },
    ],
    ["circle", { cx: "14", cy: "15", r: "1", key: "1gm4qj" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Fi = e("FolderOpen", [
    [
      "path",
      {
        d: "m6 14 1.5-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.54 6a2 2 0 0 1-1.95 1.5H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H18a2 2 0 0 1 2 2v2",
        key: "usdka0",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Bi = e("FolderOutput", [
    [
      "path",
      {
        d: "M2 7.5V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-1.5",
        key: "1yk7aj",
      },
    ],
    ["path", { d: "M2 13h10", key: "pgb2dq" }],
    ["path", { d: "m5 10-3 3 3 3", key: "1r8ie0" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const c1 = e("FolderPen", [
    ["path", { d: "M8.4 10.6a2 2 0 0 1 3 3L6 19l-4 1 1-4Z", key: "dakro8" }],
    [
      "path",
      {
        d: "M2 11.5V5a2 2 0 0 1 2-2h3.9c.7 0 1.3.3 1.7.9l.8 1.2c.4.6 1 .9 1.7.9H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-9.5",
        key: "a8xqs0",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Di = e("FolderPlus", [
    ["path", { d: "M12 10v6", key: "1bos4e" }],
    ["path", { d: "M9 13h6", key: "1uhe8q" }],
    [
      "path",
      {
        d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
        key: "1kt360",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ri = e("FolderRoot", [
    [
      "path",
      {
        d: "M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z",
        key: "1fr9dc",
      },
    ],
    ["circle", { cx: "12", cy: "13", r: "2", key: "1c1ljs" }],
    ["path", { d: "M12 15v5", key: "11xva1" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ti = e("FolderSearch2", [
    ["circle", { cx: "11.5", cy: "12.5", r: "2.5", key: "1ea5ju" }],
    [
      "path",
      {
        d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
        key: "1kt360",
      },
    ],
    ["path", { d: "M13.3 14.3 15 16", key: "1y4v1n" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ui = e("FolderSearch", [
    ["circle", { cx: "17", cy: "17", r: "3", key: "18b49y" }],
    [
      "path",
      {
        d: "M10.7 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v4.1",
        key: "1bw5m7",
      },
    ],
    ["path", { d: "m21 21-1.5-1.5", key: "3sg1j" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Zi = e("FolderSymlink", [
    [
      "path",
      {
        d: "M2 9V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h7",
        key: "x1c07l",
      },
    ],
    ["path", { d: "m8 16 3-3-3-3", key: "rlqrt1" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Oi = e("FolderSync", [
    [
      "path",
      {
        d: "M9 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v.5",
        key: "1dkoa9",
      },
    ],
    ["path", { d: "M12 10v4h4", key: "1czhmt" }],
    ["path", { d: "m12 14 1.535-1.605a5 5 0 0 1 8 1.5", key: "lvuxfi" }],
    ["path", { d: "M22 22v-4h-4", key: "1ewp4q" }],
    ["path", { d: "m22 18-1.535 1.605a5 5 0 0 1-8-1.5", key: "14ync0" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Gi = e("FolderTree", [
    [
      "path",
      {
        d: "M20 10a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-2.5a1 1 0 0 1-.8-.4l-.9-1.2A1 1 0 0 0 15 3h-2a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1Z",
        key: "hod4my",
      },
    ],
    [
      "path",
      {
        d: "M20 21a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1h-2.9a1 1 0 0 1-.88-.55l-.42-.85a1 1 0 0 0-.92-.6H13a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1Z",
        key: "w4yl2u",
      },
    ],
    ["path", { d: "M3 5a2 2 0 0 0 2 2h3", key: "f2jnh7" }],
    ["path", { d: "M3 3v13a2 2 0 0 0 2 2h3", key: "k8epm1" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ei = e("FolderUp", [
    [
      "path",
      {
        d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
        key: "1kt360",
      },
    ],
    ["path", { d: "M12 10v6", key: "1bos4e" }],
    ["path", { d: "m9 13 3-3 3 3", key: "1pxg3c" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Wi = e("FolderX", [
    [
      "path",
      {
        d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
        key: "1kt360",
      },
    ],
    ["path", { d: "m9.5 10.5 5 5", key: "ra9qjz" }],
    ["path", { d: "m14.5 10.5-5 5", key: "l2rkpq" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ni = e("Folder", [
    [
      "path",
      {
        d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
        key: "1kt360",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Xi = e("Folders", [
    [
      "path",
      {
        d: "M20 17a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3.9a2 2 0 0 1-1.69-.9l-.81-1.2a2 2 0 0 0-1.67-.9H8a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2Z",
        key: "4u7rpt",
      },
    ],
    ["path", { d: "M2 8v11a2 2 0 0 0 2 2h14", key: "1eicx1" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ki = e("Footprints", [
    [
      "path",
      {
        d: "M4 16v-2.38C4 11.5 2.97 10.5 3 8c.03-2.72 1.49-6 4.5-6C9.37 2 10 3.8 10 5.5c0 3.11-2 5.66-2 8.68V16a2 2 0 1 1-4 0Z",
        key: "1dudjm",
      },
    ],
    [
      "path",
      {
        d: "M20 20v-2.38c0-2.12 1.03-3.12 1-5.62-.03-2.72-1.49-6-4.5-6C14.63 6 14 7.8 14 9.5c0 3.11 2 5.66 2 8.68V20a2 2 0 1 0 4 0Z",
        key: "l2t8xc",
      },
    ],
    ["path", { d: "M16 17h4", key: "1dejxt" }],
    ["path", { d: "M4 13h4", key: "1bwh8b" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const _i = e("Forklift", [
    ["path", { d: "M12 12H5a2 2 0 0 0-2 2v5", key: "7zsz91" }],
    ["circle", { cx: "13", cy: "19", r: "2", key: "wjnkru" }],
    ["circle", { cx: "5", cy: "19", r: "2", key: "v8kfzx" }],
    [
      "path",
      { d: "M8 19h3m5-17v17h6M6 12V7c0-1.1.9-2 2-2h3l5 5", key: "13bk1p" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ji = e("FormInput", [
    [
      "rect",
      { width: "20", height: "12", x: "2", y: "6", rx: "2", key: "9lu3g6" },
    ],
    ["path", { d: "M12 12h.01", key: "1mp3jc" }],
    ["path", { d: "M17 12h.01", key: "1m0b6t" }],
    ["path", { d: "M7 12h.01", key: "eqddd0" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Qi = e("Forward", [
    ["polyline", { points: "15 17 20 12 15 7", key: "1w3sku" }],
    ["path", { d: "M4 18v-2a4 4 0 0 1 4-4h12", key: "jmiej9" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Yi = e("Frame", [
    ["line", { x1: "22", x2: "2", y1: "6", y2: "6", key: "15w7dq" }],
    ["line", { x1: "22", x2: "2", y1: "18", y2: "18", key: "1ip48p" }],
    ["line", { x1: "6", x2: "6", y1: "2", y2: "22", key: "a2lnyx" }],
    ["line", { x1: "18", x2: "18", y1: "2", y2: "22", key: "8vb6jd" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const $i = e("Framer", [
    [
      "path",
      { d: "M5 16V9h14V2H5l14 14h-7m-7 0 7 7v-7m-7 0h7", key: "1a2nng" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const en = e("Frown", [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["path", { d: "M16 16s-1.5-2-4-2-4 2-4 2", key: "epbg0q" }],
    ["line", { x1: "9", x2: "9.01", y1: "9", y2: "9", key: "yxxnd0" }],
    ["line", { x1: "15", x2: "15.01", y1: "9", y2: "9", key: "1p4y9e" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const an = e("Fuel", [
    ["line", { x1: "3", x2: "15", y1: "22", y2: "22", key: "xegly4" }],
    ["line", { x1: "4", x2: "14", y1: "9", y2: "9", key: "xcnuvu" }],
    ["path", { d: "M14 22V4a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v18", key: "16j0yd" }],
    [
      "path",
      {
        d: "M14 13h2a2 2 0 0 1 2 2v2a2 2 0 0 0 2 2h0a2 2 0 0 0 2-2V9.83a2 2 0 0 0-.59-1.42L18 5",
        key: "8ur5zv",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const tn = e("Fullscreen", [
    ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
    ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
    ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
    ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
    [
      "rect",
      { width: "10", height: "8", x: "7", y: "8", rx: "1", key: "vys8me" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const cn = e("FunctionSquare", [
    [
      "rect",
      {
        width: "18",
        height: "18",
        x: "3",
        y: "3",
        rx: "2",
        ry: "2",
        key: "1m3agn",
      },
    ],
    [
      "path",
      { d: "M9 17c2 0 2.8-1 2.8-2.8V10c0-2 1-3.3 3.2-3", key: "m1af9g" },
    ],
    ["path", { d: "M9 11.2h5.7", key: "3zgcl2" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const hn = e("GalleryHorizontalEnd", [
    ["path", { d: "M2 7v10", key: "a2pl2d" }],
    ["path", { d: "M6 5v14", key: "1kq3d7" }],
    [
      "rect",
      { width: "12", height: "18", x: "10", y: "3", rx: "2", key: "13i7bc" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const dn = e("GalleryHorizontal", [
    ["path", { d: "M2 3v18", key: "pzttux" }],
    [
      "rect",
      { width: "12", height: "18", x: "6", y: "3", rx: "2", key: "btr8bg" },
    ],
    ["path", { d: "M22 3v18", key: "6jf3v" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const on = e("GalleryThumbnails", [
    [
      "rect",
      { width: "18", height: "14", x: "3", y: "3", rx: "2", key: "74y24f" },
    ],
    ["path", { d: "M4 21h1", key: "16zlid" }],
    ["path", { d: "M9 21h1", key: "15o7lz" }],
    ["path", { d: "M14 21h1", key: "v9vybs" }],
    ["path", { d: "M19 21h1", key: "edywat" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const yn = e("GalleryVerticalEnd", [
    ["path", { d: "M7 2h10", key: "nczekb" }],
    ["path", { d: "M5 6h14", key: "u2x4p" }],
    [
      "rect",
      { width: "18", height: "12", x: "3", y: "10", rx: "2", key: "l0tzu3" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const nn = e("GalleryVertical", [
    ["path", { d: "M3 2h18", key: "15qxfx" }],
    [
      "rect",
      { width: "18", height: "12", x: "3", y: "6", rx: "2", key: "1439r6" },
    ],
    ["path", { d: "M3 22h18", key: "8prr45" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const rn = e("Gamepad2", [
    ["line", { x1: "6", x2: "10", y1: "11", y2: "11", key: "1gktln" }],
    ["line", { x1: "8", x2: "8", y1: "9", y2: "13", key: "qnk9ow" }],
    ["line", { x1: "15", x2: "15.01", y1: "12", y2: "12", key: "krot7o" }],
    ["line", { x1: "18", x2: "18.01", y1: "10", y2: "10", key: "1lcuu1" }],
    [
      "path",
      {
        d: "M17.32 5H6.68a4 4 0 0 0-3.978 3.59c-.006.052-.01.101-.017.152C2.604 9.416 2 14.456 2 16a3 3 0 0 0 3 3c1 0 1.5-.5 2-1l1.414-1.414A2 2 0 0 1 9.828 16h4.344a2 2 0 0 1 1.414.586L17 18c.5.5 1 1 2 1a3 3 0 0 0 3-3c0-1.545-.604-6.584-.685-7.258-.007-.05-.011-.1-.017-.151A4 4 0 0 0 17.32 5z",
        key: "mfqc10",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const kn = e("Gamepad", [
    ["line", { x1: "6", x2: "10", y1: "12", y2: "12", key: "161bw2" }],
    ["line", { x1: "8", x2: "8", y1: "10", y2: "14", key: "1i6ji0" }],
    ["line", { x1: "15", x2: "15.01", y1: "13", y2: "13", key: "dqpgro" }],
    ["line", { x1: "18", x2: "18.01", y1: "11", y2: "11", key: "meh2c" }],
    [
      "rect",
      { width: "20", height: "12", x: "2", y: "6", rx: "2", key: "9lu3g6" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const v = e("GanttChartSquare", [
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" },
    ],
    ["path", { d: "M9 8h7", key: "kbo1nt" }],
    ["path", { d: "M8 12h6", key: "ikassy" }],
    ["path", { d: "M11 16h5", key: "oq65wt" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const pn = e("GanttChart", [
    ["path", { d: "M8 6h10", key: "9lnwnk" }],
    ["path", { d: "M6 12h9", key: "1g9pqf" }],
    ["path", { d: "M11 18h7", key: "c8dzvl" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ln = e("GaugeCircle", [
    ["path", { d: "M15.6 2.7a10 10 0 1 0 5.7 5.7", key: "1e0p6d" }],
    ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }],
    ["path", { d: "M13.4 10.6 19 5", key: "1kr7tw" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const sn = e("Gauge", [
    ["path", { d: "m12 14 4-4", key: "9kzdfg" }],
    ["path", { d: "M3.34 19a10 10 0 1 1 17.32 0", key: "19p75a" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const un = e("Gavel", [
    ["path", { d: "m14.5 12.5-8 8a2.119 2.119 0 1 1-3-3l8-8", key: "15492f" }],
    ["path", { d: "m16 16 6-6", key: "vzrcl6" }],
    ["path", { d: "m8 8 6-6", key: "18bi4p" }],
    ["path", { d: "m9 7 8 8", key: "5jnvq1" }],
    ["path", { d: "m21 11-8-8", key: "z4y7zo" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Mn = e("Gem", [
    ["path", { d: "M6 3h12l4 6-10 13L2 9Z", key: "1pcd5k" }],
    ["path", { d: "M11 3 8 9l4 13 4-13-3-6", key: "1fcu3u" }],
    ["path", { d: "M2 9h20", key: "16fsjt" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const vn = e("Ghost", [
    ["path", { d: "M9 10h.01", key: "qbtxuw" }],
    ["path", { d: "M15 10h.01", key: "1qmjsl" }],
    [
      "path",
      {
        d: "M12 2a8 8 0 0 0-8 8v12l3-3 2.5 2.5L12 19l2.5 2.5L17 19l3 3V10a8 8 0 0 0-8-8z",
        key: "uwwb07",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const mn = e("Gift", [
    [
      "rect",
      { x: "3", y: "8", width: "18", height: "4", rx: "1", key: "bkv52" },
    ],
    ["path", { d: "M12 8v13", key: "1c76mn" }],
    ["path", { d: "M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7", key: "6wjy6b" }],
    [
      "path",
      {
        d: "M7.5 8a2.5 2.5 0 0 1 0-5A4.8 8 0 0 1 12 8a4.8 8 0 0 1 4.5-5 2.5 2.5 0 0 1 0 5",
        key: "1ihvrl",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const xn = e("GitBranchPlus", [
    ["path", { d: "M6 3v12", key: "qpgusn" }],
    ["path", { d: "M18 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6z", key: "1d02ji" }],
    ["path", { d: "M6 21a3 3 0 1 0 0-6 3 3 0 0 0 0 6z", key: "chk6ph" }],
    ["path", { d: "M15 6a9 9 0 0 0-9 9", key: "or332x" }],
    ["path", { d: "M18 15v6", key: "9wciyi" }],
    ["path", { d: "M21 18h-6", key: "139f0c" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const gn = e("GitBranch", [
    ["line", { x1: "6", x2: "6", y1: "3", y2: "15", key: "17qcm7" }],
    ["circle", { cx: "18", cy: "6", r: "3", key: "1h7g24" }],
    ["circle", { cx: "6", cy: "18", r: "3", key: "fqmcym" }],
    ["path", { d: "M18 9a9 9 0 0 1-9 9", key: "n2h4wq" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const h1 = e("GitCommitHorizontal", [
    ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
    ["line", { x1: "3", x2: "9", y1: "12", y2: "12", key: "1dyftd" }],
    ["line", { x1: "15", x2: "21", y1: "12", y2: "12", key: "oup4p8" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ln = e("GitCommitVertical", [
    ["path", { d: "M12 3v6", key: "1holv5" }],
    ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
    ["path", { d: "M12 15v6", key: "a9ows0" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const fn = e("GitCompareArrows", [
    ["circle", { cx: "5", cy: "6", r: "3", key: "1qnov2" }],
    ["path", { d: "M12 6h5a2 2 0 0 1 2 2v7", key: "1yj91y" }],
    ["path", { d: "m15 9-3-3 3-3", key: "1lwv8l" }],
    ["circle", { cx: "19", cy: "18", r: "3", key: "1qljk2" }],
    ["path", { d: "M12 18H7a2 2 0 0 1-2-2V9", key: "16sdep" }],
    ["path", { d: "m9 15 3 3-3 3", key: "1m3kbl" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const wn = e("GitCompare", [
    ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
    ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
    ["path", { d: "M13 6h3a2 2 0 0 1 2 2v7", key: "1yeb86" }],
    ["path", { d: "M11 18H8a2 2 0 0 1-2-2V9", key: "19pyzm" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const In = e("GitFork", [
    ["circle", { cx: "12", cy: "18", r: "3", key: "1mpf1b" }],
    ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
    ["circle", { cx: "18", cy: "6", r: "3", key: "1h7g24" }],
    ["path", { d: "M18 9v2c0 .6-.4 1-1 1H7c-.6 0-1-.4-1-1V9", key: "1uq4wg" }],
    ["path", { d: "M12 12v3", key: "158kv8" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Cn = e("GitGraph", [
    ["circle", { cx: "5", cy: "6", r: "3", key: "1qnov2" }],
    ["path", { d: "M5 9v6", key: "158jrl" }],
    ["circle", { cx: "5", cy: "18", r: "3", key: "104gr9" }],
    ["path", { d: "M12 3v18", key: "108xh3" }],
    ["circle", { cx: "19", cy: "6", r: "3", key: "108a5v" }],
    ["path", { d: "M16 15.7A9 9 0 0 0 19 9", key: "1e3vqb" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const bn = e("GitMerge", [
    ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
    ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
    ["path", { d: "M6 21V9a9 9 0 0 0 9 9", key: "7kw0sc" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Sn = e("GitPullRequestArrow", [
    ["circle", { cx: "5", cy: "6", r: "3", key: "1qnov2" }],
    ["path", { d: "M5 9v12", key: "ih889a" }],
    ["circle", { cx: "19", cy: "18", r: "3", key: "1qljk2" }],
    ["path", { d: "m15 9-3-3 3-3", key: "1lwv8l" }],
    ["path", { d: "M12 6h5a2 2 0 0 1 2 2v7", key: "1yj91y" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const qn = e("GitPullRequestClosed", [
    ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
    ["path", { d: "M6 9v12", key: "1sc30k" }],
    ["path", { d: "m21 3-6 6", key: "16nqsk" }],
    ["path", { d: "m21 9-6-6", key: "9j17rh" }],
    ["path", { d: "M18 11.5V15", key: "65xf6f" }],
    ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Hn = e("GitPullRequestCreateArrow", [
    ["circle", { cx: "5", cy: "6", r: "3", key: "1qnov2" }],
    ["path", { d: "M5 9v12", key: "ih889a" }],
    ["path", { d: "m15 9-3-3 3-3", key: "1lwv8l" }],
    ["path", { d: "M12 6h5a2 2 0 0 1 2 2v3", key: "1rbwk6" }],
    ["path", { d: "M19 15v6", key: "10aioa" }],
    ["path", { d: "M22 18h-6", key: "1d5gi5" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const zn = e("GitPullRequestCreate", [
    ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
    ["path", { d: "M6 9v12", key: "1sc30k" }],
    ["path", { d: "M13 6h3a2 2 0 0 1 2 2v3", key: "1jb6z3" }],
    ["path", { d: "M18 15v6", key: "9wciyi" }],
    ["path", { d: "M21 18h-6", key: "139f0c" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const An = e("GitPullRequestDraft", [
    ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
    ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
    ["path", { d: "M18 6V5", key: "1oao2s" }],
    ["path", { d: "M18 11v-1", key: "11c8tz" }],
    ["line", { x1: "6", x2: "6", y1: "9", y2: "21", key: "rroup" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const jn = e("GitPullRequest", [
    ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
    ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
    ["path", { d: "M13 6h3a2 2 0 0 1 2 2v7", key: "1yeb86" }],
    ["line", { x1: "6", x2: "6", y1: "9", y2: "21", key: "rroup" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Vn = e("Github", [
    [
      "path",
      {
        d: "M15 22v-4a4.8 4.8 0 0 0-1-3.5c3 0 6-2 6-5.5.08-1.25-.27-2.48-1-3.5.28-1.15.28-2.35 0-3.5 0 0-1 0-3 1.5-2.64-.5-5.36-.5-8 0C6 2 5 2 5 2c-.3 1.15-.3 2.35 0 3.5A5.403 5.403 0 0 0 4 9c0 3.5 3 5.5 6 5.5-.39.49-.68 1.05-.85 1.65-.17.6-.22 1.23-.15 1.85v4",
        key: "tonef",
      },
    ],
    ["path", { d: "M9 18c-4.51 2-5-2-7-2", key: "9comsn" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Pn = e("Gitlab", [
    [
      "path",
      {
        d: "m22 13.29-3.33-10a.42.42 0 0 0-.14-.18.38.38 0 0 0-.22-.11.39.39 0 0 0-.23.07.42.42 0 0 0-.14.18l-2.26 6.67H8.32L6.1 3.26a.42.42 0 0 0-.1-.18.38.38 0 0 0-.26-.08.39.39 0 0 0-.23.07.42.42 0 0 0-.14.18L2 13.29a.74.74 0 0 0 .27.83L12 21l9.69-6.88a.71.71 0 0 0 .31-.83Z",
        key: "148pdi",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Fn = e("GlassWater", [
    [
      "path",
      {
        d: "M15.2 22H8.8a2 2 0 0 1-2-1.79L5 3h14l-1.81 17.21A2 2 0 0 1 15.2 22Z",
        key: "48rfw3",
      },
    ],
    ["path", { d: "M6 12a5 5 0 0 1 6 0 5 5 0 0 0 6 0", key: "mjntcy" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Bn = e("Glasses", [
    ["circle", { cx: "6", cy: "15", r: "4", key: "vux9w4" }],
    ["circle", { cx: "18", cy: "15", r: "4", key: "18o8ve" }],
    ["path", { d: "M14 15a2 2 0 0 0-2-2 2 2 0 0 0-2 2", key: "1ag4bs" }],
    ["path", { d: "M2.5 13 5 7c.7-1.3 1.4-2 3-2", key: "1hm1gs" }],
    ["path", { d: "M21.5 13 19 7c-.7-1.3-1.5-2-3-2", key: "1r31ai" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Dn = e("GlobeLock", [
    [
      "path",
      {
        d: "M15.686 15A14.5 14.5 0 0 1 12 22a14.5 14.5 0 0 1 0-20 10 10 0 1 0 9.542 13",
        key: "qkt0x6",
      },
    ],
    ["path", { d: "M2 12h8.5", key: "ovaggd" }],
    ["path", { d: "M20 6V4a2 2 0 1 0-4 0v2", key: "1of5e8" }],
    [
      "rect",
      { width: "8", height: "5", x: "14", y: "6", rx: "1", key: "1fmf51" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Rn = e("Globe", [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    [
      "path",
      { d: "M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20", key: "13o1zl" },
    ],
    ["path", { d: "M2 12h20", key: "9i4pu4" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Tn = e("Goal", [
    ["path", { d: "M12 13V2l8 4-8 4", key: "5wlwwj" }],
    ["path", { d: "M20.561 10.222a9 9 0 1 1-12.55-5.29", key: "1c0wjv" }],
    ["path", { d: "M8.002 9.997a5 5 0 1 0 8.9 2.02", key: "gb1g7m" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Un = e("Grab", [
    [
      "path",
      { d: "M18 11.5V9a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v1.4", key: "n5nng" },
    ],
    ["path", { d: "M14 10V8a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v2", key: "185i9d" }],
    ["path", { d: "M10 9.9V9a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v5", key: "11pz95" }],
    ["path", { d: "M6 14v0a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v0", key: "16yk7l" }],
    [
      "path",
      {
        d: "M18 11v0a2 2 0 1 1 4 0v3a8 8 0 0 1-8 8h-4a8 8 0 0 1-8-8 2 2 0 1 1 4 0",
        key: "nzvb1c",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Zn = e("GraduationCap", [
    [
      "path",
      {
        d: "M21.42 10.922a1 1 0 0 0-.019-1.838L12.83 5.18a2 2 0 0 0-1.66 0L2.6 9.08a1 1 0 0 0 0 1.832l8.57 3.908a2 2 0 0 0 1.66 0z",
        key: "j76jl0",
      },
    ],
    ["path", { d: "M22 10v6", key: "1lu8f3" }],
    ["path", { d: "M6 12.5V16a6 3 0 0 0 12 0v-3.5", key: "1r8lef" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const On = e("Grape", [
    ["path", { d: "M22 5V2l-5.89 5.89", key: "1eenpo" }],
    ["circle", { cx: "16.6", cy: "15.89", r: "3", key: "xjtalx" }],
    ["circle", { cx: "8.11", cy: "7.4", r: "3", key: "u2fv6i" }],
    ["circle", { cx: "12.35", cy: "11.65", r: "3", key: "i6i8g7" }],
    ["circle", { cx: "13.91", cy: "5.85", r: "3", key: "6ye0dv" }],
    ["circle", { cx: "18.15", cy: "10.09", r: "3", key: "snx9no" }],
    ["circle", { cx: "6.56", cy: "13.2", r: "3", key: "17x4xg" }],
    ["circle", { cx: "10.8", cy: "17.44", r: "3", key: "1hogw9" }],
    ["circle", { cx: "5", cy: "19", r: "3", key: "1sn6vo" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const d1 = e("Grid2x2", [
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" },
    ],
    ["path", { d: "M3 12h18", key: "1i2n21" }],
    ["path", { d: "M12 3v18", key: "108xh3" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const m = e("Grid3x3", [
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" },
    ],
    ["path", { d: "M3 9h18", key: "1pudct" }],
    ["path", { d: "M3 15h18", key: "5xshup" }],
    ["path", { d: "M9 3v18", key: "fh3hqa" }],
    ["path", { d: "M15 3v18", key: "14nvp0" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Gn = e("GripHorizontal", [
    ["circle", { cx: "12", cy: "9", r: "1", key: "124mty" }],
    ["circle", { cx: "19", cy: "9", r: "1", key: "1ruzo2" }],
    ["circle", { cx: "5", cy: "9", r: "1", key: "1a8b28" }],
    ["circle", { cx: "12", cy: "15", r: "1", key: "1e56xg" }],
    ["circle", { cx: "19", cy: "15", r: "1", key: "1a92ep" }],
    ["circle", { cx: "5", cy: "15", r: "1", key: "5r1jwy" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const En = e("GripVertical", [
    ["circle", { cx: "9", cy: "12", r: "1", key: "1vctgf" }],
    ["circle", { cx: "9", cy: "5", r: "1", key: "hp0tcf" }],
    ["circle", { cx: "9", cy: "19", r: "1", key: "fkjjf6" }],
    ["circle", { cx: "15", cy: "12", r: "1", key: "1tmaij" }],
    ["circle", { cx: "15", cy: "5", r: "1", key: "19l28e" }],
    ["circle", { cx: "15", cy: "19", r: "1", key: "f4zoj3" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Wn = e("Grip", [
    ["circle", { cx: "12", cy: "5", r: "1", key: "gxeob9" }],
    ["circle", { cx: "19", cy: "5", r: "1", key: "w8mnmm" }],
    ["circle", { cx: "5", cy: "5", r: "1", key: "lttvr7" }],
    ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
    ["circle", { cx: "19", cy: "12", r: "1", key: "1wjl8i" }],
    ["circle", { cx: "5", cy: "12", r: "1", key: "1pcz8c" }],
    ["circle", { cx: "12", cy: "19", r: "1", key: "lyex9k" }],
    ["circle", { cx: "19", cy: "19", r: "1", key: "shf9b7" }],
    ["circle", { cx: "5", cy: "19", r: "1", key: "bfqh0e" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Nn = e("Group", [
    ["path", { d: "M3 7V5c0-1.1.9-2 2-2h2", key: "adw53z" }],
    ["path", { d: "M17 3h2c1.1 0 2 .9 2 2v2", key: "an4l38" }],
    ["path", { d: "M21 17v2c0 1.1-.9 2-2 2h-2", key: "144t0e" }],
    ["path", { d: "M7 21H5c-1.1 0-2-.9-2-2v-2", key: "rtnfgi" }],
    [
      "rect",
      { width: "7", height: "5", x: "7", y: "7", rx: "1", key: "1eyiv7" },
    ],
    [
      "rect",
      { width: "7", height: "5", x: "10", y: "12", rx: "1", key: "1qlmkx" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Xn = e("Guitar", [
    [
      "path",
      {
        d: "m20 7 1.7-1.7a1 1 0 0 0 0-1.4l-1.6-1.6a1 1 0 0 0-1.4 0L17 4v3Z",
        key: "15ixgv",
      },
    ],
    ["path", { d: "m17 7-5.1 5.1", key: "l9guh7" }],
    [
      "circle",
      { cx: "11.5", cy: "12.5", r: ".5", fill: "currentColor", key: "16onso" },
    ],
    [
      "path",
      {
        d: "M6 12a2 2 0 0 0 1.8-1.2l.4-.9C8.7 8.8 9.8 8 11 8c2.8 0 5 2.2 5 5 0 1.2-.8 2.3-1.9 2.8l-.9.4A2 2 0 0 0 12 18a4 4 0 0 1-4 4c-3.3 0-6-2.7-6-6a4 4 0 0 1 4-4",
        key: "x9fguj",
      },
    ],
    ["path", { d: "m6 16 2 2", key: "16qmzd" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Kn = e("Hammer", [
    ["path", { d: "m15 12-8.373 8.373a1 1 0 1 1-3-3L12 9", key: "eefl8a" }],
    ["path", { d: "m18 15 4-4", key: "16gjal" }],
    [
      "path",
      {
        d: "m21.5 11.5-1.914-1.914A2 2 0 0 1 19 8.172V7l-2.26-2.26a6 6 0 0 0-4.202-1.756L9 2.96l.92.82A6.18 6.18 0 0 1 12 8.4V10l2 2h1.172a2 2 0 0 1 1.414.586L18.5 14.5",
        key: "b7pghm",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const _n = e("HandCoins", [
    [
      "path",
      { d: "M11 15h2a2 2 0 1 0 0-4h-3c-.6 0-1.1.2-1.4.6L3 17", key: "geh8rc" },
    ],
    [
      "path",
      {
        d: "m7 21 1.6-1.4c.3-.4.8-.6 1.4-.6h4c1.1 0 2.1-.4 2.8-1.2l4.6-4.4a2 2 0 0 0-2.75-2.91l-4.2 3.9",
        key: "1fto5m",
      },
    ],
    ["path", { d: "m2 16 6 6", key: "1pfhp9" }],
    ["circle", { cx: "16", cy: "9", r: "2.9", key: "1n0dlu" }],
    ["circle", { cx: "6", cy: "5", r: "3", key: "151irh" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Jn = e("HandHeart", [
    [
      "path",
      { d: "M11 14h2a2 2 0 1 0 0-4h-3c-.6 0-1.1.2-1.4.6L3 16", key: "1ifwr1" },
    ],
    [
      "path",
      {
        d: "m7 20 1.6-1.4c.3-.4.8-.6 1.4-.6h4c1.1 0 2.1-.4 2.8-1.2l4.6-4.4a2 2 0 0 0-2.75-2.91l-4.2 3.9",
        key: "17abbs",
      },
    ],
    ["path", { d: "m2 15 6 6", key: "10dquu" }],
    [
      "path",
      {
        d: "M19.5 8.5c.7-.7 1.5-1.6 1.5-2.7A2.73 2.73 0 0 0 16 4a2.78 2.78 0 0 0-5 1.8c0 1.2.8 2 1.5 2.8L16 12Z",
        key: "1h3036",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const o1 = e("HandHelping", [
    [
      "path",
      { d: "M11 12h2a2 2 0 1 0 0-4h-3c-.6 0-1.1.2-1.4.6L3 14", key: "1j4xps" },
    ],
    [
      "path",
      {
        d: "m7 18 1.6-1.4c.3-.4.8-.6 1.4-.6h4c1.1 0 2.1-.4 2.8-1.2l4.6-4.4a2 2 0 0 0-2.75-2.91l-4.2 3.9",
        key: "uospg8",
      },
    ],
    ["path", { d: "m2 13 6 6", key: "16e5sb" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Qn = e("HandMetal", [
    [
      "path",
      { d: "M18 12.5V10a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v1.4", key: "7eki13" },
    ],
    ["path", { d: "M14 11V9a2 2 0 1 0-4 0v2", key: "94qvcw" }],
    ["path", { d: "M10 10.5V5a2 2 0 1 0-4 0v9", key: "m1ah89" }],
    [
      "path",
      {
        d: "m7 15-1.76-1.76a2 2 0 0 0-2.83 2.82l3.6 3.6C7.5 21.14 9.2 22 12 22h2a8 8 0 0 0 8-8V7a2 2 0 1 0-4 0v5",
        key: "t1skq1",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Yn = e("HandPlatter", [
    ["path", { d: "M12 3V2", key: "ar7q03" }],
    ["path", { d: "M5 10a7.1 7.1 0 0 1 14 0", key: "1t9y3n" }],
    ["path", { d: "M4 10h16", key: "img6z1" }],
    ["path", { d: "M2 14h12a2 2 0 1 1 0 4h-2", key: "loyjft" }],
    [
      "path",
      {
        d: "m15.4 17.4 3.2-2.8a2 2 0 0 1 2.8 2.9l-3.6 3.3c-.7.8-1.7 1.2-2.8 1.2h-4c-1.1 0-2.1-.4-2.8-1.2L5 18",
        key: "1rixiy",
      },
    ],
    ["path", { d: "M5 14v7H2", key: "3mujks" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const $n = e("Hand", [
    ["path", { d: "M18 11V6a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v0", key: "aigmz7" }],
    ["path", { d: "M14 10V4a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v2", key: "1n6bmn" }],
    [
      "path",
      { d: "M10 10.5V6a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v8", key: "a9iiix" },
    ],
    [
      "path",
      {
        d: "M18 8a2 2 0 1 1 4 0v6a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 0 1 2.83-2.82L7 15",
        key: "1s1gnw",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const er = e("Handshake", [
    ["path", { d: "m11 17 2 2a1 1 0 1 0 3-3", key: "efffak" }],
    [
      "path",
      {
        d: "m14 14 2.5 2.5a1 1 0 1 0 3-3l-3.88-3.88a3 3 0 0 0-4.24 0l-.88.88a1 1 0 1 1-3-3l2.81-2.81a5.79 5.79 0 0 1 7.06-.87l.47.28a2 2 0 0 0 1.42.25L21 4",
        key: "9pr0kb",
      },
    ],
    ["path", { d: "m21 3 1 11h-2", key: "1tisrp" }],
    ["path", { d: "M3 3 2 14l6.5 6.5a1 1 0 1 0 3-3", key: "1uvwmv" }],
    ["path", { d: "M3 4h8", key: "1ep09j" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ar = e("HardDriveDownload", [
    ["path", { d: "M12 2v8", key: "1q4o3n" }],
    ["path", { d: "m16 6-4 4-4-4", key: "6wukr" }],
    [
      "rect",
      { width: "20", height: "8", x: "2", y: "14", rx: "2", key: "w68u3i" },
    ],
    ["path", { d: "M6 18h.01", key: "uhywen" }],
    ["path", { d: "M10 18h.01", key: "h775k" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const tr = e("HardDriveUpload", [
    ["path", { d: "m16 6-4-4-4 4", key: "13yo43" }],
    ["path", { d: "M12 2v8", key: "1q4o3n" }],
    [
      "rect",
      { width: "20", height: "8", x: "2", y: "14", rx: "2", key: "w68u3i" },
    ],
    ["path", { d: "M6 18h.01", key: "uhywen" }],
    ["path", { d: "M10 18h.01", key: "h775k" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const cr = e("HardDrive", [
    ["line", { x1: "22", x2: "2", y1: "12", y2: "12", key: "1y58io" }],
    [
      "path",
      {
        d: "M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z",
        key: "oot6mr",
      },
    ],
    ["line", { x1: "6", x2: "6.01", y1: "16", y2: "16", key: "sgf278" }],
    ["line", { x1: "10", x2: "10.01", y1: "16", y2: "16", key: "1l4acy" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const hr = e("HardHat", [
    [
      "path",
      {
        d: "M2 18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v2z",
        key: "1dej2m",
      },
    ],
    ["path", { d: "M10 10V5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v5", key: "1p9q5i" }],
    ["path", { d: "M4 15v-3a6 6 0 0 1 6-6h0", key: "1uc279" }],
    ["path", { d: "M14 6h0a6 6 0 0 1 6 6v3", key: "1j9mnm" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const dr = e("Hash", [
    ["line", { x1: "4", x2: "20", y1: "9", y2: "9", key: "4lhtct" }],
    ["line", { x1: "4", x2: "20", y1: "15", y2: "15", key: "vyu0kd" }],
    ["line", { x1: "10", x2: "8", y1: "3", y2: "21", key: "1ggp8o" }],
    ["line", { x1: "16", x2: "14", y1: "3", y2: "21", key: "weycgp" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const or = e("Haze", [
    ["path", { d: "m5.2 6.2 1.4 1.4", key: "17imol" }],
    ["path", { d: "M2 13h2", key: "13gyu8" }],
    ["path", { d: "M20 13h2", key: "16rner" }],
    ["path", { d: "m17.4 7.6 1.4-1.4", key: "t4xlah" }],
    ["path", { d: "M22 17H2", key: "1gtaj3" }],
    ["path", { d: "M22 21H2", key: "1gy6en" }],
    ["path", { d: "M16 13a4 4 0 0 0-8 0", key: "1dyczq" }],
    ["path", { d: "M12 5V2.5", key: "1vytko" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const yr = e("HdmiPort", [
    [
      "path",
      {
        d: "M22 9a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h1l2 2h12l2-2h1a1 1 0 0 0 1-1Z",
        key: "2128wb",
      },
    ],
    ["path", { d: "M7.5 12h9", key: "1t0ckc" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ir = e("Heading1", [
    ["path", { d: "M4 12h8", key: "17cfdx" }],
    ["path", { d: "M4 18V6", key: "1rz3zl" }],
    ["path", { d: "M12 18V6", key: "zqpxq5" }],
    ["path", { d: "m17 12 3-2v8", key: "1hhhft" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const nr = e("Heading2", [
    ["path", { d: "M4 12h8", key: "17cfdx" }],
    ["path", { d: "M4 18V6", key: "1rz3zl" }],
    ["path", { d: "M12 18V6", key: "zqpxq5" }],
    ["path", { d: "M21 18h-4c0-4 4-3 4-6 0-1.5-2-2.5-4-1", key: "9jr5yi" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const rr = e("Heading3", [
    ["path", { d: "M4 12h8", key: "17cfdx" }],
    ["path", { d: "M4 18V6", key: "1rz3zl" }],
    ["path", { d: "M12 18V6", key: "zqpxq5" }],
    [
      "path",
      { d: "M17.5 10.5c1.7-1 3.5 0 3.5 1.5a2 2 0 0 1-2 2", key: "68ncm8" },
    ],
    ["path", { d: "M17 17.5c2 1.5 4 .3 4-1.5a2 2 0 0 0-2-2", key: "1ejuhz" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const kr = e("Heading4", [
    ["path", { d: "M4 12h8", key: "17cfdx" }],
    ["path", { d: "M4 18V6", key: "1rz3zl" }],
    ["path", { d: "M12 18V6", key: "zqpxq5" }],
    ["path", { d: "M17 10v4h4", key: "13sv97" }],
    ["path", { d: "M21 10v8", key: "1kdml4" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const pr = e("Heading5", [
    ["path", { d: "M4 12h8", key: "17cfdx" }],
    ["path", { d: "M4 18V6", key: "1rz3zl" }],
    ["path", { d: "M12 18V6", key: "zqpxq5" }],
    ["path", { d: "M17 13v-3h4", key: "1nvgqp" }],
    [
      "path",
      {
        d: "M17 17.7c.4.2.8.3 1.3.3 1.5 0 2.7-1.1 2.7-2.5S19.8 13 18.3 13H17",
        key: "2nebdn",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const lr = e("Heading6", [
    ["path", { d: "M4 12h8", key: "17cfdx" }],
    ["path", { d: "M4 18V6", key: "1rz3zl" }],
    ["path", { d: "M12 18V6", key: "zqpxq5" }],
    ["circle", { cx: "19", cy: "16", r: "2", key: "15mx69" }],
    ["path", { d: "M20 10c-2 2-3 3.5-3 6", key: "f35dl0" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const sr = e("Heading", [
    ["path", { d: "M6 12h12", key: "8npq4p" }],
    ["path", { d: "M6 20V4", key: "1w1bmo" }],
    ["path", { d: "M18 20V4", key: "o2hl4u" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ur = e("Headphones", [
    [
      "path",
      {
        d: "M3 14h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7a9 9 0 0 1 18 0v7a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3",
        key: "1xhozi",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Mr = e("Headset", [
    [
      "path",
      {
        d: "M3 11h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-5Zm0 0a9 9 0 1 1 18 0m0 0v5a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3Z",
        key: "12oyoe",
      },
    ],
    ["path", { d: "M21 16v2a4 4 0 0 1-4 4h-5", key: "1x7m43" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const vr = e("HeartCrack", [
    [
      "path",
      {
        d: "M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z",
        key: "c3ymky",
      },
    ],
    ["path", { d: "m12 13-1-1 2-2-3-3 2-2", key: "xjdxli" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const mr = e("HeartHandshake", [
    [
      "path",
      {
        d: "M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z",
        key: "c3ymky",
      },
    ],
    [
      "path",
      {
        d: "M12 5 9.04 7.96a2.17 2.17 0 0 0 0 3.08v0c.82.82 2.13.85 3 .07l2.07-1.9a2.82 2.82 0 0 1 3.79 0l2.96 2.66",
        key: "12sd6o",
      },
    ],
    ["path", { d: "m18 15-2-2", key: "60u0ii" }],
    ["path", { d: "m15 18-2-2", key: "6p76be" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const xr = e("HeartOff", [
    ["line", { x1: "2", y1: "2", x2: "22", y2: "22", key: "1w4vcy" }],
    [
      "path",
      {
        d: "M16.5 16.5 12 21l-7-7c-1.5-1.45-3-3.2-3-5.5a5.5 5.5 0 0 1 2.14-4.35",
        key: "3mpagl",
      },
    ],
    [
      "path",
      {
        d: "M8.76 3.1c1.15.22 2.13.78 3.24 1.9 1.5-1.5 2.74-2 4.5-2A5.5 5.5 0 0 1 22 8.5c0 2.12-1.3 3.78-2.67 5.17",
        key: "1gh3v3",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const gr = e("HeartPulse", [
    [
      "path",
      {
        d: "M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z",
        key: "c3ymky",
      },
    ],
    ["path", { d: "M3.22 12H9.5l.5-1 2 4.5 2-7 1.5 3.5h5.27", key: "1uw2ng" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Lr = e("Heart", [
    [
      "path",
      {
        d: "M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z",
        key: "c3ymky",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const fr = e("Heater", [
    ["path", { d: "M11 8c2-3-2-3 0-6", key: "1ldv5m" }],
    ["path", { d: "M15.5 8c2-3-2-3 0-6", key: "1otqoz" }],
    ["path", { d: "M6 10h.01", key: "1lbq93" }],
    ["path", { d: "M6 14h.01", key: "zudwn7" }],
    ["path", { d: "M10 16v-4", key: "1c25yv" }],
    ["path", { d: "M14 16v-4", key: "1dkbt8" }],
    ["path", { d: "M18 16v-4", key: "1yg9me" }],
    [
      "path",
      {
        d: "M20 6a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3",
        key: "1ubg90",
      },
    ],
    ["path", { d: "M5 20v2", key: "1abpe8" }],
    ["path", { d: "M19 20v2", key: "kqn6ft" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const wr = e("HelpCircle", [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["path", { d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3", key: "1u773s" }],
    ["path", { d: "M12 17h.01", key: "p32p05" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ir = e("Hexagon", [
    [
      "path",
      {
        d: "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z",
        key: "yt0hxn",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Cr = e("Highlighter", [
    ["path", { d: "m9 11-6 6v3h9l3-3", key: "1a3l36" }],
    [
      "path",
      {
        d: "m22 12-4.6 4.6a2 2 0 0 1-2.8 0l-5.2-5.2a2 2 0 0 1 0-2.8L14 4",
        key: "14a9rk",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const br = e("History", [
    [
      "path",
      { d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8", key: "1357e3" },
    ],
    ["path", { d: "M3 3v5h5", key: "1xhq8a" }],
    ["path", { d: "M12 7v5l4 2", key: "1fdv2h" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Sr = e("Home", [
    [
      "path",
      { d: "m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z", key: "y5dka4" },
    ],
    ["polyline", { points: "9 22 9 12 15 12 15 22", key: "e2us08" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const qr = e("HopOff", [
    [
      "path",
      {
        d: "M10.82 16.12c1.69.6 3.91.79 5.18.85.28.01.53-.09.7-.27",
        key: "qyzcap",
      },
    ],
    [
      "path",
      {
        d: "M11.14 20.57c.52.24 2.44 1.12 4.08 1.37.46.06.86-.25.9-.71.12-1.52-.3-3.43-.5-4.28",
        key: "y078lb",
      },
    ],
    [
      "path",
      {
        d: "M16.13 21.05c1.65.63 3.68.84 4.87.91a.9.9 0 0 0 .7-.26",
        key: "1utre3",
      },
    ],
    [
      "path",
      {
        d: "M17.99 5.52a20.83 20.83 0 0 1 3.15 4.5.8.8 0 0 1-.68 1.13c-1.17.1-2.5.02-3.9-.25",
        key: "17o9hm",
      },
    ],
    [
      "path",
      {
        d: "M20.57 11.14c.24.52 1.12 2.44 1.37 4.08.04.3-.08.59-.31.75",
        key: "1d1n4p",
      },
    ],
    [
      "path",
      {
        d: "M4.93 4.93a10 10 0 0 0-.67 13.4c.35.43.96.4 1.17-.12.69-1.71 1.07-5.07 1.07-6.71 1.34.45 3.1.9 4.88.62a.85.85 0 0 0 .48-.24",
        key: "9uv3tt",
      },
    ],
    [
      "path",
      {
        d: "M5.52 17.99c1.05.95 2.91 2.42 4.5 3.15a.8.8 0 0 0 1.13-.68c.2-2.34-.33-5.3-1.57-8.28",
        key: "1292wz",
      },
    ],
    [
      "path",
      {
        d: "M8.35 2.68a10 10 0 0 1 9.98 1.58c.43.35.4.96-.12 1.17-1.5.6-4.3.98-6.07 1.05",
        key: "7ozu9p",
      },
    ],
    ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Hr = e("Hop", [
    [
      "path",
      {
        d: "M10.82 16.12c1.69.6 3.91.79 5.18.85.55.03 1-.42.97-.97-.06-1.27-.26-3.5-.85-5.18",
        key: "18lxf1",
      },
    ],
    [
      "path",
      {
        d: "M11.5 6.5c1.64 0 5-.38 6.71-1.07.52-.2.55-.82.12-1.17A10 10 0 0 0 4.26 18.33c.35.43.96.4 1.17-.12.69-1.71 1.07-5.07 1.07-6.71 1.34.45 3.1.9 4.88.62a.88.88 0 0 0 .73-.74c.3-2.14-.15-3.5-.61-4.88",
        key: "vtfxrw",
      },
    ],
    [
      "path",
      {
        d: "M15.62 16.95c.2.85.62 2.76.5 4.28a.77.77 0 0 1-.9.7 16.64 16.64 0 0 1-4.08-1.36",
        key: "13hl71",
      },
    ],
    [
      "path",
      {
        d: "M16.13 21.05c1.65.63 3.68.84 4.87.91a.9.9 0 0 0 .96-.96 17.68 17.68 0 0 0-.9-4.87",
        key: "1sl8oj",
      },
    ],
    [
      "path",
      {
        d: "M16.94 15.62c.86.2 2.77.62 4.29.5a.77.77 0 0 0 .7-.9 16.64 16.64 0 0 0-1.36-4.08",
        key: "19c6kt",
      },
    ],
    [
      "path",
      {
        d: "M17.99 5.52a20.82 20.82 0 0 1 3.15 4.5.8.8 0 0 1-.68 1.13c-2.33.2-5.3-.32-8.27-1.57",
        key: "85ghs3",
      },
    ],
    ["path", { d: "M4.93 4.93 3 3a.7.7 0 0 1 0-1", key: "x087yj" }],
    [
      "path",
      {
        d: "M9.58 12.18c1.24 2.98 1.77 5.95 1.57 8.28a.8.8 0 0 1-1.13.68 20.82 20.82 0 0 1-4.5-3.15",
        key: "11xdqo",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const zr = e("Hotel", [
    [
      "path",
      {
        d: "M18 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2Z",
        key: "p9z69c",
      },
    ],
    [
      "path",
      {
        d: "m9 16 .348-.24c1.465-1.013 3.84-1.013 5.304 0L15 16",
        key: "1bvcvh",
      },
    ],
    ["path", { d: "M8 7h.01", key: "1vti4s" }],
    ["path", { d: "M16 7h.01", key: "1kdx03" }],
    ["path", { d: "M12 7h.01", key: "1ivr5q" }],
    ["path", { d: "M12 11h.01", key: "z322tv" }],
    ["path", { d: "M16 11h.01", key: "xkw8gn" }],
    ["path", { d: "M8 11h.01", key: "1dfujw" }],
    ["path", { d: "M10 22v-6.5m4 0V22", key: "16gs4s" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ar = e("Hourglass", [
    ["path", { d: "M5 22h14", key: "ehvnwv" }],
    ["path", { d: "M5 2h14", key: "pdyrp9" }],
    [
      "path",
      {
        d: "M17 22v-4.172a2 2 0 0 0-.586-1.414L12 12l-4.414 4.414A2 2 0 0 0 7 17.828V22",
        key: "1d314k",
      },
    ],
    [
      "path",
      {
        d: "M7 2v4.172a2 2 0 0 0 .586 1.414L12 12l4.414-4.414A2 2 0 0 0 17 6.172V2",
        key: "1vvvr6",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const jr = e("IceCream2", [
    [
      "path",
      {
        d: "M12 17c5 0 8-2.69 8-6H4c0 3.31 3 6 8 6Zm-4 4h8m-4-3v3M5.14 11a3.5 3.5 0 1 1 6.71 0",
        key: "g86ewz",
      },
    ],
    ["path", { d: "M12.14 11a3.5 3.5 0 1 1 6.71 0", key: "4k3m1s" }],
    ["path", { d: "M15.5 6.5a3.5 3.5 0 1 0-7 0", key: "zmuahr" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Vr = e("IceCream", [
    ["path", { d: "m7 11 4.08 10.35a1 1 0 0 0 1.84 0L17 11", key: "1v6356" }],
    ["path", { d: "M17 7A5 5 0 0 0 7 7", key: "151p3v" }],
    ["path", { d: "M17 7a2 2 0 0 1 0 4H7a2 2 0 0 1 0-4", key: "1sdaij" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Pr = e("ImageDown", [
    [
      "path",
      {
        d: "M10.3 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10l-3.1-3.1a2 2 0 0 0-2.814.014L6 21",
        key: "9csbqa",
      },
    ],
    ["path", { d: "m14 19 3 3v-5.5", key: "9ldu5r" }],
    ["path", { d: "m17 22 3-3", key: "1nkfve" }],
    ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Fr = e("ImageMinus", [
    [
      "path",
      {
        d: "M21 9v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7",
        key: "m87ecr",
      },
    ],
    ["line", { x1: "16", x2: "22", y1: "5", y2: "5", key: "ez7e4s" }],
    ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }],
    ["path", { d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21", key: "1xmnt7" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Br = e("ImageOff", [
    ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }],
    ["path", { d: "M10.41 10.41a2 2 0 1 1-2.83-2.83", key: "1bzlo9" }],
    ["line", { x1: "13.5", x2: "6", y1: "13.5", y2: "21", key: "1q0aeu" }],
    ["line", { x1: "18", x2: "21", y1: "12", y2: "15", key: "5mozeu" }],
    [
      "path",
      {
        d: "M3.59 3.59A1.99 1.99 0 0 0 3 5v14a2 2 0 0 0 2 2h14c.55 0 1.052-.22 1.41-.59",
        key: "mmje98",
      },
    ],
    ["path", { d: "M21 15V5a2 2 0 0 0-2-2H9", key: "43el77" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Dr = e("ImagePlus", [
    [
      "path",
      {
        d: "M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7",
        key: "31hg93",
      },
    ],
    ["line", { x1: "16", x2: "22", y1: "5", y2: "5", key: "ez7e4s" }],
    ["line", { x1: "19", x2: "19", y1: "2", y2: "8", key: "1gkr8c" }],
    ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }],
    ["path", { d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21", key: "1xmnt7" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Rr = e("ImageUp", [
    [
      "path",
      {
        d: "M10.3 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10l-3.1-3.1a2 2 0 0 0-2.814.014L6 21",
        key: "9csbqa",
      },
    ],
    ["path", { d: "m14 19.5 3-3 3 3", key: "9vmjn0" }],
    ["path", { d: "M17 22v-5.5", key: "1aa6fl" }],
    ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Tr = e("Image", [
    [
      "rect",
      {
        width: "18",
        height: "18",
        x: "3",
        y: "3",
        rx: "2",
        ry: "2",
        key: "1m3agn",
      },
    ],
    ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }],
    ["path", { d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21", key: "1xmnt7" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ur = e("Images", [
    ["path", { d: "M18 22H4a2 2 0 0 1-2-2V6", key: "pblm9e" }],
    [
      "path",
      { d: "m22 13-1.296-1.296a2.41 2.41 0 0 0-3.408 0L11 18", key: "nf6bnh" },
    ],
    ["circle", { cx: "12", cy: "8", r: "2", key: "1822b1" }],
    [
      "rect",
      { width: "16", height: "16", x: "6", y: "2", rx: "2", key: "12espp" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Zr = e("Import", [
    ["path", { d: "M12 3v12", key: "1x0j5s" }],
    ["path", { d: "m8 11 4 4 4-4", key: "1dohi6" }],
    [
      "path",
      {
        d: "M8 5H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-4",
        key: "1ywtjm",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Or = e("Inbox", [
    [
      "polyline",
      { points: "22 12 16 12 14 15 10 15 8 12 2 12", key: "o97t9d" },
    ],
    [
      "path",
      {
        d: "M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z",
        key: "oot6mr",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Gr = e("Indent", [
    ["polyline", { points: "3 8 7 12 3 16", key: "f3rxhf" }],
    ["line", { x1: "21", x2: "11", y1: "12", y2: "12", key: "1fxxak" }],
    ["line", { x1: "21", x2: "11", y1: "6", y2: "6", key: "asgu94" }],
    ["line", { x1: "21", x2: "11", y1: "18", y2: "18", key: "13dsj7" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Er = e("IndianRupee", [
    ["path", { d: "M6 3h12", key: "ggurg9" }],
    ["path", { d: "M6 8h12", key: "6g4wlu" }],
    ["path", { d: "m6 13 8.5 8", key: "u1kupk" }],
    ["path", { d: "M6 13h3", key: "wdp6ag" }],
    ["path", { d: "M9 13c6.667 0 6.667-10 0-10", key: "1nkvk2" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Wr = e("Infinity", [
    [
      "path",
      {
        d: "M12 12c-2-2.67-4-4-6-4a4 4 0 1 0 0 8c2 0 4-1.33 6-4Zm0 0c2 2.67 4 4 6 4a4 4 0 0 0 0-8c-2 0-4 1.33-6 4Z",
        key: "1z0uae",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Nr = e("Info", [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["path", { d: "M12 16v-4", key: "1dtifu" }],
    ["path", { d: "M12 8h.01", key: "e9boi3" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Xr = e("InspectionPanel", [
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" },
    ],
    ["path", { d: "M7 7h.01", key: "7u93v4" }],
    ["path", { d: "M17 7h.01", key: "14a9sn" }],
    ["path", { d: "M7 17h.01", key: "19xn7k" }],
    ["path", { d: "M17 17h.01", key: "1sd3ek" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Kr = e("Instagram", [
    [
      "rect",
      {
        width: "20",
        height: "20",
        x: "2",
        y: "2",
        rx: "5",
        ry: "5",
        key: "2e1cvw",
      },
    ],
    [
      "path",
      { d: "M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z", key: "9exkf1" },
    ],
    ["line", { x1: "17.5", x2: "17.51", y1: "6.5", y2: "6.5", key: "r4j83e" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const _r = e("Italic", [
    ["line", { x1: "19", x2: "10", y1: "4", y2: "4", key: "15jd3p" }],
    ["line", { x1: "14", x2: "5", y1: "20", y2: "20", key: "bu0au3" }],
    ["line", { x1: "15", x2: "9", y1: "4", y2: "20", key: "uljnxc" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Jr = e("IterationCcw", [
    [
      "path",
      { d: "M20 10c0-4.4-3.6-8-8-8s-8 3.6-8 8 3.6 8 8 8h8", key: "4znkd0" },
    ],
    ["polyline", { points: "16 14 20 18 16 22", key: "11njsm" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Qr = e("IterationCw", [
    [
      "path",
      { d: "M4 10c0-4.4 3.6-8 8-8s8 3.6 8 8-3.6 8-8 8H4", key: "tuf4su" },
    ],
    ["polyline", { points: "8 22 4 18 8 14", key: "evkj9s" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Yr = e("JapaneseYen", [
    ["path", { d: "M12 9.5V21m0-11.5L6 3m6 6.5L18 3", key: "2ej80x" }],
    ["path", { d: "M6 15h12", key: "1hwgt5" }],
    ["path", { d: "M6 11h12", key: "wf4gp6" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const $r = e("Joystick", [
    [
      "path",
      {
        d: "M21 17a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-2Z",
        key: "jg2n2t",
      },
    ],
    ["path", { d: "M6 15v-2", key: "gd6mvg" }],
    ["path", { d: "M12 15V9", key: "8c7uyn" }],
    ["circle", { cx: "12", cy: "6", r: "3", key: "1gm2ql" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const y1 = e("KanbanSquareDashed", [
    ["path", { d: "M8 7v7", key: "1x2jlm" }],
    ["path", { d: "M12 7v4", key: "xawao1" }],
    ["path", { d: "M16 7v9", key: "1hp2iy" }],
    ["path", { d: "M5 3a2 2 0 0 0-2 2", key: "y57alp" }],
    ["path", { d: "M9 3h1", key: "1yesri" }],
    ["path", { d: "M14 3h1", key: "1ec4yj" }],
    ["path", { d: "M19 3a2 2 0 0 1 2 2", key: "18rm91" }],
    ["path", { d: "M21 9v1", key: "mxsmne" }],
    ["path", { d: "M21 14v1", key: "169vum" }],
    ["path", { d: "M21 19a2 2 0 0 1-2 2", key: "1j7049" }],
    ["path", { d: "M14 21h1", key: "v9vybs" }],
    ["path", { d: "M9 21h1", key: "15o7lz" }],
    ["path", { d: "M5 21a2 2 0 0 1-2-2", key: "sbafld" }],
    ["path", { d: "M3 14v1", key: "vnatye" }],
    ["path", { d: "M3 9v1", key: "1r0deq" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const i1 = e("KanbanSquare", [
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" },
    ],
    ["path", { d: "M8 7v7", key: "1x2jlm" }],
    ["path", { d: "M12 7v4", key: "xawao1" }],
    ["path", { d: "M16 7v9", key: "1hp2iy" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ek = e("Kanban", [
    ["path", { d: "M6 5v11", key: "mdvv1e" }],
    ["path", { d: "M12 5v6", key: "14ar3b" }],
    ["path", { d: "M18 5v14", key: "7ji314" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ak = e("KeyRound", [
    [
      "path",
      {
        d: "M2 18v3c0 .6.4 1 1 1h4v-3h3v-3h2l1.4-1.4a6.5 6.5 0 1 0-4-4Z",
        key: "167ctg",
      },
    ],
    [
      "circle",
      { cx: "16.5", cy: "7.5", r: ".5", fill: "currentColor", key: "w0ekpg" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const tk = e("KeySquare", [
    [
      "path",
      {
        d: "M12.4 2.7c.9-.9 2.5-.9 3.4 0l5.5 5.5c.9.9.9 2.5 0 3.4l-3.7 3.7c-.9.9-2.5.9-3.4 0L8.7 9.8c-.9-.9-.9-2.5 0-3.4Z",
        key: "9li5bk",
      },
    ],
    ["path", { d: "m14 7 3 3", key: "1r5n42" }],
    [
      "path",
      { d: "M9.4 10.6 2 18v3c0 .6.4 1 1 1h4v-3h3v-3h2l1.4-1.4", key: "1ym3zm" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ck = e("Key", [
    ["circle", { cx: "7.5", cy: "15.5", r: "5.5", key: "yqb3hr" }],
    ["path", { d: "m21 2-9.6 9.6", key: "1j0ho8" }],
    ["path", { d: "m15.5 7.5 3 3L22 7l-3-3", key: "1rn1fs" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const hk = e("KeyboardMusic", [
    [
      "rect",
      { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" },
    ],
    ["path", { d: "M6 8h4", key: "utf9t1" }],
    ["path", { d: "M14 8h.01", key: "1primd" }],
    ["path", { d: "M18 8h.01", key: "emo2bl" }],
    ["path", { d: "M2 12h20", key: "9i4pu4" }],
    ["path", { d: "M6 12v4", key: "dy92yo" }],
    ["path", { d: "M10 12v4", key: "1fxnav" }],
    ["path", { d: "M14 12v4", key: "1hft58" }],
    ["path", { d: "M18 12v4", key: "tjjnbz" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const dk = e("Keyboard", [
    ["path", { d: "M10 8h.01", key: "1r9ogq" }],
    ["path", { d: "M12 12h.01", key: "1mp3jc" }],
    ["path", { d: "M14 8h.01", key: "1primd" }],
    ["path", { d: "M16 12h.01", key: "1l6xoz" }],
    ["path", { d: "M18 8h.01", key: "emo2bl" }],
    ["path", { d: "M6 8h.01", key: "x9i8wu" }],
    ["path", { d: "M7 16h10", key: "wp8him" }],
    ["path", { d: "M8 12h.01", key: "czm47f" }],
    [
      "rect",
      { x: "2", y: "4", width: "20", height: "16", rx: "2", key: "izxlao" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ok = e("LampCeiling", [
    ["path", { d: "M12 2v5", key: "nd4vlx" }],
    ["path", { d: "M6 7h12l4 9H2l4-9Z", key: "123d64" }],
    ["path", { d: "M9.17 16a3 3 0 1 0 5.66 0", key: "1061mw" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const yk = e("LampDesk", [
    ["path", { d: "m14 5-3 3 2 7 8-8-7-2Z", key: "1b0msb" }],
    ["path", { d: "m14 5-3 3-3-3 3-3 3 3Z", key: "1uemms" }],
    ["path", { d: "M9.5 6.5 4 12l3 6", key: "1bx08v" }],
    [
      "path",
      { d: "M3 22v-2c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2v2H3Z", key: "wap775" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ik = e("LampFloor", [
    ["path", { d: "M9 2h6l3 7H6l3-7Z", key: "wcx6mj" }],
    ["path", { d: "M12 9v13", key: "3n1su1" }],
    ["path", { d: "M9 22h6", key: "1rlq3v" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const nk = e("LampWallDown", [
    ["path", { d: "M11 13h6l3 7H8l3-7Z", key: "9n3qlo" }],
    ["path", { d: "M14 13V8a2 2 0 0 0-2-2H8", key: "1hu4hb" }],
    ["path", { d: "M4 9h2a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H4v6Z", key: "s053bc" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const rk = e("LampWallUp", [
    ["path", { d: "M11 4h6l3 7H8l3-7Z", key: "11x1ee" }],
    ["path", { d: "M14 11v5a2 2 0 0 1-2 2H8", key: "eutp5o" }],
    [
      "path",
      { d: "M4 15h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H4v-6Z", key: "1iuthr" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const kk = e("Lamp", [
    ["path", { d: "M8 2h8l4 10H4L8 2Z", key: "9dma5w" }],
    ["path", { d: "M12 12v6", key: "3ahymv" }],
    [
      "path",
      { d: "M8 22v-2c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2v2H8Z", key: "mwf4oh" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const pk = e("LandPlot", [
    ["path", { d: "m12 8 6-3-6-3v10", key: "mvpnpy" }],
    [
      "path",
      {
        d: "m8 11.99-5.5 3.14a1 1 0 0 0 0 1.74l8.5 4.86a2 2 0 0 0 2 0l8.5-4.86a1 1 0 0 0 0-1.74L16 12",
        key: "ek95tt",
      },
    ],
    ["path", { d: "m6.49 12.85 11.02 6.3", key: "1kt42w" }],
    ["path", { d: "M17.51 12.85 6.5 19.15", key: "v55bdg" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const lk = e("Landmark", [
    ["line", { x1: "3", x2: "21", y1: "22", y2: "22", key: "j8o0r" }],
    ["line", { x1: "6", x2: "6", y1: "18", y2: "11", key: "10tf0k" }],
    ["line", { x1: "10", x2: "10", y1: "18", y2: "11", key: "54lgf6" }],
    ["line", { x1: "14", x2: "14", y1: "18", y2: "11", key: "380y" }],
    ["line", { x1: "18", x2: "18", y1: "18", y2: "11", key: "1kevvc" }],
    ["polygon", { points: "12 2 20 7 4 7", key: "jkujk7" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const sk = e("Languages", [
    ["path", { d: "m5 8 6 6", key: "1wu5hv" }],
    ["path", { d: "m4 14 6-6 2-3", key: "1k1g8d" }],
    ["path", { d: "M2 5h12", key: "or177f" }],
    ["path", { d: "M7 2h1", key: "1t2jsx" }],
    ["path", { d: "m22 22-5-10-5 10", key: "don7ne" }],
    ["path", { d: "M14 18h6", key: "1m8k6r" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const uk = e("Laptop2", [
    [
      "rect",
      {
        width: "18",
        height: "12",
        x: "3",
        y: "4",
        rx: "2",
        ry: "2",
        key: "1qhy41",
      },
    ],
    ["line", { x1: "2", x2: "22", y1: "20", y2: "20", key: "ni3hll" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Mk = e("Laptop", [
    [
      "path",
      {
        d: "M20 16V7a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v9m16 0H4m16 0 1.28 2.55a1 1 0 0 1-.9 1.45H3.62a1 1 0 0 1-.9-1.45L4 16",
        key: "tarvll",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const vk = e("LassoSelect", [
    ["path", { d: "M7 22a5 5 0 0 1-2-4", key: "umushi" }],
    ["path", { d: "M7 16.93c.96.43 1.96.74 2.99.91", key: "ybbtv3" }],
    [
      "path",
      {
        d: "M3.34 14A6.8 6.8 0 0 1 2 10c0-4.42 4.48-8 10-8s10 3.58 10 8a7.19 7.19 0 0 1-.33 2",
        key: "gt5e1w",
      },
    ],
    ["path", { d: "M5 18a2 2 0 1 0 0-4 2 2 0 0 0 0 4z", key: "bq3ynw" }],
    [
      "path",
      {
        d: "M14.33 22h-.09a.35.35 0 0 1-.24-.32v-10a.34.34 0 0 1 .33-.34c.08 0 .15.03.21.08l7.34 6a.33.33 0 0 1-.21.59h-4.49l-2.57 3.85a.35.35 0 0 1-.28.14v0z",
        key: "1bawls",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const mk = e("Lasso", [
    ["path", { d: "M7 22a5 5 0 0 1-2-4", key: "umushi" }],
    [
      "path",
      {
        d: "M3.3 14A6.8 6.8 0 0 1 2 10c0-4.4 4.5-8 10-8s10 3.6 10 8-4.5 8-10 8a12 12 0 0 1-5-1",
        key: "146dds",
      },
    ],
    ["path", { d: "M5 18a2 2 0 1 0 0-4 2 2 0 0 0 0 4z", key: "bq3ynw" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const xk = e("Laugh", [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["path", { d: "M18 13a6 6 0 0 1-6 5 6 6 0 0 1-6-5h12Z", key: "b2q4dd" }],
    ["line", { x1: "9", x2: "9.01", y1: "9", y2: "9", key: "yxxnd0" }],
    ["line", { x1: "15", x2: "15.01", y1: "9", y2: "9", key: "1p4y9e" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const gk = e("Layers2", [
    [
      "path",
      {
        d: "m16.02 12 5.48 3.13a1 1 0 0 1 0 1.74L13 21.74a2 2 0 0 1-2 0l-8.5-4.87a1 1 0 0 1 0-1.74L7.98 12",
        key: "1cuww1",
      },
    ],
    [
      "path",
      {
        d: "M13 13.74a2 2 0 0 1-2 0L2.5 8.87a1 1 0 0 1 0-1.74L11 2.26a2 2 0 0 1 2 0l8.5 4.87a1 1 0 0 1 0 1.74Z",
        key: "pdlvxu",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Lk = e("Layers3", [
    [
      "path",
      {
        d: "m12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83Z",
        key: "8b97xw",
      },
    ],
    [
      "path",
      {
        d: "m6.08 9.5-3.5 1.6a1 1 0 0 0 0 1.81l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9a1 1 0 0 0 0-1.83l-3.5-1.59",
        key: "1e5n1m",
      },
    ],
    [
      "path",
      {
        d: "m6.08 14.5-3.5 1.6a1 1 0 0 0 0 1.81l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9a1 1 0 0 0 0-1.83l-3.5-1.59",
        key: "1iwflc",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const fk = e("Layers", [
    [
      "path",
      {
        d: "m12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83Z",
        key: "8b97xw",
      },
    ],
    [
      "path",
      { d: "m22 17.65-9.17 4.16a2 2 0 0 1-1.66 0L2 17.65", key: "dd6zsq" },
    ],
    [
      "path",
      { d: "m22 12.65-9.17 4.16a2 2 0 0 1-1.66 0L2 12.65", key: "ep9fru" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const wk = e("LayoutDashboard", [
    [
      "rect",
      { width: "7", height: "9", x: "3", y: "3", rx: "1", key: "10lvy0" },
    ],
    [
      "rect",
      { width: "7", height: "5", x: "14", y: "3", rx: "1", key: "16une8" },
    ],
    [
      "rect",
      { width: "7", height: "9", x: "14", y: "12", rx: "1", key: "1hutg5" },
    ],
    [
      "rect",
      { width: "7", height: "5", x: "3", y: "16", rx: "1", key: "ldoo1y" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ik = e("LayoutGrid", [
    [
      "rect",
      { width: "7", height: "7", x: "3", y: "3", rx: "1", key: "1g98yp" },
    ],
    [
      "rect",
      { width: "7", height: "7", x: "14", y: "3", rx: "1", key: "6d4xhi" },
    ],
    [
      "rect",
      { width: "7", height: "7", x: "14", y: "14", rx: "1", key: "nxv5o0" },
    ],
    [
      "rect",
      { width: "7", height: "7", x: "3", y: "14", rx: "1", key: "1bb6yr" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ck = e("LayoutList", [
    [
      "rect",
      { width: "7", height: "7", x: "3", y: "3", rx: "1", key: "1g98yp" },
    ],
    [
      "rect",
      { width: "7", height: "7", x: "3", y: "14", rx: "1", key: "1bb6yr" },
    ],
    ["path", { d: "M14 4h7", key: "3xa0d5" }],
    ["path", { d: "M14 9h7", key: "1icrd9" }],
    ["path", { d: "M14 15h7", key: "1mj8o2" }],
    ["path", { d: "M14 20h7", key: "11slyb" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const bk = e("LayoutPanelLeft", [
    [
      "rect",
      { width: "7", height: "18", x: "3", y: "3", rx: "1", key: "2obqm" },
    ],
    [
      "rect",
      { width: "7", height: "7", x: "14", y: "3", rx: "1", key: "6d4xhi" },
    ],
    [
      "rect",
      { width: "7", height: "7", x: "14", y: "14", rx: "1", key: "nxv5o0" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Sk = e("LayoutPanelTop", [
    [
      "rect",
      { width: "18", height: "7", x: "3", y: "3", rx: "1", key: "f1a2em" },
    ],
    [
      "rect",
      { width: "7", height: "7", x: "3", y: "14", rx: "1", key: "1bb6yr" },
    ],
    [
      "rect",
      { width: "7", height: "7", x: "14", y: "14", rx: "1", key: "nxv5o0" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const qk = e("LayoutTemplate", [
    [
      "rect",
      { width: "18", height: "7", x: "3", y: "3", rx: "1", key: "f1a2em" },
    ],
    [
      "rect",
      { width: "9", height: "7", x: "3", y: "14", rx: "1", key: "jqznyg" },
    ],
    [
      "rect",
      { width: "5", height: "7", x: "16", y: "14", rx: "1", key: "q5h2i8" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Hk = e("Leaf", [
    [
      "path",
      {
        d: "M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z",
        key: "nnexq3",
      },
    ],
    [
      "path",
      { d: "M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12", key: "mt58a7" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const zk = e("LeafyGreen", [
    [
      "path",
      {
        d: "M2 22c1.25-.987 2.27-1.975 3.9-2.2a5.56 5.56 0 0 1 3.8 1.5 4 4 0 0 0 6.187-2.353 3.5 3.5 0 0 0 3.69-5.116A3.5 3.5 0 0 0 20.95 8 3.5 3.5 0 1 0 16 3.05a3.5 3.5 0 0 0-5.831 1.373 3.5 3.5 0 0 0-5.116 3.69 4 4 0 0 0-2.348 6.155C3.499 15.42 4.409 16.712 4.2 18.1 3.926 19.743 3.014 20.732 2 22",
        key: "1134nt",
      },
    ],
    ["path", { d: "M2 22 17 7", key: "1q7jp2" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ak = e("LibraryBig", [
    [
      "rect",
      { width: "8", height: "18", x: "3", y: "3", rx: "1", key: "oynpb5" },
    ],
    ["path", { d: "M7 3v18", key: "bbkbws" }],
    [
      "path",
      {
        d: "M20.4 18.9c.2.5-.1 1.1-.6 1.3l-1.9.7c-.5.2-1.1-.1-1.3-.6L11.1 5.1c-.2-.5.1-1.1.6-1.3l1.9-.7c.5-.2 1.1.1 1.3.6Z",
        key: "1qboyk",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const jk = e("LibrarySquare", [
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" },
    ],
    ["path", { d: "M7 7v10", key: "d5nglc" }],
    ["path", { d: "M11 7v10", key: "pptsnr" }],
    ["path", { d: "m15 7 2 10", key: "1m7qm5" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Vk = e("Library", [
    ["path", { d: "m16 6 4 14", key: "ji33uf" }],
    ["path", { d: "M12 6v14", key: "1n7gus" }],
    ["path", { d: "M8 8v12", key: "1gg7y9" }],
    ["path", { d: "M4 4v16", key: "6qkkli" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Pk = e("LifeBuoy", [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["path", { d: "m4.93 4.93 4.24 4.24", key: "1ymg45" }],
    ["path", { d: "m14.83 9.17 4.24-4.24", key: "1cb5xl" }],
    ["path", { d: "m14.83 14.83 4.24 4.24", key: "q42g0n" }],
    ["path", { d: "m9.17 14.83-4.24 4.24", key: "bqpfvv" }],
    ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Fk = e("Ligature", [
    ["path", { d: "M8 20V8c0-2.2 1.8-4 4-4 1.5 0 2.8.8 3.5 2", key: "1rtphz" }],
    ["path", { d: "M6 12h4", key: "a4o3ry" }],
    ["path", { d: "M14 12h2v8", key: "c1fccl" }],
    ["path", { d: "M6 20h4", key: "1i6q5t" }],
    ["path", { d: "M14 20h4", key: "lzx1xo" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Bk = e("LightbulbOff", [
    [
      "path",
      { d: "M16.8 11.2c.8-.9 1.2-2 1.2-3.2a6 6 0 0 0-9.3-5", key: "1fkcox" },
    ],
    ["path", { d: "m2 2 20 20", key: "1ooewy" }],
    [
      "path",
      {
        d: "M6.3 6.3a4.67 4.67 0 0 0 1.2 5.2c.7.7 1.3 1.5 1.5 2.5",
        key: "10m8kw",
      },
    ],
    ["path", { d: "M9 18h6", key: "x1upvd" }],
    ["path", { d: "M10 22h4", key: "ceow96" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Dk = e("Lightbulb", [
    [
      "path",
      {
        d: "M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5",
        key: "1gvzjb",
      },
    ],
    ["path", { d: "M9 18h6", key: "x1upvd" }],
    ["path", { d: "M10 22h4", key: "ceow96" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Rk = e("LineChart", [
    ["path", { d: "M3 3v18h18", key: "1s2lah" }],
    ["path", { d: "m19 9-5 5-4-4-3 3", key: "2osh9i" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Tk = e("Link2Off", [
    ["path", { d: "M9 17H7A5 5 0 0 1 7 7", key: "10o201" }],
    ["path", { d: "M15 7h2a5 5 0 0 1 4 8", key: "1d3206" }],
    ["line", { x1: "8", x2: "12", y1: "12", y2: "12", key: "rvw6j4" }],
    ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Uk = e("Link2", [
    ["path", { d: "M9 17H7A5 5 0 0 1 7 7h2", key: "8i5ue5" }],
    ["path", { d: "M15 7h2a5 5 0 1 1 0 10h-2", key: "1b9ql8" }],
    ["line", { x1: "8", x2: "16", y1: "12", y2: "12", key: "1jonct" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Zk = e("Link", [
    [
      "path",
      {
        d: "M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71",
        key: "1cjeqo",
      },
    ],
    [
      "path",
      {
        d: "M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71",
        key: "19qd67",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ok = e("Linkedin", [
    [
      "path",
      {
        d: "M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z",
        key: "c2jq9f",
      },
    ],
    ["rect", { width: "4", height: "12", x: "2", y: "9", key: "mk3on5" }],
    ["circle", { cx: "4", cy: "4", r: "2", key: "bt5ra8" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Gk = e("ListChecks", [
    ["path", { d: "m3 17 2 2 4-4", key: "1jhpwq" }],
    ["path", { d: "m3 7 2 2 4-4", key: "1obspn" }],
    ["path", { d: "M13 6h8", key: "15sg57" }],
    ["path", { d: "M13 12h8", key: "h98zly" }],
    ["path", { d: "M13 18h8", key: "oe0vm4" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ek = e("ListCollapse", [
    ["path", { d: "m3 10 2.5-2.5L3 5", key: "i6eama" }],
    ["path", { d: "m3 19 2.5-2.5L3 14", key: "w2gmor" }],
    ["path", { d: "M10 6h11", key: "c7qv1k" }],
    ["path", { d: "M10 12h11", key: "6m4ad9" }],
    ["path", { d: "M10 18h11", key: "11hvi2" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Wk = e("ListEnd", [
    ["path", { d: "M16 12H3", key: "1a2rj7" }],
    ["path", { d: "M16 6H3", key: "1wxfjs" }],
    ["path", { d: "M10 18H3", key: "13769t" }],
    ["path", { d: "M21 6v10a2 2 0 0 1-2 2h-5", key: "ilrcs8" }],
    ["path", { d: "m16 16-2 2 2 2", key: "kkc6pm" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Nk = e("ListFilter", [
    ["path", { d: "M3 6h18", key: "d0wm0j" }],
    ["path", { d: "M7 12h10", key: "b7w52i" }],
    ["path", { d: "M10 18h4", key: "1ulq68" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Xk = e("ListMinus", [
    ["path", { d: "M11 12H3", key: "51ecnj" }],
    ["path", { d: "M16 6H3", key: "1wxfjs" }],
    ["path", { d: "M16 18H3", key: "12xzn7" }],
    ["path", { d: "M21 12h-6", key: "bt1uis" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Kk = e("ListMusic", [
    ["path", { d: "M21 15V6", key: "h1cx4g" }],
    [
      "path",
      { d: "M18.5 18a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z", key: "8saifv" },
    ],
    ["path", { d: "M12 12H3", key: "18klou" }],
    ["path", { d: "M16 6H3", key: "1wxfjs" }],
    ["path", { d: "M12 18H3", key: "11ftsu" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const _k = e("ListOrdered", [
    ["line", { x1: "10", x2: "21", y1: "6", y2: "6", key: "76qw6h" }],
    ["line", { x1: "10", x2: "21", y1: "12", y2: "12", key: "16nom4" }],
    ["line", { x1: "10", x2: "21", y1: "18", y2: "18", key: "u3jurt" }],
    ["path", { d: "M4 6h1v4", key: "cnovpq" }],
    ["path", { d: "M4 10h2", key: "16xx2s" }],
    ["path", { d: "M6 18H4c0-1 2-2 2-3s-1-1.5-2-1", key: "m9a95d" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Jk = e("ListPlus", [
    ["path", { d: "M11 12H3", key: "51ecnj" }],
    ["path", { d: "M16 6H3", key: "1wxfjs" }],
    ["path", { d: "M16 18H3", key: "12xzn7" }],
    ["path", { d: "M18 9v6", key: "1twb98" }],
    ["path", { d: "M21 12h-6", key: "bt1uis" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Qk = e("ListRestart", [
    ["path", { d: "M21 6H3", key: "1jwq7v" }],
    ["path", { d: "M7 12H3", key: "13ou7f" }],
    ["path", { d: "M7 18H3", key: "1sijw9" }],
    [
      "path",
      {
        d: "M12 18a5 5 0 0 0 9-3 4.5 4.5 0 0 0-4.5-4.5c-1.33 0-2.54.54-3.41 1.41L11 14",
        key: "qth677",
      },
    ],
    ["path", { d: "M11 10v4h4", key: "172dkj" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Yk = e("ListStart", [
    ["path", { d: "M16 12H3", key: "1a2rj7" }],
    ["path", { d: "M16 18H3", key: "12xzn7" }],
    ["path", { d: "M10 6H3", key: "lf8lx7" }],
    ["path", { d: "M21 18V8a2 2 0 0 0-2-2h-5", key: "1hghli" }],
    ["path", { d: "m16 8-2-2 2-2", key: "160uvd" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const $k = e("ListTodo", [
    [
      "rect",
      { x: "3", y: "5", width: "6", height: "6", rx: "1", key: "1defrl" },
    ],
    ["path", { d: "m3 17 2 2 4-4", key: "1jhpwq" }],
    ["path", { d: "M13 6h8", key: "15sg57" }],
    ["path", { d: "M13 12h8", key: "h98zly" }],
    ["path", { d: "M13 18h8", key: "oe0vm4" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const e4 = e("ListTree", [
    ["path", { d: "M21 12h-8", key: "1bmf0i" }],
    ["path", { d: "M21 6H8", key: "1pqkrb" }],
    ["path", { d: "M21 18h-8", key: "1tm79t" }],
    ["path", { d: "M3 6v4c0 1.1.9 2 2 2h3", key: "1ywdgy" }],
    ["path", { d: "M3 10v6c0 1.1.9 2 2 2h3", key: "2wc746" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const a4 = e("ListVideo", [
    ["path", { d: "M12 12H3", key: "18klou" }],
    ["path", { d: "M16 6H3", key: "1wxfjs" }],
    ["path", { d: "M12 18H3", key: "11ftsu" }],
    ["path", { d: "m16 12 5 3-5 3v-6Z", key: "zpskkp" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const t4 = e("ListX", [
    ["path", { d: "M11 12H3", key: "51ecnj" }],
    ["path", { d: "M16 6H3", key: "1wxfjs" }],
    ["path", { d: "M16 18H3", key: "12xzn7" }],
    ["path", { d: "m19 10-4 4", key: "1tz659" }],
    ["path", { d: "m15 10 4 4", key: "1n7nei" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const c4 = e("List", [
    ["line", { x1: "8", x2: "21", y1: "6", y2: "6", key: "7ey8pc" }],
    ["line", { x1: "8", x2: "21", y1: "12", y2: "12", key: "rjfblc" }],
    ["line", { x1: "8", x2: "21", y1: "18", y2: "18", key: "c3b1m8" }],
    ["line", { x1: "3", x2: "3.01", y1: "6", y2: "6", key: "1g7gq3" }],
    ["line", { x1: "3", x2: "3.01", y1: "12", y2: "12", key: "1pjlvk" }],
    ["line", { x1: "3", x2: "3.01", y1: "18", y2: "18", key: "28t2mc" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const h4 = e("Loader2", [
    ["path", { d: "M21 12a9 9 0 1 1-6.219-8.56", key: "13zald" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const d4 = e("Loader", [
    ["line", { x1: "12", x2: "12", y1: "2", y2: "6", key: "gza1u7" }],
    ["line", { x1: "12", x2: "12", y1: "18", y2: "22", key: "1qhbu9" }],
    ["line", { x1: "4.93", x2: "7.76", y1: "4.93", y2: "7.76", key: "xae44r" }],
    [
      "line",
      { x1: "16.24", x2: "19.07", y1: "16.24", y2: "19.07", key: "bxnmvf" },
    ],
    ["line", { x1: "2", x2: "6", y1: "12", y2: "12", key: "89khin" }],
    ["line", { x1: "18", x2: "22", y1: "12", y2: "12", key: "pb8tfm" }],
    [
      "line",
      { x1: "4.93", x2: "7.76", y1: "19.07", y2: "16.24", key: "1uxjnu" },
    ],
    [
      "line",
      { x1: "16.24", x2: "19.07", y1: "7.76", y2: "4.93", key: "6duxfx" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const o4 = e("LocateFixed", [
    ["line", { x1: "2", x2: "5", y1: "12", y2: "12", key: "bvdh0s" }],
    ["line", { x1: "19", x2: "22", y1: "12", y2: "12", key: "1tbv5k" }],
    ["line", { x1: "12", x2: "12", y1: "2", y2: "5", key: "11lu5j" }],
    ["line", { x1: "12", x2: "12", y1: "19", y2: "22", key: "x3vr5v" }],
    ["circle", { cx: "12", cy: "12", r: "7", key: "fim9np" }],
    ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const y4 = e("LocateOff", [
    ["line", { x1: "2", x2: "5", y1: "12", y2: "12", key: "bvdh0s" }],
    ["line", { x1: "19", x2: "22", y1: "12", y2: "12", key: "1tbv5k" }],
    ["line", { x1: "12", x2: "12", y1: "2", y2: "5", key: "11lu5j" }],
    ["line", { x1: "12", x2: "12", y1: "19", y2: "22", key: "x3vr5v" }],
    [
      "path",
      {
        d: "M7.11 7.11C5.83 8.39 5 10.1 5 12c0 3.87 3.13 7 7 7 1.9 0 3.61-.83 4.89-2.11",
        key: "1oh7ia",
      },
    ],
    [
      "path",
      {
        d: "M18.71 13.96c.19-.63.29-1.29.29-1.96 0-3.87-3.13-7-7-7-.67 0-1.33.1-1.96.29",
        key: "3qdecy",
      },
    ],
    ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const i4 = e("Locate", [
    ["line", { x1: "2", x2: "5", y1: "12", y2: "12", key: "bvdh0s" }],
    ["line", { x1: "19", x2: "22", y1: "12", y2: "12", key: "1tbv5k" }],
    ["line", { x1: "12", x2: "12", y1: "2", y2: "5", key: "11lu5j" }],
    ["line", { x1: "12", x2: "12", y1: "19", y2: "22", key: "x3vr5v" }],
    ["circle", { cx: "12", cy: "12", r: "7", key: "fim9np" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const n4 = e("LockKeyhole", [
    ["circle", { cx: "12", cy: "16", r: "1", key: "1au0dj" }],
    [
      "rect",
      { x: "3", y: "10", width: "18", height: "12", rx: "2", key: "6s8ecr" },
    ],
    ["path", { d: "M7 10V7a5 5 0 0 1 10 0v3", key: "1pqi11" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const r4 = e("Lock", [
    [
      "rect",
      {
        width: "18",
        height: "11",
        x: "3",
        y: "11",
        rx: "2",
        ry: "2",
        key: "1w4ew1",
      },
    ],
    ["path", { d: "M7 11V7a5 5 0 0 1 10 0v4", key: "fwvmzm" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const k4 = e("LogIn", [
    ["path", { d: "M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4", key: "u53s6r" }],
    ["polyline", { points: "10 17 15 12 10 7", key: "1ail0h" }],
    ["line", { x1: "15", x2: "3", y1: "12", y2: "12", key: "v6grx8" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const p4 = e("LogOut", [
    ["path", { d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4", key: "1uf3rs" }],
    ["polyline", { points: "16 17 21 12 16 7", key: "1gabdz" }],
    ["line", { x1: "21", x2: "9", y1: "12", y2: "12", key: "1uyos4" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const l4 = e("Lollipop", [
    ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
    ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }],
    [
      "path",
      { d: "M11 11a2 2 0 0 0 4 0 4 4 0 0 0-8 0 6 6 0 0 0 12 0", key: "107gwy" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const s4 = e("Luggage", [
    [
      "path",
      {
        d: "M6 20h0a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h0",
        key: "1h5fkc",
      },
    ],
    ["path", { d: "M8 18V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v14", key: "1l99gc" }],
    ["path", { d: "M10 20h4", key: "ni2waw" }],
    ["circle", { cx: "16", cy: "20", r: "2", key: "1vifvg" }],
    ["circle", { cx: "8", cy: "20", r: "2", key: "ckkr5m" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const u4 = e("MSquare", [
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" },
    ],
    ["path", { d: "M8 16V8l4 4 4-4v8", key: "141u4e" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const M4 = e("Magnet", [
    [
      "path",
      {
        d: "m6 15-4-4 6.75-6.77a7.79 7.79 0 0 1 11 11L13 22l-4-4 6.39-6.36a2.14 2.14 0 0 0-3-3L6 15",
        key: "1i3lhw",
      },
    ],
    ["path", { d: "m5 8 4 4", key: "j6kj7e" }],
    ["path", { d: "m12 15 4 4", key: "lnac28" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const v4 = e("MailCheck", [
    [
      "path",
      {
        d: "M22 13V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h8",
        key: "12jkf8",
      },
    ],
    ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }],
    ["path", { d: "m16 19 2 2 4-4", key: "1b14m6" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const m4 = e("MailMinus", [
    [
      "path",
      {
        d: "M22 15V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h8",
        key: "fuxbkv",
      },
    ],
    ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }],
    ["path", { d: "M16 19h6", key: "xwg31i" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const x4 = e("MailOpen", [
    [
      "path",
      {
        d: "M21.2 8.4c.5.38.8.97.8 1.6v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V10a2 2 0 0 1 .8-1.6l8-6a2 2 0 0 1 2.4 0l8 6Z",
        key: "1jhwl8",
      },
    ],
    [
      "path",
      { d: "m22 10-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 10", key: "1qfld7" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const g4 = e("MailPlus", [
    [
      "path",
      {
        d: "M22 13V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h8",
        key: "12jkf8",
      },
    ],
    ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }],
    ["path", { d: "M19 16v6", key: "tddt3s" }],
    ["path", { d: "M16 19h6", key: "xwg31i" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const L4 = e("MailQuestion", [
    [
      "path",
      {
        d: "M22 10.5V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h12.5",
        key: "e61zoh",
      },
    ],
    ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }],
    [
      "path",
      {
        d: "M18 15.28c.2-.4.5-.8.9-1a2.1 2.1 0 0 1 2.6.4c.3.4.5.8.5 1.3 0 1.3-2 2-2 2",
        key: "7z9rxb",
      },
    ],
    ["path", { d: "M20 22v.01", key: "12bgn6" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const f4 = e("MailSearch", [
    [
      "path",
      {
        d: "M22 12.5V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h7.5",
        key: "w80f2v",
      },
    ],
    ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }],
    ["path", { d: "M18 21a3 3 0 1 0 0-6 3 3 0 0 0 0 6v0Z", key: "mgbru4" }],
    ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
    ["path", { d: "m22 22-1.5-1.5", key: "1x83k4" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const w4 = e("MailWarning", [
    [
      "path",
      {
        d: "M22 10.5V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h12.5",
        key: "e61zoh",
      },
    ],
    ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }],
    ["path", { d: "M20 14v4", key: "1hm744" }],
    ["path", { d: "M20 22v.01", key: "12bgn6" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const I4 = e("MailX", [
    [
      "path",
      {
        d: "M22 13V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h9",
        key: "1j9vog",
      },
    ],
    ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }],
    ["path", { d: "m17 17 4 4", key: "1b3523" }],
    ["path", { d: "m21 17-4 4", key: "uinynz" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const E1 = e("Mail", [
    [
      "rect",
      { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" },
    ],
    ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const C4 = e("Mailbox", [
    [
      "path",
      {
        d: "M22 17a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9.5C2 7 4 5 6.5 5H18c2.2 0 4 1.8 4 4v8Z",
        key: "1lbycx",
      },
    ],
    ["polyline", { points: "15,9 18,9 18,11", key: "1pm9c0" }],
    ["path", { d: "M6.5 5C9 5 11 7 11 9.5V17a2 2 0 0 1-2 2v0", key: "n6nfvi" }],
    ["line", { x1: "6", x2: "7", y1: "10", y2: "10", key: "1e2scm" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const b4 = e("Mails", [
    [
      "rect",
      { width: "16", height: "13", x: "6", y: "4", rx: "2", key: "1drq3f" },
    ],
    ["path", { d: "m22 7-7.1 3.78c-.57.3-1.23.3-1.8 0L6 7", key: "xn252p" }],
    ["path", { d: "M2 8v11c0 1.1.9 2 2 2h14", key: "n13cji" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const S4 = e("MapPinOff", [
    [
      "path",
      {
        d: "M5.43 5.43A8.06 8.06 0 0 0 4 10c0 6 8 12 8 12a29.94 29.94 0 0 0 5-5",
        key: "12a8pk",
      },
    ],
    [
      "path",
      {
        d: "M19.18 13.52A8.66 8.66 0 0 0 20 10a8 8 0 0 0-8-8 7.88 7.88 0 0 0-3.52.82",
        key: "1r9f6y",
      },
    ],
    [
      "path",
      {
        d: "M9.13 9.13A2.78 2.78 0 0 0 9 10a3 3 0 0 0 3 3 2.78 2.78 0 0 0 .87-.13",
        key: "erynq7",
      },
    ],
    ["path", { d: "M14.9 9.25a3 3 0 0 0-2.15-2.16", key: "1hwwmx" }],
    ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const q4 = e("MapPin", [
    [
      "path",
      { d: "M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z", key: "2oe9fu" },
    ],
    ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const H4 = e("MapPinned", [
    [
      "path",
      { d: "M18 8c0 4.5-6 9-6 9s-6-4.5-6-9a6 6 0 0 1 12 0", key: "yrbn30" },
    ],
    ["circle", { cx: "12", cy: "8", r: "2", key: "1822b1" }],
    [
      "path",
      {
        d: "M8.835 14H5a1 1 0 0 0-.9.7l-2 6c-.1.1-.1.2-.1.3 0 .6.4 1 1 1h18c.6 0 1-.4 1-1 0-.1 0-.2-.1-.3l-2-6a1 1 0 0 0-.9-.7h-3.835",
        key: "112zkj",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const z4 = e("Map", [
    [
      "polygon",
      { points: "3 6 9 3 15 6 21 3 21 18 15 21 9 18 3 21", key: "ok2ie8" },
    ],
    ["line", { x1: "9", x2: "9", y1: "3", y2: "18", key: "w34qz5" }],
    ["line", { x1: "15", x2: "15", y1: "6", y2: "21", key: "volv9a" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const A4 = e("Martini", [
    ["path", { d: "M8 22h8", key: "rmew8v" }],
    ["path", { d: "M12 11v11", key: "ur9y6a" }],
    ["path", { d: "m19 3-7 8-7-8Z", key: "1sgpiw" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const j4 = e("Maximize2", [
    ["polyline", { points: "15 3 21 3 21 9", key: "mznyad" }],
    ["polyline", { points: "9 21 3 21 3 15", key: "1avn1i" }],
    ["line", { x1: "21", x2: "14", y1: "3", y2: "10", key: "ota7mn" }],
    ["line", { x1: "3", x2: "10", y1: "21", y2: "14", key: "1atl0r" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const V4 = e("Maximize", [
    ["path", { d: "M8 3H5a2 2 0 0 0-2 2v3", key: "1dcmit" }],
    ["path", { d: "M21 8V5a2 2 0 0 0-2-2h-3", key: "1e4gt3" }],
    ["path", { d: "M3 16v3a2 2 0 0 0 2 2h3", key: "wsl5sc" }],
    ["path", { d: "M16 21h3a2 2 0 0 0 2-2v-3", key: "18trek" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const P4 = e("Medal", [
    [
      "path",
      {
        d: "M7.21 15 2.66 7.14a2 2 0 0 1 .13-2.2L4.4 2.8A2 2 0 0 1 6 2h12a2 2 0 0 1 1.6.8l1.6 2.14a2 2 0 0 1 .14 2.2L16.79 15",
        key: "143lza",
      },
    ],
    ["path", { d: "M11 12 5.12 2.2", key: "qhuxz6" }],
    ["path", { d: "m13 12 5.88-9.8", key: "hbye0f" }],
    ["path", { d: "M8 7h8", key: "i86dvs" }],
    ["circle", { cx: "12", cy: "17", r: "5", key: "qbz8iq" }],
    ["path", { d: "M12 18v-2h-.5", key: "fawc4q" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const F4 = e("MegaphoneOff", [
    ["path", { d: "M9.26 9.26 3 11v3l14.14 3.14", key: "3429n" }],
    ["path", { d: "M21 15.34V6l-7.31 2.03", key: "4o1dh8" }],
    ["path", { d: "M11.6 16.8a3 3 0 1 1-5.8-1.6", key: "1yl0tm" }],
    ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const B4 = e("Megaphone", [
    ["path", { d: "m3 11 18-5v12L3 14v-3z", key: "n962bs" }],
    ["path", { d: "M11.6 16.8a3 3 0 1 1-5.8-1.6", key: "1yl0tm" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const D4 = e("Meh", [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["line", { x1: "8", x2: "16", y1: "15", y2: "15", key: "1xb1d9" }],
    ["line", { x1: "9", x2: "9.01", y1: "9", y2: "9", key: "yxxnd0" }],
    ["line", { x1: "15", x2: "15.01", y1: "9", y2: "9", key: "1p4y9e" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const R4 = e("MemoryStick", [
    ["path", { d: "M6 19v-3", key: "1nvgqn" }],
    ["path", { d: "M10 19v-3", key: "iu8nkm" }],
    ["path", { d: "M14 19v-3", key: "kcehxu" }],
    ["path", { d: "M18 19v-3", key: "1vh91z" }],
    ["path", { d: "M8 11V9", key: "63erz4" }],
    ["path", { d: "M16 11V9", key: "fru6f3" }],
    ["path", { d: "M12 11V9", key: "ha00sb" }],
    ["path", { d: "M2 15h20", key: "16ne18" }],
    [
      "path",
      {
        d: "M2 7a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v1.1a2 2 0 0 0 0 3.837V17a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-5.1a2 2 0 0 0 0-3.837Z",
        key: "lhddv3",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const T4 = e("MenuSquare", [
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" },
    ],
    ["path", { d: "M7 8h10", key: "1jw688" }],
    ["path", { d: "M7 12h10", key: "b7w52i" }],
    ["path", { d: "M7 16h10", key: "wp8him" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const U4 = e("Menu", [
    ["line", { x1: "4", x2: "20", y1: "12", y2: "12", key: "1e0a9i" }],
    ["line", { x1: "4", x2: "20", y1: "6", y2: "6", key: "1owob3" }],
    ["line", { x1: "4", x2: "20", y1: "18", y2: "18", key: "yk5zj1" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Z4 = e("Merge", [
    ["path", { d: "m8 6 4-4 4 4", key: "ybng9g" }],
    ["path", { d: "M12 2v10.3a4 4 0 0 1-1.172 2.872L4 22", key: "1hyw0i" }],
    ["path", { d: "m20 22-5-5", key: "1m27yz" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const O4 = e("MessageCircleCode", [
    ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }],
    ["path", { d: "m10 10-2 2 2 2", key: "p6et6i" }],
    ["path", { d: "m14 10 2 2-2 2", key: "1kkmpt" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const G4 = e("MessageCircleDashed", [
    ["path", { d: "M13.5 3.1c-.5 0-1-.1-1.5-.1s-1 .1-1.5.1", key: "16ll65" }],
    ["path", { d: "M19.3 6.8a10.45 10.45 0 0 0-2.1-2.1", key: "1nq77a" }],
    ["path", { d: "M20.9 13.5c.1-.5.1-1 .1-1.5s-.1-1-.1-1.5", key: "1sf7wn" }],
    ["path", { d: "M17.2 19.3a10.45 10.45 0 0 0 2.1-2.1", key: "x1hs5g" }],
    ["path", { d: "M10.5 20.9c.5.1 1 .1 1.5.1s1-.1 1.5-.1", key: "19m18z" }],
    ["path", { d: "M3.5 17.5 2 22l4.5-1.5", key: "1f36qi" }],
    ["path", { d: "M3.1 10.5c0 .5-.1 1-.1 1.5s.1 1 .1 1.5", key: "1vz3ju" }],
    ["path", { d: "M6.8 4.7a10.45 10.45 0 0 0-2.1 2.1", key: "19f9do" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const E4 = e("MessageCircleHeart", [
    ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }],
    [
      "path",
      {
        d: "M15.8 9.2a2.5 2.5 0 0 0-3.5 0l-.3.4-.35-.3a2.42 2.42 0 1 0-3.2 3.6l3.6 3.5 3.6-3.5c1.2-1.2 1.1-2.7.2-3.7",
        key: "43lnbm",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const W4 = e("MessageCircleMore", [
    ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }],
    ["path", { d: "M8 12h.01", key: "czm47f" }],
    ["path", { d: "M12 12h.01", key: "1mp3jc" }],
    ["path", { d: "M16 12h.01", key: "1l6xoz" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const N4 = e("MessageCircleOff", [
    ["path", { d: "M20.5 14.9A9 9 0 0 0 9.1 3.5", key: "1iebmn" }],
    ["path", { d: "m2 2 20 20", key: "1ooewy" }],
    [
      "path",
      {
        d: "M5.6 5.6C3 8.3 2.2 12.5 4 16l-2 6 6-2c3.4 1.8 7.6 1.1 10.3-1.7",
        key: "1ov8ce",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const X4 = e("MessageCirclePlus", [
    ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }],
    ["path", { d: "M8 12h8", key: "1wcyev" }],
    ["path", { d: "M12 8v8", key: "napkw2" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const K4 = e("MessageCircleQuestion", [
    ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }],
    ["path", { d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3", key: "1u773s" }],
    ["path", { d: "M12 17h.01", key: "p32p05" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const _4 = e("MessageCircleReply", [
    ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }],
    ["path", { d: "m10 15-3-3 3-3", key: "1pgupc" }],
    ["path", { d: "M7 12h7a2 2 0 0 1 2 2v1", key: "1gheu4" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const J4 = e("MessageCircleWarning", [
    ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }],
    ["path", { d: "M12 8v4", key: "1got3b" }],
    ["path", { d: "M12 16h.01", key: "1drbdi" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Q4 = e("MessageCircleX", [
    ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }],
    ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
    ["path", { d: "m9 9 6 6", key: "z0biqf" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Y4 = e("MessageCircle", [
    ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const $4 = e("MessageSquareCode", [
    [
      "path",
      {
        d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z",
        key: "1lielz",
      },
    ],
    ["path", { d: "m10 8-2 2 2 2", key: "19bv1o" }],
    ["path", { d: "m14 8 2 2-2 2", key: "1whylv" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ep = e("MessageSquareDashed", [
    ["path", { d: "M3 6V5c0-1.1.9-2 2-2h2", key: "9usibi" }],
    ["path", { d: "M11 3h3", key: "1c3ji7" }],
    ["path", { d: "M18 3h1c1.1 0 2 .9 2 2", key: "19esxn" }],
    ["path", { d: "M21 9v2", key: "p14lih" }],
    ["path", { d: "M21 15c0 1.1-.9 2-2 2h-1", key: "1fo1j8" }],
    ["path", { d: "M14 17h-3", key: "1w4p2m" }],
    ["path", { d: "m7 17-4 4v-5", key: "ph9x1h" }],
    ["path", { d: "M3 12v-2", key: "856n1q" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ap = e("MessageSquareDiff", [
    [
      "path",
      {
        d: "m5 19-2 2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2",
        key: "1xuzuj",
      },
    ],
    ["path", { d: "M9 10h6", key: "9gxzsh" }],
    ["path", { d: "M12 7v6", key: "lw1j43" }],
    ["path", { d: "M9 17h6", key: "r8uit2" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const tp = e("MessageSquareDot", [
    [
      "path",
      {
        d: "M11.7 3H5a2 2 0 0 0-2 2v16l4-4h12a2 2 0 0 0 2-2v-2.7",
        key: "uodpkb",
      },
    ],
    ["circle", { cx: "18", cy: "6", r: "3", key: "1h7g24" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const cp = e("MessageSquareHeart", [
    [
      "path",
      {
        d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z",
        key: "1lielz",
      },
    ],
    [
      "path",
      {
        d: "M14.8 7.5a1.84 1.84 0 0 0-2.6 0l-.2.3-.3-.3a1.84 1.84 0 1 0-2.4 2.8L12 13l2.7-2.7c.9-.9.8-2.1.1-2.8",
        key: "1blaws",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const hp = e("MessageSquareMore", [
    [
      "path",
      {
        d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z",
        key: "1lielz",
      },
    ],
    ["path", { d: "M8 10h.01", key: "19clt8" }],
    ["path", { d: "M12 10h.01", key: "1nrarc" }],
    ["path", { d: "M16 10h.01", key: "1m94wz" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const dp = e("MessageSquareOff", [
    ["path", { d: "M21 15V5a2 2 0 0 0-2-2H9", key: "43el77" }],
    ["path", { d: "m2 2 20 20", key: "1ooewy" }],
    ["path", { d: "M3.6 3.6c-.4.3-.6.8-.6 1.4v16l4-4h10", key: "pwpm4a" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const op = e("MessageSquarePlus", [
    [
      "path",
      {
        d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z",
        key: "1lielz",
      },
    ],
    ["path", { d: "M12 7v6", key: "lw1j43" }],
    ["path", { d: "M9 10h6", key: "9gxzsh" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const yp = e("MessageSquareQuote", [
    [
      "path",
      {
        d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z",
        key: "1lielz",
      },
    ],
    ["path", { d: "M8 12a2 2 0 0 0 2-2V8H8", key: "1jfesj" }],
    ["path", { d: "M14 12a2 2 0 0 0 2-2V8h-2", key: "1dq9mh" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ip = e("MessageSquareReply", [
    [
      "path",
      {
        d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z",
        key: "1lielz",
      },
    ],
    ["path", { d: "m10 7-3 3 3 3", key: "1eugdv" }],
    ["path", { d: "M17 13v-1a2 2 0 0 0-2-2H7", key: "ernfh3" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const np = e("MessageSquareShare", [
    [
      "path",
      { d: "M21 12v3a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h7", key: "tqtdkg" },
    ],
    ["path", { d: "M16 3h5v5", key: "1806ms" }],
    ["path", { d: "m16 8 5-5", key: "15mbrl" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const rp = e("MessageSquareText", [
    [
      "path",
      {
        d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z",
        key: "1lielz",
      },
    ],
    ["path", { d: "M13 8H7", key: "14i4kc" }],
    ["path", { d: "M17 12H7", key: "16if0g" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const kp = e("MessageSquareWarning", [
    [
      "path",
      {
        d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z",
        key: "1lielz",
      },
    ],
    ["path", { d: "M12 7v2", key: "stiyo7" }],
    ["path", { d: "M12 13h.01", key: "y0uutt" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const pp = e("MessageSquareX", [
    [
      "path",
      {
        d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z",
        key: "1lielz",
      },
    ],
    ["path", { d: "m14.5 7.5-5 5", key: "3lb6iw" }],
    ["path", { d: "m9.5 7.5 5 5", key: "ko136h" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const lp = e("MessageSquare", [
    [
      "path",
      {
        d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z",
        key: "1lielz",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const sp = e("MessagesSquare", [
    [
      "path",
      {
        d: "M14 9a2 2 0 0 1-2 2H6l-4 4V4c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2v5Z",
        key: "16vlm8",
      },
    ],
    [
      "path",
      { d: "M18 9h2a2 2 0 0 1 2 2v11l-4-4h-6a2 2 0 0 1-2-2v-1", key: "1cx29u" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const up = e("Mic2", [
    [
      "path",
      { d: "m12 8-9.04 9.06a2.82 2.82 0 1 0 3.98 3.98L16 12", key: "zoua8r" },
    ],
    ["circle", { cx: "17", cy: "7", r: "5", key: "1fomce" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Mp = e("MicOff", [
    ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }],
    ["path", { d: "M18.89 13.23A7.12 7.12 0 0 0 19 12v-2", key: "80xlxr" }],
    ["path", { d: "M5 10v2a7 7 0 0 0 12 5", key: "p2k8kg" }],
    ["path", { d: "M15 9.34V5a3 3 0 0 0-5.68-1.33", key: "1gzdoj" }],
    ["path", { d: "M9 9v3a3 3 0 0 0 5.12 2.12", key: "r2i35w" }],
    ["line", { x1: "12", x2: "12", y1: "19", y2: "22", key: "x3vr5v" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const vp = e("Mic", [
    [
      "path",
      {
        d: "M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z",
        key: "131961",
      },
    ],
    ["path", { d: "M19 10v2a7 7 0 0 1-14 0v-2", key: "1vc78b" }],
    ["line", { x1: "12", x2: "12", y1: "19", y2: "22", key: "x3vr5v" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const mp = e("Microscope", [
    ["path", { d: "M6 18h8", key: "1borvv" }],
    ["path", { d: "M3 22h18", key: "8prr45" }],
    ["path", { d: "M14 22a7 7 0 1 0 0-14h-1", key: "1jwaiy" }],
    ["path", { d: "M9 14h2", key: "197e7h" }],
    ["path", { d: "M9 12a2 2 0 0 1-2-2V6h6v4a2 2 0 0 1-2 2Z", key: "1bmzmy" }],
    ["path", { d: "M12 6V3a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v3", key: "1drr47" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const xp = e("Microwave", [
    [
      "rect",
      { width: "20", height: "15", x: "2", y: "4", rx: "2", key: "2no95f" },
    ],
    [
      "rect",
      { width: "8", height: "7", x: "6", y: "8", rx: "1", key: "zh9wx" },
    ],
    ["path", { d: "M18 8v7", key: "o5zi4n" }],
    ["path", { d: "M6 19v2", key: "1loha6" }],
    ["path", { d: "M18 19v2", key: "1dawf0" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const gp = e("Milestone", [
    [
      "path",
      {
        d: "M18 6H5a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h13l4-3.5L18 6Z",
        key: "1mp5s7",
      },
    ],
    ["path", { d: "M12 13v8", key: "1l5pq0" }],
    ["path", { d: "M12 3v3", key: "1n5kay" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Lp = e("MilkOff", [
    ["path", { d: "M8 2h8", key: "1ssgc1" }],
    [
      "path",
      {
        d: "M9 2v1.343M15 2v2.789a4 4 0 0 0 .672 2.219l.656.984a4 4 0 0 1 .672 2.22v1.131M7.8 7.8l-.128.192A4 4 0 0 0 7 10.212V20a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-3",
        key: "y0ejgx",
      },
    ],
    [
      "path",
      {
        d: "M7 15a6.47 6.47 0 0 1 5 0 6.472 6.472 0 0 0 3.435.435",
        key: "iaxqsy",
      },
    ],
    ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const fp = e("Milk", [
    ["path", { d: "M8 2h8", key: "1ssgc1" }],
    [
      "path",
      {
        d: "M9 2v2.789a4 4 0 0 1-.672 2.219l-.656.984A4 4 0 0 0 7 10.212V20a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-9.789a4 4 0 0 0-.672-2.219l-.656-.984A4 4 0 0 1 15 4.788V2",
        key: "qtp12x",
      },
    ],
    [
      "path",
      { d: "M7 15a6.472 6.472 0 0 1 5 0 6.47 6.47 0 0 0 5 0", key: "ygeh44" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const wp = e("Minimize2", [
    ["polyline", { points: "4 14 10 14 10 20", key: "11kfnr" }],
    ["polyline", { points: "20 10 14 10 14 4", key: "rlmsce" }],
    ["line", { x1: "14", x2: "21", y1: "10", y2: "3", key: "o5lafz" }],
    ["line", { x1: "3", x2: "10", y1: "21", y2: "14", key: "1atl0r" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ip = e("Minimize", [
    ["path", { d: "M8 3v3a2 2 0 0 1-2 2H3", key: "hohbtr" }],
    ["path", { d: "M21 8h-3a2 2 0 0 1-2-2V3", key: "5jw1f3" }],
    ["path", { d: "M3 16h3a2 2 0 0 1 2 2v3", key: "198tvr" }],
    ["path", { d: "M16 21v-3a2 2 0 0 1 2-2h3", key: "ph8mxp" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Cp = e("MinusCircle", [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["path", { d: "M8 12h8", key: "1wcyev" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const bp = e("MinusSquare", [
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" },
    ],
    ["path", { d: "M8 12h8", key: "1wcyev" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Sp = e("Minus", [["path", { d: "M5 12h14", key: "1ays0h" }]])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const qp = e("MonitorCheck", [
    ["path", { d: "m9 10 2 2 4-4", key: "1gnqz4" }],
    [
      "rect",
      { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" },
    ],
    ["path", { d: "M12 17v4", key: "1riwvh" }],
    ["path", { d: "M8 21h8", key: "1ev6f3" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Hp = e("MonitorDot", [
    ["circle", { cx: "19", cy: "6", r: "3", key: "108a5v" }],
    [
      "path",
      {
        d: "M22 12v3a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h9",
        key: "1fet9y",
      },
    ],
    ["path", { d: "M12 17v4", key: "1riwvh" }],
    ["path", { d: "M8 21h8", key: "1ev6f3" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const zp = e("MonitorDown", [
    ["path", { d: "M12 13V7", key: "h0r20n" }],
    ["path", { d: "m15 10-3 3-3-3", key: "lzhmyn" }],
    [
      "rect",
      { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" },
    ],
    ["path", { d: "M12 17v4", key: "1riwvh" }],
    ["path", { d: "M8 21h8", key: "1ev6f3" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ap = e("MonitorOff", [
    ["path", { d: "M17 17H4a2 2 0 0 1-2-2V5c0-1.5 1-2 1-2", key: "k0q8oc" }],
    ["path", { d: "M22 15V5a2 2 0 0 0-2-2H9", key: "cp1ac0" }],
    ["path", { d: "M8 21h8", key: "1ev6f3" }],
    ["path", { d: "M12 17v4", key: "1riwvh" }],
    ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const jp = e("MonitorPause", [
    ["path", { d: "M10 13V7", key: "1u13u9" }],
    ["path", { d: "M14 13V7", key: "1vj9om" }],
    [
      "rect",
      { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" },
    ],
    ["path", { d: "M12 17v4", key: "1riwvh" }],
    ["path", { d: "M8 21h8", key: "1ev6f3" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Vp = e("MonitorPlay", [
    ["path", { d: "m10 7 5 3-5 3Z", key: "29ljg6" }],
    [
      "rect",
      { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" },
    ],
    ["path", { d: "M12 17v4", key: "1riwvh" }],
    ["path", { d: "M8 21h8", key: "1ev6f3" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Pp = e("MonitorSmartphone", [
    [
      "path",
      {
        d: "M18 8V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h8",
        key: "10dyio",
      },
    ],
    ["path", { d: "M10 19v-3.96 3.15", key: "1irgej" }],
    ["path", { d: "M7 19h5", key: "qswx4l" }],
    [
      "rect",
      { width: "6", height: "10", x: "16", y: "12", rx: "2", key: "1egngj" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Fp = e("MonitorSpeaker", [
    ["path", { d: "M5.5 20H8", key: "1k40s5" }],
    ["path", { d: "M17 9h.01", key: "1j24nn" }],
    [
      "rect",
      { width: "10", height: "16", x: "12", y: "4", rx: "2", key: "ixliua" },
    ],
    ["path", { d: "M8 6H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h4", key: "1mp6e1" }],
    ["circle", { cx: "17", cy: "15", r: "1", key: "tqvash" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Bp = e("MonitorStop", [
    ["rect", { x: "9", y: "7", width: "6", height: "6", key: "4xvc6r" }],
    [
      "rect",
      { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" },
    ],
    ["path", { d: "M12 17v4", key: "1riwvh" }],
    ["path", { d: "M8 21h8", key: "1ev6f3" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Dp = e("MonitorUp", [
    ["path", { d: "m9 10 3-3 3 3", key: "11gsxs" }],
    ["path", { d: "M12 13V7", key: "h0r20n" }],
    [
      "rect",
      { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" },
    ],
    ["path", { d: "M12 17v4", key: "1riwvh" }],
    ["path", { d: "M8 21h8", key: "1ev6f3" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Rp = e("MonitorX", [
    ["path", { d: "m14.5 12.5-5-5", key: "1jahn5" }],
    ["path", { d: "m9.5 12.5 5-5", key: "1k2t7b" }],
    [
      "rect",
      { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" },
    ],
    ["path", { d: "M12 17v4", key: "1riwvh" }],
    ["path", { d: "M8 21h8", key: "1ev6f3" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Tp = e("Monitor", [
    [
      "rect",
      { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" },
    ],
    ["line", { x1: "8", x2: "16", y1: "21", y2: "21", key: "1svkeh" }],
    ["line", { x1: "12", x2: "12", y1: "17", y2: "21", key: "vw1qmm" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Up = e("MoonStar", [
    ["path", { d: "M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z", key: "a7tn18" }],
    ["path", { d: "M19 3v4", key: "vgv24u" }],
    ["path", { d: "M21 5h-4", key: "1wcg1f" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Zp = e("Moon", [
    ["path", { d: "M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z", key: "a7tn18" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Op = e("MoreHorizontal", [
    ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
    ["circle", { cx: "19", cy: "12", r: "1", key: "1wjl8i" }],
    ["circle", { cx: "5", cy: "12", r: "1", key: "1pcz8c" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Gp = e("MoreVertical", [
    ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
    ["circle", { cx: "12", cy: "5", r: "1", key: "gxeob9" }],
    ["circle", { cx: "12", cy: "19", r: "1", key: "lyex9k" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ep = e("MountainSnow", [
    ["path", { d: "m8 3 4 8 5-5 5 15H2L8 3z", key: "otkl63" }],
    [
      "path",
      {
        d: "M4.14 15.08c2.62-1.57 5.24-1.43 7.86.42 2.74 1.94 5.49 2 8.23.19",
        key: "1pvmmp",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Wp = e("Mountain", [
    ["path", { d: "m8 3 4 8 5-5 5 15H2L8 3z", key: "otkl63" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Np = e("MousePointer2", [
    ["path", { d: "m4 4 7.07 17 2.51-7.39L21 11.07z", key: "1vqm48" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Xp = e("MousePointerClick", [
    ["path", { d: "m9 9 5 12 1.8-5.2L21 14Z", key: "1b76lo" }],
    ["path", { d: "M7.2 2.2 8 5.1", key: "1cfko1" }],
    ["path", { d: "m5.1 8-2.9-.8", key: "1go3kf" }],
    ["path", { d: "M14 4.1 12 6", key: "ita8i4" }],
    ["path", { d: "m6 12-1.9 2", key: "mnht97" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Kp = e("MousePointerSquareDashed", [
    ["path", { d: "M5 3a2 2 0 0 0-2 2", key: "y57alp" }],
    ["path", { d: "M19 3a2 2 0 0 1 2 2", key: "18rm91" }],
    ["path", { d: "m12 12 4 10 1.7-4.3L22 16Z", key: "64ilsv" }],
    ["path", { d: "M5 21a2 2 0 0 1-2-2", key: "sbafld" }],
    ["path", { d: "M9 3h1", key: "1yesri" }],
    ["path", { d: "M9 21h2", key: "1qve2z" }],
    ["path", { d: "M14 3h1", key: "1ec4yj" }],
    ["path", { d: "M3 9v1", key: "1r0deq" }],
    ["path", { d: "M21 9v2", key: "p14lih" }],
    ["path", { d: "M3 14v1", key: "vnatye" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const n1 = e("MousePointerSquare", [
    [
      "path",
      {
        d: "M21 11V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h6",
        key: "14rsvq",
      },
    ],
    ["path", { d: "m12 12 4 10 1.7-4.3L22 16Z", key: "64ilsv" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const _p = e("MousePointer", [
    ["path", { d: "m3 3 7.07 16.97 2.51-7.39 7.39-2.51L3 3z", key: "y2ucgo" }],
    ["path", { d: "m13 13 6 6", key: "1nhxnf" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Jp = e("Mouse", [
    [
      "rect",
      { x: "5", y: "2", width: "14", height: "20", rx: "7", key: "11ol66" },
    ],
    ["path", { d: "M12 6v4", key: "16clxf" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const r1 = e("Move3d", [
    ["path", { d: "M5 3v16h16", key: "1mqmf9" }],
    ["path", { d: "m5 19 6-6", key: "jh6hbb" }],
    ["path", { d: "m2 6 3-3 3 3", key: "tkyvxa" }],
    ["path", { d: "m18 16 3 3-3 3", key: "1d4glt" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Qp = e("MoveDiagonal2", [
    ["polyline", { points: "5 11 5 5 11 5", key: "ncfzxk" }],
    ["polyline", { points: "19 13 19 19 13 19", key: "1mk7hk" }],
    ["line", { x1: "5", x2: "19", y1: "5", y2: "19", key: "mcyte3" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Yp = e("MoveDiagonal", [
    ["polyline", { points: "13 5 19 5 19 11", key: "11219e" }],
    ["polyline", { points: "11 19 5 19 5 13", key: "sfq3wq" }],
    ["line", { x1: "19", x2: "5", y1: "5", y2: "19", key: "1x9vlm" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const $p = e("MoveDownLeft", [
    ["path", { d: "M11 19H5V13", key: "1akmht" }],
    ["path", { d: "M19 5L5 19", key: "72u4yj" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const el = e("MoveDownRight", [
    ["path", { d: "M19 13V19H13", key: "10vkzq" }],
    ["path", { d: "M5 5L19 19", key: "5zm2fv" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const al = e("MoveDown", [
    ["path", { d: "M8 18L12 22L16 18", key: "cskvfv" }],
    ["path", { d: "M12 2V22", key: "r89rzk" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const tl = e("MoveHorizontal", [
    ["polyline", { points: "18 8 22 12 18 16", key: "1hqrds" }],
    ["polyline", { points: "6 8 2 12 6 16", key: "f0ernq" }],
    ["line", { x1: "2", x2: "22", y1: "12", y2: "12", key: "1dnqot" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const cl = e("MoveLeft", [
    ["path", { d: "M6 8L2 12L6 16", key: "kyvwex" }],
    ["path", { d: "M2 12H22", key: "1m8cig" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const hl = e("MoveRight", [
    ["path", { d: "M18 8L22 12L18 16", key: "1r0oui" }],
    ["path", { d: "M2 12H22", key: "1m8cig" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const dl = e("MoveUpLeft", [
    ["path", { d: "M5 11V5H11", key: "3q78g9" }],
    ["path", { d: "M5 5L19 19", key: "5zm2fv" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ol = e("MoveUpRight", [
    ["path", { d: "M13 5H19V11", key: "1n1gyv" }],
    ["path", { d: "M19 5L5 19", key: "72u4yj" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const yl = e("MoveUp", [
    ["path", { d: "M8 6L12 2L16 6", key: "1yvkyx" }],
    ["path", { d: "M12 2V22", key: "r89rzk" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const il = e("MoveVertical", [
    ["polyline", { points: "8 18 12 22 16 18", key: "1uutw3" }],
    ["polyline", { points: "8 6 12 2 16 6", key: "d60sxy" }],
    ["line", { x1: "12", x2: "12", y1: "2", y2: "22", key: "7eqyqh" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const nl = e("Move", [
    ["polyline", { points: "5 9 2 12 5 15", key: "1r5uj5" }],
    ["polyline", { points: "9 5 12 2 15 5", key: "5v383o" }],
    ["polyline", { points: "15 19 12 22 9 19", key: "g7qi8m" }],
    ["polyline", { points: "19 9 22 12 19 15", key: "tpp73q" }],
    ["line", { x1: "2", x2: "22", y1: "12", y2: "12", key: "1dnqot" }],
    ["line", { x1: "12", x2: "12", y1: "2", y2: "22", key: "7eqyqh" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const rl = e("Music2", [
    ["circle", { cx: "8", cy: "18", r: "4", key: "1fc0mg" }],
    ["path", { d: "M12 18V2l7 4", key: "g04rme" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const kl = e("Music3", [
    ["circle", { cx: "12", cy: "18", r: "4", key: "m3r9ws" }],
    ["path", { d: "M16 18V2", key: "40x2m5" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const pl = e("Music4", [
    ["path", { d: "M9 18V5l12-2v13", key: "1jmyc2" }],
    ["path", { d: "m9 9 12-2", key: "1e64n2" }],
    ["circle", { cx: "6", cy: "18", r: "3", key: "fqmcym" }],
    ["circle", { cx: "18", cy: "16", r: "3", key: "1hluhg" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ll = e("Music", [
    ["path", { d: "M9 18V5l12-2v13", key: "1jmyc2" }],
    ["circle", { cx: "6", cy: "18", r: "3", key: "fqmcym" }],
    ["circle", { cx: "18", cy: "16", r: "3", key: "1hluhg" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const sl = e("Navigation2Off", [
    ["path", { d: "M9.31 9.31 5 21l7-4 7 4-1.17-3.17", key: "qoq2o2" }],
    ["path", { d: "M14.53 8.88 12 2l-1.17 3.17", key: "k3sjzy" }],
    ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ul = e("Navigation2", [
    ["polygon", { points: "12 2 19 21 12 17 5 21 12 2", key: "x8c0qg" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ml = e("NavigationOff", [
    ["path", { d: "M8.43 8.43 3 11l8 2 2 8 2.57-5.43", key: "1vdtb7" }],
    ["path", { d: "M17.39 11.73 22 2l-9.73 4.61", key: "tya3r6" }],
    ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const vl = e("Navigation", [
    ["polygon", { points: "3 11 22 2 13 21 11 13 3 11", key: "1ltx0t" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ml = e("Network", [
    [
      "rect",
      { x: "16", y: "16", width: "6", height: "6", rx: "1", key: "4q2zg0" },
    ],
    [
      "rect",
      { x: "2", y: "16", width: "6", height: "6", rx: "1", key: "8cvhb9" },
    ],
    [
      "rect",
      { x: "9", y: "2", width: "6", height: "6", rx: "1", key: "1egb70" },
    ],
    ["path", { d: "M5 16v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3", key: "1jsf9p" }],
    ["path", { d: "M12 12V8", key: "2874zd" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const xl = e("Newspaper", [
    [
      "path",
      {
        d: "M4 22h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v16a2 2 0 0 1-2 2Zm0 0a2 2 0 0 1-2-2v-9c0-1.1.9-2 2-2h2",
        key: "7pis2x",
      },
    ],
    ["path", { d: "M18 14h-8", key: "sponae" }],
    ["path", { d: "M15 18h-5", key: "95g1m2" }],
    ["path", { d: "M10 6h8v4h-8V6Z", key: "smlsk5" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const gl = e("Nfc", [
    ["path", { d: "M6 8.32a7.43 7.43 0 0 1 0 7.36", key: "9iaqei" }],
    ["path", { d: "M9.46 6.21a11.76 11.76 0 0 1 0 11.58", key: "1yha7l" }],
    ["path", { d: "M12.91 4.1a15.91 15.91 0 0 1 .01 15.8", key: "4iu2gk" }],
    ["path", { d: "M16.37 2a20.16 20.16 0 0 1 0 20", key: "sap9u2" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ll = e("NotebookPen", [
    [
      "path",
      {
        d: "M13.4 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-7.4",
        key: "re6nr2",
      },
    ],
    ["path", { d: "M2 6h4", key: "aawbzj" }],
    ["path", { d: "M2 10h4", key: "l0bgd4" }],
    ["path", { d: "M2 14h4", key: "1gsvsf" }],
    ["path", { d: "M2 18h4", key: "1bu2t1" }],
    [
      "path",
      { d: "M18.4 2.6a2.17 2.17 0 0 1 3 3L16 11l-4 1 1-4Z", key: "1dba1m" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const fl = e("NotebookTabs", [
    ["path", { d: "M2 6h4", key: "aawbzj" }],
    ["path", { d: "M2 10h4", key: "l0bgd4" }],
    ["path", { d: "M2 14h4", key: "1gsvsf" }],
    ["path", { d: "M2 18h4", key: "1bu2t1" }],
    [
      "rect",
      { width: "16", height: "20", x: "4", y: "2", rx: "2", key: "1nb95v" },
    ],
    ["path", { d: "M15 2v20", key: "dcj49h" }],
    ["path", { d: "M15 7h5", key: "1xj5lc" }],
    ["path", { d: "M15 12h5", key: "w5shd9" }],
    ["path", { d: "M15 17h5", key: "1qaofu" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const wl = e("NotebookText", [
    ["path", { d: "M2 6h4", key: "aawbzj" }],
    ["path", { d: "M2 10h4", key: "l0bgd4" }],
    ["path", { d: "M2 14h4", key: "1gsvsf" }],
    ["path", { d: "M2 18h4", key: "1bu2t1" }],
    [
      "rect",
      { width: "16", height: "20", x: "4", y: "2", rx: "2", key: "1nb95v" },
    ],
    ["path", { d: "M9.5 8h5", key: "11mslq" }],
    ["path", { d: "M9.5 12H16", key: "ktog6x" }],
    ["path", { d: "M9.5 16H14", key: "p1seyn" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Il = e("Notebook", [
    ["path", { d: "M2 6h4", key: "aawbzj" }],
    ["path", { d: "M2 10h4", key: "l0bgd4" }],
    ["path", { d: "M2 14h4", key: "1gsvsf" }],
    ["path", { d: "M2 18h4", key: "1bu2t1" }],
    [
      "rect",
      { width: "16", height: "20", x: "4", y: "2", rx: "2", key: "1nb95v" },
    ],
    ["path", { d: "M16 2v20", key: "rotuqe" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Cl = e("NotepadTextDashed", [
    ["path", { d: "M8 2v4", key: "1cmpym" }],
    ["path", { d: "M12 2v4", key: "3427ic" }],
    ["path", { d: "M16 2v4", key: "4m81vk" }],
    ["path", { d: "M16 4h2a2 2 0 0 1 2 2v2", key: "j91f56" }],
    ["path", { d: "M20 12v2", key: "w8o0tu" }],
    ["path", { d: "M20 18v2a2 2 0 0 1-2 2h-1", key: "1c9ggx" }],
    ["path", { d: "M13 22h-2", key: "191ugt" }],
    ["path", { d: "M7 22H6a2 2 0 0 1-2-2v-2", key: "1rt9px" }],
    ["path", { d: "M4 14v-2", key: "1v0sqh" }],
    ["path", { d: "M4 8V6a2 2 0 0 1 2-2h2", key: "1mwabg" }],
    ["path", { d: "M8 10h6", key: "3oa6kw" }],
    ["path", { d: "M8 14h8", key: "1fgep2" }],
    ["path", { d: "M8 18h5", key: "17enja" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const bl = e("NotepadText", [
    ["path", { d: "M8 2v4", key: "1cmpym" }],
    ["path", { d: "M12 2v4", key: "3427ic" }],
    ["path", { d: "M16 2v4", key: "4m81vk" }],
    [
      "rect",
      { width: "16", height: "18", x: "4", y: "4", rx: "2", key: "1u9h20" },
    ],
    ["path", { d: "M8 10h6", key: "3oa6kw" }],
    ["path", { d: "M8 14h8", key: "1fgep2" }],
    ["path", { d: "M8 18h5", key: "17enja" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Sl = e("NutOff", [
    ["path", { d: "M12 4V2", key: "1k5q1u" }],
    [
      "path",
      {
        d: "M5 10v4a7.004 7.004 0 0 0 5.277 6.787c.412.104.802.292 1.102.592L12 22l.621-.621c.3-.3.69-.488 1.102-.592a7.01 7.01 0 0 0 4.125-2.939",
        key: "1xcvy9",
      },
    ],
    ["path", { d: "M19 10v3.343", key: "163tfc" }],
    [
      "path",
      {
        d: "M12 12c-1.349-.573-1.905-1.005-2.5-2-.546.902-1.048 1.353-2.5 2-1.018-.644-1.46-1.08-2-2-1.028.71-1.69.918-3 1 1.081-1.048 1.757-2.03 2-3 .194-.776.84-1.551 1.79-2.21m11.654 5.997c.887-.457 1.28-.891 1.556-1.787 1.032.916 1.683 1.157 3 1-1.297-1.036-1.758-2.03-2-3-.5-2-4-4-8-4-.74 0-1.461.068-2.15.192",
        key: "17914v",
      },
    ],
    ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ql = e("Nut", [
    ["path", { d: "M12 4V2", key: "1k5q1u" }],
    [
      "path",
      {
        d: "M5 10v4a7.004 7.004 0 0 0 5.277 6.787c.412.104.802.292 1.102.592L12 22l.621-.621c.3-.3.69-.488 1.102-.592A7.003 7.003 0 0 0 19 14v-4",
        key: "1tgyif",
      },
    ],
    [
      "path",
      {
        d: "M12 4C8 4 4.5 6 4 8c-.243.97-.919 1.952-2 3 1.31-.082 1.972-.29 3-1 .54.92.982 1.356 2 2 1.452-.647 1.954-1.098 2.5-2 .595.995 1.151 1.427 2.5 2 1.31-.621 1.862-1.058 2.5-2 .629.977 1.162 1.423 2.5 2 1.209-.548 1.68-.967 2-2 1.032.916 1.683 1.157 3 1-1.297-1.036-1.758-2.03-2-3-.5-2-4-4-8-4Z",
        key: "tnsqj",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Hl = e("Octagon", [
    [
      "polygon",
      {
        points:
          "7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2",
        key: "h1p8hx",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const zl = e("Option", [
    ["path", { d: "M3 3h6l6 18h6", key: "ph9rgk" }],
    ["path", { d: "M14 3h7", key: "16f0ms" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Al = e("Orbit", [
    ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
    ["circle", { cx: "19", cy: "5", r: "2", key: "mhkx31" }],
    ["circle", { cx: "5", cy: "19", r: "2", key: "v8kfzx" }],
    ["path", { d: "M10.4 21.9a10 10 0 0 0 9.941-15.416", key: "eohfx2" }],
    ["path", { d: "M13.5 2.1a10 10 0 0 0-9.841 15.416", key: "19pvbm" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const jl = e("Outdent", [
    ["polyline", { points: "7 8 3 12 7 16", key: "2j60jr" }],
    ["line", { x1: "21", x2: "11", y1: "12", y2: "12", key: "1fxxak" }],
    ["line", { x1: "21", x2: "11", y1: "6", y2: "6", key: "asgu94" }],
    ["line", { x1: "21", x2: "11", y1: "18", y2: "18", key: "13dsj7" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Vl = e("Package2", [
    [
      "path",
      { d: "M3 9h18v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9Z", key: "1ront0" },
    ],
    [
      "path",
      {
        d: "m3 9 2.45-4.9A2 2 0 0 1 7.24 3h9.52a2 2 0 0 1 1.8 1.1L21 9",
        key: "19h2x1",
      },
    ],
    ["path", { d: "M12 3v6", key: "1holv5" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Pl = e("PackageCheck", [
    ["path", { d: "m16 16 2 2 4-4", key: "gfu2re" }],
    [
      "path",
      {
        d: "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14",
        key: "e7tb2h",
      },
    ],
    ["path", { d: "m7.5 4.27 9 5.15", key: "1c824w" }],
    ["polyline", { points: "3.29 7 12 12 20.71 7", key: "ousv84" }],
    ["line", { x1: "12", x2: "12", y1: "22", y2: "12", key: "a4e8g8" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Fl = e("PackageMinus", [
    ["path", { d: "M16 16h6", key: "100bgy" }],
    [
      "path",
      {
        d: "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14",
        key: "e7tb2h",
      },
    ],
    ["path", { d: "m7.5 4.27 9 5.15", key: "1c824w" }],
    ["polyline", { points: "3.29 7 12 12 20.71 7", key: "ousv84" }],
    ["line", { x1: "12", x2: "12", y1: "22", y2: "12", key: "a4e8g8" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Bl = e("PackageOpen", [
    ["path", { d: "M12 22v-9", key: "x3hkom" }],
    [
      "path",
      {
        d: "M15.17 2.21a1.67 1.67 0 0 1 1.63 0L21 4.57a1.93 1.93 0 0 1 0 3.36L8.82 14.79a1.655 1.655 0 0 1-1.64 0L3 12.43a1.93 1.93 0 0 1 0-3.36z",
        key: "2ntwy6",
      },
    ],
    [
      "path",
      {
        d: "M20 13v3.87a2.06 2.06 0 0 1-1.11 1.83l-6 3.08a1.93 1.93 0 0 1-1.78 0l-6-3.08A2.06 2.06 0 0 1 4 16.87V13",
        key: "1pmm1c",
      },
    ],
    [
      "path",
      {
        d: "M21 12.43a1.93 1.93 0 0 0 0-3.36L8.83 2.2a1.64 1.64 0 0 0-1.63 0L3 4.57a1.93 1.93 0 0 0 0 3.36l12.18 6.86a1.636 1.636 0 0 0 1.63 0z",
        key: "12ttoo",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Dl = e("PackagePlus", [
    ["path", { d: "M16 16h6", key: "100bgy" }],
    ["path", { d: "M19 13v6", key: "85cyf1" }],
    [
      "path",
      {
        d: "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14",
        key: "e7tb2h",
      },
    ],
    ["path", { d: "m7.5 4.27 9 5.15", key: "1c824w" }],
    ["polyline", { points: "3.29 7 12 12 20.71 7", key: "ousv84" }],
    ["line", { x1: "12", x2: "12", y1: "22", y2: "12", key: "a4e8g8" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Rl = e("PackageSearch", [
    [
      "path",
      {
        d: "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14",
        key: "e7tb2h",
      },
    ],
    ["path", { d: "m7.5 4.27 9 5.15", key: "1c824w" }],
    ["polyline", { points: "3.29 7 12 12 20.71 7", key: "ousv84" }],
    ["line", { x1: "12", x2: "12", y1: "22", y2: "12", key: "a4e8g8" }],
    ["circle", { cx: "18.5", cy: "15.5", r: "2.5", key: "b5zd12" }],
    ["path", { d: "M20.27 17.27 22 19", key: "1l4muz" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Tl = e("PackageX", [
    [
      "path",
      {
        d: "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14",
        key: "e7tb2h",
      },
    ],
    ["path", { d: "m7.5 4.27 9 5.15", key: "1c824w" }],
    ["polyline", { points: "3.29 7 12 12 20.71 7", key: "ousv84" }],
    ["line", { x1: "12", x2: "12", y1: "22", y2: "12", key: "a4e8g8" }],
    ["path", { d: "m17 13 5 5m-5 0 5-5", key: "im3w4b" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ul = e("Package", [
    ["path", { d: "m7.5 4.27 9 5.15", key: "1c824w" }],
    [
      "path",
      {
        d: "M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z",
        key: "hh9hay",
      },
    ],
    ["path", { d: "m3.3 7 8.7 5 8.7-5", key: "g66t2b" }],
    ["path", { d: "M12 22V12", key: "d0xqtd" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Zl = e("PaintBucket", [
    [
      "path",
      {
        d: "m19 11-8-8-8.6 8.6a2 2 0 0 0 0 2.8l5.2 5.2c.8.8 2 .8 2.8 0L19 11Z",
        key: "irua1i",
      },
    ],
    ["path", { d: "m5 2 5 5", key: "1lls2c" }],
    ["path", { d: "M2 13h15", key: "1hkzvu" }],
    [
      "path",
      {
        d: "M22 20a2 2 0 1 1-4 0c0-1.6 1.7-2.4 2-4 .3 1.6 2 2.4 2 4Z",
        key: "xk76lq",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ol = e("PaintRoller", [
    [
      "rect",
      { width: "16", height: "6", x: "2", y: "2", rx: "2", key: "jcyz7m" },
    ],
    [
      "path",
      {
        d: "M10 16v-2a2 2 0 0 1 2-2h8a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2",
        key: "1b9h7c",
      },
    ],
    [
      "rect",
      { width: "4", height: "6", x: "8", y: "16", rx: "1", key: "d6e7yl" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Gl = e("Paintbrush2", [
    [
      "path",
      {
        d: "M14 19.9V16h3a2 2 0 0 0 2-2v-2H5v2c0 1.1.9 2 2 2h3v3.9a2 2 0 1 0 4 0Z",
        key: "1c8kta",
      },
    ],
    ["path", { d: "M6 12V2h12v10", key: "1esbnf" }],
    ["path", { d: "M14 2v4", key: "qmzblu" }],
    ["path", { d: "M10 2v2", key: "7u0qdc" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const El = e("Paintbrush", [
    [
      "path",
      {
        d: "M18.37 2.63 14 7l-1.59-1.59a2 2 0 0 0-2.82 0L8 7l9 9 1.59-1.59a2 2 0 0 0 0-2.82L17 10l4.37-4.37a2.12 2.12 0 1 0-3-3Z",
        key: "m6k5sh",
      },
    ],
    ["path", { d: "M9 8c-2 3-4 3.5-7 4l8 10c2-1 6-5 6-7", key: "arzq70" }],
    ["path", { d: "M14.5 17.5 4.5 15", key: "s7fvrz" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Wl = e("Palette", [
    [
      "circle",
      { cx: "13.5", cy: "6.5", r: ".5", fill: "currentColor", key: "1okk4w" },
    ],
    [
      "circle",
      { cx: "17.5", cy: "10.5", r: ".5", fill: "currentColor", key: "f64h9f" },
    ],
    [
      "circle",
      { cx: "8.5", cy: "7.5", r: ".5", fill: "currentColor", key: "fotxhn" },
    ],
    [
      "circle",
      { cx: "6.5", cy: "12.5", r: ".5", fill: "currentColor", key: "qy21gx" },
    ],
    [
      "path",
      {
        d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 6.012 17.461 2 12 2z",
        key: "12rzf8",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Nl = e("Palmtree", [
    [
      "path",
      { d: "M13 8c0-2.76-2.46-5-5.5-5S2 5.24 2 8h2l1-1 1 1h4", key: "foxbe7" },
    ],
    [
      "path",
      {
        d: "M13 7.14A5.82 5.82 0 0 1 16.5 6c3.04 0 5.5 2.24 5.5 5h-3l-1-1-1 1h-3",
        key: "18arnh",
      },
    ],
    [
      "path",
      {
        d: "M5.89 9.71c-2.15 2.15-2.3 5.47-.35 7.43l4.24-4.25.7-.7.71-.71 2.12-2.12c-1.95-1.96-5.27-1.8-7.42.35z",
        key: "epoumf",
      },
    ],
    [
      "path",
      { d: "M11 15.5c.5 2.5-.17 4.5-1 6.5h4c2-5.5-.5-12-1-14", key: "ft0feo" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Xl = e("PanelBottomClose", [
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" },
    ],
    ["path", { d: "M3 15h18", key: "5xshup" }],
    ["path", { d: "m15 8-3 3-3-3", key: "1oxy1z" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const k1 = e("PanelBottomDashed", [
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" },
    ],
    ["path", { d: "M14 15h1", key: "171nev" }],
    ["path", { d: "M19 15h2", key: "1vnucp" }],
    ["path", { d: "M3 15h2", key: "8bym0q" }],
    ["path", { d: "M9 15h1", key: "1tg3ks" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Kl = e("PanelBottomOpen", [
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" },
    ],
    ["path", { d: "M3 15h18", key: "5xshup" }],
    ["path", { d: "m9 10 3-3 3 3", key: "11gsxs" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const _l = e("PanelBottom", [
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" },
    ],
    ["path", { d: "M3 15h18", key: "5xshup" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const p1 = e("PanelLeftClose", [
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" },
    ],
    ["path", { d: "M9 3v18", key: "fh3hqa" }],
    ["path", { d: "m16 15-3-3 3-3", key: "14y99z" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const l1 = e("PanelLeftDashed", [
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" },
    ],
    ["path", { d: "M9 14v1", key: "askpd8" }],
    ["path", { d: "M9 19v2", key: "16tejx" }],
    ["path", { d: "M9 3v2", key: "1noubl" }],
    ["path", { d: "M9 9v1", key: "19ebxg" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const s1 = e("PanelLeftOpen", [
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" },
    ],
    ["path", { d: "M9 3v18", key: "fh3hqa" }],
    ["path", { d: "m14 9 3 3-3 3", key: "8010ee" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const u1 = e("PanelLeft", [
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" },
    ],
    ["path", { d: "M9 3v18", key: "fh3hqa" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Jl = e("PanelRightClose", [
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" },
    ],
    ["path", { d: "M15 3v18", key: "14nvp0" }],
    ["path", { d: "m8 9 3 3-3 3", key: "12hl5m" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const M1 = e("PanelRightDashed", [
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" },
    ],
    ["path", { d: "M15 14v1", key: "ilsfch" }],
    ["path", { d: "M15 19v2", key: "1fst2f" }],
    ["path", { d: "M15 3v2", key: "z204g4" }],
    ["path", { d: "M15 9v1", key: "z2a8b1" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ql = e("PanelRightOpen", [
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" },
    ],
    ["path", { d: "M15 3v18", key: "14nvp0" }],
    ["path", { d: "m10 15-3-3 3-3", key: "1pgupc" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Yl = e("PanelRight", [
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" },
    ],
    ["path", { d: "M15 3v18", key: "14nvp0" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const $l = e("PanelTopClose", [
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" },
    ],
    ["path", { d: "M3 9h18", key: "1pudct" }],
    ["path", { d: "m9 16 3-3 3 3", key: "1idcnm" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const v1 = e("PanelTopDashed", [
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" },
    ],
    ["path", { d: "M14 9h1", key: "l0svgy" }],
    ["path", { d: "M19 9h2", key: "te2zfg" }],
    ["path", { d: "M3 9h2", key: "1h4ldw" }],
    ["path", { d: "M9 9h1", key: "15jzuz" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const e5 = e("PanelTopOpen", [
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" },
    ],
    ["path", { d: "M3 9h18", key: "1pudct" }],
    ["path", { d: "m15 14-3 3-3-3", key: "g215vf" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const a5 = e("PanelTop", [
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" },
    ],
    ["path", { d: "M3 9h18", key: "1pudct" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const t5 = e("PanelsLeftBottom", [
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" },
    ],
    ["path", { d: "M9 3v18", key: "fh3hqa" }],
    ["path", { d: "M9 15h12", key: "5ijen5" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const c5 = e("PanelsRightBottom", [
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" },
    ],
    ["path", { d: "M3 15h12", key: "1wkqb3" }],
    ["path", { d: "M15 3v18", key: "14nvp0" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const m1 = e("PanelsTopLeft", [
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" },
    ],
    ["path", { d: "M3 9h18", key: "1pudct" }],
    ["path", { d: "M9 21V9", key: "1oto5p" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const h5 = e("Paperclip", [
    [
      "path",
      {
        d: "m21.44 11.05-9.19 9.19a6 6 0 0 1-8.49-8.49l8.57-8.57A4 4 0 1 1 18 8.84l-8.59 8.57a2 2 0 0 1-2.83-2.83l8.49-8.48",
        key: "1u3ebp",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const d5 = e("Parentheses", [
    ["path", { d: "M8 21s-4-3-4-9 4-9 4-9", key: "uto9ud" }],
    ["path", { d: "M16 3s4 3 4 9-4 9-4 9", key: "4w2vsq" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const o5 = e("ParkingCircleOff", [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["path", { d: "m5 5 14 14", key: "11anup" }],
    ["path", { d: "M13 13a3 3 0 1 0 0-6H9v2", key: "uoagbd" }],
    ["path", { d: "M9 17v-2.34", key: "a9qo08" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const y5 = e("ParkingCircle", [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["path", { d: "M9 17V7h4a3 3 0 0 1 0 6H9", key: "1dfk2c" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const i5 = e("ParkingMeter", [
    ["path", { d: "M9 9a3 3 0 1 1 6 0", key: "jdoeu8" }],
    ["path", { d: "M12 12v3", key: "158kv8" }],
    ["path", { d: "M11 15h2", key: "199qp6" }],
    [
      "path",
      {
        d: "M19 9a7 7 0 1 0-13.6 2.3C6.4 14.4 8 19 8 19h8s1.6-4.6 2.6-7.7c.3-.8.4-1.5.4-2.3",
        key: "1l50wn",
      },
    ],
    ["path", { d: "M12 19v3", key: "npa21l" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const n5 = e("ParkingSquareOff", [
    [
      "path",
      {
        d: "M3.6 3.6A2 2 0 0 1 5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-.59 1.41",
        key: "9l1ft6",
      },
    ],
    ["path", { d: "M3 8.7V19a2 2 0 0 0 2 2h10.3", key: "17knke" }],
    ["path", { d: "m2 2 20 20", key: "1ooewy" }],
    ["path", { d: "M13 13a3 3 0 1 0 0-6H9v2", key: "uoagbd" }],
    ["path", { d: "M9 17v-2.3", key: "1jxgo2" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const r5 = e("ParkingSquare", [
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" },
    ],
    ["path", { d: "M9 17V7h4a3 3 0 0 1 0 6H9", key: "1dfk2c" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const k5 = e("PartyPopper", [
    ["path", { d: "M5.8 11.3 2 22l10.7-3.79", key: "gwxi1d" }],
    ["path", { d: "M4 3h.01", key: "1vcuye" }],
    ["path", { d: "M22 8h.01", key: "1mrtc2" }],
    ["path", { d: "M15 2h.01", key: "1cjtqr" }],
    ["path", { d: "M22 20h.01", key: "1mrys2" }],
    [
      "path",
      {
        d: "m22 2-2.24.75a2.9 2.9 0 0 0-1.96 3.12v0c.1.86-.57 1.63-1.45 1.63h-.38c-.86 0-1.6.6-1.76 1.44L14 10",
        key: "bpx1uq",
      },
    ],
    [
      "path",
      {
        d: "m22 13-.82-.33c-.86-.34-1.82.2-1.98 1.11v0c-.11.7-.72 1.22-1.43 1.22H17",
        key: "1pd0s7",
      },
    ],
    [
      "path",
      {
        d: "m11 2 .33.82c.34.86-.2 1.82-1.11 1.98v0C9.52 4.9 9 5.52 9 6.23V7",
        key: "zq5xbz",
      },
    ],
    [
      "path",
      {
        d: "M11 13c1.93 1.93 2.83 4.17 2 5-.83.83-3.07-.07-5-2-1.93-1.93-2.83-4.17-2-5 .83-.83 3.07.07 5 2Z",
        key: "4kbmks",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const p5 = e("PauseCircle", [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["line", { x1: "10", x2: "10", y1: "15", y2: "9", key: "c1nkhi" }],
    ["line", { x1: "14", x2: "14", y1: "15", y2: "9", key: "h65svq" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const l5 = e("PauseOctagon", [
    ["path", { d: "M10 15V9", key: "1lckn7" }],
    ["path", { d: "M14 15V9", key: "1muqhk" }],
    [
      "path",
      {
        d: "M7.714 2h8.572L22 7.714v8.572L16.286 22H7.714L2 16.286V7.714L7.714 2z",
        key: "1m7qra",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const s5 = e("Pause", [
    ["rect", { width: "4", height: "16", x: "6", y: "4", key: "iffhe4" }],
    ["rect", { width: "4", height: "16", x: "14", y: "4", key: "sjin7j" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const u5 = e("PawPrint", [
    ["circle", { cx: "11", cy: "4", r: "2", key: "vol9p0" }],
    ["circle", { cx: "18", cy: "8", r: "2", key: "17gozi" }],
    ["circle", { cx: "20", cy: "16", r: "2", key: "1v9bxh" }],
    [
      "path",
      {
        d: "M9 10a5 5 0 0 1 5 5v3.5a3.5 3.5 0 0 1-6.84 1.045Q6.52 17.48 4.46 16.84A3.5 3.5 0 0 1 5.5 10Z",
        key: "1ydw1z",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const M5 = e("PcCase", [
    [
      "rect",
      { width: "14", height: "20", x: "5", y: "2", rx: "2", key: "1uq1d7" },
    ],
    ["path", { d: "M15 14h.01", key: "1kp3bh" }],
    ["path", { d: "M9 6h6", key: "dgm16u" }],
    ["path", { d: "M9 10h6", key: "9gxzsh" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const x1 = e("PenLine", [
    ["path", { d: "M12 20h9", key: "t2du7b" }],
    [
      "path",
      { d: "M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z", key: "ymcmye" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const v5 = e("PenTool", [
    ["path", { d: "m12 19 7-7 3 3-7 7-3-3z", key: "rklqx2" }],
    ["path", { d: "m18 13-1.5-7.5L2 2l3.5 14.5L13 18l5-5z", key: "1et58u" }],
    ["path", { d: "m2 2 7.586 7.586", key: "etlp93" }],
    ["circle", { cx: "11", cy: "11", r: "2", key: "xmgehs" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const g1 = e("Pen", [
    [
      "path",
      { d: "M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z", key: "5qss01" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const m5 = e("PencilLine", [
    ["path", { d: "M12 20h9", key: "t2du7b" }],
    [
      "path",
      { d: "M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z", key: "ymcmye" },
    ],
    ["path", { d: "m15 5 3 3", key: "1w25hb" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const x5 = e("PencilRuler", [
    ["path", { d: "m15 5 4 4", key: "1mk7zo" }],
    [
      "path",
      {
        d: "M13 7 8.7 2.7a2.41 2.41 0 0 0-3.4 0L2.7 5.3a2.41 2.41 0 0 0 0 3.4L7 13",
        key: "orapub",
      },
    ],
    ["path", { d: "m8 6 2-2", key: "115y1s" }],
    [
      "path",
      {
        d: "m2 22 5.5-1.5L21.17 6.83a2.82 2.82 0 0 0-4-4L3.5 16.5Z",
        key: "hes763",
      },
    ],
    ["path", { d: "m18 16 2-2", key: "ee94s4" }],
    [
      "path",
      {
        d: "m17 11 4.3 4.3c.94.94.94 2.46 0 3.4l-2.6 2.6c-.94.94-2.46.94-3.4 0L11 17",
        key: "cfq27r",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const g5 = e("Pencil", [
    [
      "path",
      { d: "M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z", key: "5qss01" },
    ],
    ["path", { d: "m15 5 4 4", key: "1mk7zo" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const L5 = e("Pentagon", [
    [
      "path",
      {
        d: "M3.5 8.7c-.7.5-1 1.4-.7 2.2l2.8 8.7c.3.8 1 1.4 1.9 1.4h9.1c.9 0 1.6-.6 1.9-1.4l2.8-8.7c.3-.8 0-1.7-.7-2.2l-7.4-5.3a2.1 2.1 0 0 0-2.4 0Z",
        key: "hsj90r",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const f5 = e("PercentCircle", [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
    ["path", { d: "M9 9h.01", key: "1q5me6" }],
    ["path", { d: "M15 15h.01", key: "lqbp3k" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const w5 = e("PercentDiamond", [
    [
      "path",
      {
        d: "M2.7 10.3a2.41 2.41 0 0 0 0 3.41l7.59 7.59a2.41 2.41 0 0 0 3.41 0l7.59-7.59a2.41 2.41 0 0 0 0-3.41L13.7 2.71a2.41 2.41 0 0 0-3.41 0Z",
        key: "1tpxz2",
      },
    ],
    ["path", { d: "M9.2 9.2h.01", key: "1b7bvt" }],
    ["path", { d: "m14.5 9.5-5 5", key: "17q4r4" }],
    ["path", { d: "M14.7 14.8h.01", key: "17nsh4" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const I5 = e("PercentSquare", [
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" },
    ],
    ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
    ["path", { d: "M9 9h.01", key: "1q5me6" }],
    ["path", { d: "M15 15h.01", key: "lqbp3k" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const C5 = e("Percent", [
    ["line", { x1: "19", x2: "5", y1: "5", y2: "19", key: "1x9vlm" }],
    ["circle", { cx: "6.5", cy: "6.5", r: "2.5", key: "4mh3h7" }],
    ["circle", { cx: "17.5", cy: "17.5", r: "2.5", key: "1mdrzq" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const b5 = e("PersonStanding", [
    ["circle", { cx: "12", cy: "5", r: "1", key: "gxeob9" }],
    ["path", { d: "m9 20 3-6 3 6", key: "se2kox" }],
    ["path", { d: "m6 8 6 2 6-2", key: "4o3us4" }],
    ["path", { d: "M12 10v4", key: "1kjpxc" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const S5 = e("PhoneCall", [
    [
      "path",
      {
        d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z",
        key: "foiqr5",
      },
    ],
    ["path", { d: "M14.05 2a9 9 0 0 1 8 7.94", key: "vmijpz" }],
    ["path", { d: "M14.05 6A5 5 0 0 1 18 10", key: "13nbpp" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const q5 = e("PhoneForwarded", [
    ["polyline", { points: "18 2 22 6 18 10", key: "6vjanh" }],
    ["line", { x1: "14", x2: "22", y1: "6", y2: "6", key: "1jsywh" }],
    [
      "path",
      {
        d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z",
        key: "foiqr5",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const H5 = e("PhoneIncoming", [
    ["polyline", { points: "16 2 16 8 22 8", key: "1ygljm" }],
    ["line", { x1: "22", x2: "16", y1: "2", y2: "8", key: "1xzwqn" }],
    [
      "path",
      {
        d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z",
        key: "foiqr5",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const z5 = e("PhoneMissed", [
    ["line", { x1: "22", x2: "16", y1: "2", y2: "8", key: "1xzwqn" }],
    ["line", { x1: "16", x2: "22", y1: "2", y2: "8", key: "13zxdn" }],
    [
      "path",
      {
        d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z",
        key: "foiqr5",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const A5 = e("PhoneOff", [
    [
      "path",
      {
        d: "M10.68 13.31a16 16 0 0 0 3.41 2.6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7 2 2 0 0 1 1.72 2v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.42 19.42 0 0 1-3.33-2.67m-2.67-3.34a19.79 19.79 0 0 1-3.07-8.63A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91",
        key: "z86iuo",
      },
    ],
    ["line", { x1: "22", x2: "2", y1: "2", y2: "22", key: "11kh81" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const j5 = e("PhoneOutgoing", [
    ["polyline", { points: "22 8 22 2 16 2", key: "1g204g" }],
    ["line", { x1: "16", x2: "22", y1: "8", y2: "2", key: "1ggias" }],
    [
      "path",
      {
        d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z",
        key: "foiqr5",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const V5 = e("Phone", [
    [
      "path",
      {
        d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z",
        key: "foiqr5",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const P5 = e("PiSquare", [
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" },
    ],
    ["path", { d: "M7 7h10", key: "udp07y" }],
    ["path", { d: "M10 7v10", key: "i1d9ee" }],
    ["path", { d: "M16 17a2 2 0 0 1-2-2V7", key: "ftwdc7" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const F5 = e("Pi", [
    ["line", { x1: "9", x2: "9", y1: "4", y2: "20", key: "ovs5a5" }],
    ["path", { d: "M4 7c0-1.7 1.3-3 3-3h13", key: "10pag4" }],
    ["path", { d: "M18 20c-1.7 0-3-1.3-3-3V4", key: "1gaosr" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const B5 = e("Piano", [
    [
      "path",
      {
        d: "M18.5 8c-1.4 0-2.6-.8-3.2-2A6.87 6.87 0 0 0 2 9v11a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-8.5C22 9.6 20.4 8 18.5 8",
        key: "lag0yf",
      },
    ],
    ["path", { d: "M2 14h20", key: "myj16y" }],
    ["path", { d: "M6 14v4", key: "9ng0ue" }],
    ["path", { d: "M10 14v4", key: "1v8uk5" }],
    ["path", { d: "M14 14v4", key: "1tqops" }],
    ["path", { d: "M18 14v4", key: "18uqwm" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const D5 = e("Pickaxe", [
    [
      "path",
      {
        d: "M14.531 12.469 6.619 20.38a1 1 0 1 1-3-3l7.912-7.912",
        key: "we99rg",
      },
    ],
    [
      "path",
      {
        d: "M15.686 4.314A12.5 12.5 0 0 0 5.461 2.958 1 1 0 0 0 5.58 4.71a22 22 0 0 1 6.318 3.393",
        key: "1w6hck",
      },
    ],
    [
      "path",
      {
        d: "M17.7 3.7a1 1 0 0 0-1.4 0l-4.6 4.6a1 1 0 0 0 0 1.4l2.6 2.6a1 1 0 0 0 1.4 0l4.6-4.6a1 1 0 0 0 0-1.4z",
        key: "15hgfx",
      },
    ],
    [
      "path",
      {
        d: "M19.686 8.314a12.501 12.501 0 0 1 1.356 10.225 1 1 0 0 1-1.751-.119 22 22 0 0 0-3.393-6.319",
        key: "452b4h",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const R5 = e("PictureInPicture2", [
    [
      "path",
      {
        d: "M21 9V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2h4",
        key: "daa4of",
      },
    ],
    [
      "rect",
      { width: "10", height: "7", x: "12", y: "13", rx: "2", key: "1nb8gs" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const T5 = e("PictureInPicture", [
    [
      "path",
      {
        d: "M8 4.5v5H3m-1-6 6 6m13 0v-3c0-1.16-.84-2-2-2h-7m-9 9v2c0 1.05.95 2 2 2h3",
        key: "bcd8fb",
      },
    ],
    [
      "rect",
      { width: "10", height: "7", x: "12", y: "13.5", ry: "2", key: "136fx3" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const U5 = e("PieChart", [
    ["path", { d: "M21.21 15.89A10 10 0 1 1 8 2.83", key: "k2fpak" }],
    ["path", { d: "M22 12A10 10 0 0 0 12 2v10z", key: "1rfc4y" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Z5 = e("PiggyBank", [
    [
      "path",
      {
        d: "M19 5c-1.5 0-2.8 1.4-3 2-3.5-1.5-11-.3-11 5 0 1.8 0 3 2 4.5V20h4v-2h3v2h4v-4c1-.5 1.7-1 2-2h2v-4h-2c0-1-.5-1.5-1-2h0V5z",
        key: "uf6l00",
      },
    ],
    ["path", { d: "M2 9v1c0 1.1.9 2 2 2h1", key: "nm575m" }],
    ["path", { d: "M16 11h0", key: "k2aug8" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const O5 = e("PilcrowSquare", [
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" },
    ],
    ["path", { d: "M12 12H9.5a2.5 2.5 0 0 1 0-5H17", key: "1l9586" }],
    ["path", { d: "M12 7v10", key: "jspqdw" }],
    ["path", { d: "M16 7v10", key: "lavkr4" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const G5 = e("Pilcrow", [
    ["path", { d: "M13 4v16", key: "8vvj80" }],
    ["path", { d: "M17 4v16", key: "7dpous" }],
    ["path", { d: "M19 4H9.5a4.5 4.5 0 0 0 0 9H13", key: "sh4n9v" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const E5 = e("Pill", [
    [
      "path",
      {
        d: "m10.5 20.5 10-10a4.95 4.95 0 1 0-7-7l-10 10a4.95 4.95 0 1 0 7 7Z",
        key: "wa1lgi",
      },
    ],
    ["path", { d: "m8.5 8.5 7 7", key: "rvfmvr" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const W5 = e("PinOff", [
    ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }],
    ["line", { x1: "12", x2: "12", y1: "17", y2: "22", key: "1jrz49" }],
    [
      "path",
      {
        d: "M9 9v1.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V17h12",
        key: "13x2n8",
      },
    ],
    ["path", { d: "M15 9.34V6h1a2 2 0 0 0 0-4H7.89", key: "reo3ki" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const N5 = e("Pin", [
    ["line", { x1: "12", x2: "12", y1: "17", y2: "22", key: "1jrz49" }],
    [
      "path",
      {
        d: "M5 17h14v-1.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V6h1a2 2 0 0 0 0-4H8a2 2 0 0 0 0 4h1v4.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24Z",
        key: "13yl11",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const X5 = e("Pipette", [
    ["path", { d: "m2 22 1-1h3l9-9", key: "1sre89" }],
    ["path", { d: "M3 21v-3l9-9", key: "hpe2y6" }],
    [
      "path",
      {
        d: "m15 6 3.4-3.4a2.1 2.1 0 1 1 3 3L18 9l.4.4a2.1 2.1 0 1 1-3 3l-3.8-3.8a2.1 2.1 0 1 1 3-3l.4.4Z",
        key: "196du1",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const K5 = e("Pizza", [
    ["path", { d: "M15 11h.01", key: "rns66s" }],
    ["path", { d: "M11 15h.01", key: "k85uqc" }],
    ["path", { d: "M16 16h.01", key: "1f9h7w" }],
    ["path", { d: "m2 16 20 6-6-20A20 20 0 0 0 2 16", key: "e4slt2" }],
    ["path", { d: "M5.71 17.11a17.04 17.04 0 0 1 11.4-11.4", key: "rerf8f" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const _5 = e("PlaneLanding", [
    ["path", { d: "M2 22h20", key: "272qi7" }],
    [
      "path",
      {
        d: "M3.77 10.77 2 9l2-4.5 1.1.55c.55.28.9.84.9 1.45s.35 1.17.9 1.45L8 8.5l3-6 1.05.53a2 2 0 0 1 1.09 1.52l.72 5.4a2 2 0 0 0 1.09 1.52l4.4 2.2c.42.22.78.55 1.01.96l.6 1.03c.49.88-.06 1.98-1.06 2.1l-1.18.15c-.47.06-.95-.02-1.37-.24L4.29 11.15a2 2 0 0 1-.52-.38Z",
        key: "1ma21e",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const J5 = e("PlaneTakeoff", [
    ["path", { d: "M2 22h20", key: "272qi7" }],
    [
      "path",
      {
        d: "M6.36 17.4 4 17l-2-4 1.1-.55a2 2 0 0 1 1.8 0l.17.1a2 2 0 0 0 1.8 0L8 12 5 6l.9-.45a2 2 0 0 1 2.09.2l4.02 3a2 2 0 0 0 2.1.2l4.19-2.06a2.41 2.41 0 0 1 1.73-.17L21 7a1.4 1.4 0 0 1 .87 1.99l-.38.76c-.23.46-.6.84-1.07 1.08L7.58 17.2a2 2 0 0 1-1.22.18Z",
        key: "fkigj9",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Q5 = e("Plane", [
    [
      "path",
      {
        d: "M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z",
        key: "1v9wt8",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Y5 = e("PlayCircle", [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["polygon", { points: "10 8 16 12 10 16 10 8", key: "1cimsy" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const $5 = e("PlaySquare", [
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" },
    ],
    ["path", { d: "m9 8 6 4-6 4Z", key: "f1r3lt" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const e3 = e("Play", [
    ["polygon", { points: "5 3 19 12 5 21 5 3", key: "191637" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const a3 = e("Plug2", [
    ["path", { d: "M9 2v6", key: "17ngun" }],
    ["path", { d: "M15 2v6", key: "s7yy2p" }],
    ["path", { d: "M12 17v5", key: "bb1du9" }],
    ["path", { d: "M5 8h14", key: "pcz4l3" }],
    ["path", { d: "M6 11V8h12v3a6 6 0 1 1-12 0v0Z", key: "nd4hoy" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const t3 = e("PlugZap2", [
    ["path", { d: "m13 2-2 2.5h3L12 7", key: "1me98u" }],
    ["path", { d: "M10 14v-3", key: "1mllf3" }],
    ["path", { d: "M14 14v-3", key: "1l3fkq" }],
    [
      "path",
      { d: "M11 19c-1.7 0-3-1.3-3-3v-2h8v2c0 1.7-1.3 3-3 3Z", key: "jd5pat" },
    ],
    ["path", { d: "M12 22v-3", key: "kmzjlo" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const c3 = e("PlugZap", [
    [
      "path",
      {
        d: "M6.3 20.3a2.4 2.4 0 0 0 3.4 0L12 18l-6-6-2.3 2.3a2.4 2.4 0 0 0 0 3.4Z",
        key: "goz73y",
      },
    ],
    ["path", { d: "m2 22 3-3", key: "19mgm9" }],
    ["path", { d: "M7.5 13.5 10 11", key: "7xgeeb" }],
    ["path", { d: "M10.5 16.5 13 14", key: "10btkg" }],
    ["path", { d: "m18 3-4 4h6l-4 4", key: "16psg9" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const h3 = e("Plug", [
    ["path", { d: "M12 22v-5", key: "1ega77" }],
    ["path", { d: "M9 8V2", key: "14iosj" }],
    ["path", { d: "M15 8V2", key: "18g5xt" }],
    ["path", { d: "M18 8v5a4 4 0 0 1-4 4h-4a4 4 0 0 1-4-4V8Z", key: "osxo6l" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const d3 = e("PlusCircle", [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["path", { d: "M8 12h8", key: "1wcyev" }],
    ["path", { d: "M12 8v8", key: "napkw2" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const o3 = e("PlusSquare", [
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" },
    ],
    ["path", { d: "M8 12h8", key: "1wcyev" }],
    ["path", { d: "M12 8v8", key: "napkw2" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const y3 = e("Plus", [
    ["path", { d: "M5 12h14", key: "1ays0h" }],
    ["path", { d: "M12 5v14", key: "s699le" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const i3 = e("PocketKnife", [
    [
      "path",
      {
        d: "M3 2v1c0 1 2 1 2 2S3 6 3 7s2 1 2 2-2 1-2 2 2 1 2 2",
        key: "19w3oe",
      },
    ],
    ["path", { d: "M18 6h.01", key: "1v4wsw" }],
    ["path", { d: "M6 18h.01", key: "uhywen" }],
    [
      "path",
      {
        d: "M20.83 8.83a4 4 0 0 0-5.66-5.66l-12 12a4 4 0 1 0 5.66 5.66Z",
        key: "6fykxj",
      },
    ],
    ["path", { d: "M18 11.66V22a4 4 0 0 0 4-4V6", key: "1utzek" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const n3 = e("Pocket", [
    [
      "path",
      {
        d: "M4 3h16a2 2 0 0 1 2 2v6a10 10 0 0 1-10 10A10 10 0 0 1 2 11V5a2 2 0 0 1 2-2z",
        key: "1mz881",
      },
    ],
    ["polyline", { points: "8 10 12 14 16 10", key: "w4mbv5" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const r3 = e("Podcast", [
    ["circle", { cx: "12", cy: "11", r: "1", key: "1gvufo" }],
    [
      "path",
      {
        d: "M11 17a1 1 0 0 1 2 0c0 .5-.34 3-.5 4.5a.5.5 0 0 1-1 0c-.16-1.5-.5-4-.5-4.5Z",
        key: "1n5fvv",
      },
    ],
    ["path", { d: "M8 14a5 5 0 1 1 8 0", key: "fc81rn" }],
    ["path", { d: "M17 18.5a9 9 0 1 0-10 0", key: "jqtxkf" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const k3 = e("PointerOff", [
    ["path", { d: "M10 4.5V4a2 2 0 0 0-2.41-1.957", key: "jsi14n" }],
    ["path", { d: "M13.9 8.4a2 2 0 0 0-1.26-1.295", key: "hirc7f" }],
    [
      "path",
      {
        d: "M21.7 16.2A8 8 0 0 0 22 14v-3a2 2 0 1 0-4 0v-1a2 2 0 0 0-3.63-1.158",
        key: "1jxb2e",
      },
    ],
    [
      "path",
      {
        d: "m7 15-1.8-1.8a2 2 0 0 0-2.79 2.86L6 19.7a7.74 7.74 0 0 0 6 2.3h2a8 8 0 0 0 5.657-2.343",
        key: "10r7hm",
      },
    ],
    ["path", { d: "M6 6v8", key: "tv5xkp" }],
    ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const p3 = e("Pointer", [
    ["path", { d: "M22 14a8 8 0 0 1-8 8", key: "56vcr3" }],
    ["path", { d: "M18 11v-1a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v0", key: "1pp0yd" }],
    ["path", { d: "M14 10V9a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v1", key: "u654g" }],
    [
      "path",
      { d: "M10 9.5V4a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v10", key: "1e2dtv" },
    ],
    [
      "path",
      {
        d: "M18 11a2 2 0 1 1 4 0v3a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 0 1 2.83-2.82L7 15",
        key: "g6ys72",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const l3 = e("Popcorn", [
    [
      "path",
      {
        d: "M18 8a2 2 0 0 0 0-4 2 2 0 0 0-4 0 2 2 0 0 0-4 0 2 2 0 0 0-4 0 2 2 0 0 0 0 4",
        key: "10td1f",
      },
    ],
    ["path", { d: "M10 22 9 8", key: "yjptiv" }],
    ["path", { d: "m14 22 1-14", key: "8jwc8b" }],
    [
      "path",
      {
        d: "M20 8c.5 0 .9.4.8 1l-2.6 12c-.1.5-.7 1-1.2 1H7c-.6 0-1.1-.4-1.2-1L3.2 9c-.1-.6.3-1 .8-1Z",
        key: "1qo33t",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const s3 = e("Popsicle", [
    [
      "path",
      {
        d: "M18.6 14.4c.8-.8.8-2 0-2.8l-8.1-8.1a4.95 4.95 0 1 0-7.1 7.1l8.1 8.1c.9.7 2.1.7 2.9-.1Z",
        key: "1o68ps",
      },
    ],
    ["path", { d: "m22 22-5.5-5.5", key: "17o70y" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const u3 = e("PoundSterling", [
    ["path", { d: "M18 7c0-5.333-8-5.333-8 0", key: "1prm2n" }],
    ["path", { d: "M10 7v14", key: "18tmcs" }],
    ["path", { d: "M6 21h12", key: "4dkmi1" }],
    ["path", { d: "M6 13h10", key: "ybwr4a" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const M3 = e("PowerCircle", [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["path", { d: "M12 12V6", key: "30zewn" }],
    [
      "path",
      { d: "M8 7.5A6.1 6.1 0 0 0 12 18a6 6 0 0 0 4-10.5", key: "1r0tk2" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const v3 = e("PowerOff", [
    ["path", { d: "M18.36 6.64A9 9 0 0 1 20.77 15", key: "dxknvb" }],
    ["path", { d: "M6.16 6.16a9 9 0 1 0 12.68 12.68", key: "1x7qb5" }],
    ["path", { d: "M12 2v4", key: "3427ic" }],
    ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const m3 = e("PowerSquare", [
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" },
    ],
    ["path", { d: "M12 7v5", key: "ma6bk" }],
    [
      "path",
      { d: "M8 9a5.14 5.14 0 0 0 4 8 4.95 4.95 0 0 0 4-8", key: "15eubv" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const x3 = e("Power", [
    ["path", { d: "M12 2v10", key: "mnfbl" }],
    ["path", { d: "M18.4 6.6a9 9 0 1 1-12.77.04", key: "obofu9" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const g3 = e("Presentation", [
    ["path", { d: "M2 3h20", key: "91anmk" }],
    ["path", { d: "M21 3v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V3", key: "2k9sn8" }],
    ["path", { d: "m7 21 5-5 5 5", key: "bip4we" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const L3 = e("Printer", [
    ["polyline", { points: "6 9 6 2 18 2 18 9", key: "1306q4" }],
    [
      "path",
      {
        d: "M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2",
        key: "143wyd",
      },
    ],
    ["rect", { width: "12", height: "8", x: "6", y: "14", key: "5ipwut" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const f3 = e("Projector", [
    ["path", { d: "M5 7 3 5", key: "1yys58" }],
    ["path", { d: "M9 6V3", key: "1ptz9u" }],
    ["path", { d: "m13 7 2-2", key: "1w3vmq" }],
    ["circle", { cx: "9", cy: "13", r: "3", key: "1mma13" }],
    [
      "path",
      {
        d: "M11.83 12H20a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h2.17",
        key: "2frwzc",
      },
    ],
    ["path", { d: "M16 16h2", key: "dnq2od" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const w3 = e("Puzzle", [
    [
      "path",
      {
        d: "M19.439 7.85c-.049.322.059.648.289.878l1.568 1.568c.47.47.706 1.087.706 1.704s-.235 1.233-.706 1.704l-1.611 1.611a.98.98 0 0 1-.837.276c-.47-.07-.802-.48-.968-.925a2.501 2.501 0 1 0-3.214 3.214c.446.166.855.497.925.968a.979.979 0 0 1-.276.837l-1.61 1.61a2.404 2.404 0 0 1-1.705.707 2.402 2.402 0 0 1-1.704-.706l-1.568-1.568a1.026 1.026 0 0 0-.877-.29c-.493.074-.84.504-1.02.968a2.5 2.5 0 1 1-3.237-3.237c.464-.18.894-.527.967-1.02a1.026 1.026 0 0 0-.289-.877l-1.568-1.568A2.402 2.402 0 0 1 1.998 12c0-.617.236-1.234.706-1.704L4.23 8.77c.24-.24.581-.353.917-.303.515.077.877.528 1.073 1.01a2.5 2.5 0 1 0 3.259-3.259c-.482-.196-.933-.558-1.01-1.073-.05-.336.062-.676.303-.917l1.525-1.525A2.402 2.402 0 0 1 12 1.998c.617 0 1.234.236 1.704.706l1.568 1.568c.23.23.556.338.877.29.493-.074.84-.504 1.02-.968a2.5 2.5 0 1 1 3.237 3.237c-.464.18-.894.527-.967 1.02Z",
        key: "i0oyt7",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const I3 = e("Pyramid", [
    [
      "path",
      {
        d: "M2.5 16.88a1 1 0 0 1-.32-1.43l9-13.02a1 1 0 0 1 1.64 0l9 13.01a1 1 0 0 1-.32 1.44l-8.51 4.86a2 2 0 0 1-1.98 0Z",
        key: "aenxs0",
      },
    ],
    ["path", { d: "M12 2v20", key: "t6zp3m" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const C3 = e("QrCode", [
    [
      "rect",
      { width: "5", height: "5", x: "3", y: "3", rx: "1", key: "1tu5fj" },
    ],
    [
      "rect",
      { width: "5", height: "5", x: "16", y: "3", rx: "1", key: "1v8r4q" },
    ],
    [
      "rect",
      { width: "5", height: "5", x: "3", y: "16", rx: "1", key: "1x03jg" },
    ],
    ["path", { d: "M21 16h-3a2 2 0 0 0-2 2v3", key: "177gqh" }],
    ["path", { d: "M21 21v.01", key: "ents32" }],
    ["path", { d: "M12 7v3a2 2 0 0 1-2 2H7", key: "8crl2c" }],
    ["path", { d: "M3 12h.01", key: "nlz23k" }],
    ["path", { d: "M12 3h.01", key: "n36tog" }],
    ["path", { d: "M12 16v.01", key: "133mhm" }],
    ["path", { d: "M16 12h1", key: "1slzba" }],
    ["path", { d: "M21 12v.01", key: "1lwtk9" }],
    ["path", { d: "M12 21v-1", key: "1880an" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const b3 = e("Quote", [
    [
      "path",
      {
        d: "M3 21c3 0 7-1 7-8V5c0-1.25-.756-2.017-2-2H4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2 1 0 1 0 1 1v1c0 1-1 2-2 2s-1 .008-1 1.031V20c0 1 0 1 1 1z",
        key: "4rm80e",
      },
    ],
    [
      "path",
      {
        d: "M15 21c3 0 7-1 7-8V5c0-1.25-.757-2.017-2-2h-4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2h.75c0 2.25.25 4-2.75 4v3c0 1 0 1 1 1z",
        key: "10za9r",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const S3 = e("Rabbit", [
    ["path", { d: "M13 16a3 3 0 0 1 2.24 5", key: "1epib5" }],
    ["path", { d: "M18 12h.01", key: "yjnet6" }],
    [
      "path",
      {
        d: "M18 21h-8a4 4 0 0 1-4-4 7 7 0 0 1 7-7h.2L9.6 6.4a1 1 0 1 1 2.8-2.8L15.8 7h.2c3.3 0 6 2.7 6 6v1a2 2 0 0 1-2 2h-1a3 3 0 0 0-3 3",
        key: "ue9ozu",
      },
    ],
    ["path", { d: "M20 8.54V4a2 2 0 1 0-4 0v3", key: "49iql8" }],
    ["path", { d: "M7.612 12.524a3 3 0 1 0-1.6 4.3", key: "1e33i0" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const q3 = e("Radar", [
    ["path", { d: "M19.07 4.93A10 10 0 0 0 6.99 3.34", key: "z3du51" }],
    ["path", { d: "M4 6h.01", key: "oypzma" }],
    ["path", { d: "M2.29 9.62A10 10 0 1 0 21.31 8.35", key: "qzzz0" }],
    ["path", { d: "M16.24 7.76A6 6 0 1 0 8.23 16.67", key: "1yjesh" }],
    ["path", { d: "M12 18h.01", key: "mhygvu" }],
    ["path", { d: "M17.99 11.66A6 6 0 0 1 15.77 16.67", key: "1u2y91" }],
    ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }],
    ["path", { d: "m13.41 10.59 5.66-5.66", key: "mhq4k0" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const H3 = e("Radiation", [
    ["path", { d: "M12 12h0.01", key: "6ztbls" }],
    [
      "path",
      {
        d: "M7.5 4.2c-.3-.5-.9-.7-1.3-.4C3.9 5.5 2.3 8.1 2 11c-.1.5.4 1 1 1h5c0-1.5.8-2.8 2-3.4-1.1-1.9-2-3.5-2.5-4.4z",
        key: "wy49g3",
      },
    ],
    [
      "path",
      {
        d: "M21 12c.6 0 1-.4 1-1-.3-2.9-1.8-5.5-4.1-7.1-.4-.3-1.1-.2-1.3.3-.6.9-1.5 2.5-2.6 4.3 1.2.7 2 2 2 3.5h5z",
        key: "vklnvr",
      },
    ],
    [
      "path",
      {
        d: "M7.5 19.8c-.3.5-.1 1.1.4 1.3 2.6 1.2 5.6 1.2 8.2 0 .5-.2.7-.8.4-1.3-.5-.9-1.4-2.5-2.5-4.3-1.2.7-2.8.7-4 0-1.1 1.8-2 3.4-2.5 4.3z",
        key: "wkdf1o",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const z3 = e("Radical", [
    ["path", { d: "M3 12h4l3 9 4-17h7", key: "bpxjrx" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const A3 = e("RadioReceiver", [
    ["path", { d: "M5 16v2", key: "g5qcv5" }],
    ["path", { d: "M19 16v2", key: "1gbaio" }],
    [
      "rect",
      { width: "20", height: "8", x: "2", y: "8", rx: "2", key: "vjsjur" },
    ],
    ["path", { d: "M18 12h0", key: "1ucjzd" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const j3 = e("RadioTower", [
    ["path", { d: "M4.9 16.1C1 12.2 1 5.8 4.9 1.9", key: "s0qx1y" }],
    ["path", { d: "M7.8 4.7a6.14 6.14 0 0 0-.8 7.5", key: "1idnkw" }],
    ["circle", { cx: "12", cy: "9", r: "2", key: "1092wv" }],
    ["path", { d: "M16.2 4.8c2 2 2.26 5.11.8 7.47", key: "ojru2q" }],
    ["path", { d: "M19.1 1.9a9.96 9.96 0 0 1 0 14.1", key: "rhi7fg" }],
    ["path", { d: "M9.5 18h5", key: "mfy3pd" }],
    ["path", { d: "m8 22 4-11 4 11", key: "25yftu" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const V3 = e("Radio", [
    ["path", { d: "M4.9 19.1C1 15.2 1 8.8 4.9 4.9", key: "1vaf9d" }],
    ["path", { d: "M7.8 16.2c-2.3-2.3-2.3-6.1 0-8.5", key: "u1ii0m" }],
    ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }],
    ["path", { d: "M16.2 7.8c2.3 2.3 2.3 6.1 0 8.5", key: "1j5fej" }],
    ["path", { d: "M19.1 4.9C23 8.8 23 15.1 19.1 19", key: "10b0cb" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const P3 = e("Radius", [
    ["path", { d: "M20.34 17.52a10 10 0 1 0-2.82 2.82", key: "fydyku" }],
    ["circle", { cx: "19", cy: "19", r: "2", key: "17f5cg" }],
    ["path", { d: "m13.41 13.41 4.18 4.18", key: "1gqbwc" }],
    ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const F3 = e("RailSymbol", [
    ["path", { d: "M5 15h14", key: "m0yey3" }],
    ["path", { d: "M5 9h14", key: "7tsvo6" }],
    ["path", { d: "m14 20-5-5 6-6-5-5", key: "1jo42i" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const B3 = e("Rainbow", [
    ["path", { d: "M22 17a10 10 0 0 0-20 0", key: "ozegv" }],
    ["path", { d: "M6 17a6 6 0 0 1 12 0", key: "5giftw" }],
    ["path", { d: "M10 17a2 2 0 0 1 4 0", key: "gnsikk" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const D3 = e("Rat", [
    [
      "path",
      {
        d: "M17 5c0-1.7-1.3-3-3-3s-3 1.3-3 3c0 .8.3 1.5.8 2H11c-3.9 0-7 3.1-7 7v0c0 2.2 1.8 4 4 4",
        key: "16aj0u",
      },
    ],
    [
      "path",
      {
        d: "M16.8 3.9c.3-.3.6-.5 1-.7 1.5-.6 3.3.1 3.9 1.6.6 1.5-.1 3.3-1.6 3.9l1.6 2.8c.2.3.2.7.2 1-.2.8-.9 1.2-1.7 1.1 0 0-1.6-.3-2.7-.6H17c-1.7 0-3 1.3-3 3",
        key: "1crdmb",
      },
    ],
    ["path", { d: "M13.2 18a3 3 0 0 0-2.2-5", key: "1ol3lk" }],
    ["path", { d: "M13 22H4a2 2 0 0 1 0-4h12", key: "bt3f23" }],
    ["path", { d: "M16 9h.01", key: "1bdo4e" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const R3 = e("Ratio", [
    [
      "rect",
      { width: "12", height: "20", x: "6", y: "2", rx: "2", key: "1oxtiu" },
    ],
    [
      "rect",
      { width: "20", height: "12", x: "2", y: "6", rx: "2", key: "9lu3g6" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const T3 = e("ReceiptCent", [
    [
      "path",
      {
        d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z",
        key: "q3az6g",
      },
    ],
    ["path", { d: "M12 6.5v11", key: "ecfhkf" }],
    ["path", { d: "M15 9.4a4 4 0 1 0 0 5.2", key: "1makmb" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const U3 = e("ReceiptEuro", [
    [
      "path",
      {
        d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z",
        key: "q3az6g",
      },
    ],
    ["path", { d: "M8 12h5", key: "1g6qi8" }],
    ["path", { d: "M16 9.5a4 4 0 1 0 0 5.2", key: "b2px4r" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Z3 = e("ReceiptIndianRupee", [
    [
      "path",
      {
        d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z",
        key: "q3az6g",
      },
    ],
    ["path", { d: "M8 7h8", key: "i86dvs" }],
    ["path", { d: "M12 17.5 8 15h1a4 4 0 0 0 0-8", key: "grpkl4" }],
    ["path", { d: "M8 11h8", key: "vwpz6n" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const O3 = e("ReceiptJapaneseYen", [
    [
      "path",
      {
        d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z",
        key: "q3az6g",
      },
    ],
    ["path", { d: "m12 10 3-3", key: "1mc12w" }],
    ["path", { d: "m9 7 3 3v7.5", key: "39i0xv" }],
    ["path", { d: "M9 11h6", key: "1fldmi" }],
    ["path", { d: "M9 15h6", key: "cctwl0" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const G3 = e("ReceiptPoundSterling", [
    [
      "path",
      {
        d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z",
        key: "q3az6g",
      },
    ],
    ["path", { d: "M8 13h5", key: "1k9z8w" }],
    ["path", { d: "M10 17V9.5a2.5 2.5 0 0 1 5 0", key: "1dzgp0" }],
    ["path", { d: "M8 17h7", key: "8mjdqu" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const E3 = e("ReceiptRussianRuble", [
    [
      "path",
      {
        d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z",
        key: "q3az6g",
      },
    ],
    ["path", { d: "M8 15h5", key: "vxg57a" }],
    ["path", { d: "M8 11h5a2 2 0 1 0 0-4h-3v10", key: "1usi5u" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const W3 = e("ReceiptSwissFranc", [
    [
      "path",
      {
        d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z",
        key: "q3az6g",
      },
    ],
    ["path", { d: "M10 17V7h5", key: "k7jq18" }],
    ["path", { d: "M10 11h4", key: "1i0mka" }],
    ["path", { d: "M8 15h5", key: "vxg57a" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const N3 = e("ReceiptText", [
    [
      "path",
      {
        d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z",
        key: "q3az6g",
      },
    ],
    ["path", { d: "M14 8H8", key: "1l3xfs" }],
    ["path", { d: "M16 12H8", key: "1fr5h0" }],
    ["path", { d: "M13 16H8", key: "wsln4y" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const X3 = e("Receipt", [
    [
      "path",
      {
        d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z",
        key: "q3az6g",
      },
    ],
    ["path", { d: "M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8", key: "1h4pet" }],
    ["path", { d: "M12 17.5v-11", key: "1jc1ny" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const K3 = e("RectangleHorizontal", [
    [
      "rect",
      { width: "20", height: "12", x: "2", y: "6", rx: "2", key: "9lu3g6" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const _3 = e("RectangleVertical", [
    [
      "rect",
      { width: "12", height: "20", x: "6", y: "2", rx: "2", key: "1oxtiu" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const J3 = e("Recycle", [
    [
      "path",
      {
        d: "M7 19H4.815a1.83 1.83 0 0 1-1.57-.881 1.785 1.785 0 0 1-.004-1.784L7.196 9.5",
        key: "x6z5xu",
      },
    ],
    [
      "path",
      {
        d: "M11 19h8.203a1.83 1.83 0 0 0 1.556-.89 1.784 1.784 0 0 0 0-1.775l-1.226-2.12",
        key: "1x4zh5",
      },
    ],
    ["path", { d: "m14 16-3 3 3 3", key: "f6jyew" }],
    ["path", { d: "M8.293 13.596 7.196 9.5 3.1 10.598", key: "wf1obh" }],
    [
      "path",
      {
        d: "m9.344 5.811 1.093-1.892A1.83 1.83 0 0 1 11.985 3a1.784 1.784 0 0 1 1.546.888l3.943 6.843",
        key: "9tzpgr",
      },
    ],
    ["path", { d: "m13.378 9.633 4.096 1.098 1.097-4.096", key: "1oe83g" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Q3 = e("Redo2", [
    ["path", { d: "m15 14 5-5-5-5", key: "12vg1m" }],
    [
      "path",
      {
        d: "M20 9H9.5A5.5 5.5 0 0 0 4 14.5v0A5.5 5.5 0 0 0 9.5 20H13",
        key: "19mnr4",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Y3 = e("RedoDot", [
    ["circle", { cx: "12", cy: "17", r: "1", key: "1ixnty" }],
    ["path", { d: "M21 7v6h-6", key: "3ptur4" }],
    ["path", { d: "M3 17a9 9 0 0 1 9-9 9 9 0 0 1 6 2.3l3 2.7", key: "1kgawr" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const $3 = e("Redo", [
    ["path", { d: "M21 7v6h-6", key: "3ptur4" }],
    ["path", { d: "M3 17a9 9 0 0 1 9-9 9 9 0 0 1 6 2.3l3 2.7", key: "1kgawr" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const e6 = e("RefreshCcwDot", [
    ["path", { d: "M3 2v6h6", key: "18ldww" }],
    ["path", { d: "M21 12A9 9 0 0 0 6 5.3L3 8", key: "1pbrqz" }],
    ["path", { d: "M21 22v-6h-6", key: "usdfbe" }],
    ["path", { d: "M3 12a9 9 0 0 0 15 6.7l3-2.7", key: "1hosoe" }],
    ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const a6 = e("RefreshCcw", [
    [
      "path",
      {
        d: "M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8",
        key: "14sxne",
      },
    ],
    ["path", { d: "M3 3v5h5", key: "1xhq8a" }],
    [
      "path",
      {
        d: "M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16",
        key: "1hlbsb",
      },
    ],
    ["path", { d: "M16 16h5v5", key: "ccwih5" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const t6 = e("RefreshCwOff", [
    [
      "path",
      {
        d: "M21 8L18.74 5.74A9.75 9.75 0 0 0 12 3C11 3 10.03 3.16 9.13 3.47",
        key: "1krf6h",
      },
    ],
    ["path", { d: "M8 16H3v5", key: "1cv678" }],
    ["path", { d: "M3 12C3 9.51 4 7.26 5.64 5.64", key: "ruvoct" }],
    [
      "path",
      {
        d: "m3 16 2.26 2.26A9.75 9.75 0 0 0 12 21c2.49 0 4.74-1 6.36-2.64",
        key: "19q130",
      },
    ],
    ["path", { d: "M21 12c0 1-.16 1.97-.47 2.87", key: "4w8emr" }],
    ["path", { d: "M21 3v5h-5", key: "1q7to0" }],
    ["path", { d: "M22 22 2 2", key: "1r8tn9" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const c6 = e("RefreshCw", [
    [
      "path",
      {
        d: "M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8",
        key: "v9h5vc",
      },
    ],
    ["path", { d: "M21 3v5h-5", key: "1q7to0" }],
    [
      "path",
      {
        d: "M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16",
        key: "3uifl3",
      },
    ],
    ["path", { d: "M8 16H3v5", key: "1cv678" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const h6 = e("Refrigerator", [
    [
      "path",
      {
        d: "M5 6a4 4 0 0 1 4-4h6a4 4 0 0 1 4 4v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6Z",
        key: "fpq118",
      },
    ],
    ["path", { d: "M5 10h14", key: "elsbfy" }],
    ["path", { d: "M15 7v6", key: "1nx30x" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const d6 = e("Regex", [
    ["path", { d: "M17 3v10", key: "15fgeh" }],
    ["path", { d: "m12.67 5.5 8.66 5", key: "1gpheq" }],
    ["path", { d: "m12.67 10.5 8.66-5", key: "1dkfa6" }],
    [
      "path",
      {
        d: "M9 17a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-2z",
        key: "swwfx4",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const o6 = e("RemoveFormatting", [
    ["path", { d: "M4 7V4h16v3", key: "9msm58" }],
    ["path", { d: "M5 20h6", key: "1h6pxn" }],
    ["path", { d: "M13 4 8 20", key: "kqq6aj" }],
    ["path", { d: "m15 15 5 5", key: "me55sn" }],
    ["path", { d: "m20 15-5 5", key: "11p7ol" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const y6 = e("Repeat1", [
    ["path", { d: "m17 2 4 4-4 4", key: "nntrym" }],
    ["path", { d: "M3 11v-1a4 4 0 0 1 4-4h14", key: "84bu3i" }],
    ["path", { d: "m7 22-4-4 4-4", key: "1wqhfi" }],
    ["path", { d: "M21 13v1a4 4 0 0 1-4 4H3", key: "1rx37r" }],
    ["path", { d: "M11 10h1v4", key: "70cz1p" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const i6 = e("Repeat2", [
    ["path", { d: "m2 9 3-3 3 3", key: "1ltn5i" }],
    ["path", { d: "M13 18H7a2 2 0 0 1-2-2V6", key: "1r6tfw" }],
    ["path", { d: "m22 15-3 3-3-3", key: "4rnwn2" }],
    ["path", { d: "M11 6h6a2 2 0 0 1 2 2v10", key: "2f72bc" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const n6 = e("Repeat", [
    ["path", { d: "m17 2 4 4-4 4", key: "nntrym" }],
    ["path", { d: "M3 11v-1a4 4 0 0 1 4-4h14", key: "84bu3i" }],
    ["path", { d: "m7 22-4-4 4-4", key: "1wqhfi" }],
    ["path", { d: "M21 13v1a4 4 0 0 1-4 4H3", key: "1rx37r" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const r6 = e("ReplaceAll", [
    ["path", { d: "M14 4c0-1.1.9-2 2-2", key: "1mvvbw" }],
    ["path", { d: "M20 2c1.1 0 2 .9 2 2", key: "1mj6oe" }],
    ["path", { d: "M22 8c0 1.1-.9 2-2 2", key: "v1wql3" }],
    ["path", { d: "M16 10c-1.1 0-2-.9-2-2", key: "821ux0" }],
    ["path", { d: "m3 7 3 3 3-3", key: "x25e72" }],
    ["path", { d: "M6 10V5c0-1.7 1.3-3 3-3h1", key: "13af7h" }],
    [
      "rect",
      { width: "8", height: "8", x: "2", y: "14", rx: "2", key: "17ihk4" },
    ],
    ["path", { d: "M14 14c1.1 0 2 .9 2 2v4c0 1.1-.9 2-2 2", key: "1w9p8c" }],
    ["path", { d: "M20 14c1.1 0 2 .9 2 2v4c0 1.1-.9 2-2 2", key: "m45eaa" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const k6 = e("Replace", [
    ["path", { d: "M14 4c0-1.1.9-2 2-2", key: "1mvvbw" }],
    ["path", { d: "M20 2c1.1 0 2 .9 2 2", key: "1mj6oe" }],
    ["path", { d: "M22 8c0 1.1-.9 2-2 2", key: "v1wql3" }],
    ["path", { d: "M16 10c-1.1 0-2-.9-2-2", key: "821ux0" }],
    ["path", { d: "m3 7 3 3 3-3", key: "x25e72" }],
    ["path", { d: "M6 10V5c0-1.7 1.3-3 3-3h1", key: "13af7h" }],
    [
      "rect",
      { width: "8", height: "8", x: "2", y: "14", rx: "2", key: "17ihk4" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const p6 = e("ReplyAll", [
    ["polyline", { points: "7 17 2 12 7 7", key: "t83bqg" }],
    ["polyline", { points: "12 17 7 12 12 7", key: "1g4ajm" }],
    ["path", { d: "M22 18v-2a4 4 0 0 0-4-4H7", key: "1fcyog" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const l6 = e("Reply", [
    ["polyline", { points: "9 17 4 12 9 7", key: "hvgpf2" }],
    ["path", { d: "M20 18v-2a4 4 0 0 0-4-4H4", key: "5vmcpk" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const s6 = e("Rewind", [
    ["polygon", { points: "11 19 2 12 11 5 11 19", key: "14yba5" }],
    ["polygon", { points: "22 19 13 12 22 5 22 19", key: "1pi1cj" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const u6 = e("Ribbon", [
    [
      "path",
      {
        d: "M17.75 9.01c-.52 2.08-1.83 3.64-3.18 5.49l-2.6 3.54-2.97 4-3.5-2.54 3.85-4.97c-1.86-2.61-2.8-3.77-3.16-5.44",
        key: "1njedg",
      },
    ],
    [
      "path",
      {
        d: "M17.75 9.01A7 7 0 0 0 6.2 9.1C6.06 8.5 6 7.82 6 7c0-3.5 2.83-5 5.98-5C15.24 2 18 3.5 18 7c0 .73-.09 1.4-.25 2.01Z",
        key: "10len7",
      },
    ],
    ["path", { d: "m9.35 14.53 2.64-3.31", key: "1wfi09" }],
    ["path", { d: "m11.97 18.04 2.99 4 3.54-2.54-3.93-5", key: "1ezyge" }],
    [
      "path",
      {
        d: "M14 8c0 1-1 2-2.01 3.22C11 10 10 9 10 8a2 2 0 1 1 4 0",
        key: "aw0zq5",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const M6 = e("Rocket", [
    [
      "path",
      {
        d: "M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z",
        key: "m3kijz",
      },
    ],
    [
      "path",
      {
        d: "m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z",
        key: "1fmvmk",
      },
    ],
    ["path", { d: "M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0", key: "1f8sc4" }],
    ["path", { d: "M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5", key: "qeys4" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const v6 = e("RockingChair", [
    ["polyline", { points: "3.5 2 6.5 12.5 18 12.5", key: "y3iy52" }],
    ["line", { x1: "9.5", x2: "5.5", y1: "12.5", y2: "20", key: "19vg5i" }],
    ["line", { x1: "15", x2: "18.5", y1: "12.5", y2: "20", key: "1inpmv" }],
    ["path", { d: "M2.75 18a13 13 0 0 0 18.5 0", key: "1nquas" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const m6 = e("RollerCoaster", [
    ["path", { d: "M6 19V5", key: "1r845m" }],
    ["path", { d: "M10 19V6.8", key: "9j2tfs" }],
    ["path", { d: "M14 19v-7.8", key: "10s8qv" }],
    ["path", { d: "M18 5v4", key: "1tajlv" }],
    ["path", { d: "M18 19v-6", key: "ielfq3" }],
    ["path", { d: "M22 19V9", key: "158nzp" }],
    [
      "path",
      {
        d: "M2 19V9a4 4 0 0 1 4-4c2 0 4 1.33 6 4s4 4 6 4a4 4 0 1 0-3-6.65",
        key: "1930oh",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const L1 = e("Rotate3d", [
    [
      "path",
      {
        d: "M16.466 7.5C15.643 4.237 13.952 2 12 2 9.239 2 7 6.477 7 12s2.239 10 5 10c.342 0 .677-.069 1-.2",
        key: "10n0gc",
      },
    ],
    ["path", { d: "m15.194 13.707 3.814 1.86-1.86 3.814", key: "16shm9" }],
    [
      "path",
      {
        d: "M19 15.57c-1.804.885-4.274 1.43-7 1.43-5.523 0-10-2.239-10-5s4.477-5 10-5c4.838 0 8.873 1.718 9.8 4",
        key: "1lxi77",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const W1 = e("RotateCcw", [
    [
      "path",
      { d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8", key: "1357e3" },
    ],
    ["path", { d: "M3 3v5h5", key: "1xhq8a" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const x6 = e("RotateCw", [
    [
      "path",
      { d: "M21 12a9 9 0 1 1-9-9c2.52 0 4.93 1 6.74 2.74L21 8", key: "1p45f6" },
    ],
    ["path", { d: "M21 3v5h-5", key: "1q7to0" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const g6 = e("RouteOff", [
    ["circle", { cx: "6", cy: "19", r: "3", key: "1kj8tv" }],
    ["path", { d: "M9 19h8.5c.4 0 .9-.1 1.3-.2", key: "1effex" }],
    ["path", { d: "M5.2 5.2A3.5 3.53 0 0 0 6.5 12H12", key: "k9y2ds" }],
    ["path", { d: "m2 2 20 20", key: "1ooewy" }],
    ["path", { d: "M21 15.3a3.5 3.5 0 0 0-3.3-3.3", key: "11nlu2" }],
    ["path", { d: "M15 5h-4.3", key: "6537je" }],
    ["circle", { cx: "18", cy: "5", r: "3", key: "gq8acd" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const L6 = e("Route", [
    ["circle", { cx: "6", cy: "19", r: "3", key: "1kj8tv" }],
    [
      "path",
      {
        d: "M9 19h8.5a3.5 3.5 0 0 0 0-7h-11a3.5 3.5 0 0 1 0-7H15",
        key: "1d8sl",
      },
    ],
    ["circle", { cx: "18", cy: "5", r: "3", key: "gq8acd" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const f6 = e("Router", [
    [
      "rect",
      { width: "20", height: "8", x: "2", y: "14", rx: "2", key: "w68u3i" },
    ],
    ["path", { d: "M6.01 18H6", key: "19vcac" }],
    ["path", { d: "M10.01 18H10", key: "uamcmx" }],
    ["path", { d: "M15 10v4", key: "qjz1xs" }],
    ["path", { d: "M17.84 7.17a4 4 0 0 0-5.66 0", key: "1rif40" }],
    ["path", { d: "M20.66 4.34a8 8 0 0 0-11.31 0", key: "6a5xfq" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const f1 = e("Rows2", [
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" },
    ],
    ["path", { d: "M3 12h18", key: "1i2n21" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const w1 = e("Rows3", [
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" },
    ],
    ["path", { d: "M21 9H3", key: "1338ky" }],
    ["path", { d: "M21 15H3", key: "9uk58r" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const w6 = e("Rows4", [
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" },
    ],
    ["path", { d: "M21 7.5H3", key: "1hm9pq" }],
    ["path", { d: "M21 12H3", key: "2avoz0" }],
    ["path", { d: "M21 16.5H3", key: "n7jzkj" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const I6 = e("Rss", [
    ["path", { d: "M4 11a9 9 0 0 1 9 9", key: "pv89mb" }],
    ["path", { d: "M4 4a16 16 0 0 1 16 16", key: "k0647b" }],
    ["circle", { cx: "5", cy: "19", r: "1", key: "bfqh0e" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const C6 = e("Ruler", [
    [
      "path",
      {
        d: "M21.3 15.3a2.4 2.4 0 0 1 0 3.4l-2.6 2.6a2.4 2.4 0 0 1-3.4 0L2.7 8.7a2.41 2.41 0 0 1 0-3.4l2.6-2.6a2.41 2.41 0 0 1 3.4 0Z",
        key: "icamh8",
      },
    ],
    ["path", { d: "m14.5 12.5 2-2", key: "inckbg" }],
    ["path", { d: "m11.5 9.5 2-2", key: "fmmyf7" }],
    ["path", { d: "m8.5 6.5 2-2", key: "vc6u1g" }],
    ["path", { d: "m17.5 15.5 2-2", key: "wo5hmg" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const b6 = e("RussianRuble", [
    ["path", { d: "M6 11h8a4 4 0 0 0 0-8H9v18", key: "18ai8t" }],
    ["path", { d: "M6 15h8", key: "1y8f6l" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const S6 = e("Sailboat", [
    ["path", { d: "M22 18H2a4 4 0 0 0 4 4h12a4 4 0 0 0 4-4Z", key: "1404fh" }],
    ["path", { d: "M21 14 10 2 3 14h18Z", key: "1nzg7v" }],
    ["path", { d: "M10 2v16", key: "1labyt" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const q6 = e("Salad", [
    ["path", { d: "M7 21h10", key: "1b0cd5" }],
    ["path", { d: "M12 21a9 9 0 0 0 9-9H3a9 9 0 0 0 9 9Z", key: "4rw317" }],
    [
      "path",
      {
        d: "M11.38 12a2.4 2.4 0 0 1-.4-4.77 2.4 2.4 0 0 1 3.2-2.77 2.4 2.4 0 0 1 3.47-.63 2.4 2.4 0 0 1 3.37 3.37 2.4 2.4 0 0 1-1.1 3.7 2.51 2.51 0 0 1 .03 1.1",
        key: "10xrj0",
      },
    ],
    ["path", { d: "m13 12 4-4", key: "1hckqy" }],
    [
      "path",
      { d: "M10.9 7.25A3.99 3.99 0 0 0 4 10c0 .73.2 1.41.54 2", key: "1p4srx" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const H6 = e("Sandwich", [
    ["path", { d: "M3 11v3a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-3", key: "34v9d7" }],
    [
      "path",
      {
        d: "M12 19H4a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-3.83",
        key: "1k5vfb",
      },
    ],
    ["path", { d: "m3 11 7.77-6.04a2 2 0 0 1 2.46 0L21 11H3Z", key: "1oe7l6" }],
    [
      "path",
      {
        d: "M12.97 19.77 7 15h12.5l-3.75 4.5a2 2 0 0 1-2.78.27Z",
        key: "1ts2ri",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const z6 = e("SatelliteDish", [
    ["path", { d: "M4 10a7.31 7.31 0 0 0 10 10Z", key: "1fzpp3" }],
    ["path", { d: "m9 15 3-3", key: "88sc13" }],
    ["path", { d: "M17 13a6 6 0 0 0-6-6", key: "15cc6u" }],
    ["path", { d: "M21 13A10 10 0 0 0 11 3", key: "11nf8s" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const A6 = e("Satellite", [
    ["path", { d: "M13 7 9 3 5 7l4 4", key: "vyckw6" }],
    ["path", { d: "m17 11 4 4-4 4-4-4", key: "rchckc" }],
    ["path", { d: "m8 12 4 4 6-6-4-4Z", key: "1sshf7" }],
    ["path", { d: "m16 8 3-3", key: "x428zp" }],
    ["path", { d: "M9 21a6 6 0 0 0-6-6", key: "1iajcf" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const j6 = e("SaveAll", [
    [
      "path",
      {
        d: "M6 4a2 2 0 0 1 2-2h10l4 4v10.2a2 2 0 0 1-2 1.8H8a2 2 0 0 1-2-2Z",
        key: "1unput",
      },
    ],
    ["path", { d: "M10 2v4h6", key: "1p5sg6" }],
    ["path", { d: "M18 18v-7h-8v7", key: "1oniuk" }],
    ["path", { d: "M18 22H4a2 2 0 0 1-2-2V6", key: "pblm9e" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const V6 = e("Save", [
    [
      "path",
      {
        d: "M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z",
        key: "1owoqh",
      },
    ],
    ["polyline", { points: "17 21 17 13 7 13 7 21", key: "1md35c" }],
    ["polyline", { points: "7 3 7 8 15 8", key: "8nz8an" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const I1 = e("Scale3d", [
    ["circle", { cx: "19", cy: "19", r: "2", key: "17f5cg" }],
    ["circle", { cx: "5", cy: "5", r: "2", key: "1gwv83" }],
    ["path", { d: "M5 7v12h12", key: "vtaa4r" }],
    ["path", { d: "m5 19 6-6", key: "jh6hbb" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const P6 = e("Scale", [
    [
      "path",
      { d: "m16 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z", key: "7g6ntu" },
    ],
    [
      "path",
      { d: "m2 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z", key: "ijws7r" },
    ],
    ["path", { d: "M7 21h10", key: "1b0cd5" }],
    ["path", { d: "M12 3v18", key: "108xh3" }],
    ["path", { d: "M3 7h2c2 0 5-1 7-2 2 1 5 2 7 2h2", key: "3gwbw2" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const F6 = e("Scaling", [
    [
      "path",
      {
        d: "M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7",
        key: "1m0v6g",
      },
    ],
    ["path", { d: "M14 15H9v-5", key: "pi4jk9" }],
    ["path", { d: "M16 3h5v5", key: "1806ms" }],
    ["path", { d: "M21 3 9 15", key: "15kdhq" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const B6 = e("ScanBarcode", [
    ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
    ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
    ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
    ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
    ["path", { d: "M8 7v10", key: "23sfjj" }],
    ["path", { d: "M12 7v10", key: "jspqdw" }],
    ["path", { d: "M17 7v10", key: "578dap" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const D6 = e("ScanEye", [
    ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
    ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
    ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
    ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
    ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
    ["path", { d: "M5 12s2.5-5 7-5 7 5 7 5-2.5 5-7 5-7-5-7-5", key: "nhuolu" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const R6 = e("ScanFace", [
    ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
    ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
    ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
    ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
    ["path", { d: "M8 14s1.5 2 4 2 4-2 4-2", key: "1y1vjs" }],
    ["path", { d: "M9 9h.01", key: "1q5me6" }],
    ["path", { d: "M15 9h.01", key: "x1ddxp" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const T6 = e("ScanLine", [
    ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
    ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
    ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
    ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
    ["path", { d: "M7 12h10", key: "b7w52i" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const U6 = e("ScanSearch", [
    ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
    ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
    ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
    ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
    ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
    ["path", { d: "m16 16-1.9-1.9", key: "1dq9hf" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Z6 = e("ScanText", [
    ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
    ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
    ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
    ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
    ["path", { d: "M7 8h8", key: "1jbsf9" }],
    ["path", { d: "M7 12h10", key: "b7w52i" }],
    ["path", { d: "M7 16h6", key: "1vyc9m" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const O6 = e("Scan", [
    ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
    ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
    ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
    ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const G6 = e("ScatterChart", [
    [
      "circle",
      { cx: "7.5", cy: "7.5", r: ".5", fill: "currentColor", key: "kqv944" },
    ],
    [
      "circle",
      { cx: "18.5", cy: "5.5", r: ".5", fill: "currentColor", key: "lysivs" },
    ],
    [
      "circle",
      { cx: "11.5", cy: "11.5", r: ".5", fill: "currentColor", key: "byv1b8" },
    ],
    [
      "circle",
      { cx: "7.5", cy: "16.5", r: ".5", fill: "currentColor", key: "nkw3mc" },
    ],
    [
      "circle",
      { cx: "17.5", cy: "14.5", r: ".5", fill: "currentColor", key: "1gjh6j" },
    ],
    ["path", { d: "M3 3v18h18", key: "1s2lah" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const E6 = e("School2", [
    ["circle", { cx: "12", cy: "10", r: "1", key: "1gnqs8" }],
    [
      "path",
      {
        d: "M22 20V8h-4l-6-4-6 4H2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2Z",
        key: "8z0lq4",
      },
    ],
    ["path", { d: "M6 17v.01", key: "roodi6" }],
    ["path", { d: "M6 13v.01", key: "67c122" }],
    ["path", { d: "M18 17v.01", key: "12ktxm" }],
    ["path", { d: "M18 13v.01", key: "tn1rt1" }],
    ["path", { d: "M14 22v-5a2 2 0 0 0-2-2v0a2 2 0 0 0-2 2v5", key: "jfgdp0" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const W6 = e("School", [
    ["path", { d: "M14 22v-4a2 2 0 1 0-4 0v4", key: "hhkicm" }],
    [
      "path",
      { d: "m18 10 4 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-8l4-2", key: "1vwozw" },
    ],
    ["path", { d: "M18 5v17", key: "1sw6gf" }],
    ["path", { d: "m4 6 8-4 8 4", key: "1q0ilc" }],
    ["path", { d: "M6 5v17", key: "1xfsm0" }],
    ["circle", { cx: "12", cy: "9", r: "2", key: "1092wv" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const N6 = e("ScissorsLineDashed", [
    ["path", { d: "M5.42 9.42 8 12", key: "12pkuq" }],
    ["circle", { cx: "4", cy: "8", r: "2", key: "107mxr" }],
    ["path", { d: "m14 6-8.58 8.58", key: "gvzu5l" }],
    ["circle", { cx: "4", cy: "16", r: "2", key: "1ehqvc" }],
    ["path", { d: "M10.8 14.8 14 18", key: "ax7m9r" }],
    ["path", { d: "M16 12h-2", key: "10asgb" }],
    ["path", { d: "M22 12h-2", key: "14jgyd" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const X6 = e("ScissorsSquareDashedBottom", [
    [
      "path",
      {
        d: "M4 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2",
        key: "1vzg26",
      },
    ],
    ["path", { d: "M10 22H8", key: "euku7a" }],
    ["path", { d: "M16 22h-2", key: "18d249" }],
    ["circle", { cx: "8", cy: "8", r: "2", key: "14cg06" }],
    ["path", { d: "M9.414 9.414 12 12", key: "qz4lzr" }],
    ["path", { d: "M14.8 14.8 18 18", key: "11flf1" }],
    ["circle", { cx: "8", cy: "16", r: "2", key: "1acxsx" }],
    ["path", { d: "m18 6-8.586 8.586", key: "11kzk1" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const K6 = e("ScissorsSquare", [
    [
      "rect",
      { width: "20", height: "20", x: "2", y: "2", rx: "2", key: "1btzen" },
    ],
    ["circle", { cx: "8", cy: "8", r: "2", key: "14cg06" }],
    ["path", { d: "M9.414 9.414 12 12", key: "qz4lzr" }],
    ["path", { d: "M14.8 14.8 18 18", key: "11flf1" }],
    ["circle", { cx: "8", cy: "16", r: "2", key: "1acxsx" }],
    ["path", { d: "m18 6-8.586 8.586", key: "11kzk1" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const _6 = e("Scissors", [
    ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
    ["path", { d: "M8.12 8.12 12 12", key: "1alkpv" }],
    ["path", { d: "M20 4 8.12 15.88", key: "xgtan2" }],
    ["circle", { cx: "6", cy: "18", r: "3", key: "fqmcym" }],
    ["path", { d: "M14.8 14.8 20 20", key: "ptml3r" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const J6 = e("ScreenShareOff", [
    [
      "path",
      {
        d: "M13 3H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-3",
        key: "i8wdob",
      },
    ],
    ["path", { d: "M8 21h8", key: "1ev6f3" }],
    ["path", { d: "M12 17v4", key: "1riwvh" }],
    ["path", { d: "m22 3-5 5", key: "12jva0" }],
    ["path", { d: "m17 3 5 5", key: "k36vhe" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Q6 = e("ScreenShare", [
    [
      "path",
      {
        d: "M13 3H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-3",
        key: "i8wdob",
      },
    ],
    ["path", { d: "M8 21h8", key: "1ev6f3" }],
    ["path", { d: "M12 17v4", key: "1riwvh" }],
    ["path", { d: "m17 8 5-5", key: "fqif7o" }],
    ["path", { d: "M17 3h5v5", key: "1o3tu8" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Y6 = e("ScrollText", [
    [
      "path",
      {
        d: "M8 21h12a2 2 0 0 0 2-2v-2H10v2a2 2 0 1 1-4 0V5a2 2 0 1 0-4 0v3h4",
        key: "13a6an",
      },
    ],
    ["path", { d: "M19 17V5a2 2 0 0 0-2-2H4", key: "zz82l3" }],
    ["path", { d: "M15 8h-5", key: "1khuty" }],
    ["path", { d: "M15 12h-5", key: "r7krc0" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const $6 = e("Scroll", [
    [
      "path",
      {
        d: "M8 21h12a2 2 0 0 0 2-2v-2H10v2a2 2 0 1 1-4 0V5a2 2 0 1 0-4 0v3h4",
        key: "13a6an",
      },
    ],
    ["path", { d: "M19 17V5a2 2 0 0 0-2-2H4", key: "zz82l3" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const es = e("SearchCheck", [
    ["path", { d: "m8 11 2 2 4-4", key: "1sed1v" }],
    ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
    ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const as = e("SearchCode", [
    ["path", { d: "m9 9-2 2 2 2", key: "17gsfh" }],
    ["path", { d: "m13 13 2-2-2-2", key: "186z8k" }],
    ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
    ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ts = e("SearchSlash", [
    ["path", { d: "m13.5 8.5-5 5", key: "1cs55j" }],
    ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
    ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const cs = e("SearchX", [
    ["path", { d: "m13.5 8.5-5 5", key: "1cs55j" }],
    ["path", { d: "m8.5 8.5 5 5", key: "a8mexj" }],
    ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
    ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const hs = e("Search", [
    ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
    ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const C1 = e("SendHorizontal", [
    ["path", { d: "m3 3 3 9-3 9 19-9Z", key: "1aobqy" }],
    ["path", { d: "M6 12h16", key: "s4cdu5" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ds = e("SendToBack", [
    [
      "rect",
      { x: "14", y: "14", width: "8", height: "8", rx: "2", key: "1b0bso" },
    ],
    [
      "rect",
      { x: "2", y: "2", width: "8", height: "8", rx: "2", key: "1x09vl" },
    ],
    ["path", { d: "M7 14v1a2 2 0 0 0 2 2h1", key: "pao6x6" }],
    ["path", { d: "M14 7h1a2 2 0 0 1 2 2v1", key: "19tdru" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const os = e("Send", [
    ["path", { d: "m22 2-7 20-4-9-9-4Z", key: "1q3vgg" }],
    ["path", { d: "M22 2 11 13", key: "nzbqef" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ys = e("SeparatorHorizontal", [
    ["line", { x1: "3", x2: "21", y1: "12", y2: "12", key: "10d38w" }],
    ["polyline", { points: "8 8 12 4 16 8", key: "zo8t4w" }],
    ["polyline", { points: "16 16 12 20 8 16", key: "1oyrid" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const is = e("SeparatorVertical", [
    ["line", { x1: "12", x2: "12", y1: "3", y2: "21", key: "1efggb" }],
    ["polyline", { points: "8 8 4 12 8 16", key: "bnfmv4" }],
    ["polyline", { points: "16 16 20 12 16 8", key: "u90052" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ns = e("ServerCog", [
    ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
    [
      "path",
      {
        d: "M4.5 10H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-.5",
        key: "tn8das",
      },
    ],
    [
      "path",
      {
        d: "M4.5 14H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-.5",
        key: "1g2pve",
      },
    ],
    ["path", { d: "M6 6h.01", key: "1utrut" }],
    ["path", { d: "M6 18h.01", key: "uhywen" }],
    ["path", { d: "m15.7 13.4-.9-.3", key: "1jwmzr" }],
    ["path", { d: "m9.2 10.9-.9-.3", key: "qapnim" }],
    ["path", { d: "m10.6 15.7.3-.9", key: "quwk0k" }],
    ["path", { d: "m13.6 15.7-.4-1", key: "cb9xp7" }],
    ["path", { d: "m10.8 9.3-.4-1", key: "1uaiz5" }],
    ["path", { d: "m8.3 13.6 1-.4", key: "s6srou" }],
    ["path", { d: "m14.7 10.8 1-.4", key: "4d31cq" }],
    ["path", { d: "m13.4 8.3-.3.9", key: "1bm987" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const rs = e("ServerCrash", [
    [
      "path",
      {
        d: "M6 10H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-2",
        key: "4b9dqc",
      },
    ],
    [
      "path",
      {
        d: "M6 14H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-2",
        key: "22nnkd",
      },
    ],
    ["path", { d: "M6 6h.01", key: "1utrut" }],
    ["path", { d: "M6 18h.01", key: "uhywen" }],
    ["path", { d: "m13 6-4 6h6l-4 6", key: "14hqih" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ks = e("ServerOff", [
    ["path", { d: "M7 2h13a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-5", key: "bt2siv" }],
    [
      "path",
      { d: "M10 10 2.5 2.5C2 2 2 2.5 2 5v3a2 2 0 0 0 2 2h6z", key: "1hjrv1" },
    ],
    ["path", { d: "M22 17v-1a2 2 0 0 0-2-2h-1", key: "1iynyr" }],
    [
      "path",
      {
        d: "M4 14a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h16.5l1-.5.5.5-8-8H4z",
        key: "161ggg",
      },
    ],
    ["path", { d: "M6 18h.01", key: "uhywen" }],
    ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ps = e("Server", [
    [
      "rect",
      {
        width: "20",
        height: "8",
        x: "2",
        y: "2",
        rx: "2",
        ry: "2",
        key: "ngkwjq",
      },
    ],
    [
      "rect",
      {
        width: "20",
        height: "8",
        x: "2",
        y: "14",
        rx: "2",
        ry: "2",
        key: "iecqi9",
      },
    ],
    ["line", { x1: "6", x2: "6.01", y1: "6", y2: "6", key: "16zg32" }],
    ["line", { x1: "6", x2: "6.01", y1: "18", y2: "18", key: "nzw8ys" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ls = e("Settings2", [
    ["path", { d: "M20 7h-9", key: "3s1dr2" }],
    ["path", { d: "M14 17H5", key: "gfn3mx" }],
    ["circle", { cx: "17", cy: "17", r: "3", key: "18b49y" }],
    ["circle", { cx: "7", cy: "7", r: "3", key: "dfmy0x" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ss = e("Settings", [
    [
      "path",
      {
        d: "M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z",
        key: "1qme2f",
      },
    ],
    ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const us = e("Shapes", [
    [
      "path",
      {
        d: "M8.3 10a.7.7 0 0 1-.626-1.079L11.4 3a.7.7 0 0 1 1.198-.043L16.3 8.9a.7.7 0 0 1-.572 1.1Z",
        key: "1bo67w",
      },
    ],
    [
      "rect",
      { x: "3", y: "14", width: "7", height: "7", rx: "1", key: "1bkyp8" },
    ],
    ["circle", { cx: "17.5", cy: "17.5", r: "3.5", key: "w3z12y" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ms = e("Share2", [
    ["circle", { cx: "18", cy: "5", r: "3", key: "gq8acd" }],
    ["circle", { cx: "6", cy: "12", r: "3", key: "w7nqdw" }],
    ["circle", { cx: "18", cy: "19", r: "3", key: "1xt0gg" }],
    [
      "line",
      { x1: "8.59", x2: "15.42", y1: "13.51", y2: "17.49", key: "47mynk" },
    ],
    [
      "line",
      { x1: "15.41", x2: "8.59", y1: "6.51", y2: "10.49", key: "1n3mei" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const vs = e("Share", [
    ["path", { d: "M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8", key: "1b2hhj" }],
    ["polyline", { points: "16 6 12 2 8 6", key: "m901s6" }],
    ["line", { x1: "12", x2: "12", y1: "2", y2: "15", key: "1p0rca" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ms = e("Sheet", [
    [
      "rect",
      {
        width: "18",
        height: "18",
        x: "3",
        y: "3",
        rx: "2",
        ry: "2",
        key: "1m3agn",
      },
    ],
    ["line", { x1: "3", x2: "21", y1: "9", y2: "9", key: "1vqk6q" }],
    ["line", { x1: "3", x2: "21", y1: "15", y2: "15", key: "o2sbyz" }],
    ["line", { x1: "9", x2: "9", y1: "9", y2: "21", key: "1ib60c" }],
    ["line", { x1: "15", x2: "15", y1: "9", y2: "21", key: "1n26ft" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const xs = e("Shell", [
    [
      "path",
      {
        d: "M14 11a2 2 0 1 1-4 0 4 4 0 0 1 8 0 6 6 0 0 1-12 0 8 8 0 0 1 16 0 10 10 0 1 1-20 0 11.93 11.93 0 0 1 2.42-7.22 2 2 0 1 1 3.16 2.44",
        key: "1cn552",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const gs = e("ShieldAlert", [
    [
      "path",
      {
        d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
        key: "oel41y",
      },
    ],
    ["path", { d: "M12 8v4", key: "1got3b" }],
    ["path", { d: "M12 16h.01", key: "1drbdi" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ls = e("ShieldBan", [
    [
      "path",
      {
        d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
        key: "oel41y",
      },
    ],
    ["path", { d: "m4.243 5.21 14.39 12.472", key: "1c9a7c" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const fs = e("ShieldCheck", [
    [
      "path",
      {
        d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
        key: "oel41y",
      },
    ],
    ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ws = e("ShieldEllipsis", [
    [
      "path",
      {
        d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
        key: "oel41y",
      },
    ],
    ["path", { d: "M8 12h.01", key: "czm47f" }],
    ["path", { d: "M12 12h.01", key: "1mp3jc" }],
    ["path", { d: "M16 12h.01", key: "1l6xoz" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Is = e("ShieldHalf", [
    [
      "path",
      {
        d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
        key: "oel41y",
      },
    ],
    ["path", { d: "M12 22V2", key: "zs6s6o" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Cs = e("ShieldMinus", [
    [
      "path",
      {
        d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
        key: "oel41y",
      },
    ],
    ["path", { d: "M9 12h6", key: "1c52cq" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const bs = e("ShieldOff", [
    ["path", { d: "m2 2 20 20", key: "1ooewy" }],
    [
      "path",
      {
        d: "M5 5a1 1 0 0 0-1 1v7c0 5 3.5 7.5 7.67 8.94a1 1 0 0 0 .67.01c2.35-.82 4.48-1.97 5.9-3.71",
        key: "1jlk70",
      },
    ],
    [
      "path",
      {
        d: "M9.309 3.652A12.252 12.252 0 0 0 11.24 2.28a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1v7a9.784 9.784 0 0 1-.08 1.264",
        key: "18rp1v",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ss = e("ShieldPlus", [
    [
      "path",
      {
        d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
        key: "oel41y",
      },
    ],
    ["path", { d: "M9 12h6", key: "1c52cq" }],
    ["path", { d: "M12 9v6", key: "199k2o" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const qs = e("ShieldQuestion", [
    [
      "path",
      {
        d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
        key: "oel41y",
      },
    ],
    ["path", { d: "M9.1 9a3 3 0 0 1 5.82 1c0 2-3 3-3 3", key: "mhlwft" }],
    ["path", { d: "M12 17h.01", key: "p32p05" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const b1 = e("ShieldX", [
    [
      "path",
      {
        d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
        key: "oel41y",
      },
    ],
    ["path", { d: "m14.5 9.5-5 5", key: "17q4r4" }],
    ["path", { d: "m9.5 9.5 5 5", key: "18nt4w" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Hs = e("Shield", [
    [
      "path",
      {
        d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
        key: "oel41y",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const zs = e("ShipWheel", [
    ["circle", { cx: "12", cy: "12", r: "8", key: "46899m" }],
    ["path", { d: "M12 2v7.5", key: "1e5rl5" }],
    ["path", { d: "m19 5-5.23 5.23", key: "1ezxxf" }],
    ["path", { d: "M22 12h-7.5", key: "le1719" }],
    ["path", { d: "m19 19-5.23-5.23", key: "p3fmgn" }],
    ["path", { d: "M12 14.5V22", key: "dgcmos" }],
    ["path", { d: "M10.23 13.77 5 19", key: "qwopd4" }],
    ["path", { d: "M9.5 12H2", key: "r7bup8" }],
    ["path", { d: "M10.23 10.23 5 5", key: "k2y7lj" }],
    ["circle", { cx: "12", cy: "12", r: "2.5", key: "ix0uyj" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const As = e("Ship", [
    [
      "path",
      {
        d: "M2 21c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1 .6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1",
        key: "iegodh",
      },
    ],
    [
      "path",
      {
        d: "M19.38 20A11.6 11.6 0 0 0 21 14l-9-4-9 4c0 2.9.94 5.34 2.81 7.76",
        key: "fp8vka",
      },
    ],
    ["path", { d: "M19 13V7a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v6", key: "qpkstq" }],
    ["path", { d: "M12 10v4", key: "1kjpxc" }],
    ["path", { d: "M12 2v3", key: "qbqxhf" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const js = e("Shirt", [
    [
      "path",
      {
        d: "M20.38 3.46 16 2a4 4 0 0 1-8 0L3.62 3.46a2 2 0 0 0-1.34 2.23l.58 3.47a1 1 0 0 0 .99.84H6v10c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V10h2.15a1 1 0 0 0 .99-.84l.58-3.47a2 2 0 0 0-1.34-2.23z",
        key: "1wgbhj",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Vs = e("ShoppingBag", [
    [
      "path",
      {
        d: "M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z",
        key: "hou9p0",
      },
    ],
    ["path", { d: "M3 6h18", key: "d0wm0j" }],
    ["path", { d: "M16 10a4 4 0 0 1-8 0", key: "1ltviw" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ps = e("ShoppingBasket", [
    ["path", { d: "m15 11-1 9", key: "5wnq3a" }],
    ["path", { d: "m19 11-4-7", key: "cnml18" }],
    ["path", { d: "M2 11h20", key: "3eubbj" }],
    [
      "path",
      {
        d: "m3.5 11 1.6 7.4a2 2 0 0 0 2 1.6h9.8a2 2 0 0 0 2-1.6l1.7-7.4",
        key: "yiazzp",
      },
    ],
    ["path", { d: "M4.5 15.5h15", key: "13mye1" }],
    ["path", { d: "m5 11 4-7", key: "116ra9" }],
    ["path", { d: "m9 11 1 9", key: "1ojof7" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Fs = e("ShoppingCart", [
    ["circle", { cx: "8", cy: "21", r: "1", key: "jimo8o" }],
    ["circle", { cx: "19", cy: "21", r: "1", key: "13723u" }],
    [
      "path",
      {
        d: "M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12",
        key: "9zh506",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Bs = e("Shovel", [
    ["path", { d: "M2 22v-5l5-5 5 5-5 5z", key: "1fh25c" }],
    ["path", { d: "M9.5 14.5 16 8", key: "1smz5x" }],
    [
      "path",
      {
        d: "m17 2 5 5-.5.5a3.53 3.53 0 0 1-5 0s0 0 0 0a3.53 3.53 0 0 1 0-5L17 2",
        key: "1q8uv5",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ds = e("ShowerHead", [
    ["path", { d: "m4 4 2.5 2.5", key: "uv2vmf" }],
    ["path", { d: "M13.5 6.5a4.95 4.95 0 0 0-7 7", key: "frdkwv" }],
    ["path", { d: "M15 5 5 15", key: "1ag8rq" }],
    ["path", { d: "M14 17v.01", key: "eokfpp" }],
    ["path", { d: "M10 16v.01", key: "14uyyl" }],
    ["path", { d: "M13 13v.01", key: "1v1k97" }],
    ["path", { d: "M16 10v.01", key: "5169yg" }],
    ["path", { d: "M11 20v.01", key: "cj92p8" }],
    ["path", { d: "M17 14v.01", key: "11cswd" }],
    ["path", { d: "M20 11v.01", key: "19e0od" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Rs = e("Shrink", [
    ["path", { d: "m15 15 6 6m-6-6v4.8m0-4.8h4.8", key: "17vawe" }],
    ["path", { d: "M9 19.8V15m0 0H4.2M9 15l-6 6", key: "chjx8e" }],
    ["path", { d: "M15 4.2V9m0 0h4.8M15 9l6-6", key: "lav6yq" }],
    ["path", { d: "M9 4.2V9m0 0H4.2M9 9 3 3", key: "1pxi2q" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ts = e("Shrub", [
    ["path", { d: "M12 22v-7l-2-2", key: "eqv9mc" }],
    [
      "path",
      {
        d: "M17 8v.8A6 6 0 0 1 13.8 20v0H10v0A6.5 6.5 0 0 1 7 8h0a5 5 0 0 1 10 0Z",
        key: "12jcau",
      },
    ],
    ["path", { d: "m14 14-2 2", key: "847xa2" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Us = e("Shuffle", [
    [
      "path",
      {
        d: "M2 18h1.4c1.3 0 2.5-.6 3.3-1.7l6.1-8.6c.7-1.1 2-1.7 3.3-1.7H22",
        key: "1wmou1",
      },
    ],
    ["path", { d: "m18 2 4 4-4 4", key: "pucp1d" }],
    ["path", { d: "M2 6h1.9c1.5 0 2.9.9 3.6 2.2", key: "10bdb2" }],
    ["path", { d: "M22 18h-5.9c-1.3 0-2.6-.7-3.3-1.8l-.5-.8", key: "vgxac0" }],
    ["path", { d: "m18 14 4 4-4 4", key: "10pe0f" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Zs = e("SigmaSquare", [
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" },
    ],
    ["path", { d: "M16 8.9V7H8l4 5-4 5h8v-1.9", key: "9nih0i" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Os = e("Sigma", [
    ["path", { d: "M18 7V4H6l6 8-6 8h12v-3", key: "zis8ev" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Gs = e("SignalHigh", [
    ["path", { d: "M2 20h.01", key: "4haj6o" }],
    ["path", { d: "M7 20v-4", key: "j294jx" }],
    ["path", { d: "M12 20v-8", key: "i3yub9" }],
    ["path", { d: "M17 20V8", key: "1tkaf5" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Es = e("SignalLow", [
    ["path", { d: "M2 20h.01", key: "4haj6o" }],
    ["path", { d: "M7 20v-4", key: "j294jx" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ws = e("SignalMedium", [
    ["path", { d: "M2 20h.01", key: "4haj6o" }],
    ["path", { d: "M7 20v-4", key: "j294jx" }],
    ["path", { d: "M12 20v-8", key: "i3yub9" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ns = e("SignalZero", [["path", { d: "M2 20h.01", key: "4haj6o" }]])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Xs = e("Signal", [
    ["path", { d: "M2 20h.01", key: "4haj6o" }],
    ["path", { d: "M7 20v-4", key: "j294jx" }],
    ["path", { d: "M12 20v-8", key: "i3yub9" }],
    ["path", { d: "M17 20V8", key: "1tkaf5" }],
    ["path", { d: "M22 4v16", key: "sih9yq" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ks = e("SignpostBig", [
    ["path", { d: "M10 9H4L2 7l2-2h6", key: "1hq7x2" }],
    ["path", { d: "M14 5h6l2 2-2 2h-6", key: "bv62ej" }],
    ["path", { d: "M10 22V4a2 2 0 1 1 4 0v18", key: "eqpcf2" }],
    ["path", { d: "M8 22h8", key: "rmew8v" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const _s = e("Signpost", [
    ["path", { d: "M12 3v3", key: "1n5kay" }],
    ["path", { d: "M18.5 13h-13L2 9.5 5.5 6h13L22 9.5Z", key: "27os56" }],
    ["path", { d: "M12 13v8", key: "1l5pq0" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Js = e("Siren", [
    ["path", { d: "M7 18v-6a5 5 0 1 1 10 0v6", key: "pcx96s" }],
    [
      "path",
      {
        d: "M5 21a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-1a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2z",
        key: "1b4s83",
      },
    ],
    ["path", { d: "M21 12h1", key: "jtio3y" }],
    ["path", { d: "M18.5 4.5 18 5", key: "g5sp9y" }],
    ["path", { d: "M2 12h1", key: "1uaihz" }],
    ["path", { d: "M12 2v1", key: "11qlp1" }],
    ["path", { d: "m4.929 4.929.707.707", key: "1i51kw" }],
    ["path", { d: "M12 12v6", key: "3ahymv" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Qs = e("SkipBack", [
    ["polygon", { points: "19 20 9 12 19 4 19 20", key: "o2sva" }],
    ["line", { x1: "5", x2: "5", y1: "19", y2: "5", key: "1ocqjk" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ys = e("SkipForward", [
    ["polygon", { points: "5 4 15 12 5 20 5 4", key: "16p6eg" }],
    ["line", { x1: "19", x2: "19", y1: "5", y2: "19", key: "futhcm" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const $s = e("Skull", [
    ["circle", { cx: "9", cy: "12", r: "1", key: "1vctgf" }],
    ["circle", { cx: "15", cy: "12", r: "1", key: "1tmaij" }],
    ["path", { d: "M8 20v2h8v-2", key: "ded4og" }],
    ["path", { d: "m12.5 17-.5-1-.5 1h1z", key: "3me087" }],
    [
      "path",
      {
        d: "M16 20a2 2 0 0 0 1.56-3.25 8 8 0 1 0-11.12 0A2 2 0 0 0 8 20",
        key: "xq9p5u",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const e8 = e("Slack", [
    [
      "rect",
      { width: "3", height: "8", x: "13", y: "2", rx: "1.5", key: "diqz80" },
    ],
    ["path", { d: "M19 8.5V10h1.5A1.5 1.5 0 1 0 19 8.5", key: "183iwg" }],
    [
      "rect",
      { width: "3", height: "8", x: "8", y: "14", rx: "1.5", key: "hqg7r1" },
    ],
    ["path", { d: "M5 15.5V14H3.5A1.5 1.5 0 1 0 5 15.5", key: "76g71w" }],
    [
      "rect",
      { width: "8", height: "3", x: "14", y: "13", rx: "1.5", key: "1kmz0a" },
    ],
    ["path", { d: "M15.5 19H14v1.5a1.5 1.5 0 1 0 1.5-1.5", key: "jc4sz0" }],
    [
      "rect",
      { width: "8", height: "3", x: "2", y: "8", rx: "1.5", key: "1omvl4" },
    ],
    ["path", { d: "M8.5 5H10V3.5A1.5 1.5 0 1 0 8.5 5", key: "16f3cl" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const S1 = e("SlashSquare", [
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" },
    ],
    ["line", { x1: "9", x2: "15", y1: "15", y2: "9", key: "1dfufj" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const a8 = e("Slash", [["path", { d: "M22 2 2 22", key: "y4kqgn" }]])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const t8 = e("Slice", [
    ["path", { d: "m8 14-6 6h9v-3", key: "zo3j9a" }],
    [
      "path",
      {
        d: "M18.37 3.63 8 14l3 3L21.37 6.63a2.12 2.12 0 1 0-3-3Z",
        key: "1dzx0j",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const c8 = e("SlidersHorizontal", [
    ["line", { x1: "21", x2: "14", y1: "4", y2: "4", key: "obuewd" }],
    ["line", { x1: "10", x2: "3", y1: "4", y2: "4", key: "1q6298" }],
    ["line", { x1: "21", x2: "12", y1: "12", y2: "12", key: "1iu8h1" }],
    ["line", { x1: "8", x2: "3", y1: "12", y2: "12", key: "ntss68" }],
    ["line", { x1: "21", x2: "16", y1: "20", y2: "20", key: "14d8ph" }],
    ["line", { x1: "12", x2: "3", y1: "20", y2: "20", key: "m0wm8r" }],
    ["line", { x1: "14", x2: "14", y1: "2", y2: "6", key: "14e1ph" }],
    ["line", { x1: "8", x2: "8", y1: "10", y2: "14", key: "1i6ji0" }],
    ["line", { x1: "16", x2: "16", y1: "18", y2: "22", key: "1lctlv" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const h8 = e("Sliders", [
    ["line", { x1: "4", x2: "4", y1: "21", y2: "14", key: "1p332r" }],
    ["line", { x1: "4", x2: "4", y1: "10", y2: "3", key: "gb41h5" }],
    ["line", { x1: "12", x2: "12", y1: "21", y2: "12", key: "hf2csr" }],
    ["line", { x1: "12", x2: "12", y1: "8", y2: "3", key: "1kfi7u" }],
    ["line", { x1: "20", x2: "20", y1: "21", y2: "16", key: "1lhrwl" }],
    ["line", { x1: "20", x2: "20", y1: "12", y2: "3", key: "16vvfq" }],
    ["line", { x1: "2", x2: "6", y1: "14", y2: "14", key: "1uebub" }],
    ["line", { x1: "10", x2: "14", y1: "8", y2: "8", key: "1yglbp" }],
    ["line", { x1: "18", x2: "22", y1: "16", y2: "16", key: "1jxqpz" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const d8 = e("SmartphoneCharging", [
    [
      "rect",
      {
        width: "14",
        height: "20",
        x: "5",
        y: "2",
        rx: "2",
        ry: "2",
        key: "1yt0o3",
      },
    ],
    ["path", { d: "M12.667 8 10 12h4l-2.667 4", key: "h9lk2d" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const o8 = e("SmartphoneNfc", [
    [
      "rect",
      { width: "7", height: "12", x: "2", y: "6", rx: "1", key: "5nje8w" },
    ],
    ["path", { d: "M13 8.32a7.43 7.43 0 0 1 0 7.36", key: "1g306n" }],
    ["path", { d: "M16.46 6.21a11.76 11.76 0 0 1 0 11.58", key: "uqvjvo" }],
    ["path", { d: "M19.91 4.1a15.91 15.91 0 0 1 .01 15.8", key: "ujntz3" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const y8 = e("Smartphone", [
    [
      "rect",
      {
        width: "14",
        height: "20",
        x: "5",
        y: "2",
        rx: "2",
        ry: "2",
        key: "1yt0o3",
      },
    ],
    ["path", { d: "M12 18h.01", key: "mhygvu" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const i8 = e("SmilePlus", [
    ["path", { d: "M22 11v1a10 10 0 1 1-9-10", key: "ew0xw9" }],
    ["path", { d: "M8 14s1.5 2 4 2 4-2 4-2", key: "1y1vjs" }],
    ["line", { x1: "9", x2: "9.01", y1: "9", y2: "9", key: "yxxnd0" }],
    ["line", { x1: "15", x2: "15.01", y1: "9", y2: "9", key: "1p4y9e" }],
    ["path", { d: "M16 5h6", key: "1vod17" }],
    ["path", { d: "M19 2v6", key: "4bpg5p" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const n8 = e("Smile", [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["path", { d: "M8 14s1.5 2 4 2 4-2 4-2", key: "1y1vjs" }],
    ["line", { x1: "9", x2: "9.01", y1: "9", y2: "9", key: "yxxnd0" }],
    ["line", { x1: "15", x2: "15.01", y1: "9", y2: "9", key: "1p4y9e" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const r8 = e("Snail", [
    [
      "path",
      { d: "M2 13a6 6 0 1 0 12 0 4 4 0 1 0-8 0 2 2 0 0 0 4 0", key: "hneq2s" },
    ],
    ["circle", { cx: "10", cy: "13", r: "8", key: "194lz3" }],
    [
      "path",
      { d: "M2 21h12c4.4 0 8-3.6 8-8V7a2 2 0 1 0-4 0v6", key: "ixqyt7" },
    ],
    ["path", { d: "M18 3 19.1 5.2", key: "9tjm43" }],
    ["path", { d: "M22 3 20.9 5.2", key: "j3odrs" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const k8 = e("Snowflake", [
    ["line", { x1: "2", x2: "22", y1: "12", y2: "12", key: "1dnqot" }],
    ["line", { x1: "12", x2: "12", y1: "2", y2: "22", key: "7eqyqh" }],
    ["path", { d: "m20 16-4-4 4-4", key: "rquw4f" }],
    ["path", { d: "m4 8 4 4-4 4", key: "12s3z9" }],
    ["path", { d: "m16 4-4 4-4-4", key: "1tumq1" }],
    ["path", { d: "m8 20 4-4 4 4", key: "9p200w" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const p8 = e("Sofa", [
    ["path", { d: "M20 9V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v3", key: "1dgpiv" }],
    [
      "path",
      {
        d: "M2 11v5a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-5a2 2 0 0 0-4 0v2H6v-2a2 2 0 0 0-4 0Z",
        key: "u5qfb7",
      },
    ],
    ["path", { d: "M4 18v2", key: "jwo5n2" }],
    ["path", { d: "M20 18v2", key: "1ar1qi" }],
    ["path", { d: "M12 4v9", key: "oqhhn3" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const l8 = e("Soup", [
    ["path", { d: "M12 21a9 9 0 0 0 9-9H3a9 9 0 0 0 9 9Z", key: "4rw317" }],
    ["path", { d: "M7 21h10", key: "1b0cd5" }],
    ["path", { d: "M19.5 12 22 6", key: "shfsr5" }],
    [
      "path",
      {
        d: "M16.25 3c.27.1.8.53.75 1.36-.06.83-.93 1.2-1 2.02-.05.78.34 1.24.73 1.62",
        key: "rpc6vp",
      },
    ],
    [
      "path",
      {
        d: "M11.25 3c.27.1.8.53.74 1.36-.05.83-.93 1.2-.98 2.02-.06.78.33 1.24.72 1.62",
        key: "1lf63m",
      },
    ],
    [
      "path",
      {
        d: "M6.25 3c.27.1.8.53.75 1.36-.06.83-.93 1.2-1 2.02-.05.78.34 1.24.74 1.62",
        key: "97tijn",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const s8 = e("Space", [
    [
      "path",
      { d: "M22 17v1c0 .5-.5 1-1 1H3c-.5 0-1-.5-1-1v-1", key: "lt2kga" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const u8 = e("Spade", [
    [
      "path",
      {
        d: "M5 9c-1.5 1.5-3 3.2-3 5.5A5.5 5.5 0 0 0 7.5 20c1.8 0 3-.5 4.5-2 1.5 1.5 2.7 2 4.5 2a5.5 5.5 0 0 0 5.5-5.5c0-2.3-1.5-4-3-5.5l-7-7-7 7Z",
        key: "40bo9n",
      },
    ],
    ["path", { d: "M12 18v4", key: "jadmvz" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const M8 = e("Sparkle", [
    [
      "path",
      {
        d: "m12 3-1.9 5.8a2 2 0 0 1-1.287 1.288L3 12l5.8 1.9a2 2 0 0 1 1.288 1.287L12 21l1.9-5.8a2 2 0 0 1 1.287-1.288L21 12l-5.8-1.9a2 2 0 0 1-1.288-1.287Z",
        key: "nraa5p",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const q1 = e("Sparkles", [
    [
      "path",
      {
        d: "m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z",
        key: "17u4zn",
      },
    ],
    ["path", { d: "M5 3v4", key: "bklmnn" }],
    ["path", { d: "M19 17v4", key: "iiml17" }],
    ["path", { d: "M3 5h4", key: "nem4j1" }],
    ["path", { d: "M17 19h4", key: "lbex7p" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const v8 = e("Speaker", [
    [
      "rect",
      { width: "16", height: "20", x: "4", y: "2", rx: "2", key: "1nb95v" },
    ],
    ["path", { d: "M12 6h.01", key: "1vi96p" }],
    ["circle", { cx: "12", cy: "14", r: "4", key: "1jruaj" }],
    ["path", { d: "M12 14h.01", key: "1etili" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const m8 = e("Speech", [
    [
      "path",
      {
        d: "M8.8 20v-4.1l1.9.2a2.3 2.3 0 0 0 2.164-2.1V8.3A5.37 5.37 0 0 0 2 8.25c0 2.8.656 3.054 1 4.55a5.77 5.77 0 0 1 .029 2.758L2 20",
        key: "11atix",
      },
    ],
    ["path", { d: "M19.8 17.8a7.5 7.5 0 0 0 .003-10.603", key: "yol142" }],
    ["path", { d: "M17 15a3.5 3.5 0 0 0-.025-4.975", key: "ssbmkc" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const x8 = e("SpellCheck2", [
    ["path", { d: "m6 16 6-12 6 12", key: "1b4byz" }],
    ["path", { d: "M8 12h8", key: "1wcyev" }],
    [
      "path",
      {
        d: "M4 21c1.1 0 1.1-1 2.3-1s1.1 1 2.3 1c1.1 0 1.1-1 2.3-1 1.1 0 1.1 1 2.3 1 1.1 0 1.1-1 2.3-1 1.1 0 1.1 1 2.3 1 1.1 0 1.1-1 2.3-1",
        key: "8mdmtu",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const g8 = e("SpellCheck", [
    ["path", { d: "m6 16 6-12 6 12", key: "1b4byz" }],
    ["path", { d: "M8 12h8", key: "1wcyev" }],
    ["path", { d: "m16 20 2 2 4-4", key: "13tcca" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const L8 = e("Spline", [
    ["circle", { cx: "19", cy: "5", r: "2", key: "mhkx31" }],
    ["circle", { cx: "5", cy: "19", r: "2", key: "v8kfzx" }],
    ["path", { d: "M5 17A12 12 0 0 1 17 5", key: "1okkup" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const f8 = e("SplitSquareHorizontal", [
    ["path", { d: "M8 19H5c-1 0-2-1-2-2V7c0-1 1-2 2-2h3", key: "lubmu8" }],
    ["path", { d: "M16 5h3c1 0 2 1 2 2v10c0 1-1 2-2 2h-3", key: "1ag34g" }],
    ["line", { x1: "12", x2: "12", y1: "4", y2: "20", key: "1tx1rr" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const w8 = e("SplitSquareVertical", [
    ["path", { d: "M5 8V5c0-1 1-2 2-2h10c1 0 2 1 2 2v3", key: "1pi83i" }],
    ["path", { d: "M19 16v3c0 1-1 2-2 2H7c-1 0-2-1-2-2v-3", key: "ido5k7" }],
    ["line", { x1: "4", x2: "20", y1: "12", y2: "12", key: "1e0a9i" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const I8 = e("Split", [
    ["path", { d: "M16 3h5v5", key: "1806ms" }],
    ["path", { d: "M8 3H3v5", key: "15dfkv" }],
    ["path", { d: "M12 22v-8.3a4 4 0 0 0-1.172-2.872L3 3", key: "1qrqzj" }],
    ["path", { d: "m15 9 6-6", key: "ko1vev" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const C8 = e("SprayCan", [
    ["path", { d: "M3 3h.01", key: "159qn6" }],
    ["path", { d: "M7 5h.01", key: "1hq22a" }],
    ["path", { d: "M11 7h.01", key: "1osv80" }],
    ["path", { d: "M3 7h.01", key: "1xzrh3" }],
    ["path", { d: "M7 9h.01", key: "19b3jx" }],
    ["path", { d: "M3 11h.01", key: "1eifu7" }],
    ["rect", { width: "4", height: "4", x: "15", y: "5", key: "mri9e4" }],
    [
      "path",
      {
        d: "m19 9 2 2v10c0 .6-.4 1-1 1h-6c-.6 0-1-.4-1-1V11l2-2",
        key: "aib6hk",
      },
    ],
    ["path", { d: "m13 14 8-2", key: "1d7bmk" }],
    ["path", { d: "m13 19 8-2", key: "1y2vml" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const b8 = e("Sprout", [
    ["path", { d: "M7 20h10", key: "e6iznv" }],
    ["path", { d: "M10 20c5.5-2.5.8-6.4 3-10", key: "161w41" }],
    [
      "path",
      {
        d: "M9.5 9.4c1.1.8 1.8 2.2 2.3 3.7-2 .4-3.5.4-4.8-.3-1.2-.6-2.3-1.9-3-4.2 2.8-.5 4.4 0 5.5.8z",
        key: "9gtqwd",
      },
    ],
    [
      "path",
      {
        d: "M14.1 6a7 7 0 0 0-1.1 4c1.9-.1 3.3-.6 4.3-1.4 1-1 1.6-2.3 1.7-4.6-2.7.1-4 1-4.9 2z",
        key: "bkxnd2",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const S8 = e("SquareDashedBottomCode", [
    ["path", { d: "m10 10-2 2 2 2", key: "p6et6i" }],
    ["path", { d: "m14 14 2-2-2-2", key: "m075q2" }],
    [
      "path",
      {
        d: "M5 21a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2",
        key: "as5y1o",
      },
    ],
    ["path", { d: "M9 21h1", key: "15o7lz" }],
    ["path", { d: "M14 21h1", key: "v9vybs" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const q8 = e("SquareDashedBottom", [
    [
      "path",
      {
        d: "M5 21a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2",
        key: "as5y1o",
      },
    ],
    ["path", { d: "M9 21h1", key: "15o7lz" }],
    ["path", { d: "M14 21h1", key: "v9vybs" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const k = e("SquarePen", [
    [
      "path",
      {
        d: "M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7",
        key: "1m0v6g",
      },
    ],
    [
      "path",
      {
        d: "M18.375 2.625a2.121 2.121 0 1 1 3 3L12 15l-4 1 1-4Z",
        key: "1lpok0",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const H8 = e("SquareRadical", [
    ["path", { d: "M7 12h2l2 5 2-10h4", key: "1fxv6h" }],
    [
      "rect",
      { x: "3", y: "3", width: "18", height: "18", rx: "2", key: "h1oib" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const z8 = e("SquareStack", [
    [
      "path",
      {
        d: "M4 10c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h4c1.1 0 2 .9 2 2",
        key: "4i38lg",
      },
    ],
    [
      "path",
      {
        d: "M10 16c-1.1 0-2-.9-2-2v-4c0-1.1.9-2 2-2h4c1.1 0 2 .9 2 2",
        key: "mlte4a",
      },
    ],
    [
      "rect",
      { width: "8", height: "8", x: "14", y: "14", rx: "2", key: "1fa9i4" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const H1 = e("SquareUserRound", [
    ["path", { d: "M18 21a6 6 0 0 0-12 0", key: "kaz2du" }],
    ["circle", { cx: "12", cy: "11", r: "4", key: "1gt34v" }],
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const z1 = e("SquareUser", [
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" },
    ],
    ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }],
    ["path", { d: "M7 21v-2a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2", key: "1m6ac2" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const A8 = e("Square", [
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const j8 = e("Squircle", [
    [
      "path",
      {
        d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9-9 9-9-1.8-9-9 1.8-9 9-9",
        key: "garfkc",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const V8 = e("Squirrel", [
    ["path", { d: "M15.236 22a3 3 0 0 0-2.2-5", key: "21bitc" }],
    [
      "path",
      {
        d: "M16 20a3 3 0 0 1 3-3h1a2 2 0 0 0 2-2v-2a4 4 0 0 0-4-4V4",
        key: "oh0fg0",
      },
    ],
    ["path", { d: "M18 13h.01", key: "9veqaj" }],
    [
      "path",
      {
        d: "M18 6a4 4 0 0 0-4 4 7 7 0 0 0-7 7c0-5 4-5 4-10.5a4.5 4.5 0 1 0-9 0 2.5 2.5 0 0 0 5 0C7 10 3 11 3 17c0 2.8 2.2 5 5 5h10",
        key: "980v8a",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const P8 = e("Stamp", [
    ["path", { d: "M5 22h14", key: "ehvnwv" }],
    [
      "path",
      {
        d: "M19.27 13.73A2.5 2.5 0 0 0 17.5 13h-11A2.5 2.5 0 0 0 4 15.5V17a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-1.5c0-.66-.26-1.3-.73-1.77Z",
        key: "1sy9ra",
      },
    ],
    [
      "path",
      {
        d: "M14 13V8.5C14 7 15 7 15 5a3 3 0 0 0-3-3c-1.66 0-3 1-3 3s1 2 1 3.5V13",
        key: "cnxgux",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const F8 = e("StarHalf", [
    ["path", { d: "M12 17.8 5.8 21 7 14.1 2 9.3l7-1L12 2", key: "nare05" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const B8 = e("StarOff", [
    [
      "path",
      {
        d: "M8.34 8.34 2 9.27l5 4.87L5.82 21 12 17.77 18.18 21l-.59-3.43",
        key: "16m0ql",
      },
    ],
    [
      "path",
      { d: "M18.42 12.76 22 9.27l-6.91-1L12 2l-1.44 2.91", key: "1vt8nq" },
    ],
    ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const D8 = e("Star", [
    [
      "polygon",
      {
        points:
          "12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2",
        key: "8f66p6",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const R8 = e("StepBack", [
    ["line", { x1: "18", x2: "18", y1: "20", y2: "4", key: "cun8e5" }],
    ["polygon", { points: "14,20 4,12 14,4", key: "ypakod" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const T8 = e("StepForward", [
    ["line", { x1: "6", x2: "6", y1: "4", y2: "20", key: "fy8qot" }],
    ["polygon", { points: "10,4 20,12 10,20", key: "1mc1pf" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const U8 = e("Stethoscope", [
    [
      "path",
      {
        d: "M4.8 2.3A.3.3 0 1 0 5 2H4a2 2 0 0 0-2 2v5a6 6 0 0 0 6 6v0a6 6 0 0 0 6-6V4a2 2 0 0 0-2-2h-1a.2.2 0 1 0 .3.3",
        key: "1jd90r",
      },
    ],
    ["path", { d: "M8 15v1a6 6 0 0 0 6 6v0a6 6 0 0 0 6-6v-4", key: "126ukv" }],
    ["circle", { cx: "20", cy: "10", r: "2", key: "ts1r5v" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Z8 = e("Sticker", [
    [
      "path",
      {
        d: "M15.5 3H5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h14a2 2 0 0 0 2-2V8.5L15.5 3Z",
        key: "1wis1t",
      },
    ],
    ["path", { d: "M14 3v4a2 2 0 0 0 2 2h4", key: "36rjfy" }],
    ["path", { d: "M8 13h0", key: "jdup5h" }],
    ["path", { d: "M16 13h0", key: "l4i2ga" }],
    ["path", { d: "M10 16s.8 1 2 1c1.3 0 2-1 2-1", key: "1vvgv3" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const O8 = e("StickyNote", [
    [
      "path",
      {
        d: "M16 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8Z",
        key: "qazsjp",
      },
    ],
    ["path", { d: "M15 3v4a2 2 0 0 0 2 2h4", key: "40519r" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const G8 = e("StopCircle", [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["rect", { width: "6", height: "6", x: "9", y: "9", key: "1wrtvo" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const E8 = e("Store", [
    [
      "path",
      {
        d: "m2 7 4.41-4.41A2 2 0 0 1 7.83 2h8.34a2 2 0 0 1 1.42.59L22 7",
        key: "ztvudi",
      },
    ],
    ["path", { d: "M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8", key: "1b2hhj" }],
    [
      "path",
      { d: "M15 22v-4a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v4", key: "2ebpfo" },
    ],
    ["path", { d: "M2 7h20", key: "1fcdvo" }],
    [
      "path",
      {
        d: "M22 7v3a2 2 0 0 1-2 2v0a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 16 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 12 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 8 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 4 12v0a2 2 0 0 1-2-2V7",
        key: "jon5kx",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const W8 = e("StretchHorizontal", [
    [
      "rect",
      { width: "20", height: "6", x: "2", y: "4", rx: "2", key: "qdearl" },
    ],
    [
      "rect",
      { width: "20", height: "6", x: "2", y: "14", rx: "2", key: "1xrn6j" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const N8 = e("StretchVertical", [
    [
      "rect",
      { width: "6", height: "20", x: "4", y: "2", rx: "2", key: "19qu7m" },
    ],
    [
      "rect",
      { width: "6", height: "20", x: "14", y: "2", rx: "2", key: "24v0nk" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const X8 = e("Strikethrough", [
    ["path", { d: "M16 4H9a3 3 0 0 0-2.83 4", key: "43sutm" }],
    ["path", { d: "M14 12a4 4 0 0 1 0 8H6", key: "nlfj13" }],
    ["line", { x1: "4", x2: "20", y1: "12", y2: "12", key: "1e0a9i" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const K8 = e("Subscript", [
    ["path", { d: "m4 5 8 8", key: "1eunvl" }],
    ["path", { d: "m12 5-8 8", key: "1ah0jp" }],
    [
      "path",
      {
        d: "M20 19h-4c0-1.5.44-2 1.5-2.5S20 15.33 20 14c0-.47-.17-.93-.48-1.29a2.11 2.11 0 0 0-2.62-.44c-.42.24-.74.62-.9 1.07",
        key: "e8ta8j",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const _8 = e("SunDim", [
    ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
    ["path", { d: "M12 4h.01", key: "1ujb9j" }],
    ["path", { d: "M20 12h.01", key: "1ykeid" }],
    ["path", { d: "M12 20h.01", key: "zekei9" }],
    ["path", { d: "M4 12h.01", key: "158zrr" }],
    ["path", { d: "M17.657 6.343h.01", key: "31pqzk" }],
    ["path", { d: "M17.657 17.657h.01", key: "jehnf4" }],
    ["path", { d: "M6.343 17.657h.01", key: "gdk6ow" }],
    ["path", { d: "M6.343 6.343h.01", key: "1uurf0" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const J8 = e("SunMedium", [
    ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
    ["path", { d: "M12 3v1", key: "1asbbs" }],
    ["path", { d: "M12 20v1", key: "1wcdkc" }],
    ["path", { d: "M3 12h1", key: "lp3yf2" }],
    ["path", { d: "M20 12h1", key: "1vloll" }],
    ["path", { d: "m18.364 5.636-.707.707", key: "1hakh0" }],
    ["path", { d: "m6.343 17.657-.707.707", key: "18m9nf" }],
    ["path", { d: "m5.636 5.636.707.707", key: "1xv1c5" }],
    ["path", { d: "m17.657 17.657.707.707", key: "vl76zb" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Q8 = e("SunMoon", [
    ["path", { d: "M12 8a2.83 2.83 0 0 0 4 4 4 4 0 1 1-4-4", key: "1fu5g2" }],
    ["path", { d: "M12 2v2", key: "tus03m" }],
    ["path", { d: "M12 20v2", key: "1lh1kg" }],
    ["path", { d: "m4.9 4.9 1.4 1.4", key: "b9915j" }],
    ["path", { d: "m17.7 17.7 1.4 1.4", key: "qc3ed3" }],
    ["path", { d: "M2 12h2", key: "1t8f8n" }],
    ["path", { d: "M20 12h2", key: "1q8mjw" }],
    ["path", { d: "m6.3 17.7-1.4 1.4", key: "5gca6" }],
    ["path", { d: "m19.1 4.9-1.4 1.4", key: "wpu9u6" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Y8 = e("SunSnow", [
    ["path", { d: "M10 9a3 3 0 1 0 0 6", key: "6zmtdl" }],
    ["path", { d: "M2 12h1", key: "1uaihz" }],
    ["path", { d: "M14 21V3", key: "1llu3z" }],
    ["path", { d: "M10 4V3", key: "pkzwkn" }],
    ["path", { d: "M10 21v-1", key: "1u8rkd" }],
    ["path", { d: "m3.64 18.36.7-.7", key: "105rm9" }],
    ["path", { d: "m4.34 6.34-.7-.7", key: "d3unjp" }],
    ["path", { d: "M14 12h8", key: "4f43i9" }],
    ["path", { d: "m17 4-3 3", key: "15jcng" }],
    ["path", { d: "m14 17 3 3", key: "6tlq38" }],
    ["path", { d: "m21 15-3-3 3-3", key: "1nlnje" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const $8 = e("Sun", [
    ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
    ["path", { d: "M12 2v2", key: "tus03m" }],
    ["path", { d: "M12 20v2", key: "1lh1kg" }],
    ["path", { d: "m4.93 4.93 1.41 1.41", key: "149t6j" }],
    ["path", { d: "m17.66 17.66 1.41 1.41", key: "ptbguv" }],
    ["path", { d: "M2 12h2", key: "1t8f8n" }],
    ["path", { d: "M20 12h2", key: "1q8mjw" }],
    ["path", { d: "m6.34 17.66-1.41 1.41", key: "1m8zz5" }],
    ["path", { d: "m19.07 4.93-1.41 1.41", key: "1shlcs" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const e7 = e("Sunrise", [
    ["path", { d: "M12 2v8", key: "1q4o3n" }],
    ["path", { d: "m4.93 10.93 1.41 1.41", key: "2a7f42" }],
    ["path", { d: "M2 18h2", key: "j10viu" }],
    ["path", { d: "M20 18h2", key: "wocana" }],
    ["path", { d: "m19.07 10.93-1.41 1.41", key: "15zs5n" }],
    ["path", { d: "M22 22H2", key: "19qnx5" }],
    ["path", { d: "m8 6 4-4 4 4", key: "ybng9g" }],
    ["path", { d: "M16 18a4 4 0 0 0-8 0", key: "1lzouq" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const a7 = e("Sunset", [
    ["path", { d: "M12 10V2", key: "16sf7g" }],
    ["path", { d: "m4.93 10.93 1.41 1.41", key: "2a7f42" }],
    ["path", { d: "M2 18h2", key: "j10viu" }],
    ["path", { d: "M20 18h2", key: "wocana" }],
    ["path", { d: "m19.07 10.93-1.41 1.41", key: "15zs5n" }],
    ["path", { d: "M22 22H2", key: "19qnx5" }],
    ["path", { d: "m16 6-4 4-4-4", key: "6wukr" }],
    ["path", { d: "M16 18a4 4 0 0 0-8 0", key: "1lzouq" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const t7 = e("Superscript", [
    ["path", { d: "m4 19 8-8", key: "hr47gm" }],
    ["path", { d: "m12 19-8-8", key: "1dhhmo" }],
    [
      "path",
      {
        d: "M20 12h-4c0-1.5.442-2 1.5-2.5S20 8.334 20 7.002c0-.472-.17-.93-.484-1.29a2.105 2.105 0 0 0-2.617-.436c-.42.239-.738.614-.899 1.06",
        key: "1dfcux",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const c7 = e("SwatchBook", [
    [
      "path",
      {
        d: "M11 17a4 4 0 0 1-8 0V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2Z",
        key: "1ldrpk",
      },
    ],
    [
      "path",
      { d: "M16.7 13H19a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H7", key: "11i5po" },
    ],
    ["path", { d: "M 7 17h0.01", key: "10821z" }],
    [
      "path",
      {
        d: "m11 8 2.3-2.3a2.4 2.4 0 0 1 3.404.004L18.6 7.6a2.4 2.4 0 0 1 .026 3.434L9.9 19.8",
        key: "o2gii7",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const h7 = e("SwissFranc", [
    ["path", { d: "M10 21V3h8", key: "br2l0g" }],
    ["path", { d: "M6 16h9", key: "2py0wn" }],
    ["path", { d: "M10 9.5h7", key: "13dmhz" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const d7 = e("SwitchCamera", [
    ["path", { d: "M11 19H4a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h5", key: "mtk2lu" }],
    ["path", { d: "M13 5h7a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-5", key: "120jsl" }],
    ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
    ["path", { d: "m18 22-3-3 3-3", key: "kgdoj7" }],
    ["path", { d: "m6 2 3 3-3 3", key: "1fnbkv" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const o7 = e("Sword", [
    ["polyline", { points: "14.5 17.5 3 6 3 3 6 3 17.5 14.5", key: "1hfsw2" }],
    ["line", { x1: "13", x2: "19", y1: "19", y2: "13", key: "1vrmhu" }],
    ["line", { x1: "16", x2: "20", y1: "16", y2: "20", key: "1bron3" }],
    ["line", { x1: "19", x2: "21", y1: "21", y2: "19", key: "13pww6" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const y7 = e("Swords", [
    ["polyline", { points: "14.5 17.5 3 6 3 3 6 3 17.5 14.5", key: "1hfsw2" }],
    ["line", { x1: "13", x2: "19", y1: "19", y2: "13", key: "1vrmhu" }],
    ["line", { x1: "16", x2: "20", y1: "16", y2: "20", key: "1bron3" }],
    ["line", { x1: "19", x2: "21", y1: "21", y2: "19", key: "13pww6" }],
    ["polyline", { points: "14.5 6.5 18 3 21 3 21 6 17.5 9.5", key: "hbey2j" }],
    ["line", { x1: "5", x2: "9", y1: "14", y2: "18", key: "1hf58s" }],
    ["line", { x1: "7", x2: "4", y1: "17", y2: "20", key: "pidxm4" }],
    ["line", { x1: "3", x2: "5", y1: "19", y2: "21", key: "1pehsh" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const i7 = e("Syringe", [
    ["path", { d: "m18 2 4 4", key: "22kx64" }],
    ["path", { d: "m17 7 3-3", key: "1w1zoj" }],
    [
      "path",
      {
        d: "M19 9 8.7 19.3c-1 1-2.5 1-3.4 0l-.6-.6c-1-1-1-2.5 0-3.4L15 5",
        key: "1exhtz",
      },
    ],
    ["path", { d: "m9 11 4 4", key: "rovt3i" }],
    ["path", { d: "m5 19-3 3", key: "59f2uf" }],
    ["path", { d: "m14 4 6 6", key: "yqp9t2" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const n7 = e("Table2", [
    [
      "path",
      {
        d: "M9 3H5a2 2 0 0 0-2 2v4m6-6h10a2 2 0 0 1 2 2v4M9 3v18m0 0h10a2 2 0 0 0 2-2V9M9 21H5a2 2 0 0 1-2-2V9m0 0h18",
        key: "gugj83",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const r7 = e("TableCellsMerge", [
    ["path", { d: "M12 21v-6", key: "lihzve" }],
    ["path", { d: "M12 9V3", key: "da5inc" }],
    ["path", { d: "M3 15h18", key: "5xshup" }],
    ["path", { d: "M3 9h18", key: "1pudct" }],
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const k7 = e("TableCellsSplit", [
    ["path", { d: "M12 15V9", key: "8c7uyn" }],
    ["path", { d: "M3 15h18", key: "5xshup" }],
    ["path", { d: "M3 9h18", key: "1pudct" }],
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const p7 = e("TableColumnsSplit", [
    ["path", { d: "M14 14v2", key: "w2a1xv" }],
    ["path", { d: "M14 20v2", key: "1lq872" }],
    ["path", { d: "M14 2v2", key: "6buw04" }],
    ["path", { d: "M14 8v2", key: "i67w9a" }],
    ["path", { d: "M2 15h8", key: "82wtch" }],
    ["path", { d: "M2 3h6a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H2", key: "up0l64" }],
    ["path", { d: "M2 9h8", key: "yelfik" }],
    ["path", { d: "M22 15h-4", key: "1es58f" }],
    ["path", { d: "M22 3h-2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h2", key: "pdjoqf" }],
    ["path", { d: "M22 9h-4", key: "1luja7" }],
    ["path", { d: "M5 3v18", key: "14hmio" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const l7 = e("TableProperties", [
    ["path", { d: "M15 3v18", key: "14nvp0" }],
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" },
    ],
    ["path", { d: "M21 9H3", key: "1338ky" }],
    ["path", { d: "M21 15H3", key: "9uk58r" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const s7 = e("TableRowsSplit", [
    ["path", { d: "M14 10h2", key: "1lstlu" }],
    ["path", { d: "M15 22v-8", key: "1fwwgm" }],
    ["path", { d: "M15 2v4", key: "1044rn" }],
    ["path", { d: "M2 10h2", key: "1r8dkt" }],
    ["path", { d: "M20 10h2", key: "1ug425" }],
    ["path", { d: "M3 19h18", key: "awlh7x" }],
    [
      "path",
      { d: "M3 22v-6a2 2 135 0 1 2-2h14a2 2 45 0 1 2 2v6", key: "ibqhof" },
    ],
    [
      "path",
      { d: "M3 2v2a2 2 45 0 0 2 2h14a2 2 135 0 0 2-2V2", key: "1uenja" },
    ],
    ["path", { d: "M8 10h2", key: "66od0" }],
    ["path", { d: "M9 22v-8", key: "fmnu31" }],
    ["path", { d: "M9 2v4", key: "j1yeou" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const u7 = e("Table", [
    ["path", { d: "M12 3v18", key: "108xh3" }],
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" },
    ],
    ["path", { d: "M3 9h18", key: "1pudct" }],
    ["path", { d: "M3 15h18", key: "5xshup" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const M7 = e("TabletSmartphone", [
    [
      "rect",
      { width: "10", height: "14", x: "3", y: "8", rx: "2", key: "1vrsiq" },
    ],
    [
      "path",
      {
        d: "M5 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2h-2.4",
        key: "1j4zmg",
      },
    ],
    ["path", { d: "M8 18h.01", key: "lrp35t" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const v7 = e("Tablet", [
    [
      "rect",
      {
        width: "16",
        height: "20",
        x: "4",
        y: "2",
        rx: "2",
        ry: "2",
        key: "76otgf",
      },
    ],
    ["line", { x1: "12", x2: "12.01", y1: "18", y2: "18", key: "1dp563" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const m7 = e("Tablets", [
    ["circle", { cx: "7", cy: "7", r: "5", key: "x29byf" }],
    ["circle", { cx: "17", cy: "17", r: "5", key: "1op1d2" }],
    ["path", { d: "M12 17h10", key: "ls21zv" }],
    ["path", { d: "m3.46 10.54 7.08-7.08", key: "1rehiu" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const x7 = e("Tag", [
    [
      "path",
      {
        d: "M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z",
        key: "vktsd0",
      },
    ],
    [
      "circle",
      { cx: "7.5", cy: "7.5", r: ".5", fill: "currentColor", key: "kqv944" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const g7 = e("Tags", [
    ["path", { d: "m15 5 6.3 6.3a2.4 2.4 0 0 1 0 3.4L17 19", key: "1cbfv1" }],
    [
      "path",
      {
        d: "M9.586 5.586A2 2 0 0 0 8.172 5H3a1 1 0 0 0-1 1v5.172a2 2 0 0 0 .586 1.414L8.29 18.29a2.426 2.426 0 0 0 3.42 0l3.58-3.58a2.426 2.426 0 0 0 0-3.42z",
        key: "135mg7",
      },
    ],
    [
      "circle",
      { cx: "6.5", cy: "9.5", r: ".5", fill: "currentColor", key: "5pm5xn" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const L7 = e("Tally1", [["path", { d: "M4 4v16", key: "6qkkli" }]])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const f7 = e("Tally2", [
    ["path", { d: "M4 4v16", key: "6qkkli" }],
    ["path", { d: "M9 4v16", key: "81ygyz" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const w7 = e("Tally3", [
    ["path", { d: "M4 4v16", key: "6qkkli" }],
    ["path", { d: "M9 4v16", key: "81ygyz" }],
    ["path", { d: "M14 4v16", key: "12vmem" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const I7 = e("Tally4", [
    ["path", { d: "M4 4v16", key: "6qkkli" }],
    ["path", { d: "M9 4v16", key: "81ygyz" }],
    ["path", { d: "M14 4v16", key: "12vmem" }],
    ["path", { d: "M19 4v16", key: "8ij5ei" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const C7 = e("Tally5", [
    ["path", { d: "M4 4v16", key: "6qkkli" }],
    ["path", { d: "M9 4v16", key: "81ygyz" }],
    ["path", { d: "M14 4v16", key: "12vmem" }],
    ["path", { d: "M19 4v16", key: "8ij5ei" }],
    ["path", { d: "M22 6 2 18", key: "h9moai" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const b7 = e("Tangent", [
    ["circle", { cx: "17", cy: "4", r: "2", key: "y5j2s2" }],
    ["path", { d: "M15.59 5.41 5.41 15.59", key: "l0vprr" }],
    ["circle", { cx: "4", cy: "17", r: "2", key: "9p4efm" }],
    ["path", { d: "M12 22s-4-9-1.5-11.5S22 12 22 12", key: "1twk4o" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const S7 = e("Target", [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["circle", { cx: "12", cy: "12", r: "6", key: "1vlfrh" }],
    ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const q7 = e("Telescope", [
    [
      "path",
      {
        d: "m10.065 12.493-6.18 1.318a.934.934 0 0 1-1.108-.702l-.537-2.15a1.07 1.07 0 0 1 .691-1.265l13.504-4.44",
        key: "k4qptu",
      },
    ],
    ["path", { d: "m13.56 11.747 4.332-.924", key: "19l80z" }],
    ["path", { d: "m16 21-3.105-6.21", key: "7oh9d" }],
    [
      "path",
      {
        d: "M16.485 5.94a2 2 0 0 1 1.455-2.425l1.09-.272a1 1 0 0 1 1.212.727l1.515 6.06a1 1 0 0 1-.727 1.213l-1.09.272a2 2 0 0 1-2.425-1.455z",
        key: "m7xp4m",
      },
    ],
    ["path", { d: "m6.158 8.633 1.114 4.456", key: "74o979" }],
    ["path", { d: "m8 21 3.105-6.21", key: "1fvxut" }],
    ["circle", { cx: "12", cy: "13", r: "2", key: "1c1ljs" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const H7 = e("TentTree", [
    ["circle", { cx: "4", cy: "4", r: "2", key: "bt5ra8" }],
    ["path", { d: "m14 5 3-3 3 3", key: "1sorif" }],
    ["path", { d: "m14 10 3-3 3 3", key: "1jyi9h" }],
    ["path", { d: "M17 14V2", key: "8ymqnk" }],
    ["path", { d: "M17 14H7l-5 8h20Z", key: "13ar7p" }],
    ["path", { d: "M8 14v8", key: "1ghmqk" }],
    ["path", { d: "m9 14 5 8", key: "13pgi6" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const z7 = e("Tent", [
    ["path", { d: "M3.5 21 14 3", key: "1szst5" }],
    ["path", { d: "M20.5 21 10 3", key: "1310c3" }],
    ["path", { d: "M15.5 21 12 15l-3.5 6", key: "1ddtfw" }],
    ["path", { d: "M2 21h20", key: "1nyx9w" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const A7 = e("TerminalSquare", [
    ["path", { d: "m7 11 2-2-2-2", key: "1lz0vl" }],
    ["path", { d: "M11 13h4", key: "1p7l4v" }],
    [
      "rect",
      {
        width: "18",
        height: "18",
        x: "3",
        y: "3",
        rx: "2",
        ry: "2",
        key: "1m3agn",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const j7 = e("Terminal", [
    ["polyline", { points: "4 17 10 11 4 5", key: "akl6gq" }],
    ["line", { x1: "12", x2: "20", y1: "19", y2: "19", key: "q2wloq" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const V7 = e("TestTube2", [
    [
      "path",
      {
        d: "M21 7 6.82 21.18a2.83 2.83 0 0 1-3.99-.01v0a2.83 2.83 0 0 1 0-4L17 3",
        key: "dg8b2p",
      },
    ],
    ["path", { d: "m16 2 6 6", key: "1gw87d" }],
    ["path", { d: "M12 16H4", key: "1cjfip" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const P7 = e("TestTube", [
    [
      "path",
      {
        d: "M14.5 2v17.5c0 1.4-1.1 2.5-2.5 2.5h0c-1.4 0-2.5-1.1-2.5-2.5V2",
        key: "187lwq",
      },
    ],
    ["path", { d: "M8.5 2h7", key: "csnxdl" }],
    ["path", { d: "M14.5 16h-5", key: "1ox875" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const F7 = e("TestTubes", [
    [
      "path",
      {
        d: "M9 2v17.5A2.5 2.5 0 0 1 6.5 22v0A2.5 2.5 0 0 1 4 19.5V2",
        key: "12z67u",
      },
    ],
    [
      "path",
      {
        d: "M20 2v17.5a2.5 2.5 0 0 1-2.5 2.5v0a2.5 2.5 0 0 1-2.5-2.5V2",
        key: "1q2nfy",
      },
    ],
    ["path", { d: "M3 2h7", key: "7s29d5" }],
    ["path", { d: "M14 2h7", key: "7sicin" }],
    ["path", { d: "M9 16H4", key: "1bfye3" }],
    ["path", { d: "M20 16h-5", key: "ddnjpe" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const B7 = e("TextCursorInput", [
    ["path", { d: "M5 4h1a3 3 0 0 1 3 3 3 3 0 0 1 3-3h1", key: "18xjzo" }],
    ["path", { d: "M13 20h-1a3 3 0 0 1-3-3 3 3 0 0 1-3 3H5", key: "fj48gi" }],
    ["path", { d: "M5 16H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h1", key: "1n9rhb" }],
    ["path", { d: "M13 8h7a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-7", key: "13ksps" }],
    ["path", { d: "M9 7v10", key: "1vc8ob" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const D7 = e("TextCursor", [
    ["path", { d: "M17 22h-1a4 4 0 0 1-4-4V6a4 4 0 0 1 4-4h1", key: "uvaxm9" }],
    ["path", { d: "M7 22h1a4 4 0 0 0 4-4v-1", key: "11xy8d" }],
    ["path", { d: "M7 2h1a4 4 0 0 1 4 4v1", key: "1uw06m" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const R7 = e("TextQuote", [
    ["path", { d: "M17 6H3", key: "16j9eg" }],
    ["path", { d: "M21 12H8", key: "scolzb" }],
    ["path", { d: "M21 18H8", key: "1wfozv" }],
    ["path", { d: "M3 12v6", key: "fv4c87" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const T7 = e("TextSearch", [
    ["path", { d: "M21 6H3", key: "1jwq7v" }],
    ["path", { d: "M10 12H3", key: "1ulcyk" }],
    ["path", { d: "M10 18H3", key: "13769t" }],
    ["circle", { cx: "17", cy: "15", r: "3", key: "1upz2a" }],
    ["path", { d: "m21 19-1.9-1.9", key: "dwi7p8" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const A1 = e("TextSelect", [
    ["path", { d: "M5 3a2 2 0 0 0-2 2", key: "y57alp" }],
    ["path", { d: "M19 3a2 2 0 0 1 2 2", key: "18rm91" }],
    ["path", { d: "M21 19a2 2 0 0 1-2 2", key: "1j7049" }],
    ["path", { d: "M5 21a2 2 0 0 1-2-2", key: "sbafld" }],
    ["path", { d: "M9 3h1", key: "1yesri" }],
    ["path", { d: "M9 21h1", key: "15o7lz" }],
    ["path", { d: "M14 3h1", key: "1ec4yj" }],
    ["path", { d: "M14 21h1", key: "v9vybs" }],
    ["path", { d: "M3 9v1", key: "1r0deq" }],
    ["path", { d: "M21 9v1", key: "mxsmne" }],
    ["path", { d: "M3 14v1", key: "vnatye" }],
    ["path", { d: "M21 14v1", key: "169vum" }],
    ["line", { x1: "7", x2: "15", y1: "8", y2: "8", key: "1758g8" }],
    ["line", { x1: "7", x2: "17", y1: "12", y2: "12", key: "197423" }],
    ["line", { x1: "7", x2: "13", y1: "16", y2: "16", key: "37cgm6" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const U7 = e("Text", [
    ["path", { d: "M17 6.1H3", key: "wptmhv" }],
    ["path", { d: "M21 12.1H3", key: "1j38uz" }],
    ["path", { d: "M15.1 18H3", key: "1nb16a" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Z7 = e("Theater", [
    ["path", { d: "M2 10s3-3 3-8", key: "3xiif0" }],
    ["path", { d: "M22 10s-3-3-3-8", key: "ioaa5q" }],
    ["path", { d: "M10 2c0 4.4-3.6 8-8 8", key: "16fkpi" }],
    ["path", { d: "M14 2c0 4.4 3.6 8 8 8", key: "b9eulq" }],
    ["path", { d: "M2 10s2 2 2 5", key: "1au1lb" }],
    ["path", { d: "M22 10s-2 2-2 5", key: "qi2y5e" }],
    ["path", { d: "M8 15h8", key: "45n4r" }],
    ["path", { d: "M2 22v-1a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v1", key: "1vsc2m" }],
    ["path", { d: "M14 22v-1a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v1", key: "hrha4u" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const O7 = e("ThermometerSnowflake", [
    ["path", { d: "M2 12h10", key: "19562f" }],
    ["path", { d: "M9 4v16", key: "81ygyz" }],
    ["path", { d: "m3 9 3 3-3 3", key: "1sas0l" }],
    ["path", { d: "M12 6 9 9 6 6", key: "pfrgxu" }],
    ["path", { d: "m6 18 3-3 1.5 1.5", key: "1e277p" }],
    [
      "path",
      { d: "M20 4v10.54a4 4 0 1 1-4 0V4a2 2 0 0 1 4 0Z", key: "iof6y5" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const G7 = e("ThermometerSun", [
    ["path", { d: "M12 9a4 4 0 0 0-2 7.5", key: "1jvsq6" }],
    ["path", { d: "M12 3v2", key: "1w22ol" }],
    ["path", { d: "m6.6 18.4-1.4 1.4", key: "w2yidj" }],
    [
      "path",
      { d: "M20 4v10.54a4 4 0 1 1-4 0V4a2 2 0 0 1 4 0Z", key: "iof6y5" },
    ],
    ["path", { d: "M4 13H2", key: "118le4" }],
    ["path", { d: "M6.34 7.34 4.93 5.93", key: "1brd51" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const E7 = e("Thermometer", [
    [
      "path",
      { d: "M14 4v10.54a4 4 0 1 1-4 0V4a2 2 0 0 1 4 0Z", key: "17jzev" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const W7 = e("ThumbsDown", [
    ["path", { d: "M17 14V2", key: "8ymqnk" }],
    [
      "path",
      {
        d: "M9 18.12 10 14H4.17a2 2 0 0 1-1.92-2.56l2.33-8A2 2 0 0 1 6.5 2H20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.76a2 2 0 0 0-1.79 1.11L12 22h0a3.13 3.13 0 0 1-3-3.88Z",
        key: "s6e0r",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const N7 = e("ThumbsUp", [
    ["path", { d: "M7 10v12", key: "1qc93n" }],
    [
      "path",
      {
        d: "M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2h0a3.13 3.13 0 0 1 3 3.88Z",
        key: "y3tblf",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const X7 = e("TicketCheck", [
    [
      "path",
      {
        d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
        key: "qn84l0",
      },
    ],
    ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const K7 = e("TicketMinus", [
    [
      "path",
      {
        d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
        key: "qn84l0",
      },
    ],
    ["path", { d: "M9 12h6", key: "1c52cq" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const _7 = e("TicketPercent", [
    [
      "path",
      {
        d: "M2 9a3 3 0 1 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 1 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
        key: "1l48ns",
      },
    ],
    ["path", { d: "M9 9h.01", key: "1q5me6" }],
    ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
    ["path", { d: "M15 15h.01", key: "lqbp3k" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const J7 = e("TicketPlus", [
    [
      "path",
      {
        d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
        key: "qn84l0",
      },
    ],
    ["path", { d: "M9 12h6", key: "1c52cq" }],
    ["path", { d: "M12 9v6", key: "199k2o" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Q7 = e("TicketSlash", [
    [
      "path",
      {
        d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
        key: "qn84l0",
      },
    ],
    ["path", { d: "m9.5 14.5 5-5", key: "qviqfa" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Y7 = e("TicketX", [
    [
      "path",
      {
        d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
        key: "qn84l0",
      },
    ],
    ["path", { d: "m9.5 14.5 5-5", key: "qviqfa" }],
    ["path", { d: "m9.5 9.5 5 5", key: "18nt4w" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const $7 = e("Ticket", [
    [
      "path",
      {
        d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
        key: "qn84l0",
      },
    ],
    ["path", { d: "M13 5v2", key: "dyzc3o" }],
    ["path", { d: "M13 17v2", key: "1ont0d" }],
    ["path", { d: "M13 11v2", key: "1wjjxi" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const eu = e("TimerOff", [
    ["path", { d: "M10 2h4", key: "n1abiw" }],
    [
      "path",
      { d: "M4.6 11a8 8 0 0 0 1.7 8.7 8 8 0 0 0 8.7 1.7", key: "10he05" },
    ],
    [
      "path",
      { d: "M7.4 7.4a8 8 0 0 1 10.3 1 8 8 0 0 1 .9 10.2", key: "15f7sh" },
    ],
    ["path", { d: "m2 2 20 20", key: "1ooewy" }],
    ["path", { d: "M12 12v-2", key: "fwoke6" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const au = e("TimerReset", [
    ["path", { d: "M10 2h4", key: "n1abiw" }],
    ["path", { d: "M12 14v-4", key: "1evpnu" }],
    [
      "path",
      { d: "M4 13a8 8 0 0 1 8-7 8 8 0 1 1-5.3 14L4 17.6", key: "1ts96g" },
    ],
    ["path", { d: "M9 17H4v5", key: "8t5av" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const tu = e("Timer", [
    ["line", { x1: "10", x2: "14", y1: "2", y2: "2", key: "14vaq8" }],
    ["line", { x1: "12", x2: "15", y1: "14", y2: "11", key: "17fdiu" }],
    ["circle", { cx: "12", cy: "14", r: "8", key: "1e1u0o" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const cu = e("ToggleLeft", [
    [
      "rect",
      {
        width: "20",
        height: "12",
        x: "2",
        y: "6",
        rx: "6",
        ry: "6",
        key: "f2vt7d",
      },
    ],
    ["circle", { cx: "8", cy: "12", r: "2", key: "1nvbw3" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const hu = e("ToggleRight", [
    [
      "rect",
      {
        width: "20",
        height: "12",
        x: "2",
        y: "6",
        rx: "6",
        ry: "6",
        key: "f2vt7d",
      },
    ],
    ["circle", { cx: "16", cy: "12", r: "2", key: "4ma0v8" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const du = e("Tornado", [
    ["path", { d: "M21 4H3", key: "1hwok0" }],
    ["path", { d: "M18 8H6", key: "41n648" }],
    ["path", { d: "M19 12H9", key: "1g4lpz" }],
    ["path", { d: "M16 16h-6", key: "1j5d54" }],
    ["path", { d: "M11 20H9", key: "39obr8" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ou = e("Torus", [
    ["ellipse", { cx: "12", cy: "11", rx: "3", ry: "2", key: "1b2qxu" }],
    ["ellipse", { cx: "12", cy: "12.5", rx: "10", ry: "8.5", key: "h8emeu" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const yu = e("TouchpadOff", [
    ["path", { d: "M4 4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16", key: "lnt0bk" }],
    ["path", { d: "M2 14h12", key: "d8icqz" }],
    ["path", { d: "M22 14h-2", key: "jrx26d" }],
    ["path", { d: "M12 20v-6", key: "1rm09r" }],
    ["path", { d: "m2 2 20 20", key: "1ooewy" }],
    ["path", { d: "M22 16V6a2 2 0 0 0-2-2H10", key: "11y8e4" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const iu = e("Touchpad", [
    [
      "rect",
      { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" },
    ],
    ["path", { d: "M2 14h20", key: "myj16y" }],
    ["path", { d: "M12 20v-6", key: "1rm09r" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const nu = e("TowerControl", [
    [
      "path",
      {
        d: "M18.2 12.27 20 6H4l1.8 6.27a1 1 0 0 0 .95.73h10.5a1 1 0 0 0 .96-.73Z",
        key: "1pledb",
      },
    ],
    ["path", { d: "M8 13v9", key: "hmv0ci" }],
    ["path", { d: "M16 22v-9", key: "ylnf1u" }],
    ["path", { d: "m9 6 1 7", key: "dpdgam" }],
    ["path", { d: "m15 6-1 7", key: "ls7zgu" }],
    ["path", { d: "M12 6V2", key: "1pj48d" }],
    ["path", { d: "M13 2h-2", key: "mj6ths" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ru = e("ToyBrick", [
    [
      "rect",
      { width: "18", height: "12", x: "3", y: "8", rx: "1", key: "158fvp" },
    ],
    ["path", { d: "M10 8V5c0-.6-.4-1-1-1H6a1 1 0 0 0-1 1v3", key: "s0042v" }],
    ["path", { d: "M19 8V5c0-.6-.4-1-1-1h-3a1 1 0 0 0-1 1v3", key: "9wmeh2" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ku = e("Tractor", [
    ["path", { d: "m10 11 11 .9c.6 0 .9.5.8 1.1l-.8 5h-1", key: "2w242w" }],
    ["path", { d: "M16 18h-5", key: "bq60fd" }],
    ["path", { d: "M18 5a1 1 0 0 0-1 1v5.573", key: "1kv8ia" }],
    ["path", { d: "M3 4h9l1 7.246", key: "d639it" }],
    ["path", { d: "M4 11V4", key: "9ft8pt" }],
    ["path", { d: "M7 15h.01", key: "k5ht0j" }],
    ["path", { d: "M8 10.1V4", key: "1jgyzo" }],
    ["circle", { cx: "18", cy: "18", r: "2", key: "1emm8v" }],
    ["circle", { cx: "7", cy: "15", r: "5", key: "ddtuc" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const pu = e("TrafficCone", [
    ["path", { d: "M9.3 6.2a4.55 4.55 0 0 0 5.4 0", key: "flyxqv" }],
    [
      "path",
      { d: "M7.9 10.7c.9.8 2.4 1.3 4.1 1.3s3.2-.5 4.1-1.3", key: "1nlxxg" },
    ],
    [
      "path",
      {
        d: "M13.9 3.5a1.93 1.93 0 0 0-3.8-.1l-3 10c-.1.2-.1.4-.1.6 0 1.7 2.2 3 5 3s5-1.3 5-3c0-.2 0-.4-.1-.5Z",
        key: "vz7x1l",
      },
    ],
    [
      "path",
      {
        d: "m7.5 12.2-4.7 2.7c-.5.3-.8.7-.8 1.1s.3.8.8 1.1l7.6 4.5c.9.5 2.1.5 3 0l7.6-4.5c.7-.3 1-.7 1-1.1s-.3-.8-.8-1.1l-4.7-2.8",
        key: "1xfzlw",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const lu = e("TrainFrontTunnel", [
    ["path", { d: "M2 22V12a10 10 0 1 1 20 0v10", key: "o0fyp0" }],
    ["path", { d: "M15 6.8v1.4a3 2.8 0 1 1-6 0V6.8", key: "m8q3n9" }],
    ["path", { d: "M10 15h.01", key: "44in9x" }],
    ["path", { d: "M14 15h.01", key: "5mohn5" }],
    [
      "path",
      {
        d: "M10 19a4 4 0 0 1-4-4v-3a6 6 0 1 1 12 0v3a4 4 0 0 1-4 4Z",
        key: "hckbmu",
      },
    ],
    ["path", { d: "m9 19-2 3", key: "iij7hm" }],
    ["path", { d: "m15 19 2 3", key: "npx8sa" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const su = e("TrainFront", [
    ["path", { d: "M8 3.1V7a4 4 0 0 0 8 0V3.1", key: "1v71zp" }],
    ["path", { d: "m9 15-1-1", key: "1yrq24" }],
    ["path", { d: "m15 15 1-1", key: "1t0d6s" }],
    [
      "path",
      {
        d: "M9 19c-2.8 0-5-2.2-5-5v-4a8 8 0 0 1 16 0v4c0 2.8-2.2 5-5 5Z",
        key: "1p0hjs",
      },
    ],
    ["path", { d: "m8 19-2 3", key: "13i0xs" }],
    ["path", { d: "m16 19 2 3", key: "xo31yx" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const uu = e("TrainTrack", [
    ["path", { d: "M2 17 17 2", key: "18b09t" }],
    ["path", { d: "m2 14 8 8", key: "1gv9hu" }],
    ["path", { d: "m5 11 8 8", key: "189pqp" }],
    ["path", { d: "m8 8 8 8", key: "1imecy" }],
    ["path", { d: "m11 5 8 8", key: "ummqn6" }],
    ["path", { d: "m14 2 8 8", key: "1vk7dn" }],
    ["path", { d: "M7 22 22 7", key: "15mb1i" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const j1 = e("TramFront", [
    [
      "rect",
      { width: "16", height: "16", x: "4", y: "3", rx: "2", key: "1wxw4b" },
    ],
    ["path", { d: "M4 11h16", key: "mpoxn0" }],
    ["path", { d: "M12 3v8", key: "1h2ygw" }],
    ["path", { d: "m8 19-2 3", key: "13i0xs" }],
    ["path", { d: "m18 22-2-3", key: "1p0ohu" }],
    ["path", { d: "M8 15h0", key: "q9eq1f" }],
    ["path", { d: "M16 15h0", key: "pzrbjg" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Mu = e("Trash2", [
    ["path", { d: "M3 6h18", key: "d0wm0j" }],
    ["path", { d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6", key: "4alrt4" }],
    ["path", { d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2", key: "v07s0e" }],
    ["line", { x1: "10", x2: "10", y1: "11", y2: "17", key: "1uufr5" }],
    ["line", { x1: "14", x2: "14", y1: "11", y2: "17", key: "xtxkd" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const vu = e("Trash", [
    ["path", { d: "M3 6h18", key: "d0wm0j" }],
    ["path", { d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6", key: "4alrt4" }],
    ["path", { d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2", key: "v07s0e" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const mu = e("TreeDeciduous", [
    [
      "path",
      {
        d: "M8 19a4 4 0 0 1-2.24-7.32A3.5 3.5 0 0 1 9 6.03V6a3 3 0 1 1 6 0v.04a3.5 3.5 0 0 1 3.24 5.65A4 4 0 0 1 16 19Z",
        key: "oadzkq",
      },
    ],
    ["path", { d: "M12 19v3", key: "npa21l" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const xu = e("TreePine", [
    [
      "path",
      {
        d: "m17 14 3 3.3a1 1 0 0 1-.7 1.7H4.7a1 1 0 0 1-.7-1.7L7 14h-.3a1 1 0 0 1-.7-1.7L9 9h-.2A1 1 0 0 1 8 7.3L12 3l4 4.3a1 1 0 0 1-.8 1.7H15l3 3.3a1 1 0 0 1-.7 1.7H17Z",
        key: "cpyugq",
      },
    ],
    ["path", { d: "M12 22v-3", key: "kmzjlo" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const gu = e("Trees", [
    [
      "path",
      {
        d: "M10 10v.2A3 3 0 0 1 8.9 16v0H5v0h0a3 3 0 0 1-1-5.8V10a3 3 0 0 1 6 0Z",
        key: "yh07w9",
      },
    ],
    ["path", { d: "M7 16v6", key: "1a82de" }],
    ["path", { d: "M13 19v3", key: "13sx9i" }],
    [
      "path",
      {
        d: "M12 19h8.3a1 1 0 0 0 .7-1.7L18 14h.3a1 1 0 0 0 .7-1.7L16 9h.2a1 1 0 0 0 .8-1.7L13 3l-1.4 1.5",
        key: "1sj9kv",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Lu = e("Trello", [
    [
      "rect",
      {
        width: "18",
        height: "18",
        x: "3",
        y: "3",
        rx: "2",
        ry: "2",
        key: "1m3agn",
      },
    ],
    ["rect", { width: "3", height: "9", x: "7", y: "7", key: "14n3xi" }],
    ["rect", { width: "3", height: "5", x: "14", y: "7", key: "s4azjd" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const fu = e("TrendingDown", [
    ["polyline", { points: "22 17 13.5 8.5 8.5 13.5 2 7", key: "1r2t7k" }],
    ["polyline", { points: "16 17 22 17 22 11", key: "11uiuu" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const wu = e("TrendingUp", [
    ["polyline", { points: "22 7 13.5 15.5 8.5 10.5 2 17", key: "126l90" }],
    ["polyline", { points: "16 7 22 7 22 13", key: "kwv8wd" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Iu = e("TriangleRight", [
    [
      "path",
      {
        d: "M22 18a2 2 0 0 1-2 2H3c-1.1 0-1.3-.6-.4-1.3L20.4 4.3c.9-.7 1.6-.4 1.6.7Z",
        key: "183wce",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Cu = e("Triangle", [
    [
      "path",
      {
        d: "M13.73 4a2 2 0 0 0-3.46 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z",
        key: "14u9p9",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const bu = e("Trophy", [
    ["path", { d: "M6 9H4.5a2.5 2.5 0 0 1 0-5H6", key: "17hqa7" }],
    ["path", { d: "M18 9h1.5a2.5 2.5 0 0 0 0-5H18", key: "lmptdp" }],
    ["path", { d: "M4 22h16", key: "57wxv0" }],
    [
      "path",
      {
        d: "M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22",
        key: "1nw9bq",
      },
    ],
    [
      "path",
      {
        d: "M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22",
        key: "1np0yb",
      },
    ],
    ["path", { d: "M18 2H6v7a6 6 0 0 0 12 0V2Z", key: "u46fv3" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Su = e("Truck", [
    [
      "path",
      {
        d: "M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2",
        key: "wrbu53",
      },
    ],
    ["path", { d: "M15 18H9", key: "1lyqi6" }],
    [
      "path",
      {
        d: "M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14",
        key: "lysw3i",
      },
    ],
    ["circle", { cx: "17", cy: "18", r: "2", key: "332jqn" }],
    ["circle", { cx: "7", cy: "18", r: "2", key: "19iecd" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const qu = e("Turtle", [
    [
      "path",
      {
        d: "m12 10 2 4v3a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-3a8 8 0 1 0-16 0v3a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-3l2-4h4Z",
        key: "1lbbv7",
      },
    ],
    ["path", { d: "M4.82 7.9 8 10", key: "m9wose" }],
    ["path", { d: "M15.18 7.9 12 10", key: "p8dp2u" }],
    ["path", { d: "M16.93 10H20a2 2 0 0 1 0 4H2", key: "12nsm7" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Hu = e("Tv2", [
    ["path", { d: "M7 21h10", key: "1b0cd5" }],
    [
      "rect",
      { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const zu = e("Tv", [
    [
      "rect",
      {
        width: "20",
        height: "15",
        x: "2",
        y: "7",
        rx: "2",
        ry: "2",
        key: "10ag99",
      },
    ],
    ["polyline", { points: "17 2 12 7 7 2", key: "11pgbg" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Au = e("Twitch", [
    ["path", { d: "M21 2H3v16h5v4l4-4h5l4-4V2zm-10 9V7m5 4V7", key: "c0yzno" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const ju = e("Twitter", [
    [
      "path",
      {
        d: "M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z",
        key: "pff0z6",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Vu = e("Type", [
    ["polyline", { points: "4 7 4 4 20 4 20 7", key: "1nosan" }],
    ["line", { x1: "9", x2: "15", y1: "20", y2: "20", key: "swin9y" }],
    ["line", { x1: "12", x2: "12", y1: "4", y2: "20", key: "1tx1rr" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Pu = e("UmbrellaOff", [
    ["path", { d: "M12 2v1", key: "11qlp1" }],
    [
      "path",
      {
        d: "M15.5 21a1.85 1.85 0 0 1-3.5-1v-8H2a10 10 0 0 1 3.428-6.575",
        key: "eki10q",
      },
    ],
    ["path", { d: "M17.5 12H22A10 10 0 0 0 9.004 3.455", key: "n2ayka" }],
    ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Fu = e("Umbrella", [
    ["path", { d: "M22 12a10.06 10.06 1 0 0-20 0Z", key: "1teyop" }],
    ["path", { d: "M12 12v8a2 2 0 0 0 4 0", key: "ulpmoc" }],
    ["path", { d: "M12 2v1", key: "11qlp1" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Bu = e("Underline", [
    ["path", { d: "M6 4v6a6 6 0 0 0 12 0V4", key: "9kb039" }],
    ["line", { x1: "4", x2: "20", y1: "20", y2: "20", key: "nun2al" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Du = e("Undo2", [
    ["path", { d: "M9 14 4 9l5-5", key: "102s5s" }],
    [
      "path",
      {
        d: "M4 9h10.5a5.5 5.5 0 0 1 5.5 5.5v0a5.5 5.5 0 0 1-5.5 5.5H11",
        key: "llx8ln",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ru = e("UndoDot", [
    ["circle", { cx: "12", cy: "17", r: "1", key: "1ixnty" }],
    ["path", { d: "M3 7v6h6", key: "1v2h90" }],
    ["path", { d: "M21 17a9 9 0 0 0-9-9 9 9 0 0 0-6 2.3L3 13", key: "1r6uu6" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Tu = e("Undo", [
    ["path", { d: "M3 7v6h6", key: "1v2h90" }],
    ["path", { d: "M21 17a9 9 0 0 0-9-9 9 9 0 0 0-6 2.3L3 13", key: "1r6uu6" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Uu = e("UnfoldHorizontal", [
    ["path", { d: "M16 12h6", key: "15xry1" }],
    ["path", { d: "M8 12H2", key: "1jqql6" }],
    ["path", { d: "M12 2v2", key: "tus03m" }],
    ["path", { d: "M12 8v2", key: "1woqiv" }],
    ["path", { d: "M12 14v2", key: "8jcxud" }],
    ["path", { d: "M12 20v2", key: "1lh1kg" }],
    ["path", { d: "m19 15 3-3-3-3", key: "wjy7rq" }],
    ["path", { d: "m5 9-3 3 3 3", key: "j64kie" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Zu = e("UnfoldVertical", [
    ["path", { d: "M12 22v-6", key: "6o8u61" }],
    ["path", { d: "M12 8V2", key: "1wkif3" }],
    ["path", { d: "M4 12H2", key: "rhcxmi" }],
    ["path", { d: "M10 12H8", key: "s88cx1" }],
    ["path", { d: "M16 12h-2", key: "10asgb" }],
    ["path", { d: "M22 12h-2", key: "14jgyd" }],
    ["path", { d: "m15 19-3 3-3-3", key: "11eu04" }],
    ["path", { d: "m15 5-3-3-3 3", key: "itvq4r" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ou = e("Ungroup", [
    [
      "rect",
      { width: "8", height: "6", x: "5", y: "4", rx: "1", key: "nzclkv" },
    ],
    [
      "rect",
      { width: "8", height: "6", x: "11", y: "14", rx: "1", key: "4tytwb" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Gu = e("Unlink2", [
    [
      "path",
      { d: "M15 7h2a5 5 0 0 1 0 10h-2m-6 0H7A5 5 0 0 1 7 7h2", key: "1re2ne" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Eu = e("Unlink", [
    [
      "path",
      {
        d: "m18.84 12.25 1.72-1.71h-.02a5.004 5.004 0 0 0-.12-7.07 5.006 5.006 0 0 0-6.95 0l-1.72 1.71",
        key: "yqzxt4",
      },
    ],
    [
      "path",
      {
        d: "m5.17 11.75-1.71 1.71a5.004 5.004 0 0 0 .12 7.07 5.006 5.006 0 0 0 6.95 0l1.71-1.71",
        key: "4qinb0",
      },
    ],
    ["line", { x1: "8", x2: "8", y1: "2", y2: "5", key: "1041cp" }],
    ["line", { x1: "2", x2: "5", y1: "8", y2: "8", key: "14m1p5" }],
    ["line", { x1: "16", x2: "16", y1: "19", y2: "22", key: "rzdirn" }],
    ["line", { x1: "19", x2: "22", y1: "16", y2: "16", key: "ox905f" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Wu = e("UnlockKeyhole", [
    ["circle", { cx: "12", cy: "16", r: "1", key: "1au0dj" }],
    [
      "rect",
      { x: "3", y: "10", width: "18", height: "12", rx: "2", key: "6s8ecr" },
    ],
    ["path", { d: "M7 10V7a5 5 0 0 1 9.33-2.5", key: "car5b7" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Nu = e("Unlock", [
    [
      "rect",
      {
        width: "18",
        height: "11",
        x: "3",
        y: "11",
        rx: "2",
        ry: "2",
        key: "1w4ew1",
      },
    ],
    ["path", { d: "M7 11V7a5 5 0 0 1 9.9-1", key: "1mm8w8" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Xu = e("Unplug", [
    ["path", { d: "m19 5 3-3", key: "yk6iyv" }],
    ["path", { d: "m2 22 3-3", key: "19mgm9" }],
    [
      "path",
      {
        d: "M6.3 20.3a2.4 2.4 0 0 0 3.4 0L12 18l-6-6-2.3 2.3a2.4 2.4 0 0 0 0 3.4Z",
        key: "goz73y",
      },
    ],
    ["path", { d: "M7.5 13.5 10 11", key: "7xgeeb" }],
    ["path", { d: "M10.5 16.5 13 14", key: "10btkg" }],
    [
      "path",
      {
        d: "m12 6 6 6 2.3-2.3a2.4 2.4 0 0 0 0-3.4l-2.6-2.6a2.4 2.4 0 0 0-3.4 0Z",
        key: "1snsnr",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ku = e("UploadCloud", [
    [
      "path",
      {
        d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242",
        key: "1pljnt",
      },
    ],
    ["path", { d: "M12 12v9", key: "192myk" }],
    ["path", { d: "m16 16-4-4-4 4", key: "119tzi" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const _u = e("Upload", [
    ["path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4", key: "ih7n3h" }],
    ["polyline", { points: "17 8 12 3 7 8", key: "t8dd8p" }],
    ["line", { x1: "12", x2: "12", y1: "3", y2: "15", key: "widbto" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Ju = e("Usb", [
    ["circle", { cx: "10", cy: "7", r: "1", key: "dypaad" }],
    ["circle", { cx: "4", cy: "20", r: "1", key: "22iqad" }],
    ["path", { d: "M4.7 19.3 19 5", key: "1enqfc" }],
    ["path", { d: "m21 3-3 1 2 2Z", key: "d3ov82" }],
    ["path", { d: "M9.26 7.68 5 12l2 5", key: "1esawj" }],
    ["path", { d: "m10 14 5 2 3.5-3.5", key: "v8oal5" }],
    ["path", { d: "m18 12 1-1 1 1-1 1Z", key: "1bh22v" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Qu = e("UserCheck", [
    ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }],
    ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }],
    ["polyline", { points: "16 11 18 13 22 9", key: "1pwet4" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Yu = e("UserCog", [
    ["circle", { cx: "18", cy: "15", r: "3", key: "gjjjvw" }],
    ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }],
    ["path", { d: "M10 15H6a4 4 0 0 0-4 4v2", key: "1nfge6" }],
    ["path", { d: "m21.7 16.4-.9-.3", key: "12j9ji" }],
    ["path", { d: "m15.2 13.9-.9-.3", key: "1fdjdi" }],
    ["path", { d: "m16.6 18.7.3-.9", key: "heedtr" }],
    ["path", { d: "m19.1 12.2.3-.9", key: "1af3ki" }],
    ["path", { d: "m19.6 18.7-.4-1", key: "1x9vze" }],
    ["path", { d: "m16.8 12.3-.4-1", key: "vqeiwj" }],
    ["path", { d: "m14.3 16.6 1-.4", key: "1qlj63" }],
    ["path", { d: "m20.7 13.8 1-.4", key: "1v5t8k" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const $u = e("UserMinus", [
    ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }],
    ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }],
    ["line", { x1: "22", x2: "16", y1: "11", y2: "11", key: "1shjgl" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const e9 = e("UserPlus", [
    ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }],
    ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }],
    ["line", { x1: "19", x2: "19", y1: "8", y2: "14", key: "1bvyxn" }],
    ["line", { x1: "22", x2: "16", y1: "11", y2: "11", key: "1shjgl" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const V1 = e("UserRoundCheck", [
    ["path", { d: "M2 21a8 8 0 0 1 13.292-6", key: "bjp14o" }],
    ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }],
    ["path", { d: "m16 19 2 2 4-4", key: "1b14m6" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const P1 = e("UserRoundCog", [
    ["path", { d: "M2 21a8 8 0 0 1 10.434-7.62", key: "1yezr2" }],
    ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }],
    ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
    ["path", { d: "m19.5 14.3-.4.9", key: "1eb35c" }],
    ["path", { d: "m16.9 20.8-.4.9", key: "dfjc4z" }],
    ["path", { d: "m21.7 19.5-.9-.4", key: "q4dx6b" }],
    ["path", { d: "m15.2 16.9-.9-.4", key: "1r0w5f" }],
    ["path", { d: "m21.7 16.5-.9.4", key: "1knoei" }],
    ["path", { d: "m15.2 19.1-.9.4", key: "j188fs" }],
    ["path", { d: "m19.5 21.7-.4-.9", key: "1tonu5" }],
    ["path", { d: "m16.9 15.2-.4-.9", key: "699xu" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const F1 = e("UserRoundMinus", [
    ["path", { d: "M2 21a8 8 0 0 1 13.292-6", key: "bjp14o" }],
    ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }],
    ["path", { d: "M22 19h-6", key: "vcuq98" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const B1 = e("UserRoundPlus", [
    ["path", { d: "M2 21a8 8 0 0 1 13.292-6", key: "bjp14o" }],
    ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }],
    ["path", { d: "M19 16v6", key: "tddt3s" }],
    ["path", { d: "M22 19h-6", key: "vcuq98" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const a9 = e("UserRoundSearch", [
    ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }],
    ["path", { d: "M2 21a8 8 0 0 1 10.434-7.62", key: "1yezr2" }],
    ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
    ["path", { d: "m22 22-1.9-1.9", key: "1e5ubv" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const D1 = e("UserRoundX", [
    ["path", { d: "M2 21a8 8 0 0 1 11.873-7", key: "74fkxq" }],
    ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }],
    ["path", { d: "m17 17 5 5", key: "p7ous7" }],
    ["path", { d: "m22 17-5 5", key: "gqnmv0" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const R1 = e("UserRound", [
    ["circle", { cx: "12", cy: "8", r: "5", key: "1hypcn" }],
    ["path", { d: "M20 21a8 8 0 0 0-16 0", key: "rfgkzh" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const t9 = e("UserSearch", [
    ["circle", { cx: "10", cy: "7", r: "4", key: "e45bow" }],
    ["path", { d: "M10.3 15H7a4 4 0 0 0-4 4v2", key: "3bnktk" }],
    ["circle", { cx: "17", cy: "17", r: "3", key: "18b49y" }],
    ["path", { d: "m21 21-1.9-1.9", key: "1g2n9r" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const c9 = e("UserX", [
    ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }],
    ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }],
    ["line", { x1: "17", x2: "22", y1: "8", y2: "13", key: "3nzzx3" }],
    ["line", { x1: "22", x2: "17", y1: "8", y2: "13", key: "1swrse" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const h9 = e("User", [
    ["path", { d: "M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2", key: "975kel" }],
    ["circle", { cx: "12", cy: "7", r: "4", key: "17ys0d" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const T1 = e("UsersRound", [
    ["path", { d: "M18 21a8 8 0 0 0-16 0", key: "3ypg7q" }],
    ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }],
    ["path", { d: "M22 20c0-3.37-2-6.5-4-8a5 5 0 0 0-.45-8.3", key: "10s06x" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const d9 = e("Users", [
    ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }],
    ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }],
    ["path", { d: "M22 21v-2a4 4 0 0 0-3-3.87", key: "kshegd" }],
    ["path", { d: "M16 3.13a4 4 0 0 1 0 7.75", key: "1da9ce" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const o9 = e("UtensilsCrossed", [
    [
      "path",
      {
        d: "m16 2-2.3 2.3a3 3 0 0 0 0 4.2l1.8 1.8a3 3 0 0 0 4.2 0L22 8",
        key: "n7qcjb",
      },
    ],
    [
      "path",
      {
        d: "M15 15 3.3 3.3a4.2 4.2 0 0 0 0 6l7.3 7.3c.7.7 2 .7 2.8 0L15 15Zm0 0 7 7",
        key: "d0u48b",
      },
    ],
    ["path", { d: "m2.1 21.8 6.4-6.3", key: "yn04lh" }],
    ["path", { d: "m19 5-7 7", key: "194lzd" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const y9 = e("Utensils", [
    ["path", { d: "M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2", key: "cjf0a3" }],
    ["path", { d: "M7 2v20", key: "1473qp" }],
    [
      "path",
      { d: "M21 15V2v0a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7", key: "1ogz0v" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const i9 = e("UtilityPole", [
    ["path", { d: "M12 2v20", key: "t6zp3m" }],
    ["path", { d: "M2 5h20", key: "1fs1ex" }],
    ["path", { d: "M3 3v2", key: "9imdir" }],
    ["path", { d: "M7 3v2", key: "n0os7" }],
    ["path", { d: "M17 3v2", key: "1l2re6" }],
    ["path", { d: "M21 3v2", key: "1duuac" }],
    ["path", { d: "m19 5-7 7-7-7", key: "133zxf" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const n9 = e("Variable", [
    ["path", { d: "M8 21s-4-3-4-9 4-9 4-9", key: "uto9ud" }],
    ["path", { d: "M16 3s4 3 4 9-4 9-4 9", key: "4w2vsq" }],
    ["line", { x1: "15", x2: "9", y1: "9", y2: "15", key: "f7djnv" }],
    ["line", { x1: "9", x2: "15", y1: "9", y2: "15", key: "1shsy8" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const r9 = e("Vault", [
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" },
    ],
    [
      "circle",
      { cx: "7.5", cy: "7.5", r: ".5", fill: "currentColor", key: "kqv944" },
    ],
    ["path", { d: "m7.9 7.9 2.7 2.7", key: "hpeyl3" }],
    [
      "circle",
      { cx: "16.5", cy: "7.5", r: ".5", fill: "currentColor", key: "w0ekpg" },
    ],
    ["path", { d: "m13.4 10.6 2.7-2.7", key: "264c1n" }],
    [
      "circle",
      { cx: "7.5", cy: "16.5", r: ".5", fill: "currentColor", key: "nkw3mc" },
    ],
    ["path", { d: "m7.9 16.1 2.7-2.7", key: "p81g5e" }],
    [
      "circle",
      { cx: "16.5", cy: "16.5", r: ".5", fill: "currentColor", key: "fubopw" },
    ],
    ["path", { d: "m13.4 13.4 2.7 2.7", key: "abhel3" }],
    ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const k9 = e("Vegan", [
    [
      "path",
      { d: "M2 2a26.6 26.6 0 0 1 10 20c.9-6.82 1.5-9.5 4-14", key: "qiv7li" },
    ],
    ["path", { d: "M16 8c4 0 6-2 6-6-4 0-6 2-6 6", key: "n7eohy" }],
    ["path", { d: "M17.41 3.6a10 10 0 1 0 3 3", key: "1dion0" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const p9 = e("VenetianMask", [
    [
      "path",
      {
        d: "M2 12a5 5 0 0 0 5 5 8 8 0 0 1 5 2 8 8 0 0 1 5-2 5 5 0 0 0 5-5V7h-5a8 8 0 0 0-5 2 8 8 0 0 0-5-2H2Z",
        key: "1g6z3j",
      },
    ],
    ["path", { d: "M6 11c1.5 0 3 .5 3 2-2 0-3 0-3-2Z", key: "c2lwnf" }],
    ["path", { d: "M18 11c-1.5 0-3 .5-3 2 2 0 3 0 3-2Z", key: "njd9zo" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const l9 = e("VibrateOff", [
    ["path", { d: "m2 8 2 2-2 2 2 2-2 2", key: "sv1b1" }],
    ["path", { d: "m22 8-2 2 2 2-2 2 2 2", key: "101i4y" }],
    [
      "path",
      { d: "M8 8v10c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2", key: "1hbad5" },
    ],
    ["path", { d: "M16 10.34V6c0-.55-.45-1-1-1h-4.34", key: "1x5tf0" }],
    ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const s9 = e("Vibrate", [
    ["path", { d: "m2 8 2 2-2 2 2 2-2 2", key: "sv1b1" }],
    ["path", { d: "m22 8-2 2 2 2-2 2 2 2", key: "101i4y" }],
    [
      "rect",
      { width: "8", height: "14", x: "8", y: "5", rx: "1", key: "1oyrl4" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const u9 = e("VideoOff", [
    ["path", { d: "M10.66 6H14a2 2 0 0 1 2 2v2.34l1 1L22 8v8", key: "ubwiq0" }],
    [
      "path",
      {
        d: "M16 16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h2l10 10Z",
        key: "1l10zd",
      },
    ],
    ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const M9 = e("Video", [
    ["path", { d: "m22 8-6 4 6 4V8Z", key: "50v9me" }],
    [
      "rect",
      {
        width: "14",
        height: "12",
        x: "2",
        y: "6",
        rx: "2",
        ry: "2",
        key: "1rqjg6",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const v9 = e("Videotape", [
    [
      "rect",
      { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" },
    ],
    ["path", { d: "M2 8h20", key: "d11cs7" }],
    ["circle", { cx: "8", cy: "14", r: "2", key: "1k2qr5" }],
    ["path", { d: "M8 12h8", key: "1wcyev" }],
    ["circle", { cx: "16", cy: "14", r: "2", key: "14k7lr" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const m9 = e("View", [
    [
      "path",
      {
        d: "M5 12s2.545-5 7-5c4.454 0 7 5 7 5s-2.546 5-7 5c-4.455 0-7-5-7-5z",
        key: "vptub8",
      },
    ],
    ["path", { d: "M12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2z", key: "10lhjs" }],
    ["path", { d: "M21 17v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-2", key: "mrq65r" }],
    ["path", { d: "M21 7V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2", key: "be3xqs" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const x9 = e("Voicemail", [
    ["circle", { cx: "6", cy: "12", r: "4", key: "1ehtga" }],
    ["circle", { cx: "18", cy: "12", r: "4", key: "4vafl8" }],
    ["line", { x1: "6", x2: "18", y1: "16", y2: "16", key: "pmt8us" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const g9 = e("Volume1", [
    ["polygon", { points: "11 5 6 9 2 9 2 15 6 15 11 19 11 5", key: "16drj5" }],
    ["path", { d: "M15.54 8.46a5 5 0 0 1 0 7.07", key: "ltjumu" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const L9 = e("Volume2", [
    ["polygon", { points: "11 5 6 9 2 9 2 15 6 15 11 19 11 5", key: "16drj5" }],
    ["path", { d: "M15.54 8.46a5 5 0 0 1 0 7.07", key: "ltjumu" }],
    ["path", { d: "M19.07 4.93a10 10 0 0 1 0 14.14", key: "1kegas" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const f9 = e("VolumeX", [
    ["polygon", { points: "11 5 6 9 2 9 2 15 6 15 11 19 11 5", key: "16drj5" }],
    ["line", { x1: "22", x2: "16", y1: "9", y2: "15", key: "1ewh16" }],
    ["line", { x1: "16", x2: "22", y1: "9", y2: "15", key: "5ykzw1" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const w9 = e("Volume", [
    ["polygon", { points: "11 5 6 9 2 9 2 15 6 15 11 19 11 5", key: "16drj5" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const I9 = e("Vote", [
    ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }],
    [
      "path",
      { d: "M5 7c0-1.1.9-2 2-2h10a2 2 0 0 1 2 2v12H5V7Z", key: "1ezoue" },
    ],
    ["path", { d: "M22 19H2", key: "nuriw5" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const C9 = e("Wallet2", [
    ["path", { d: "M17 14h.01", key: "7oqj8z" }],
    [
      "path",
      {
        d: "M7 7h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14",
        key: "u1rqew",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const b9 = e("WalletCards", [
    [
      "rect",
      { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" },
    ],
    ["path", { d: "M3 9a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2", key: "4125el" }],
    [
      "path",
      {
        d: "M3 11h3c.8 0 1.6.3 2.1.9l1.1.9c1.6 1.6 4.1 1.6 5.7 0l1.1-.9c.5-.5 1.3-.9 2.1-.9H21",
        key: "1dpki6",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const S9 = e("Wallet", [
    ["path", { d: "M21 12V7H5a2 2 0 0 1 0-4h14v4", key: "195gfw" }],
    ["path", { d: "M3 5v14a2 2 0 0 0 2 2h16v-5", key: "195n9w" }],
    ["path", { d: "M18 12a2 2 0 0 0 0 4h4v-4Z", key: "vllfpd" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const q9 = e("Wallpaper", [
    ["circle", { cx: "8", cy: "9", r: "2", key: "gjzl9d" }],
    [
      "path",
      {
        d: "m9 17 6.1-6.1a2 2 0 0 1 2.81.01L22 15V5a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2",
        key: "69xh40",
      },
    ],
    ["path", { d: "M8 21h8", key: "1ev6f3" }],
    ["path", { d: "M12 17v4", key: "1riwvh" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const H9 = e("Wand2", [
    [
      "path",
      {
        d: "m21.64 3.64-1.28-1.28a1.21 1.21 0 0 0-1.72 0L2.36 18.64a1.21 1.21 0 0 0 0 1.72l1.28 1.28a1.2 1.2 0 0 0 1.72 0L21.64 5.36a1.2 1.2 0 0 0 0-1.72Z",
        key: "1bcowg",
      },
    ],
    ["path", { d: "m14 7 3 3", key: "1r5n42" }],
    ["path", { d: "M5 6v4", key: "ilb8ba" }],
    ["path", { d: "M19 14v4", key: "blhpug" }],
    ["path", { d: "M10 2v2", key: "7u0qdc" }],
    ["path", { d: "M7 8H3", key: "zfb6yr" }],
    ["path", { d: "M21 16h-4", key: "1cnmox" }],
    ["path", { d: "M11 3H9", key: "1obp7u" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const z9 = e("Wand", [
    ["path", { d: "M15 4V2", key: "z1p9b7" }],
    ["path", { d: "M15 16v-2", key: "px0unx" }],
    ["path", { d: "M8 9h2", key: "1g203m" }],
    ["path", { d: "M20 9h2", key: "19tzq7" }],
    ["path", { d: "M17.8 11.8 19 13", key: "yihg8r" }],
    ["path", { d: "M15 9h0", key: "kg5t1u" }],
    ["path", { d: "M17.8 6.2 19 5", key: "fd4us0" }],
    ["path", { d: "m3 21 9-9", key: "1jfql5" }],
    ["path", { d: "M12.2 6.2 11 5", key: "i3da3b" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const A9 = e("Warehouse", [
    [
      "path",
      {
        d: "M22 8.35V20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8.35A2 2 0 0 1 3.26 6.5l8-3.2a2 2 0 0 1 1.48 0l8 3.2A2 2 0 0 1 22 8.35Z",
        key: "gksnxg",
      },
    ],
    ["path", { d: "M6 18h12", key: "9pbo8z" }],
    ["path", { d: "M6 14h12", key: "4cwo0f" }],
    ["rect", { width: "12", height: "12", x: "6", y: "10", key: "apd30q" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const j9 = e("WashingMachine", [
    ["path", { d: "M3 6h3", key: "155dbl" }],
    ["path", { d: "M17 6h.01", key: "e2y6kg" }],
    [
      "rect",
      { width: "18", height: "20", x: "3", y: "2", rx: "2", key: "od3kk9" },
    ],
    ["circle", { cx: "12", cy: "13", r: "5", key: "nlbqau" }],
    [
      "path",
      { d: "M12 18a2.5 2.5 0 0 0 0-5 2.5 2.5 0 0 1 0-5", key: "17lach" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const V9 = e("Watch", [
    ["circle", { cx: "12", cy: "12", r: "6", key: "1vlfrh" }],
    ["polyline", { points: "12 10 12 12 13 13", key: "19dquz" }],
    [
      "path",
      {
        d: "m16.13 7.66-.81-4.05a2 2 0 0 0-2-1.61h-2.68a2 2 0 0 0-2 1.61l-.78 4.05",
        key: "18k57s",
      },
    ],
    [
      "path",
      {
        d: "m7.88 16.36.8 4a2 2 0 0 0 2 1.61h2.72a2 2 0 0 0 2-1.61l.81-4.05",
        key: "16ny36",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const P9 = e("Waves", [
    [
      "path",
      {
        d: "M2 6c.6.5 1.2 1 2.5 1C7 7 7 5 9.5 5c2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1",
        key: "knzxuh",
      },
    ],
    [
      "path",
      {
        d: "M2 12c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1",
        key: "2jd2cc",
      },
    ],
    [
      "path",
      {
        d: "M2 18c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1",
        key: "rd2r6e",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const F9 = e("Waypoints", [
    ["circle", { cx: "12", cy: "4.5", r: "2.5", key: "r5ysbb" }],
    ["path", { d: "m10.2 6.3-3.9 3.9", key: "1nzqf6" }],
    ["circle", { cx: "4.5", cy: "12", r: "2.5", key: "jydg6v" }],
    ["path", { d: "M7 12h10", key: "b7w52i" }],
    ["circle", { cx: "19.5", cy: "12", r: "2.5", key: "1piiel" }],
    ["path", { d: "m13.8 17.7 3.9-3.9", key: "1wyg1y" }],
    ["circle", { cx: "12", cy: "19.5", r: "2.5", key: "13o1pw" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const B9 = e("Webcam", [
    ["circle", { cx: "12", cy: "10", r: "8", key: "1gshiw" }],
    ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }],
    ["path", { d: "M7 22h10", key: "10w4w3" }],
    ["path", { d: "M12 22v-4", key: "1utk9m" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const D9 = e("WebhookOff", [
    [
      "path",
      {
        d: "M17 17h-5c-1.09-.02-1.94.92-2.5 1.9A3 3 0 1 1 2.57 15",
        key: "1tvl6x",
      },
    ],
    ["path", { d: "M9 3.4a4 4 0 0 1 6.52.66", key: "q04jfq" }],
    ["path", { d: "m6 17 3.1-5.8a2.5 2.5 0 0 0 .057-2.05", key: "azowf0" }],
    ["path", { d: "M20.3 20.3a4 4 0 0 1-2.3.7", key: "5joiws" }],
    ["path", { d: "M18.6 13a4 4 0 0 1 3.357 3.414", key: "cangb8" }],
    ["path", { d: "m12 6 .6 1", key: "tpjl1n" }],
    ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const R9 = e("Webhook", [
    [
      "path",
      {
        d: "M18 16.98h-5.99c-1.1 0-1.95.94-2.48 1.9A4 4 0 0 1 2 17c.01-.7.2-1.4.57-2",
        key: "q3hayz",
      },
    ],
    [
      "path",
      {
        d: "m6 17 3.13-5.78c.53-.97.1-2.18-.5-3.1a4 4 0 1 1 6.89-4.06",
        key: "1go1hn",
      },
    ],
    [
      "path",
      {
        d: "m12 6 3.13 5.73C15.66 12.7 16.9 13 18 13a4 4 0 0 1 0 8",
        key: "qlwsc0",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const T9 = e("Weight", [
    ["circle", { cx: "12", cy: "5", r: "3", key: "rqqgnr" }],
    [
      "path",
      {
        d: "M6.5 8a2 2 0 0 0-1.905 1.46L2.1 18.5A2 2 0 0 0 4 21h16a2 2 0 0 0 1.925-2.54L19.4 9.5A2 2 0 0 0 17.48 8Z",
        key: "56o5sh",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const U9 = e("WheatOff", [
    ["path", { d: "m2 22 10-10", key: "28ilpk" }],
    ["path", { d: "m16 8-1.17 1.17", key: "1qqm82" }],
    [
      "path",
      {
        d: "M3.47 12.53 5 11l1.53 1.53a3.5 3.5 0 0 1 0 4.94L5 19l-1.53-1.53a3.5 3.5 0 0 1 0-4.94Z",
        key: "1rdhi6",
      },
    ],
    [
      "path",
      {
        d: "m8 8-.53.53a3.5 3.5 0 0 0 0 4.94L9 15l1.53-1.53c.55-.55.88-1.25.98-1.97",
        key: "4wz8re",
      },
    ],
    [
      "path",
      {
        d: "M10.91 5.26c.15-.26.34-.51.56-.73L13 3l1.53 1.53a3.5 3.5 0 0 1 .28 4.62",
        key: "rves66",
      },
    ],
    [
      "path",
      { d: "M20 2h2v2a4 4 0 0 1-4 4h-2V6a4 4 0 0 1 4-4Z", key: "19rau1" },
    ],
    [
      "path",
      {
        d: "M11.47 17.47 13 19l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L5 19l1.53-1.53a3.5 3.5 0 0 1 4.94 0Z",
        key: "tc8ph9",
      },
    ],
    [
      "path",
      {
        d: "m16 16-.53.53a3.5 3.5 0 0 1-4.94 0L9 15l1.53-1.53a3.49 3.49 0 0 1 1.97-.98",
        key: "ak46r",
      },
    ],
    [
      "path",
      {
        d: "M18.74 13.09c.26-.15.51-.34.73-.56L21 11l-1.53-1.53a3.5 3.5 0 0 0-4.62-.28",
        key: "1tw520",
      },
    ],
    ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Z9 = e("Wheat", [
    ["path", { d: "M2 22 16 8", key: "60hf96" }],
    [
      "path",
      {
        d: "M3.47 12.53 5 11l1.53 1.53a3.5 3.5 0 0 1 0 4.94L5 19l-1.53-1.53a3.5 3.5 0 0 1 0-4.94Z",
        key: "1rdhi6",
      },
    ],
    [
      "path",
      {
        d: "M7.47 8.53 9 7l1.53 1.53a3.5 3.5 0 0 1 0 4.94L9 15l-1.53-1.53a3.5 3.5 0 0 1 0-4.94Z",
        key: "1sdzmb",
      },
    ],
    [
      "path",
      {
        d: "M11.47 4.53 13 3l1.53 1.53a3.5 3.5 0 0 1 0 4.94L13 11l-1.53-1.53a3.5 3.5 0 0 1 0-4.94Z",
        key: "eoatbi",
      },
    ],
    [
      "path",
      { d: "M20 2h2v2a4 4 0 0 1-4 4h-2V6a4 4 0 0 1 4-4Z", key: "19rau1" },
    ],
    [
      "path",
      {
        d: "M11.47 17.47 13 19l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L5 19l1.53-1.53a3.5 3.5 0 0 1 4.94 0Z",
        key: "tc8ph9",
      },
    ],
    [
      "path",
      {
        d: "M15.47 13.47 17 15l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L9 15l1.53-1.53a3.5 3.5 0 0 1 4.94 0Z",
        key: "2m8kc5",
      },
    ],
    [
      "path",
      {
        d: "M19.47 9.47 21 11l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L13 11l1.53-1.53a3.5 3.5 0 0 1 4.94 0Z",
        key: "vex3ng",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const O9 = e("WholeWord", [
    ["circle", { cx: "7", cy: "12", r: "3", key: "12clwm" }],
    ["path", { d: "M10 9v6", key: "17i7lo" }],
    ["circle", { cx: "17", cy: "12", r: "3", key: "gl7c2s" }],
    ["path", { d: "M14 7v8", key: "dl84cr" }],
    [
      "path",
      { d: "M22 17v1c0 .5-.5 1-1 1H3c-.5 0-1-.5-1-1v-1", key: "lt2kga" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const G9 = e("WifiOff", [
    ["path", { d: "M12 20h.01", key: "zekei9" }],
    ["path", { d: "M8.5 16.429a5 5 0 0 1 7 0", key: "1bycff" }],
    ["path", { d: "M5 12.859a10 10 0 0 1 5.17-2.69", key: "1dl1wf" }],
    ["path", { d: "M19 12.859a10 10 0 0 0-2.007-1.523", key: "4k23kn" }],
    ["path", { d: "M2 8.82a15 15 0 0 1 4.177-2.643", key: "1grhjp" }],
    ["path", { d: "M22 8.82a15 15 0 0 0-11.288-3.764", key: "z3jwby" }],
    ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const E9 = e("Wifi", [
    ["path", { d: "M12 20h.01", key: "zekei9" }],
    ["path", { d: "M2 8.82a15 15 0 0 1 20 0", key: "dnpr2z" }],
    ["path", { d: "M5 12.859a10 10 0 0 1 14 0", key: "1x1e6c" }],
    ["path", { d: "M8.5 16.429a5 5 0 0 1 7 0", key: "1bycff" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const W9 = e("Wind", [
    ["path", { d: "M17.7 7.7a2.5 2.5 0 1 1 1.8 4.3H2", key: "1k4u03" }],
    ["path", { d: "M9.6 4.6A2 2 0 1 1 11 8H2", key: "b7d0fd" }],
    ["path", { d: "M12.6 19.4A2 2 0 1 0 14 16H2", key: "1p5cb3" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const N9 = e("WineOff", [
    ["path", { d: "M8 22h8", key: "rmew8v" }],
    ["path", { d: "M7 10h3m7 0h-1.343", key: "v48bem" }],
    ["path", { d: "M12 15v7", key: "t2xh3l" }],
    [
      "path",
      {
        d: "M7.307 7.307A12.33 12.33 0 0 0 7 10a5 5 0 0 0 7.391 4.391M8.638 2.981C8.75 2.668 8.872 2.34 9 2h6c1.5 4 2 6 2 8 0 .407-.05.809-.145 1.198",
        key: "1ymjlu",
      },
    ],
    ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const X9 = e("Wine", [
    ["path", { d: "M8 22h8", key: "rmew8v" }],
    ["path", { d: "M7 10h10", key: "1101jm" }],
    ["path", { d: "M12 15v7", key: "t2xh3l" }],
    [
      "path",
      {
        d: "M12 15a5 5 0 0 0 5-5c0-2-.5-4-2-8H9c-1.5 4-2 6-2 8a5 5 0 0 0 5 5Z",
        key: "10ffi3",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const K9 = e("Workflow", [
    [
      "rect",
      { width: "8", height: "8", x: "3", y: "3", rx: "2", key: "by2w9f" },
    ],
    ["path", { d: "M7 11v4a2 2 0 0 0 2 2h4", key: "xkn7yn" }],
    [
      "rect",
      { width: "8", height: "8", x: "13", y: "13", rx: "2", key: "1cgmvn" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const _9 = e("WrapText", [
    ["line", { x1: "3", x2: "21", y1: "6", y2: "6", key: "4m8b97" }],
    ["path", { d: "M3 12h15a3 3 0 1 1 0 6h-4", key: "1cl7v7" }],
    ["polyline", { points: "16 16 14 18 16 20", key: "1jznyi" }],
    ["line", { x1: "3", x2: "10", y1: "18", y2: "18", key: "1h33wv" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const J9 = e("Wrench", [
    [
      "path",
      {
        d: "M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z",
        key: "cbrjhi",
      },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Q9 = e("XCircle", [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
    ["path", { d: "m9 9 6 6", key: "z0biqf" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const Y9 = e("XOctagon", [
    [
      "polygon",
      {
        points:
          "7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2",
        key: "h1p8hx",
      },
    ],
    ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
    ["path", { d: "m9 9 6 6", key: "z0biqf" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const $9 = e("XSquare", [
    [
      "rect",
      {
        width: "18",
        height: "18",
        x: "3",
        y: "3",
        rx: "2",
        ry: "2",
        key: "1m3agn",
      },
    ],
    ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
    ["path", { d: "m9 9 6 6", key: "z0biqf" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const N1 = e("X", [
    ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
    ["path", { d: "m6 6 12 12", key: "d8bk6v" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const eM = e("Youtube", [
    [
      "path",
      {
        d: "M2.5 17a24.12 24.12 0 0 1 0-10 2 2 0 0 1 1.4-1.4 49.56 49.56 0 0 1 16.2 0A2 2 0 0 1 21.5 7a24.12 24.12 0 0 1 0 10 2 2 0 0 1-1.4 1.4 49.55 49.55 0 0 1-16.2 0A2 2 0 0 1 2.5 17",
        key: "1q2vi4",
      },
    ],
    ["path", { d: "m10 15 5-3-5-3z", key: "1jp15x" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const aM = e("ZapOff", [
    ["polyline", { points: "12.41 6.75 13 2 10.57 4.92", key: "122m05" }],
    ["polyline", { points: "18.57 12.91 21 10 15.66 10", key: "16r43o" }],
    ["polyline", { points: "8 8 3 14 12 14 11 22 16 16", key: "tmh4bc" }],
    ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const tM = e("Zap", [
    [
      "polygon",
      { points: "13 2 3 14 12 14 11 22 21 10 12 10 13 2", key: "45s27k" },
    ],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const cM = e("ZoomIn", [
    ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
    ["line", { x1: "21", x2: "16.65", y1: "21", y2: "16.65", key: "13gj7c" }],
    ["line", { x1: "11", x2: "11", y1: "8", y2: "14", key: "1vmskp" }],
    ["line", { x1: "8", x2: "14", y1: "11", y2: "11", key: "durymu" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const hM = e("ZoomOut", [
    ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
    ["line", { x1: "21", x2: "16.65", y1: "21", y2: "16.65", key: "13gj7c" }],
    ["line", { x1: "8", x2: "14", y1: "11", y2: "11", key: "durymu" }],
  ])
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const HM = Object.freeze(
    Object.defineProperty(
      {
        __proto__: null,
        AArrowDown: J1,
        AArrowUp: Q1,
        ALargeSmall: Y1,
        Accessibility: $1,
        Activity: a2,
        ActivitySquare: e2,
        AirVent: t2,
        Airplay: c2,
        AlarmClock: d2,
        AlarmClockCheck: I,
        AlarmClockMinus: C,
        AlarmClockOff: h2,
        AlarmClockPlus: b,
        AlarmSmoke: o2,
        Album: y2,
        AlertCircle: i2,
        AlertOctagon: n2,
        AlertTriangle: r2,
        AlignCenter: l2,
        AlignCenterHorizontal: k2,
        AlignCenterVertical: p2,
        AlignEndHorizontal: s2,
        AlignEndVertical: u2,
        AlignHorizontalDistributeCenter: M2,
        AlignHorizontalDistributeEnd: v2,
        AlignHorizontalDistributeStart: m2,
        AlignHorizontalJustifyCenter: x2,
        AlignHorizontalJustifyEnd: g2,
        AlignHorizontalJustifyStart: L2,
        AlignHorizontalSpaceAround: f2,
        AlignHorizontalSpaceBetween: w2,
        AlignJustify: I2,
        AlignLeft: C2,
        AlignRight: b2,
        AlignStartHorizontal: S2,
        AlignStartVertical: q2,
        AlignVerticalDistributeCenter: H2,
        AlignVerticalDistributeEnd: z2,
        AlignVerticalDistributeStart: A2,
        AlignVerticalJustifyCenter: j2,
        AlignVerticalJustifyEnd: V2,
        AlignVerticalJustifyStart: P2,
        AlignVerticalSpaceAround: F2,
        AlignVerticalSpaceBetween: B2,
        Ambulance: D2,
        Ampersand: R2,
        Ampersands: T2,
        Anchor: U2,
        Angry: Z2,
        Annoyed: O2,
        Antenna: G2,
        Anvil: E2,
        Aperture: W2,
        AppWindow: N2,
        Apple: X2,
        Archive: J2,
        ArchiveRestore: K2,
        ArchiveX: _2,
        AreaChart: Q2,
        Armchair: Y2,
        ArrowBigDown: ee,
        ArrowBigDownDash: $2,
        ArrowBigLeft: te,
        ArrowBigLeftDash: ae,
        ArrowBigRight: he,
        ArrowBigRightDash: ce,
        ArrowBigUp: oe,
        ArrowBigUpDash: de,
        ArrowDown: Ie,
        ArrowDown01: ye,
        ArrowDown10: ie,
        ArrowDownAZ: S,
        ArrowDownCircle: ne,
        ArrowDownFromLine: re,
        ArrowDownLeft: se,
        ArrowDownLeftFromCircle: ke,
        ArrowDownLeftFromSquare: pe,
        ArrowDownLeftSquare: le,
        ArrowDownNarrowWide: ue,
        ArrowDownRight: xe,
        ArrowDownRightFromCircle: Me,
        ArrowDownRightFromSquare: ve,
        ArrowDownRightSquare: me,
        ArrowDownSquare: ge,
        ArrowDownToDot: Le,
        ArrowDownToLine: fe,
        ArrowDownUp: we,
        ArrowDownWideNarrow: q,
        ArrowDownZA: H,
        ArrowLeft: ze,
        ArrowLeftCircle: Ce,
        ArrowLeftFromLine: be,
        ArrowLeftRight: Se,
        ArrowLeftSquare: qe,
        ArrowLeftToLine: He,
        ArrowRight: G1,
        ArrowRightCircle: Ae,
        ArrowRightFromLine: je,
        ArrowRightLeft: Ve,
        ArrowRightSquare: Pe,
        ArrowRightToLine: Fe,
        ArrowUp: $e,
        ArrowUp01: Be,
        ArrowUp10: De,
        ArrowUpAZ: z,
        ArrowUpCircle: Re,
        ArrowUpDown: Te,
        ArrowUpFromDot: Ue,
        ArrowUpFromLine: Ze,
        ArrowUpLeft: We,
        ArrowUpLeftFromCircle: Oe,
        ArrowUpLeftFromSquare: Ge,
        ArrowUpLeftSquare: Ee,
        ArrowUpNarrowWide: A,
        ArrowUpRight: _e,
        ArrowUpRightFromCircle: Ne,
        ArrowUpRightFromSquare: Xe,
        ArrowUpRightSquare: Ke,
        ArrowUpSquare: Je,
        ArrowUpToLine: Qe,
        ArrowUpWideNarrow: Ye,
        ArrowUpZA: j,
        ArrowsUpFromLine: ea,
        Asterisk: aa,
        AsteriskSquare: V,
        AtSign: ta,
        Atom: ca,
        AudioLines: ha,
        AudioWaveform: da,
        Award: oa,
        Axe: ya,
        Axis3d: P,
        Baby: ia,
        Backpack: na,
        Badge: Ca,
        BadgeAlert: ra,
        BadgeCent: ka,
        BadgeCheck: F,
        BadgeDollarSign: pa,
        BadgeEuro: la,
        BadgeHelp: sa,
        BadgeIndianRupee: ua,
        BadgeInfo: Ma,
        BadgeJapaneseYen: va,
        BadgeMinus: ma,
        BadgePercent: xa,
        BadgePlus: ga,
        BadgePoundSterling: La,
        BadgeRussianRuble: fa,
        BadgeSwissFranc: wa,
        BadgeX: Ia,
        BaggageClaim: ba,
        Ban: Sa,
        Banana: qa,
        Banknote: Ha,
        BarChart: Ba,
        BarChart2: za,
        BarChart3: Aa,
        BarChart4: ja,
        BarChartBig: Va,
        BarChartHorizontal: Fa,
        BarChartHorizontalBig: Pa,
        Barcode: Da,
        Baseline: Ra,
        Bath: Ta,
        Battery: Wa,
        BatteryCharging: Ua,
        BatteryFull: Za,
        BatteryLow: Oa,
        BatteryMedium: Ga,
        BatteryWarning: Ea,
        Beaker: Na,
        Bean: Ka,
        BeanOff: Xa,
        Bed: Qa,
        BedDouble: _a,
        BedSingle: Ja,
        Beef: Ya,
        Beer: $a,
        Bell: o0,
        BellDot: e0,
        BellElectric: a0,
        BellMinus: t0,
        BellOff: c0,
        BellPlus: h0,
        BellRing: d0,
        BetweenHorizontalEnd: B,
        BetweenHorizontalStart: D,
        BetweenVerticalEnd: y0,
        BetweenVerticalStart: i0,
        Bike: n0,
        Binary: r0,
        Biohazard: k0,
        Bird: p0,
        Bitcoin: l0,
        Blend: s0,
        Blinds: u0,
        Blocks: M0,
        Bluetooth: g0,
        BluetoothConnected: v0,
        BluetoothOff: m0,
        BluetoothSearching: x0,
        Bold: L0,
        Bolt: f0,
        Bomb: w0,
        Bone: I0,
        Book: X0,
        BookA: C0,
        BookAudio: b0,
        BookCheck: S0,
        BookCopy: q0,
        BookDashed: R,
        BookDown: H0,
        BookHeadphones: z0,
        BookHeart: A0,
        BookImage: j0,
        BookKey: V0,
        BookLock: P0,
        BookMarked: F0,
        BookMinus: B0,
        BookOpen: T0,
        BookOpenCheck: D0,
        BookOpenText: R0,
        BookPlus: U0,
        BookText: Z0,
        BookType: O0,
        BookUp: E0,
        BookUp2: G0,
        BookUser: W0,
        BookX: N0,
        Bookmark: Y0,
        BookmarkCheck: K0,
        BookmarkMinus: _0,
        BookmarkPlus: J0,
        BookmarkX: Q0,
        BoomBox: $0,
        Bot: at,
        BotMessageSquare: et,
        Box: ct,
        BoxSelect: tt,
        Boxes: ht,
        Braces: T,
        Brackets: dt,
        Brain: it,
        BrainCircuit: ot,
        BrainCog: yt,
        BrickWall: nt,
        Briefcase: rt,
        BringToFront: kt,
        Brush: pt,
        Bug: ut,
        BugOff: lt,
        BugPlay: st,
        Building: vt,
        Building2: Mt,
        Bus: xt,
        BusFront: mt,
        Cable: Lt,
        CableCar: gt,
        Cake: wt,
        CakeSlice: ft,
        Calculator: It,
        Calendar: Ut,
        CalendarCheck: bt,
        CalendarCheck2: Ct,
        CalendarClock: St,
        CalendarDays: qt,
        CalendarFold: Ht,
        CalendarHeart: zt,
        CalendarMinus: jt,
        CalendarMinus2: At,
        CalendarOff: Vt,
        CalendarPlus: Ft,
        CalendarPlus2: Pt,
        CalendarRange: Bt,
        CalendarSearch: Dt,
        CalendarX: Tt,
        CalendarX2: Rt,
        Camera: Ot,
        CameraOff: Zt,
        CandlestickChart: Gt,
        Candy: Nt,
        CandyCane: Et,
        CandyOff: Wt,
        Captions: U,
        CaptionsOff: Xt,
        Car: Jt,
        CarFront: Kt,
        CarTaxiFront: _t,
        Caravan: Qt,
        Carrot: Yt,
        CaseLower: $t,
        CaseSensitive: ec,
        CaseUpper: ac,
        CassetteTape: tc,
        Cast: cc,
        Castle: hc,
        Cat: dc,
        Cctv: oc,
        Check: kc,
        CheckCheck: yc,
        CheckCircle: Z1,
        CheckCircle2: ic,
        CheckSquare: rc,
        CheckSquare2: nc,
        ChefHat: pc,
        Cherry: lc,
        ChevronDown: Mc,
        ChevronDownCircle: sc,
        ChevronDownSquare: uc,
        ChevronFirst: vc,
        ChevronLast: mc,
        ChevronLeft: Lc,
        ChevronLeftCircle: xc,
        ChevronLeftSquare: gc,
        ChevronRight: Ic,
        ChevronRightCircle: fc,
        ChevronRightSquare: wc,
        ChevronUp: Sc,
        ChevronUpCircle: Cc,
        ChevronUpSquare: bc,
        ChevronsDown: Hc,
        ChevronsDownUp: qc,
        ChevronsLeft: Ac,
        ChevronsLeftRight: zc,
        ChevronsRight: Vc,
        ChevronsRightLeft: jc,
        ChevronsUp: Fc,
        ChevronsUpDown: Pc,
        Chrome: Bc,
        Church: Dc,
        Cigarette: Tc,
        CigaretteOff: Rc,
        Circle: _c,
        CircleDashed: Uc,
        CircleDollarSign: Zc,
        CircleDot: Gc,
        CircleDotDashed: Oc,
        CircleEllipsis: Ec,
        CircleEqual: Wc,
        CircleFadingPlus: Nc,
        CircleOff: Xc,
        CircleSlash: Kc,
        CircleSlash2: Z,
        CircleUser: G,
        CircleUserRound: O,
        CircuitBoard: Jc,
        Citrus: Qc,
        Clapperboard: Yc,
        Clipboard: yh,
        ClipboardCheck: $c,
        ClipboardCopy: eh,
        ClipboardList: ah,
        ClipboardMinus: th,
        ClipboardPaste: ch,
        ClipboardPen: W,
        ClipboardPenLine: E,
        ClipboardPlus: hh,
        ClipboardType: dh,
        ClipboardX: oh,
        Clock: gh,
        Clock1: ih,
        Clock10: nh,
        Clock11: rh,
        Clock12: kh,
        Clock2: ph,
        Clock3: lh,
        Clock4: sh,
        Clock5: uh,
        Clock6: Mh,
        Clock7: vh,
        Clock8: mh,
        Clock9: xh,
        Cloud: Ph,
        CloudCog: Lh,
        CloudDrizzle: fh,
        CloudFog: wh,
        CloudHail: Ih,
        CloudLightning: Ch,
        CloudMoon: Sh,
        CloudMoonRain: bh,
        CloudOff: qh,
        CloudRain: zh,
        CloudRainWind: Hh,
        CloudSnow: Ah,
        CloudSun: Vh,
        CloudSunRain: jh,
        Cloudy: Fh,
        Clover: Bh,
        Club: Dh,
        Code: Th,
        Code2: Rh,
        CodeSquare: N,
        Codepen: Uh,
        Codesandbox: Zh,
        Coffee: Oh,
        Cog: Gh,
        Coins: Eh,
        Columns2: X,
        Columns3: K,
        Columns4: Wh,
        Combine: Nh,
        Command: Xh,
        Compass: Kh,
        Component: _h,
        Computer: Jh,
        ConciergeBell: Qh,
        Cone: Yh,
        Construction: $h,
        Contact: ad,
        Contact2: ed,
        Container: td,
        Contrast: cd,
        Cookie: hd,
        CookingPot: dd,
        Copy: kd,
        CopyCheck: od,
        CopyMinus: yd,
        CopyPlus: id,
        CopySlash: nd,
        CopyX: rd,
        Copyleft: pd,
        Copyright: ld,
        CornerDownLeft: sd,
        CornerDownRight: ud,
        CornerLeftDown: Md,
        CornerLeftUp: vd,
        CornerRightDown: md,
        CornerRightUp: xd,
        CornerUpLeft: gd,
        CornerUpRight: Ld,
        Cpu: fd,
        CreativeCommons: wd,
        CreditCard: Id,
        Croissant: Cd,
        Crop: bd,
        Cross: Sd,
        Crosshair: qd,
        Crown: Hd,
        Cuboid: zd,
        CupSoda: Ad,
        Currency: jd,
        Cylinder: Vd,
        Database: Bd,
        DatabaseBackup: Pd,
        DatabaseZap: Fd,
        Delete: Dd,
        Dessert: Rd,
        Diameter: Td,
        Diamond: Ud,
        Dice1: Zd,
        Dice2: Od,
        Dice3: Gd,
        Dice4: Ed,
        Dice5: Wd,
        Dice6: Nd,
        Dices: Xd,
        Diff: Kd,
        Disc: Yd,
        Disc2: _d,
        Disc3: Jd,
        DiscAlbum: Qd,
        Divide: ao,
        DivideCircle: $d,
        DivideSquare: eo,
        Dna: co,
        DnaOff: to,
        Dog: ho,
        DollarSign: oo,
        Donut: yo,
        DoorClosed: io,
        DoorOpen: no,
        Dot: ro,
        DotSquare: _,
        Download: po,
        DownloadCloud: ko,
        DraftingCompass: lo,
        Drama: so,
        Dribbble: uo,
        Drill: Mo,
        Droplet: vo,
        Droplets: mo,
        Drum: xo,
        Drumstick: go,
        Dumbbell: Lo,
        Ear: wo,
        EarOff: fo,
        Earth: J,
        EarthLock: Io,
        Eclipse: Co,
        Egg: qo,
        EggFried: bo,
        EggOff: So,
        Equal: zo,
        EqualNot: Ho,
        EqualSquare: Q,
        Eraser: Ao,
        Euro: jo,
        Expand: Vo,
        ExternalLink: Po,
        Eye: Bo,
        EyeOff: Fo,
        Facebook: Do,
        Factory: Ro,
        Fan: To,
        FastForward: Uo,
        Feather: Zo,
        Fence: Oo,
        FerrisWheel: Go,
        Figma: Eo,
        File: Ey,
        FileArchive: Wo,
        FileAudio: Xo,
        FileAudio2: No,
        FileAxis3d: Y,
        FileBadge: _o,
        FileBadge2: Ko,
        FileBarChart: Qo,
        FileBarChart2: Jo,
        FileBox: Yo,
        FileCheck: ey,
        FileCheck2: $o,
        FileClock: ay,
        FileCode: cy,
        FileCode2: ty,
        FileCog: $,
        FileDiff: hy,
        FileDigit: dy,
        FileDown: oy,
        FileHeart: yy,
        FileImage: iy,
        FileInput: ny,
        FileJson: ky,
        FileJson2: ry,
        FileKey: ly,
        FileKey2: py,
        FileLineChart: sy,
        FileLock: My,
        FileLock2: uy,
        FileMinus: my,
        FileMinus2: vy,
        FileMusic: xy,
        FileOutput: gy,
        FilePen: a1,
        FilePenLine: e1,
        FilePieChart: Ly,
        FilePlus: wy,
        FilePlus2: fy,
        FileQuestion: Iy,
        FileScan: Cy,
        FileSearch: Sy,
        FileSearch2: by,
        FileSliders: qy,
        FileSpreadsheet: Hy,
        FileStack: zy,
        FileSymlink: Ay,
        FileTerminal: jy,
        FileText: Vy,
        FileType: Fy,
        FileType2: Py,
        FileUp: By,
        FileVideo: Ry,
        FileVideo2: Dy,
        FileVolume: Uy,
        FileVolume2: Ty,
        FileWarning: Zy,
        FileX: Gy,
        FileX2: Oy,
        Files: Wy,
        Film: Ny,
        Filter: Ky,
        FilterX: Xy,
        Fingerprint: _y,
        FireExtinguisher: Jy,
        Fish: $y,
        FishOff: Qy,
        FishSymbol: Yy,
        Flag: ci,
        FlagOff: ei,
        FlagTriangleLeft: ai,
        FlagTriangleRight: ti,
        Flame: di,
        FlameKindling: hi,
        Flashlight: yi,
        FlashlightOff: oi,
        FlaskConical: ni,
        FlaskConicalOff: ii,
        FlaskRound: ri,
        FlipHorizontal: pi,
        FlipHorizontal2: ki,
        FlipVertical: si,
        FlipVertical2: li,
        Flower: Mi,
        Flower2: ui,
        Focus: vi,
        FoldHorizontal: mi,
        FoldVertical: xi,
        Folder: Ni,
        FolderArchive: gi,
        FolderCheck: Li,
        FolderClock: fi,
        FolderClosed: wi,
        FolderCog: t1,
        FolderDot: Ii,
        FolderDown: Ci,
        FolderGit: Si,
        FolderGit2: bi,
        FolderHeart: qi,
        FolderInput: Hi,
        FolderKanban: zi,
        FolderKey: Ai,
        FolderLock: ji,
        FolderMinus: Vi,
        FolderOpen: Fi,
        FolderOpenDot: Pi,
        FolderOutput: Bi,
        FolderPen: c1,
        FolderPlus: Di,
        FolderRoot: Ri,
        FolderSearch: Ui,
        FolderSearch2: Ti,
        FolderSymlink: Zi,
        FolderSync: Oi,
        FolderTree: Gi,
        FolderUp: Ei,
        FolderX: Wi,
        Folders: Xi,
        Footprints: Ki,
        Forklift: _i,
        FormInput: Ji,
        Forward: Qi,
        Frame: Yi,
        Framer: $i,
        Frown: en,
        Fuel: an,
        Fullscreen: tn,
        FunctionSquare: cn,
        GalleryHorizontal: dn,
        GalleryHorizontalEnd: hn,
        GalleryThumbnails: on,
        GalleryVertical: nn,
        GalleryVerticalEnd: yn,
        Gamepad: kn,
        Gamepad2: rn,
        GanttChart: pn,
        GanttChartSquare: v,
        Gauge: sn,
        GaugeCircle: ln,
        Gavel: un,
        Gem: Mn,
        Ghost: vn,
        Gift: mn,
        GitBranch: gn,
        GitBranchPlus: xn,
        GitCommitHorizontal: h1,
        GitCommitVertical: Ln,
        GitCompare: wn,
        GitCompareArrows: fn,
        GitFork: In,
        GitGraph: Cn,
        GitMerge: bn,
        GitPullRequest: jn,
        GitPullRequestArrow: Sn,
        GitPullRequestClosed: qn,
        GitPullRequestCreate: zn,
        GitPullRequestCreateArrow: Hn,
        GitPullRequestDraft: An,
        Github: Vn,
        Gitlab: Pn,
        GlassWater: Fn,
        Glasses: Bn,
        Globe: Rn,
        GlobeLock: Dn,
        Goal: Tn,
        Grab: Un,
        GraduationCap: Zn,
        Grape: On,
        Grid2x2: d1,
        Grid3x3: m,
        Grip: Wn,
        GripHorizontal: Gn,
        GripVertical: En,
        Group: Nn,
        Guitar: Xn,
        Hammer: Kn,
        Hand: $n,
        HandCoins: _n,
        HandHeart: Jn,
        HandHelping: o1,
        HandMetal: Qn,
        HandPlatter: Yn,
        Handshake: er,
        HardDrive: cr,
        HardDriveDownload: ar,
        HardDriveUpload: tr,
        HardHat: hr,
        Hash: dr,
        Haze: or,
        HdmiPort: yr,
        Heading: sr,
        Heading1: ir,
        Heading2: nr,
        Heading3: rr,
        Heading4: kr,
        Heading5: pr,
        Heading6: lr,
        Headphones: ur,
        Headset: Mr,
        Heart: Lr,
        HeartCrack: vr,
        HeartHandshake: mr,
        HeartOff: xr,
        HeartPulse: gr,
        Heater: fr,
        HelpCircle: wr,
        Hexagon: Ir,
        Highlighter: Cr,
        History: br,
        Home: Sr,
        Hop: Hr,
        HopOff: qr,
        Hotel: zr,
        Hourglass: Ar,
        IceCream: Vr,
        IceCream2: jr,
        Image: Tr,
        ImageDown: Pr,
        ImageMinus: Fr,
        ImageOff: Br,
        ImagePlus: Dr,
        ImageUp: Rr,
        Images: Ur,
        Import: Zr,
        Inbox: Or,
        Indent: Gr,
        IndianRupee: Er,
        Infinity: Wr,
        Info: Nr,
        InspectionPanel: Xr,
        Instagram: Kr,
        Italic: _r,
        IterationCcw: Jr,
        IterationCw: Qr,
        JapaneseYen: Yr,
        Joystick: $r,
        Kanban: ek,
        KanbanSquare: i1,
        KanbanSquareDashed: y1,
        Key: ck,
        KeyRound: ak,
        KeySquare: tk,
        Keyboard: dk,
        KeyboardMusic: hk,
        Lamp: kk,
        LampCeiling: ok,
        LampDesk: yk,
        LampFloor: ik,
        LampWallDown: nk,
        LampWallUp: rk,
        LandPlot: pk,
        Landmark: lk,
        Languages: sk,
        Laptop: Mk,
        Laptop2: uk,
        Lasso: mk,
        LassoSelect: vk,
        Laugh: xk,
        Layers: fk,
        Layers2: gk,
        Layers3: Lk,
        LayoutDashboard: wk,
        LayoutGrid: Ik,
        LayoutList: Ck,
        LayoutPanelLeft: bk,
        LayoutPanelTop: Sk,
        LayoutTemplate: qk,
        Leaf: Hk,
        LeafyGreen: zk,
        Library: Vk,
        LibraryBig: Ak,
        LibrarySquare: jk,
        LifeBuoy: Pk,
        Ligature: Fk,
        Lightbulb: Dk,
        LightbulbOff: Bk,
        LineChart: Rk,
        Link: Zk,
        Link2: Uk,
        Link2Off: Tk,
        Linkedin: Ok,
        List: c4,
        ListChecks: Gk,
        ListCollapse: Ek,
        ListEnd: Wk,
        ListFilter: Nk,
        ListMinus: Xk,
        ListMusic: Kk,
        ListOrdered: _k,
        ListPlus: Jk,
        ListRestart: Qk,
        ListStart: Yk,
        ListTodo: $k,
        ListTree: e4,
        ListVideo: a4,
        ListX: t4,
        Loader: d4,
        Loader2: h4,
        Locate: i4,
        LocateFixed: o4,
        LocateOff: y4,
        Lock: r4,
        LockKeyhole: n4,
        LogIn: k4,
        LogOut: p4,
        Lollipop: l4,
        Luggage: s4,
        MSquare: u4,
        Magnet: M4,
        Mail: E1,
        MailCheck: v4,
        MailMinus: m4,
        MailOpen: x4,
        MailPlus: g4,
        MailQuestion: L4,
        MailSearch: f4,
        MailWarning: w4,
        MailX: I4,
        Mailbox: C4,
        Mails: b4,
        Map: z4,
        MapPin: q4,
        MapPinOff: S4,
        MapPinned: H4,
        Martini: A4,
        Maximize: V4,
        Maximize2: j4,
        Medal: P4,
        Megaphone: B4,
        MegaphoneOff: F4,
        Meh: D4,
        MemoryStick: R4,
        Menu: U4,
        MenuSquare: T4,
        Merge: Z4,
        MessageCircle: Y4,
        MessageCircleCode: O4,
        MessageCircleDashed: G4,
        MessageCircleHeart: E4,
        MessageCircleMore: W4,
        MessageCircleOff: N4,
        MessageCirclePlus: X4,
        MessageCircleQuestion: K4,
        MessageCircleReply: _4,
        MessageCircleWarning: J4,
        MessageCircleX: Q4,
        MessageSquare: lp,
        MessageSquareCode: $4,
        MessageSquareDashed: ep,
        MessageSquareDiff: ap,
        MessageSquareDot: tp,
        MessageSquareHeart: cp,
        MessageSquareMore: hp,
        MessageSquareOff: dp,
        MessageSquarePlus: op,
        MessageSquareQuote: yp,
        MessageSquareReply: ip,
        MessageSquareShare: np,
        MessageSquareText: rp,
        MessageSquareWarning: kp,
        MessageSquareX: pp,
        MessagesSquare: sp,
        Mic: vp,
        Mic2: up,
        MicOff: Mp,
        Microscope: mp,
        Microwave: xp,
        Milestone: gp,
        Milk: fp,
        MilkOff: Lp,
        Minimize: Ip,
        Minimize2: wp,
        Minus: Sp,
        MinusCircle: Cp,
        MinusSquare: bp,
        Monitor: Tp,
        MonitorCheck: qp,
        MonitorDot: Hp,
        MonitorDown: zp,
        MonitorOff: Ap,
        MonitorPause: jp,
        MonitorPlay: Vp,
        MonitorSmartphone: Pp,
        MonitorSpeaker: Fp,
        MonitorStop: Bp,
        MonitorUp: Dp,
        MonitorX: Rp,
        Moon: Zp,
        MoonStar: Up,
        MoreHorizontal: Op,
        MoreVertical: Gp,
        Mountain: Wp,
        MountainSnow: Ep,
        Mouse: Jp,
        MousePointer: _p,
        MousePointer2: Np,
        MousePointerClick: Xp,
        MousePointerSquare: n1,
        MousePointerSquareDashed: Kp,
        Move: nl,
        Move3d: r1,
        MoveDiagonal: Yp,
        MoveDiagonal2: Qp,
        MoveDown: al,
        MoveDownLeft: $p,
        MoveDownRight: el,
        MoveHorizontal: tl,
        MoveLeft: cl,
        MoveRight: hl,
        MoveUp: yl,
        MoveUpLeft: dl,
        MoveUpRight: ol,
        MoveVertical: il,
        Music: ll,
        Music2: rl,
        Music3: kl,
        Music4: pl,
        Navigation: vl,
        Navigation2: ul,
        Navigation2Off: sl,
        NavigationOff: Ml,
        Network: ml,
        Newspaper: xl,
        Nfc: gl,
        Notebook: Il,
        NotebookPen: Ll,
        NotebookTabs: fl,
        NotebookText: wl,
        NotepadText: bl,
        NotepadTextDashed: Cl,
        Nut: ql,
        NutOff: Sl,
        Octagon: Hl,
        Option: zl,
        Orbit: Al,
        Outdent: jl,
        Package: Ul,
        Package2: Vl,
        PackageCheck: Pl,
        PackageMinus: Fl,
        PackageOpen: Bl,
        PackagePlus: Dl,
        PackageSearch: Rl,
        PackageX: Tl,
        PaintBucket: Zl,
        PaintRoller: Ol,
        Paintbrush: El,
        Paintbrush2: Gl,
        Palette: Wl,
        Palmtree: Nl,
        PanelBottom: _l,
        PanelBottomClose: Xl,
        PanelBottomDashed: k1,
        PanelBottomOpen: Kl,
        PanelLeft: u1,
        PanelLeftClose: p1,
        PanelLeftDashed: l1,
        PanelLeftOpen: s1,
        PanelRight: Yl,
        PanelRightClose: Jl,
        PanelRightDashed: M1,
        PanelRightOpen: Ql,
        PanelTop: a5,
        PanelTopClose: $l,
        PanelTopDashed: v1,
        PanelTopOpen: e5,
        PanelsLeftBottom: t5,
        PanelsRightBottom: c5,
        PanelsTopLeft: m1,
        Paperclip: h5,
        Parentheses: d5,
        ParkingCircle: y5,
        ParkingCircleOff: o5,
        ParkingMeter: i5,
        ParkingSquare: r5,
        ParkingSquareOff: n5,
        PartyPopper: k5,
        Pause: s5,
        PauseCircle: p5,
        PauseOctagon: l5,
        PawPrint: u5,
        PcCase: M5,
        Pen: g1,
        PenLine: x1,
        PenTool: v5,
        Pencil: g5,
        PencilLine: m5,
        PencilRuler: x5,
        Pentagon: L5,
        Percent: C5,
        PercentCircle: f5,
        PercentDiamond: w5,
        PercentSquare: I5,
        PersonStanding: b5,
        Phone: V5,
        PhoneCall: S5,
        PhoneForwarded: q5,
        PhoneIncoming: H5,
        PhoneMissed: z5,
        PhoneOff: A5,
        PhoneOutgoing: j5,
        Pi: F5,
        PiSquare: P5,
        Piano: B5,
        Pickaxe: D5,
        PictureInPicture: T5,
        PictureInPicture2: R5,
        PieChart: U5,
        PiggyBank: Z5,
        Pilcrow: G5,
        PilcrowSquare: O5,
        Pill: E5,
        Pin: N5,
        PinOff: W5,
        Pipette: X5,
        Pizza: K5,
        Plane: Q5,
        PlaneLanding: _5,
        PlaneTakeoff: J5,
        Play: e3,
        PlayCircle: Y5,
        PlaySquare: $5,
        Plug: h3,
        Plug2: a3,
        PlugZap: c3,
        PlugZap2: t3,
        Plus: y3,
        PlusCircle: d3,
        PlusSquare: o3,
        Pocket: n3,
        PocketKnife: i3,
        Podcast: r3,
        Pointer: p3,
        PointerOff: k3,
        Popcorn: l3,
        Popsicle: s3,
        PoundSterling: u3,
        Power: x3,
        PowerCircle: M3,
        PowerOff: v3,
        PowerSquare: m3,
        Presentation: g3,
        Printer: L3,
        Projector: f3,
        Puzzle: w3,
        Pyramid: I3,
        QrCode: C3,
        Quote: b3,
        Rabbit: S3,
        Radar: q3,
        Radiation: H3,
        Radical: z3,
        Radio: V3,
        RadioReceiver: A3,
        RadioTower: j3,
        Radius: P3,
        RailSymbol: F3,
        Rainbow: B3,
        Rat: D3,
        Ratio: R3,
        Receipt: X3,
        ReceiptCent: T3,
        ReceiptEuro: U3,
        ReceiptIndianRupee: Z3,
        ReceiptJapaneseYen: O3,
        ReceiptPoundSterling: G3,
        ReceiptRussianRuble: E3,
        ReceiptSwissFranc: W3,
        ReceiptText: N3,
        RectangleHorizontal: K3,
        RectangleVertical: _3,
        Recycle: J3,
        Redo: $3,
        Redo2: Q3,
        RedoDot: Y3,
        RefreshCcw: a6,
        RefreshCcwDot: e6,
        RefreshCw: c6,
        RefreshCwOff: t6,
        Refrigerator: h6,
        Regex: d6,
        RemoveFormatting: o6,
        Repeat: n6,
        Repeat1: y6,
        Repeat2: i6,
        Replace: k6,
        ReplaceAll: r6,
        Reply: l6,
        ReplyAll: p6,
        Rewind: s6,
        Ribbon: u6,
        Rocket: M6,
        RockingChair: v6,
        RollerCoaster: m6,
        Rotate3d: L1,
        RotateCcw: W1,
        RotateCw: x6,
        Route: L6,
        RouteOff: g6,
        Router: f6,
        Rows2: f1,
        Rows3: w1,
        Rows4: w6,
        Rss: I6,
        Ruler: C6,
        RussianRuble: b6,
        Sailboat: S6,
        Salad: q6,
        Sandwich: H6,
        Satellite: A6,
        SatelliteDish: z6,
        Save: V6,
        SaveAll: j6,
        Scale: P6,
        Scale3d: I1,
        Scaling: F6,
        Scan: O6,
        ScanBarcode: B6,
        ScanEye: D6,
        ScanFace: R6,
        ScanLine: T6,
        ScanSearch: U6,
        ScanText: Z6,
        ScatterChart: G6,
        School: W6,
        School2: E6,
        Scissors: _6,
        ScissorsLineDashed: N6,
        ScissorsSquare: K6,
        ScissorsSquareDashedBottom: X6,
        ScreenShare: Q6,
        ScreenShareOff: J6,
        Scroll: $6,
        ScrollText: Y6,
        Search: hs,
        SearchCheck: es,
        SearchCode: as,
        SearchSlash: ts,
        SearchX: cs,
        Send: os,
        SendHorizontal: C1,
        SendToBack: ds,
        SeparatorHorizontal: ys,
        SeparatorVertical: is,
        Server: ps,
        ServerCog: ns,
        ServerCrash: rs,
        ServerOff: ks,
        Settings: ss,
        Settings2: ls,
        Shapes: us,
        Share: vs,
        Share2: Ms,
        Sheet: ms,
        Shell: xs,
        Shield: Hs,
        ShieldAlert: gs,
        ShieldBan: Ls,
        ShieldCheck: fs,
        ShieldEllipsis: ws,
        ShieldHalf: Is,
        ShieldMinus: Cs,
        ShieldOff: bs,
        ShieldPlus: Ss,
        ShieldQuestion: qs,
        ShieldX: b1,
        Ship: As,
        ShipWheel: zs,
        Shirt: js,
        ShoppingBag: Vs,
        ShoppingBasket: Ps,
        ShoppingCart: Fs,
        Shovel: Bs,
        ShowerHead: Ds,
        Shrink: Rs,
        Shrub: Ts,
        Shuffle: Us,
        Sigma: Os,
        SigmaSquare: Zs,
        Signal: Xs,
        SignalHigh: Gs,
        SignalLow: Es,
        SignalMedium: Ws,
        SignalZero: Ns,
        Signpost: _s,
        SignpostBig: Ks,
        Siren: Js,
        SkipBack: Qs,
        SkipForward: Ys,
        Skull: $s,
        Slack: e8,
        Slash: a8,
        SlashSquare: S1,
        Slice: t8,
        Sliders: h8,
        SlidersHorizontal: c8,
        Smartphone: y8,
        SmartphoneCharging: d8,
        SmartphoneNfc: o8,
        Smile: n8,
        SmilePlus: i8,
        Snail: r8,
        Snowflake: k8,
        Sofa: p8,
        Soup: l8,
        Space: s8,
        Spade: u8,
        Sparkle: M8,
        Sparkles: q1,
        Speaker: v8,
        Speech: m8,
        SpellCheck: g8,
        SpellCheck2: x8,
        Spline: L8,
        Split: I8,
        SplitSquareHorizontal: f8,
        SplitSquareVertical: w8,
        SprayCan: C8,
        Sprout: b8,
        Square: A8,
        SquareDashedBottom: q8,
        SquareDashedBottomCode: S8,
        SquarePen: k,
        SquareRadical: H8,
        SquareStack: z8,
        SquareUser: z1,
        SquareUserRound: H1,
        Squircle: j8,
        Squirrel: V8,
        Stamp: P8,
        Star: D8,
        StarHalf: F8,
        StarOff: B8,
        StepBack: R8,
        StepForward: T8,
        Stethoscope: U8,
        Sticker: Z8,
        StickyNote: O8,
        StopCircle: G8,
        Store: E8,
        StretchHorizontal: W8,
        StretchVertical: N8,
        Strikethrough: X8,
        Subscript: K8,
        Sun: $8,
        SunDim: _8,
        SunMedium: J8,
        SunMoon: Q8,
        SunSnow: Y8,
        Sunrise: e7,
        Sunset: a7,
        Superscript: t7,
        SwatchBook: c7,
        SwissFranc: h7,
        SwitchCamera: d7,
        Sword: o7,
        Swords: y7,
        Syringe: i7,
        Table: u7,
        Table2: n7,
        TableCellsMerge: r7,
        TableCellsSplit: k7,
        TableColumnsSplit: p7,
        TableProperties: l7,
        TableRowsSplit: s7,
        Tablet: v7,
        TabletSmartphone: M7,
        Tablets: m7,
        Tag: x7,
        Tags: g7,
        Tally1: L7,
        Tally2: f7,
        Tally3: w7,
        Tally4: I7,
        Tally5: C7,
        Tangent: b7,
        Target: S7,
        Telescope: q7,
        Tent: z7,
        TentTree: H7,
        Terminal: j7,
        TerminalSquare: A7,
        TestTube: P7,
        TestTube2: V7,
        TestTubes: F7,
        Text: U7,
        TextCursor: D7,
        TextCursorInput: B7,
        TextQuote: R7,
        TextSearch: T7,
        TextSelect: A1,
        Theater: Z7,
        Thermometer: E7,
        ThermometerSnowflake: O7,
        ThermometerSun: G7,
        ThumbsDown: W7,
        ThumbsUp: N7,
        Ticket: $7,
        TicketCheck: X7,
        TicketMinus: K7,
        TicketPercent: _7,
        TicketPlus: J7,
        TicketSlash: Q7,
        TicketX: Y7,
        Timer: tu,
        TimerOff: eu,
        TimerReset: au,
        ToggleLeft: cu,
        ToggleRight: hu,
        Tornado: du,
        Torus: ou,
        Touchpad: iu,
        TouchpadOff: yu,
        TowerControl: nu,
        ToyBrick: ru,
        Tractor: ku,
        TrafficCone: pu,
        TrainFront: su,
        TrainFrontTunnel: lu,
        TrainTrack: uu,
        TramFront: j1,
        Trash: vu,
        Trash2: Mu,
        TreeDeciduous: mu,
        TreePine: xu,
        Trees: gu,
        Trello: Lu,
        TrendingDown: fu,
        TrendingUp: wu,
        Triangle: Cu,
        TriangleRight: Iu,
        Trophy: bu,
        Truck: Su,
        Turtle: qu,
        Tv: zu,
        Tv2: Hu,
        Twitch: Au,
        Twitter: ju,
        Type: Vu,
        Umbrella: Fu,
        UmbrellaOff: Pu,
        Underline: Bu,
        Undo: Tu,
        Undo2: Du,
        UndoDot: Ru,
        UnfoldHorizontal: Uu,
        UnfoldVertical: Zu,
        Ungroup: Ou,
        Unlink: Eu,
        Unlink2: Gu,
        Unlock: Nu,
        UnlockKeyhole: Wu,
        Unplug: Xu,
        Upload: _u,
        UploadCloud: Ku,
        Usb: Ju,
        User: h9,
        UserCheck: Qu,
        UserCog: Yu,
        UserMinus: $u,
        UserPlus: e9,
        UserRound: R1,
        UserRoundCheck: V1,
        UserRoundCog: P1,
        UserRoundMinus: F1,
        UserRoundPlus: B1,
        UserRoundSearch: a9,
        UserRoundX: D1,
        UserSearch: t9,
        UserX: c9,
        Users: d9,
        UsersRound: T1,
        Utensils: y9,
        UtensilsCrossed: o9,
        UtilityPole: i9,
        Variable: n9,
        Vault: r9,
        Vegan: k9,
        VenetianMask: p9,
        Vibrate: s9,
        VibrateOff: l9,
        Video: M9,
        VideoOff: u9,
        Videotape: v9,
        View: m9,
        Voicemail: x9,
        Volume: w9,
        Volume1: g9,
        Volume2: L9,
        VolumeX: f9,
        Vote: I9,
        Wallet: S9,
        Wallet2: C9,
        WalletCards: b9,
        Wallpaper: q9,
        Wand: z9,
        Wand2: H9,
        Warehouse: A9,
        WashingMachine: j9,
        Watch: V9,
        Waves: P9,
        Waypoints: F9,
        Webcam: B9,
        Webhook: R9,
        WebhookOff: D9,
        Weight: T9,
        Wheat: Z9,
        WheatOff: U9,
        WholeWord: O9,
        Wifi: E9,
        WifiOff: G9,
        Wind: W9,
        Wine: X9,
        WineOff: N9,
        Workflow: K9,
        WrapText: _9,
        Wrench: J9,
        X: N1,
        XCircle: Q9,
        XOctagon: Y9,
        XSquare: $9,
        Youtube: eM,
        Zap: tM,
        ZapOff: aM,
        ZoomIn: cM,
        ZoomOut: hM,
      },
      Symbol.toStringTag,
      { value: "Module" }
    )
  )
  /**
   * @license lucide-react v0.344.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */ const zM = Object.freeze(
      Object.defineProperty(
        {
          __proto__: null,
          AArrowDown: J1,
          AArrowDownIcon: J1,
          AArrowUp: Q1,
          AArrowUpIcon: Q1,
          ALargeSmall: Y1,
          ALargeSmallIcon: Y1,
          Accessibility: $1,
          AccessibilityIcon: $1,
          Activity: a2,
          ActivityIcon: a2,
          ActivitySquare: e2,
          ActivitySquareIcon: e2,
          AirVent: t2,
          AirVentIcon: t2,
          Airplay: c2,
          AirplayIcon: c2,
          AlarmCheck: I,
          AlarmCheckIcon: I,
          AlarmClock: d2,
          AlarmClockCheck: I,
          AlarmClockCheckIcon: I,
          AlarmClockIcon: d2,
          AlarmClockMinus: C,
          AlarmClockMinusIcon: C,
          AlarmClockOff: h2,
          AlarmClockOffIcon: h2,
          AlarmClockPlus: b,
          AlarmClockPlusIcon: b,
          AlarmMinus: C,
          AlarmMinusIcon: C,
          AlarmPlus: b,
          AlarmPlusIcon: b,
          AlarmSmoke: o2,
          AlarmSmokeIcon: o2,
          Album: y2,
          AlbumIcon: y2,
          AlertCircle: i2,
          AlertCircleIcon: i2,
          AlertOctagon: n2,
          AlertOctagonIcon: n2,
          AlertTriangle: r2,
          AlertTriangleIcon: r2,
          AlignCenter: l2,
          AlignCenterHorizontal: k2,
          AlignCenterHorizontalIcon: k2,
          AlignCenterIcon: l2,
          AlignCenterVertical: p2,
          AlignCenterVerticalIcon: p2,
          AlignEndHorizontal: s2,
          AlignEndHorizontalIcon: s2,
          AlignEndVertical: u2,
          AlignEndVerticalIcon: u2,
          AlignHorizontalDistributeCenter: M2,
          AlignHorizontalDistributeCenterIcon: M2,
          AlignHorizontalDistributeEnd: v2,
          AlignHorizontalDistributeEndIcon: v2,
          AlignHorizontalDistributeStart: m2,
          AlignHorizontalDistributeStartIcon: m2,
          AlignHorizontalJustifyCenter: x2,
          AlignHorizontalJustifyCenterIcon: x2,
          AlignHorizontalJustifyEnd: g2,
          AlignHorizontalJustifyEndIcon: g2,
          AlignHorizontalJustifyStart: L2,
          AlignHorizontalJustifyStartIcon: L2,
          AlignHorizontalSpaceAround: f2,
          AlignHorizontalSpaceAroundIcon: f2,
          AlignHorizontalSpaceBetween: w2,
          AlignHorizontalSpaceBetweenIcon: w2,
          AlignJustify: I2,
          AlignJustifyIcon: I2,
          AlignLeft: C2,
          AlignLeftIcon: C2,
          AlignRight: b2,
          AlignRightIcon: b2,
          AlignStartHorizontal: S2,
          AlignStartHorizontalIcon: S2,
          AlignStartVertical: q2,
          AlignStartVerticalIcon: q2,
          AlignVerticalDistributeCenter: H2,
          AlignVerticalDistributeCenterIcon: H2,
          AlignVerticalDistributeEnd: z2,
          AlignVerticalDistributeEndIcon: z2,
          AlignVerticalDistributeStart: A2,
          AlignVerticalDistributeStartIcon: A2,
          AlignVerticalJustifyCenter: j2,
          AlignVerticalJustifyCenterIcon: j2,
          AlignVerticalJustifyEnd: V2,
          AlignVerticalJustifyEndIcon: V2,
          AlignVerticalJustifyStart: P2,
          AlignVerticalJustifyStartIcon: P2,
          AlignVerticalSpaceAround: F2,
          AlignVerticalSpaceAroundIcon: F2,
          AlignVerticalSpaceBetween: B2,
          AlignVerticalSpaceBetweenIcon: B2,
          Ambulance: D2,
          AmbulanceIcon: D2,
          Ampersand: R2,
          AmpersandIcon: R2,
          Ampersands: T2,
          AmpersandsIcon: T2,
          Anchor: U2,
          AnchorIcon: U2,
          Angry: Z2,
          AngryIcon: Z2,
          Annoyed: O2,
          AnnoyedIcon: O2,
          Antenna: G2,
          AntennaIcon: G2,
          Anvil: E2,
          AnvilIcon: E2,
          Aperture: W2,
          ApertureIcon: W2,
          AppWindow: N2,
          AppWindowIcon: N2,
          Apple: X2,
          AppleIcon: X2,
          Archive: J2,
          ArchiveIcon: J2,
          ArchiveRestore: K2,
          ArchiveRestoreIcon: K2,
          ArchiveX: _2,
          ArchiveXIcon: _2,
          AreaChart: Q2,
          AreaChartIcon: Q2,
          Armchair: Y2,
          ArmchairIcon: Y2,
          ArrowBigDown: ee,
          ArrowBigDownDash: $2,
          ArrowBigDownDashIcon: $2,
          ArrowBigDownIcon: ee,
          ArrowBigLeft: te,
          ArrowBigLeftDash: ae,
          ArrowBigLeftDashIcon: ae,
          ArrowBigLeftIcon: te,
          ArrowBigRight: he,
          ArrowBigRightDash: ce,
          ArrowBigRightDashIcon: ce,
          ArrowBigRightIcon: he,
          ArrowBigUp: oe,
          ArrowBigUpDash: de,
          ArrowBigUpDashIcon: de,
          ArrowBigUpIcon: oe,
          ArrowDown: Ie,
          ArrowDown01: ye,
          ArrowDown01Icon: ye,
          ArrowDown10: ie,
          ArrowDown10Icon: ie,
          ArrowDownAZ: S,
          ArrowDownAZIcon: S,
          ArrowDownAz: S,
          ArrowDownAzIcon: S,
          ArrowDownCircle: ne,
          ArrowDownCircleIcon: ne,
          ArrowDownFromLine: re,
          ArrowDownFromLineIcon: re,
          ArrowDownIcon: Ie,
          ArrowDownLeft: se,
          ArrowDownLeftFromCircle: ke,
          ArrowDownLeftFromCircleIcon: ke,
          ArrowDownLeftFromSquare: pe,
          ArrowDownLeftFromSquareIcon: pe,
          ArrowDownLeftIcon: se,
          ArrowDownLeftSquare: le,
          ArrowDownLeftSquareIcon: le,
          ArrowDownNarrowWide: ue,
          ArrowDownNarrowWideIcon: ue,
          ArrowDownRight: xe,
          ArrowDownRightFromCircle: Me,
          ArrowDownRightFromCircleIcon: Me,
          ArrowDownRightFromSquare: ve,
          ArrowDownRightFromSquareIcon: ve,
          ArrowDownRightIcon: xe,
          ArrowDownRightSquare: me,
          ArrowDownRightSquareIcon: me,
          ArrowDownSquare: ge,
          ArrowDownSquareIcon: ge,
          ArrowDownToDot: Le,
          ArrowDownToDotIcon: Le,
          ArrowDownToLine: fe,
          ArrowDownToLineIcon: fe,
          ArrowDownUp: we,
          ArrowDownUpIcon: we,
          ArrowDownWideNarrow: q,
          ArrowDownWideNarrowIcon: q,
          ArrowDownZA: H,
          ArrowDownZAIcon: H,
          ArrowDownZa: H,
          ArrowDownZaIcon: H,
          ArrowLeft: ze,
          ArrowLeftCircle: Ce,
          ArrowLeftCircleIcon: Ce,
          ArrowLeftFromLine: be,
          ArrowLeftFromLineIcon: be,
          ArrowLeftIcon: ze,
          ArrowLeftRight: Se,
          ArrowLeftRightIcon: Se,
          ArrowLeftSquare: qe,
          ArrowLeftSquareIcon: qe,
          ArrowLeftToLine: He,
          ArrowLeftToLineIcon: He,
          ArrowRight: G1,
          ArrowRightCircle: Ae,
          ArrowRightCircleIcon: Ae,
          ArrowRightFromLine: je,
          ArrowRightFromLineIcon: je,
          ArrowRightIcon: G1,
          ArrowRightLeft: Ve,
          ArrowRightLeftIcon: Ve,
          ArrowRightSquare: Pe,
          ArrowRightSquareIcon: Pe,
          ArrowRightToLine: Fe,
          ArrowRightToLineIcon: Fe,
          ArrowUp: $e,
          ArrowUp01: Be,
          ArrowUp01Icon: Be,
          ArrowUp10: De,
          ArrowUp10Icon: De,
          ArrowUpAZ: z,
          ArrowUpAZIcon: z,
          ArrowUpAz: z,
          ArrowUpAzIcon: z,
          ArrowUpCircle: Re,
          ArrowUpCircleIcon: Re,
          ArrowUpDown: Te,
          ArrowUpDownIcon: Te,
          ArrowUpFromDot: Ue,
          ArrowUpFromDotIcon: Ue,
          ArrowUpFromLine: Ze,
          ArrowUpFromLineIcon: Ze,
          ArrowUpIcon: $e,
          ArrowUpLeft: We,
          ArrowUpLeftFromCircle: Oe,
          ArrowUpLeftFromCircleIcon: Oe,
          ArrowUpLeftFromSquare: Ge,
          ArrowUpLeftFromSquareIcon: Ge,
          ArrowUpLeftIcon: We,
          ArrowUpLeftSquare: Ee,
          ArrowUpLeftSquareIcon: Ee,
          ArrowUpNarrowWide: A,
          ArrowUpNarrowWideIcon: A,
          ArrowUpRight: _e,
          ArrowUpRightFromCircle: Ne,
          ArrowUpRightFromCircleIcon: Ne,
          ArrowUpRightFromSquare: Xe,
          ArrowUpRightFromSquareIcon: Xe,
          ArrowUpRightIcon: _e,
          ArrowUpRightSquare: Ke,
          ArrowUpRightSquareIcon: Ke,
          ArrowUpSquare: Je,
          ArrowUpSquareIcon: Je,
          ArrowUpToLine: Qe,
          ArrowUpToLineIcon: Qe,
          ArrowUpWideNarrow: Ye,
          ArrowUpWideNarrowIcon: Ye,
          ArrowUpZA: j,
          ArrowUpZAIcon: j,
          ArrowUpZa: j,
          ArrowUpZaIcon: j,
          ArrowsUpFromLine: ea,
          ArrowsUpFromLineIcon: ea,
          Asterisk: aa,
          AsteriskIcon: aa,
          AsteriskSquare: V,
          AsteriskSquareIcon: V,
          AtSign: ta,
          AtSignIcon: ta,
          Atom: ca,
          AtomIcon: ca,
          AudioLines: ha,
          AudioLinesIcon: ha,
          AudioWaveform: da,
          AudioWaveformIcon: da,
          Award: oa,
          AwardIcon: oa,
          Axe: ya,
          AxeIcon: ya,
          Axis3D: P,
          Axis3DIcon: P,
          Axis3d: P,
          Axis3dIcon: P,
          Baby: ia,
          BabyIcon: ia,
          Backpack: na,
          BackpackIcon: na,
          Badge: Ca,
          BadgeAlert: ra,
          BadgeAlertIcon: ra,
          BadgeCent: ka,
          BadgeCentIcon: ka,
          BadgeCheck: F,
          BadgeCheckIcon: F,
          BadgeDollarSign: pa,
          BadgeDollarSignIcon: pa,
          BadgeEuro: la,
          BadgeEuroIcon: la,
          BadgeHelp: sa,
          BadgeHelpIcon: sa,
          BadgeIcon: Ca,
          BadgeIndianRupee: ua,
          BadgeIndianRupeeIcon: ua,
          BadgeInfo: Ma,
          BadgeInfoIcon: Ma,
          BadgeJapaneseYen: va,
          BadgeJapaneseYenIcon: va,
          BadgeMinus: ma,
          BadgeMinusIcon: ma,
          BadgePercent: xa,
          BadgePercentIcon: xa,
          BadgePlus: ga,
          BadgePlusIcon: ga,
          BadgePoundSterling: La,
          BadgePoundSterlingIcon: La,
          BadgeRussianRuble: fa,
          BadgeRussianRubleIcon: fa,
          BadgeSwissFranc: wa,
          BadgeSwissFrancIcon: wa,
          BadgeX: Ia,
          BadgeXIcon: Ia,
          BaggageClaim: ba,
          BaggageClaimIcon: ba,
          Ban: Sa,
          BanIcon: Sa,
          Banana: qa,
          BananaIcon: qa,
          Banknote: Ha,
          BanknoteIcon: Ha,
          BarChart: Ba,
          BarChart2: za,
          BarChart2Icon: za,
          BarChart3: Aa,
          BarChart3Icon: Aa,
          BarChart4: ja,
          BarChart4Icon: ja,
          BarChartBig: Va,
          BarChartBigIcon: Va,
          BarChartHorizontal: Fa,
          BarChartHorizontalBig: Pa,
          BarChartHorizontalBigIcon: Pa,
          BarChartHorizontalIcon: Fa,
          BarChartIcon: Ba,
          Barcode: Da,
          BarcodeIcon: Da,
          Baseline: Ra,
          BaselineIcon: Ra,
          Bath: Ta,
          BathIcon: Ta,
          Battery: Wa,
          BatteryCharging: Ua,
          BatteryChargingIcon: Ua,
          BatteryFull: Za,
          BatteryFullIcon: Za,
          BatteryIcon: Wa,
          BatteryLow: Oa,
          BatteryLowIcon: Oa,
          BatteryMedium: Ga,
          BatteryMediumIcon: Ga,
          BatteryWarning: Ea,
          BatteryWarningIcon: Ea,
          Beaker: Na,
          BeakerIcon: Na,
          Bean: Ka,
          BeanIcon: Ka,
          BeanOff: Xa,
          BeanOffIcon: Xa,
          Bed: Qa,
          BedDouble: _a,
          BedDoubleIcon: _a,
          BedIcon: Qa,
          BedSingle: Ja,
          BedSingleIcon: Ja,
          Beef: Ya,
          BeefIcon: Ya,
          Beer: $a,
          BeerIcon: $a,
          Bell: o0,
          BellDot: e0,
          BellDotIcon: e0,
          BellElectric: a0,
          BellElectricIcon: a0,
          BellIcon: o0,
          BellMinus: t0,
          BellMinusIcon: t0,
          BellOff: c0,
          BellOffIcon: c0,
          BellPlus: h0,
          BellPlusIcon: h0,
          BellRing: d0,
          BellRingIcon: d0,
          BetweenHorizonalEnd: B,
          BetweenHorizonalEndIcon: B,
          BetweenHorizonalStart: D,
          BetweenHorizonalStartIcon: D,
          BetweenHorizontalEnd: B,
          BetweenHorizontalEndIcon: B,
          BetweenHorizontalStart: D,
          BetweenHorizontalStartIcon: D,
          BetweenVerticalEnd: y0,
          BetweenVerticalEndIcon: y0,
          BetweenVerticalStart: i0,
          BetweenVerticalStartIcon: i0,
          Bike: n0,
          BikeIcon: n0,
          Binary: r0,
          BinaryIcon: r0,
          Biohazard: k0,
          BiohazardIcon: k0,
          Bird: p0,
          BirdIcon: p0,
          Bitcoin: l0,
          BitcoinIcon: l0,
          Blend: s0,
          BlendIcon: s0,
          Blinds: u0,
          BlindsIcon: u0,
          Blocks: M0,
          BlocksIcon: M0,
          Bluetooth: g0,
          BluetoothConnected: v0,
          BluetoothConnectedIcon: v0,
          BluetoothIcon: g0,
          BluetoothOff: m0,
          BluetoothOffIcon: m0,
          BluetoothSearching: x0,
          BluetoothSearchingIcon: x0,
          Bold: L0,
          BoldIcon: L0,
          Bolt: f0,
          BoltIcon: f0,
          Bomb: w0,
          BombIcon: w0,
          Bone: I0,
          BoneIcon: I0,
          Book: X0,
          BookA: C0,
          BookAIcon: C0,
          BookAudio: b0,
          BookAudioIcon: b0,
          BookCheck: S0,
          BookCheckIcon: S0,
          BookCopy: q0,
          BookCopyIcon: q0,
          BookDashed: R,
          BookDashedIcon: R,
          BookDown: H0,
          BookDownIcon: H0,
          BookHeadphones: z0,
          BookHeadphonesIcon: z0,
          BookHeart: A0,
          BookHeartIcon: A0,
          BookIcon: X0,
          BookImage: j0,
          BookImageIcon: j0,
          BookKey: V0,
          BookKeyIcon: V0,
          BookLock: P0,
          BookLockIcon: P0,
          BookMarked: F0,
          BookMarkedIcon: F0,
          BookMinus: B0,
          BookMinusIcon: B0,
          BookOpen: T0,
          BookOpenCheck: D0,
          BookOpenCheckIcon: D0,
          BookOpenIcon: T0,
          BookOpenText: R0,
          BookOpenTextIcon: R0,
          BookPlus: U0,
          BookPlusIcon: U0,
          BookTemplate: R,
          BookTemplateIcon: R,
          BookText: Z0,
          BookTextIcon: Z0,
          BookType: O0,
          BookTypeIcon: O0,
          BookUp: E0,
          BookUp2: G0,
          BookUp2Icon: G0,
          BookUpIcon: E0,
          BookUser: W0,
          BookUserIcon: W0,
          BookX: N0,
          BookXIcon: N0,
          Bookmark: Y0,
          BookmarkCheck: K0,
          BookmarkCheckIcon: K0,
          BookmarkIcon: Y0,
          BookmarkMinus: _0,
          BookmarkMinusIcon: _0,
          BookmarkPlus: J0,
          BookmarkPlusIcon: J0,
          BookmarkX: Q0,
          BookmarkXIcon: Q0,
          BoomBox: $0,
          BoomBoxIcon: $0,
          Bot: at,
          BotIcon: at,
          BotMessageSquare: et,
          BotMessageSquareIcon: et,
          Box: ct,
          BoxIcon: ct,
          BoxSelect: tt,
          BoxSelectIcon: tt,
          Boxes: ht,
          BoxesIcon: ht,
          Braces: T,
          BracesIcon: T,
          Brackets: dt,
          BracketsIcon: dt,
          Brain: it,
          BrainCircuit: ot,
          BrainCircuitIcon: ot,
          BrainCog: yt,
          BrainCogIcon: yt,
          BrainIcon: it,
          BrickWall: nt,
          BrickWallIcon: nt,
          Briefcase: rt,
          BriefcaseIcon: rt,
          BringToFront: kt,
          BringToFrontIcon: kt,
          Brush: pt,
          BrushIcon: pt,
          Bug: ut,
          BugIcon: ut,
          BugOff: lt,
          BugOffIcon: lt,
          BugPlay: st,
          BugPlayIcon: st,
          Building: vt,
          Building2: Mt,
          Building2Icon: Mt,
          BuildingIcon: vt,
          Bus: xt,
          BusFront: mt,
          BusFrontIcon: mt,
          BusIcon: xt,
          Cable: Lt,
          CableCar: gt,
          CableCarIcon: gt,
          CableIcon: Lt,
          Cake: wt,
          CakeIcon: wt,
          CakeSlice: ft,
          CakeSliceIcon: ft,
          Calculator: It,
          CalculatorIcon: It,
          Calendar: Ut,
          CalendarCheck: bt,
          CalendarCheck2: Ct,
          CalendarCheck2Icon: Ct,
          CalendarCheckIcon: bt,
          CalendarClock: St,
          CalendarClockIcon: St,
          CalendarDays: qt,
          CalendarDaysIcon: qt,
          CalendarFold: Ht,
          CalendarFoldIcon: Ht,
          CalendarHeart: zt,
          CalendarHeartIcon: zt,
          CalendarIcon: Ut,
          CalendarMinus: jt,
          CalendarMinus2: At,
          CalendarMinus2Icon: At,
          CalendarMinusIcon: jt,
          CalendarOff: Vt,
          CalendarOffIcon: Vt,
          CalendarPlus: Ft,
          CalendarPlus2: Pt,
          CalendarPlus2Icon: Pt,
          CalendarPlusIcon: Ft,
          CalendarRange: Bt,
          CalendarRangeIcon: Bt,
          CalendarSearch: Dt,
          CalendarSearchIcon: Dt,
          CalendarX: Tt,
          CalendarX2: Rt,
          CalendarX2Icon: Rt,
          CalendarXIcon: Tt,
          Camera: Ot,
          CameraIcon: Ot,
          CameraOff: Zt,
          CameraOffIcon: Zt,
          CandlestickChart: Gt,
          CandlestickChartIcon: Gt,
          Candy: Nt,
          CandyCane: Et,
          CandyCaneIcon: Et,
          CandyIcon: Nt,
          CandyOff: Wt,
          CandyOffIcon: Wt,
          Captions: U,
          CaptionsIcon: U,
          CaptionsOff: Xt,
          CaptionsOffIcon: Xt,
          Car: Jt,
          CarFront: Kt,
          CarFrontIcon: Kt,
          CarIcon: Jt,
          CarTaxiFront: _t,
          CarTaxiFrontIcon: _t,
          Caravan: Qt,
          CaravanIcon: Qt,
          Carrot: Yt,
          CarrotIcon: Yt,
          CaseLower: $t,
          CaseLowerIcon: $t,
          CaseSensitive: ec,
          CaseSensitiveIcon: ec,
          CaseUpper: ac,
          CaseUpperIcon: ac,
          CassetteTape: tc,
          CassetteTapeIcon: tc,
          Cast: cc,
          CastIcon: cc,
          Castle: hc,
          CastleIcon: hc,
          Cat: dc,
          CatIcon: dc,
          Cctv: oc,
          CctvIcon: oc,
          Check: kc,
          CheckCheck: yc,
          CheckCheckIcon: yc,
          CheckCircle: Z1,
          CheckCircle2: ic,
          CheckCircle2Icon: ic,
          CheckCircleIcon: Z1,
          CheckIcon: kc,
          CheckSquare: rc,
          CheckSquare2: nc,
          CheckSquare2Icon: nc,
          CheckSquareIcon: rc,
          ChefHat: pc,
          ChefHatIcon: pc,
          Cherry: lc,
          CherryIcon: lc,
          ChevronDown: Mc,
          ChevronDownCircle: sc,
          ChevronDownCircleIcon: sc,
          ChevronDownIcon: Mc,
          ChevronDownSquare: uc,
          ChevronDownSquareIcon: uc,
          ChevronFirst: vc,
          ChevronFirstIcon: vc,
          ChevronLast: mc,
          ChevronLastIcon: mc,
          ChevronLeft: Lc,
          ChevronLeftCircle: xc,
          ChevronLeftCircleIcon: xc,
          ChevronLeftIcon: Lc,
          ChevronLeftSquare: gc,
          ChevronLeftSquareIcon: gc,
          ChevronRight: Ic,
          ChevronRightCircle: fc,
          ChevronRightCircleIcon: fc,
          ChevronRightIcon: Ic,
          ChevronRightSquare: wc,
          ChevronRightSquareIcon: wc,
          ChevronUp: Sc,
          ChevronUpCircle: Cc,
          ChevronUpCircleIcon: Cc,
          ChevronUpIcon: Sc,
          ChevronUpSquare: bc,
          ChevronUpSquareIcon: bc,
          ChevronsDown: Hc,
          ChevronsDownIcon: Hc,
          ChevronsDownUp: qc,
          ChevronsDownUpIcon: qc,
          ChevronsLeft: Ac,
          ChevronsLeftIcon: Ac,
          ChevronsLeftRight: zc,
          ChevronsLeftRightIcon: zc,
          ChevronsRight: Vc,
          ChevronsRightIcon: Vc,
          ChevronsRightLeft: jc,
          ChevronsRightLeftIcon: jc,
          ChevronsUp: Fc,
          ChevronsUpDown: Pc,
          ChevronsUpDownIcon: Pc,
          ChevronsUpIcon: Fc,
          Chrome: Bc,
          ChromeIcon: Bc,
          Church: Dc,
          ChurchIcon: Dc,
          Cigarette: Tc,
          CigaretteIcon: Tc,
          CigaretteOff: Rc,
          CigaretteOffIcon: Rc,
          Circle: _c,
          CircleDashed: Uc,
          CircleDashedIcon: Uc,
          CircleDollarSign: Zc,
          CircleDollarSignIcon: Zc,
          CircleDot: Gc,
          CircleDotDashed: Oc,
          CircleDotDashedIcon: Oc,
          CircleDotIcon: Gc,
          CircleEllipsis: Ec,
          CircleEllipsisIcon: Ec,
          CircleEqual: Wc,
          CircleEqualIcon: Wc,
          CircleFadingPlus: Nc,
          CircleFadingPlusIcon: Nc,
          CircleIcon: _c,
          CircleOff: Xc,
          CircleOffIcon: Xc,
          CircleSlash: Kc,
          CircleSlash2: Z,
          CircleSlash2Icon: Z,
          CircleSlashIcon: Kc,
          CircleSlashed: Z,
          CircleSlashedIcon: Z,
          CircleUser: G,
          CircleUserIcon: G,
          CircleUserRound: O,
          CircleUserRoundIcon: O,
          CircuitBoard: Jc,
          CircuitBoardIcon: Jc,
          Citrus: Qc,
          CitrusIcon: Qc,
          Clapperboard: Yc,
          ClapperboardIcon: Yc,
          Clipboard: yh,
          ClipboardCheck: $c,
          ClipboardCheckIcon: $c,
          ClipboardCopy: eh,
          ClipboardCopyIcon: eh,
          ClipboardEdit: W,
          ClipboardEditIcon: W,
          ClipboardIcon: yh,
          ClipboardList: ah,
          ClipboardListIcon: ah,
          ClipboardMinus: th,
          ClipboardMinusIcon: th,
          ClipboardPaste: ch,
          ClipboardPasteIcon: ch,
          ClipboardPen: W,
          ClipboardPenIcon: W,
          ClipboardPenLine: E,
          ClipboardPenLineIcon: E,
          ClipboardPlus: hh,
          ClipboardPlusIcon: hh,
          ClipboardSignature: E,
          ClipboardSignatureIcon: E,
          ClipboardType: dh,
          ClipboardTypeIcon: dh,
          ClipboardX: oh,
          ClipboardXIcon: oh,
          Clock: gh,
          Clock1: ih,
          Clock10: nh,
          Clock10Icon: nh,
          Clock11: rh,
          Clock11Icon: rh,
          Clock12: kh,
          Clock12Icon: kh,
          Clock1Icon: ih,
          Clock2: ph,
          Clock2Icon: ph,
          Clock3: lh,
          Clock3Icon: lh,
          Clock4: sh,
          Clock4Icon: sh,
          Clock5: uh,
          Clock5Icon: uh,
          Clock6: Mh,
          Clock6Icon: Mh,
          Clock7: vh,
          Clock7Icon: vh,
          Clock8: mh,
          Clock8Icon: mh,
          Clock9: xh,
          Clock9Icon: xh,
          ClockIcon: gh,
          Cloud: Ph,
          CloudCog: Lh,
          CloudCogIcon: Lh,
          CloudDrizzle: fh,
          CloudDrizzleIcon: fh,
          CloudFog: wh,
          CloudFogIcon: wh,
          CloudHail: Ih,
          CloudHailIcon: Ih,
          CloudIcon: Ph,
          CloudLightning: Ch,
          CloudLightningIcon: Ch,
          CloudMoon: Sh,
          CloudMoonIcon: Sh,
          CloudMoonRain: bh,
          CloudMoonRainIcon: bh,
          CloudOff: qh,
          CloudOffIcon: qh,
          CloudRain: zh,
          CloudRainIcon: zh,
          CloudRainWind: Hh,
          CloudRainWindIcon: Hh,
          CloudSnow: Ah,
          CloudSnowIcon: Ah,
          CloudSun: Vh,
          CloudSunIcon: Vh,
          CloudSunRain: jh,
          CloudSunRainIcon: jh,
          Cloudy: Fh,
          CloudyIcon: Fh,
          Clover: Bh,
          CloverIcon: Bh,
          Club: Dh,
          ClubIcon: Dh,
          Code: Th,
          Code2: Rh,
          Code2Icon: Rh,
          CodeIcon: Th,
          CodeSquare: N,
          CodeSquareIcon: N,
          Codepen: Uh,
          CodepenIcon: Uh,
          Codesandbox: Zh,
          CodesandboxIcon: Zh,
          Coffee: Oh,
          CoffeeIcon: Oh,
          Cog: Gh,
          CogIcon: Gh,
          Coins: Eh,
          CoinsIcon: Eh,
          Columns: X,
          Columns2: X,
          Columns2Icon: X,
          Columns3: K,
          Columns3Icon: K,
          Columns4: Wh,
          Columns4Icon: Wh,
          ColumnsIcon: X,
          Combine: Nh,
          CombineIcon: Nh,
          Command: Xh,
          CommandIcon: Xh,
          Compass: Kh,
          CompassIcon: Kh,
          Component: _h,
          ComponentIcon: _h,
          Computer: Jh,
          ComputerIcon: Jh,
          ConciergeBell: Qh,
          ConciergeBellIcon: Qh,
          Cone: Yh,
          ConeIcon: Yh,
          Construction: $h,
          ConstructionIcon: $h,
          Contact: ad,
          Contact2: ed,
          Contact2Icon: ed,
          ContactIcon: ad,
          Container: td,
          ContainerIcon: td,
          Contrast: cd,
          ContrastIcon: cd,
          Cookie: hd,
          CookieIcon: hd,
          CookingPot: dd,
          CookingPotIcon: dd,
          Copy: kd,
          CopyCheck: od,
          CopyCheckIcon: od,
          CopyIcon: kd,
          CopyMinus: yd,
          CopyMinusIcon: yd,
          CopyPlus: id,
          CopyPlusIcon: id,
          CopySlash: nd,
          CopySlashIcon: nd,
          CopyX: rd,
          CopyXIcon: rd,
          Copyleft: pd,
          CopyleftIcon: pd,
          Copyright: ld,
          CopyrightIcon: ld,
          CornerDownLeft: sd,
          CornerDownLeftIcon: sd,
          CornerDownRight: ud,
          CornerDownRightIcon: ud,
          CornerLeftDown: Md,
          CornerLeftDownIcon: Md,
          CornerLeftUp: vd,
          CornerLeftUpIcon: vd,
          CornerRightDown: md,
          CornerRightDownIcon: md,
          CornerRightUp: xd,
          CornerRightUpIcon: xd,
          CornerUpLeft: gd,
          CornerUpLeftIcon: gd,
          CornerUpRight: Ld,
          CornerUpRightIcon: Ld,
          Cpu: fd,
          CpuIcon: fd,
          CreativeCommons: wd,
          CreativeCommonsIcon: wd,
          CreditCard: Id,
          CreditCardIcon: Id,
          Croissant: Cd,
          CroissantIcon: Cd,
          Crop: bd,
          CropIcon: bd,
          Cross: Sd,
          CrossIcon: Sd,
          Crosshair: qd,
          CrosshairIcon: qd,
          Crown: Hd,
          CrownIcon: Hd,
          Cuboid: zd,
          CuboidIcon: zd,
          CupSoda: Ad,
          CupSodaIcon: Ad,
          CurlyBraces: T,
          CurlyBracesIcon: T,
          Currency: jd,
          CurrencyIcon: jd,
          Cylinder: Vd,
          CylinderIcon: Vd,
          Database: Bd,
          DatabaseBackup: Pd,
          DatabaseBackupIcon: Pd,
          DatabaseIcon: Bd,
          DatabaseZap: Fd,
          DatabaseZapIcon: Fd,
          Delete: Dd,
          DeleteIcon: Dd,
          Dessert: Rd,
          DessertIcon: Rd,
          Diameter: Td,
          DiameterIcon: Td,
          Diamond: Ud,
          DiamondIcon: Ud,
          Dice1: Zd,
          Dice1Icon: Zd,
          Dice2: Od,
          Dice2Icon: Od,
          Dice3: Gd,
          Dice3Icon: Gd,
          Dice4: Ed,
          Dice4Icon: Ed,
          Dice5: Wd,
          Dice5Icon: Wd,
          Dice6: Nd,
          Dice6Icon: Nd,
          Dices: Xd,
          DicesIcon: Xd,
          Diff: Kd,
          DiffIcon: Kd,
          Disc: Yd,
          Disc2: _d,
          Disc2Icon: _d,
          Disc3: Jd,
          Disc3Icon: Jd,
          DiscAlbum: Qd,
          DiscAlbumIcon: Qd,
          DiscIcon: Yd,
          Divide: ao,
          DivideCircle: $d,
          DivideCircleIcon: $d,
          DivideIcon: ao,
          DivideSquare: eo,
          DivideSquareIcon: eo,
          Dna: co,
          DnaIcon: co,
          DnaOff: to,
          DnaOffIcon: to,
          Dog: ho,
          DogIcon: ho,
          DollarSign: oo,
          DollarSignIcon: oo,
          Donut: yo,
          DonutIcon: yo,
          DoorClosed: io,
          DoorClosedIcon: io,
          DoorOpen: no,
          DoorOpenIcon: no,
          Dot: ro,
          DotIcon: ro,
          DotSquare: _,
          DotSquareIcon: _,
          Download: po,
          DownloadCloud: ko,
          DownloadCloudIcon: ko,
          DownloadIcon: po,
          DraftingCompass: lo,
          DraftingCompassIcon: lo,
          Drama: so,
          DramaIcon: so,
          Dribbble: uo,
          DribbbleIcon: uo,
          Drill: Mo,
          DrillIcon: Mo,
          Droplet: vo,
          DropletIcon: vo,
          Droplets: mo,
          DropletsIcon: mo,
          Drum: xo,
          DrumIcon: xo,
          Drumstick: go,
          DrumstickIcon: go,
          Dumbbell: Lo,
          DumbbellIcon: Lo,
          Ear: wo,
          EarIcon: wo,
          EarOff: fo,
          EarOffIcon: fo,
          Earth: J,
          EarthIcon: J,
          EarthLock: Io,
          EarthLockIcon: Io,
          Eclipse: Co,
          EclipseIcon: Co,
          Edit: k,
          Edit2: g1,
          Edit2Icon: g1,
          Edit3: x1,
          Edit3Icon: x1,
          EditIcon: k,
          Egg: qo,
          EggFried: bo,
          EggFriedIcon: bo,
          EggIcon: qo,
          EggOff: So,
          EggOffIcon: So,
          Equal: zo,
          EqualIcon: zo,
          EqualNot: Ho,
          EqualNotIcon: Ho,
          EqualSquare: Q,
          EqualSquareIcon: Q,
          Eraser: Ao,
          EraserIcon: Ao,
          Euro: jo,
          EuroIcon: jo,
          Expand: Vo,
          ExpandIcon: Vo,
          ExternalLink: Po,
          ExternalLinkIcon: Po,
          Eye: Bo,
          EyeIcon: Bo,
          EyeOff: Fo,
          EyeOffIcon: Fo,
          Facebook: Do,
          FacebookIcon: Do,
          Factory: Ro,
          FactoryIcon: Ro,
          Fan: To,
          FanIcon: To,
          FastForward: Uo,
          FastForwardIcon: Uo,
          Feather: Zo,
          FeatherIcon: Zo,
          Fence: Oo,
          FenceIcon: Oo,
          FerrisWheel: Go,
          FerrisWheelIcon: Go,
          Figma: Eo,
          FigmaIcon: Eo,
          File: Ey,
          FileArchive: Wo,
          FileArchiveIcon: Wo,
          FileAudio: Xo,
          FileAudio2: No,
          FileAudio2Icon: No,
          FileAudioIcon: Xo,
          FileAxis3D: Y,
          FileAxis3DIcon: Y,
          FileAxis3d: Y,
          FileAxis3dIcon: Y,
          FileBadge: _o,
          FileBadge2: Ko,
          FileBadge2Icon: Ko,
          FileBadgeIcon: _o,
          FileBarChart: Qo,
          FileBarChart2: Jo,
          FileBarChart2Icon: Jo,
          FileBarChartIcon: Qo,
          FileBox: Yo,
          FileBoxIcon: Yo,
          FileCheck: ey,
          FileCheck2: $o,
          FileCheck2Icon: $o,
          FileCheckIcon: ey,
          FileClock: ay,
          FileClockIcon: ay,
          FileCode: cy,
          FileCode2: ty,
          FileCode2Icon: ty,
          FileCodeIcon: cy,
          FileCog: $,
          FileCog2: $,
          FileCog2Icon: $,
          FileCogIcon: $,
          FileDiff: hy,
          FileDiffIcon: hy,
          FileDigit: dy,
          FileDigitIcon: dy,
          FileDown: oy,
          FileDownIcon: oy,
          FileEdit: a1,
          FileEditIcon: a1,
          FileHeart: yy,
          FileHeartIcon: yy,
          FileIcon: Ey,
          FileImage: iy,
          FileImageIcon: iy,
          FileInput: ny,
          FileInputIcon: ny,
          FileJson: ky,
          FileJson2: ry,
          FileJson2Icon: ry,
          FileJsonIcon: ky,
          FileKey: ly,
          FileKey2: py,
          FileKey2Icon: py,
          FileKeyIcon: ly,
          FileLineChart: sy,
          FileLineChartIcon: sy,
          FileLock: My,
          FileLock2: uy,
          FileLock2Icon: uy,
          FileLockIcon: My,
          FileMinus: my,
          FileMinus2: vy,
          FileMinus2Icon: vy,
          FileMinusIcon: my,
          FileMusic: xy,
          FileMusicIcon: xy,
          FileOutput: gy,
          FileOutputIcon: gy,
          FilePen: a1,
          FilePenIcon: a1,
          FilePenLine: e1,
          FilePenLineIcon: e1,
          FilePieChart: Ly,
          FilePieChartIcon: Ly,
          FilePlus: wy,
          FilePlus2: fy,
          FilePlus2Icon: fy,
          FilePlusIcon: wy,
          FileQuestion: Iy,
          FileQuestionIcon: Iy,
          FileScan: Cy,
          FileScanIcon: Cy,
          FileSearch: Sy,
          FileSearch2: by,
          FileSearch2Icon: by,
          FileSearchIcon: Sy,
          FileSignature: e1,
          FileSignatureIcon: e1,
          FileSliders: qy,
          FileSlidersIcon: qy,
          FileSpreadsheet: Hy,
          FileSpreadsheetIcon: Hy,
          FileStack: zy,
          FileStackIcon: zy,
          FileSymlink: Ay,
          FileSymlinkIcon: Ay,
          FileTerminal: jy,
          FileTerminalIcon: jy,
          FileText: Vy,
          FileTextIcon: Vy,
          FileType: Fy,
          FileType2: Py,
          FileType2Icon: Py,
          FileTypeIcon: Fy,
          FileUp: By,
          FileUpIcon: By,
          FileVideo: Ry,
          FileVideo2: Dy,
          FileVideo2Icon: Dy,
          FileVideoIcon: Ry,
          FileVolume: Uy,
          FileVolume2: Ty,
          FileVolume2Icon: Ty,
          FileVolumeIcon: Uy,
          FileWarning: Zy,
          FileWarningIcon: Zy,
          FileX: Gy,
          FileX2: Oy,
          FileX2Icon: Oy,
          FileXIcon: Gy,
          Files: Wy,
          FilesIcon: Wy,
          Film: Ny,
          FilmIcon: Ny,
          Filter: Ky,
          FilterIcon: Ky,
          FilterX: Xy,
          FilterXIcon: Xy,
          Fingerprint: _y,
          FingerprintIcon: _y,
          FireExtinguisher: Jy,
          FireExtinguisherIcon: Jy,
          Fish: $y,
          FishIcon: $y,
          FishOff: Qy,
          FishOffIcon: Qy,
          FishSymbol: Yy,
          FishSymbolIcon: Yy,
          Flag: ci,
          FlagIcon: ci,
          FlagOff: ei,
          FlagOffIcon: ei,
          FlagTriangleLeft: ai,
          FlagTriangleLeftIcon: ai,
          FlagTriangleRight: ti,
          FlagTriangleRightIcon: ti,
          Flame: di,
          FlameIcon: di,
          FlameKindling: hi,
          FlameKindlingIcon: hi,
          Flashlight: yi,
          FlashlightIcon: yi,
          FlashlightOff: oi,
          FlashlightOffIcon: oi,
          FlaskConical: ni,
          FlaskConicalIcon: ni,
          FlaskConicalOff: ii,
          FlaskConicalOffIcon: ii,
          FlaskRound: ri,
          FlaskRoundIcon: ri,
          FlipHorizontal: pi,
          FlipHorizontal2: ki,
          FlipHorizontal2Icon: ki,
          FlipHorizontalIcon: pi,
          FlipVertical: si,
          FlipVertical2: li,
          FlipVertical2Icon: li,
          FlipVerticalIcon: si,
          Flower: Mi,
          Flower2: ui,
          Flower2Icon: ui,
          FlowerIcon: Mi,
          Focus: vi,
          FocusIcon: vi,
          FoldHorizontal: mi,
          FoldHorizontalIcon: mi,
          FoldVertical: xi,
          FoldVerticalIcon: xi,
          Folder: Ni,
          FolderArchive: gi,
          FolderArchiveIcon: gi,
          FolderCheck: Li,
          FolderCheckIcon: Li,
          FolderClock: fi,
          FolderClockIcon: fi,
          FolderClosed: wi,
          FolderClosedIcon: wi,
          FolderCog: t1,
          FolderCog2: t1,
          FolderCog2Icon: t1,
          FolderCogIcon: t1,
          FolderDot: Ii,
          FolderDotIcon: Ii,
          FolderDown: Ci,
          FolderDownIcon: Ci,
          FolderEdit: c1,
          FolderEditIcon: c1,
          FolderGit: Si,
          FolderGit2: bi,
          FolderGit2Icon: bi,
          FolderGitIcon: Si,
          FolderHeart: qi,
          FolderHeartIcon: qi,
          FolderIcon: Ni,
          FolderInput: Hi,
          FolderInputIcon: Hi,
          FolderKanban: zi,
          FolderKanbanIcon: zi,
          FolderKey: Ai,
          FolderKeyIcon: Ai,
          FolderLock: ji,
          FolderLockIcon: ji,
          FolderMinus: Vi,
          FolderMinusIcon: Vi,
          FolderOpen: Fi,
          FolderOpenDot: Pi,
          FolderOpenDotIcon: Pi,
          FolderOpenIcon: Fi,
          FolderOutput: Bi,
          FolderOutputIcon: Bi,
          FolderPen: c1,
          FolderPenIcon: c1,
          FolderPlus: Di,
          FolderPlusIcon: Di,
          FolderRoot: Ri,
          FolderRootIcon: Ri,
          FolderSearch: Ui,
          FolderSearch2: Ti,
          FolderSearch2Icon: Ti,
          FolderSearchIcon: Ui,
          FolderSymlink: Zi,
          FolderSymlinkIcon: Zi,
          FolderSync: Oi,
          FolderSyncIcon: Oi,
          FolderTree: Gi,
          FolderTreeIcon: Gi,
          FolderUp: Ei,
          FolderUpIcon: Ei,
          FolderX: Wi,
          FolderXIcon: Wi,
          Folders: Xi,
          FoldersIcon: Xi,
          Footprints: Ki,
          FootprintsIcon: Ki,
          Forklift: _i,
          ForkliftIcon: _i,
          FormInput: Ji,
          FormInputIcon: Ji,
          Forward: Qi,
          ForwardIcon: Qi,
          Frame: Yi,
          FrameIcon: Yi,
          Framer: $i,
          FramerIcon: $i,
          Frown: en,
          FrownIcon: en,
          Fuel: an,
          FuelIcon: an,
          Fullscreen: tn,
          FullscreenIcon: tn,
          FunctionSquare: cn,
          FunctionSquareIcon: cn,
          GalleryHorizontal: dn,
          GalleryHorizontalEnd: hn,
          GalleryHorizontalEndIcon: hn,
          GalleryHorizontalIcon: dn,
          GalleryThumbnails: on,
          GalleryThumbnailsIcon: on,
          GalleryVertical: nn,
          GalleryVerticalEnd: yn,
          GalleryVerticalEndIcon: yn,
          GalleryVerticalIcon: nn,
          Gamepad: kn,
          Gamepad2: rn,
          Gamepad2Icon: rn,
          GamepadIcon: kn,
          GanttChart: pn,
          GanttChartIcon: pn,
          GanttChartSquare: v,
          GanttChartSquareIcon: v,
          GanttSquare: v,
          GanttSquareIcon: v,
          Gauge: sn,
          GaugeCircle: ln,
          GaugeCircleIcon: ln,
          GaugeIcon: sn,
          Gavel: un,
          GavelIcon: un,
          Gem: Mn,
          GemIcon: Mn,
          Ghost: vn,
          GhostIcon: vn,
          Gift: mn,
          GiftIcon: mn,
          GitBranch: gn,
          GitBranchIcon: gn,
          GitBranchPlus: xn,
          GitBranchPlusIcon: xn,
          GitCommit: h1,
          GitCommitHorizontal: h1,
          GitCommitHorizontalIcon: h1,
          GitCommitIcon: h1,
          GitCommitVertical: Ln,
          GitCommitVerticalIcon: Ln,
          GitCompare: wn,
          GitCompareArrows: fn,
          GitCompareArrowsIcon: fn,
          GitCompareIcon: wn,
          GitFork: In,
          GitForkIcon: In,
          GitGraph: Cn,
          GitGraphIcon: Cn,
          GitMerge: bn,
          GitMergeIcon: bn,
          GitPullRequest: jn,
          GitPullRequestArrow: Sn,
          GitPullRequestArrowIcon: Sn,
          GitPullRequestClosed: qn,
          GitPullRequestClosedIcon: qn,
          GitPullRequestCreate: zn,
          GitPullRequestCreateArrow: Hn,
          GitPullRequestCreateArrowIcon: Hn,
          GitPullRequestCreateIcon: zn,
          GitPullRequestDraft: An,
          GitPullRequestDraftIcon: An,
          GitPullRequestIcon: jn,
          Github: Vn,
          GithubIcon: Vn,
          Gitlab: Pn,
          GitlabIcon: Pn,
          GlassWater: Fn,
          GlassWaterIcon: Fn,
          Glasses: Bn,
          GlassesIcon: Bn,
          Globe: Rn,
          Globe2: J,
          Globe2Icon: J,
          GlobeIcon: Rn,
          GlobeLock: Dn,
          GlobeLockIcon: Dn,
          Goal: Tn,
          GoalIcon: Tn,
          Grab: Un,
          GrabIcon: Un,
          GraduationCap: Zn,
          GraduationCapIcon: Zn,
          Grape: On,
          GrapeIcon: On,
          Grid: m,
          Grid2X2: d1,
          Grid2X2Icon: d1,
          Grid2x2: d1,
          Grid2x2Icon: d1,
          Grid3X3: m,
          Grid3X3Icon: m,
          Grid3x3: m,
          Grid3x3Icon: m,
          GridIcon: m,
          Grip: Wn,
          GripHorizontal: Gn,
          GripHorizontalIcon: Gn,
          GripIcon: Wn,
          GripVertical: En,
          GripVerticalIcon: En,
          Group: Nn,
          GroupIcon: Nn,
          Guitar: Xn,
          GuitarIcon: Xn,
          Hammer: Kn,
          HammerIcon: Kn,
          Hand: $n,
          HandCoins: _n,
          HandCoinsIcon: _n,
          HandHeart: Jn,
          HandHeartIcon: Jn,
          HandHelping: o1,
          HandHelpingIcon: o1,
          HandIcon: $n,
          HandMetal: Qn,
          HandMetalIcon: Qn,
          HandPlatter: Yn,
          HandPlatterIcon: Yn,
          Handshake: er,
          HandshakeIcon: er,
          HardDrive: cr,
          HardDriveDownload: ar,
          HardDriveDownloadIcon: ar,
          HardDriveIcon: cr,
          HardDriveUpload: tr,
          HardDriveUploadIcon: tr,
          HardHat: hr,
          HardHatIcon: hr,
          Hash: dr,
          HashIcon: dr,
          Haze: or,
          HazeIcon: or,
          HdmiPort: yr,
          HdmiPortIcon: yr,
          Heading: sr,
          Heading1: ir,
          Heading1Icon: ir,
          Heading2: nr,
          Heading2Icon: nr,
          Heading3: rr,
          Heading3Icon: rr,
          Heading4: kr,
          Heading4Icon: kr,
          Heading5: pr,
          Heading5Icon: pr,
          Heading6: lr,
          Heading6Icon: lr,
          HeadingIcon: sr,
          Headphones: ur,
          HeadphonesIcon: ur,
          Headset: Mr,
          HeadsetIcon: Mr,
          Heart: Lr,
          HeartCrack: vr,
          HeartCrackIcon: vr,
          HeartHandshake: mr,
          HeartHandshakeIcon: mr,
          HeartIcon: Lr,
          HeartOff: xr,
          HeartOffIcon: xr,
          HeartPulse: gr,
          HeartPulseIcon: gr,
          Heater: fr,
          HeaterIcon: fr,
          HelpCircle: wr,
          HelpCircleIcon: wr,
          HelpingHand: o1,
          HelpingHandIcon: o1,
          Hexagon: Ir,
          HexagonIcon: Ir,
          Highlighter: Cr,
          HighlighterIcon: Cr,
          History: br,
          HistoryIcon: br,
          Home: Sr,
          HomeIcon: Sr,
          Hop: Hr,
          HopIcon: Hr,
          HopOff: qr,
          HopOffIcon: qr,
          Hotel: zr,
          HotelIcon: zr,
          Hourglass: Ar,
          HourglassIcon: Ar,
          IceCream: Vr,
          IceCream2: jr,
          IceCream2Icon: jr,
          IceCreamIcon: Vr,
          Image: Tr,
          ImageDown: Pr,
          ImageDownIcon: Pr,
          ImageIcon: Tr,
          ImageMinus: Fr,
          ImageMinusIcon: Fr,
          ImageOff: Br,
          ImageOffIcon: Br,
          ImagePlus: Dr,
          ImagePlusIcon: Dr,
          ImageUp: Rr,
          ImageUpIcon: Rr,
          Images: Ur,
          ImagesIcon: Ur,
          Import: Zr,
          ImportIcon: Zr,
          Inbox: Or,
          InboxIcon: Or,
          Indent: Gr,
          IndentIcon: Gr,
          IndianRupee: Er,
          IndianRupeeIcon: Er,
          Infinity: Wr,
          InfinityIcon: Wr,
          Info: Nr,
          InfoIcon: Nr,
          Inspect: n1,
          InspectIcon: n1,
          InspectionPanel: Xr,
          InspectionPanelIcon: Xr,
          Instagram: Kr,
          InstagramIcon: Kr,
          Italic: _r,
          ItalicIcon: _r,
          IterationCcw: Jr,
          IterationCcwIcon: Jr,
          IterationCw: Qr,
          IterationCwIcon: Qr,
          JapaneseYen: Yr,
          JapaneseYenIcon: Yr,
          Joystick: $r,
          JoystickIcon: $r,
          Kanban: ek,
          KanbanIcon: ek,
          KanbanSquare: i1,
          KanbanSquareDashed: y1,
          KanbanSquareDashedIcon: y1,
          KanbanSquareIcon: i1,
          Key: ck,
          KeyIcon: ck,
          KeyRound: ak,
          KeyRoundIcon: ak,
          KeySquare: tk,
          KeySquareIcon: tk,
          Keyboard: dk,
          KeyboardIcon: dk,
          KeyboardMusic: hk,
          KeyboardMusicIcon: hk,
          Lamp: kk,
          LampCeiling: ok,
          LampCeilingIcon: ok,
          LampDesk: yk,
          LampDeskIcon: yk,
          LampFloor: ik,
          LampFloorIcon: ik,
          LampIcon: kk,
          LampWallDown: nk,
          LampWallDownIcon: nk,
          LampWallUp: rk,
          LampWallUpIcon: rk,
          LandPlot: pk,
          LandPlotIcon: pk,
          Landmark: lk,
          LandmarkIcon: lk,
          Languages: sk,
          LanguagesIcon: sk,
          Laptop: Mk,
          Laptop2: uk,
          Laptop2Icon: uk,
          LaptopIcon: Mk,
          Lasso: mk,
          LassoIcon: mk,
          LassoSelect: vk,
          LassoSelectIcon: vk,
          Laugh: xk,
          LaughIcon: xk,
          Layers: fk,
          Layers2: gk,
          Layers2Icon: gk,
          Layers3: Lk,
          Layers3Icon: Lk,
          LayersIcon: fk,
          Layout: m1,
          LayoutDashboard: wk,
          LayoutDashboardIcon: wk,
          LayoutGrid: Ik,
          LayoutGridIcon: Ik,
          LayoutIcon: m1,
          LayoutList: Ck,
          LayoutListIcon: Ck,
          LayoutPanelLeft: bk,
          LayoutPanelLeftIcon: bk,
          LayoutPanelTop: Sk,
          LayoutPanelTopIcon: Sk,
          LayoutTemplate: qk,
          LayoutTemplateIcon: qk,
          Leaf: Hk,
          LeafIcon: Hk,
          LeafyGreen: zk,
          LeafyGreenIcon: zk,
          Library: Vk,
          LibraryBig: Ak,
          LibraryBigIcon: Ak,
          LibraryIcon: Vk,
          LibrarySquare: jk,
          LibrarySquareIcon: jk,
          LifeBuoy: Pk,
          LifeBuoyIcon: Pk,
          Ligature: Fk,
          LigatureIcon: Fk,
          Lightbulb: Dk,
          LightbulbIcon: Dk,
          LightbulbOff: Bk,
          LightbulbOffIcon: Bk,
          LineChart: Rk,
          LineChartIcon: Rk,
          Link: Zk,
          Link2: Uk,
          Link2Icon: Uk,
          Link2Off: Tk,
          Link2OffIcon: Tk,
          LinkIcon: Zk,
          Linkedin: Ok,
          LinkedinIcon: Ok,
          List: c4,
          ListChecks: Gk,
          ListChecksIcon: Gk,
          ListCollapse: Ek,
          ListCollapseIcon: Ek,
          ListEnd: Wk,
          ListEndIcon: Wk,
          ListFilter: Nk,
          ListFilterIcon: Nk,
          ListIcon: c4,
          ListMinus: Xk,
          ListMinusIcon: Xk,
          ListMusic: Kk,
          ListMusicIcon: Kk,
          ListOrdered: _k,
          ListOrderedIcon: _k,
          ListPlus: Jk,
          ListPlusIcon: Jk,
          ListRestart: Qk,
          ListRestartIcon: Qk,
          ListStart: Yk,
          ListStartIcon: Yk,
          ListTodo: $k,
          ListTodoIcon: $k,
          ListTree: e4,
          ListTreeIcon: e4,
          ListVideo: a4,
          ListVideoIcon: a4,
          ListX: t4,
          ListXIcon: t4,
          Loader: d4,
          Loader2: h4,
          Loader2Icon: h4,
          LoaderIcon: d4,
          Locate: i4,
          LocateFixed: o4,
          LocateFixedIcon: o4,
          LocateIcon: i4,
          LocateOff: y4,
          LocateOffIcon: y4,
          Lock: r4,
          LockIcon: r4,
          LockKeyhole: n4,
          LockKeyholeIcon: n4,
          LogIn: k4,
          LogInIcon: k4,
          LogOut: p4,
          LogOutIcon: p4,
          Lollipop: l4,
          LollipopIcon: l4,
          LucideAArrowDown: J1,
          LucideAArrowUp: Q1,
          LucideALargeSmall: Y1,
          LucideAccessibility: $1,
          LucideActivity: a2,
          LucideActivitySquare: e2,
          LucideAirVent: t2,
          LucideAirplay: c2,
          LucideAlarmCheck: I,
          LucideAlarmClock: d2,
          LucideAlarmClockCheck: I,
          LucideAlarmClockMinus: C,
          LucideAlarmClockOff: h2,
          LucideAlarmClockPlus: b,
          LucideAlarmMinus: C,
          LucideAlarmPlus: b,
          LucideAlarmSmoke: o2,
          LucideAlbum: y2,
          LucideAlertCircle: i2,
          LucideAlertOctagon: n2,
          LucideAlertTriangle: r2,
          LucideAlignCenter: l2,
          LucideAlignCenterHorizontal: k2,
          LucideAlignCenterVertical: p2,
          LucideAlignEndHorizontal: s2,
          LucideAlignEndVertical: u2,
          LucideAlignHorizontalDistributeCenter: M2,
          LucideAlignHorizontalDistributeEnd: v2,
          LucideAlignHorizontalDistributeStart: m2,
          LucideAlignHorizontalJustifyCenter: x2,
          LucideAlignHorizontalJustifyEnd: g2,
          LucideAlignHorizontalJustifyStart: L2,
          LucideAlignHorizontalSpaceAround: f2,
          LucideAlignHorizontalSpaceBetween: w2,
          LucideAlignJustify: I2,
          LucideAlignLeft: C2,
          LucideAlignRight: b2,
          LucideAlignStartHorizontal: S2,
          LucideAlignStartVertical: q2,
          LucideAlignVerticalDistributeCenter: H2,
          LucideAlignVerticalDistributeEnd: z2,
          LucideAlignVerticalDistributeStart: A2,
          LucideAlignVerticalJustifyCenter: j2,
          LucideAlignVerticalJustifyEnd: V2,
          LucideAlignVerticalJustifyStart: P2,
          LucideAlignVerticalSpaceAround: F2,
          LucideAlignVerticalSpaceBetween: B2,
          LucideAmbulance: D2,
          LucideAmpersand: R2,
          LucideAmpersands: T2,
          LucideAnchor: U2,
          LucideAngry: Z2,
          LucideAnnoyed: O2,
          LucideAntenna: G2,
          LucideAnvil: E2,
          LucideAperture: W2,
          LucideAppWindow: N2,
          LucideApple: X2,
          LucideArchive: J2,
          LucideArchiveRestore: K2,
          LucideArchiveX: _2,
          LucideAreaChart: Q2,
          LucideArmchair: Y2,
          LucideArrowBigDown: ee,
          LucideArrowBigDownDash: $2,
          LucideArrowBigLeft: te,
          LucideArrowBigLeftDash: ae,
          LucideArrowBigRight: he,
          LucideArrowBigRightDash: ce,
          LucideArrowBigUp: oe,
          LucideArrowBigUpDash: de,
          LucideArrowDown: Ie,
          LucideArrowDown01: ye,
          LucideArrowDown10: ie,
          LucideArrowDownAZ: S,
          LucideArrowDownAz: S,
          LucideArrowDownCircle: ne,
          LucideArrowDownFromLine: re,
          LucideArrowDownLeft: se,
          LucideArrowDownLeftFromCircle: ke,
          LucideArrowDownLeftFromSquare: pe,
          LucideArrowDownLeftSquare: le,
          LucideArrowDownNarrowWide: ue,
          LucideArrowDownRight: xe,
          LucideArrowDownRightFromCircle: Me,
          LucideArrowDownRightFromSquare: ve,
          LucideArrowDownRightSquare: me,
          LucideArrowDownSquare: ge,
          LucideArrowDownToDot: Le,
          LucideArrowDownToLine: fe,
          LucideArrowDownUp: we,
          LucideArrowDownWideNarrow: q,
          LucideArrowDownZA: H,
          LucideArrowDownZa: H,
          LucideArrowLeft: ze,
          LucideArrowLeftCircle: Ce,
          LucideArrowLeftFromLine: be,
          LucideArrowLeftRight: Se,
          LucideArrowLeftSquare: qe,
          LucideArrowLeftToLine: He,
          LucideArrowRight: G1,
          LucideArrowRightCircle: Ae,
          LucideArrowRightFromLine: je,
          LucideArrowRightLeft: Ve,
          LucideArrowRightSquare: Pe,
          LucideArrowRightToLine: Fe,
          LucideArrowUp: $e,
          LucideArrowUp01: Be,
          LucideArrowUp10: De,
          LucideArrowUpAZ: z,
          LucideArrowUpAz: z,
          LucideArrowUpCircle: Re,
          LucideArrowUpDown: Te,
          LucideArrowUpFromDot: Ue,
          LucideArrowUpFromLine: Ze,
          LucideArrowUpLeft: We,
          LucideArrowUpLeftFromCircle: Oe,
          LucideArrowUpLeftFromSquare: Ge,
          LucideArrowUpLeftSquare: Ee,
          LucideArrowUpNarrowWide: A,
          LucideArrowUpRight: _e,
          LucideArrowUpRightFromCircle: Ne,
          LucideArrowUpRightFromSquare: Xe,
          LucideArrowUpRightSquare: Ke,
          LucideArrowUpSquare: Je,
          LucideArrowUpToLine: Qe,
          LucideArrowUpWideNarrow: Ye,
          LucideArrowUpZA: j,
          LucideArrowUpZa: j,
          LucideArrowsUpFromLine: ea,
          LucideAsterisk: aa,
          LucideAsteriskSquare: V,
          LucideAtSign: ta,
          LucideAtom: ca,
          LucideAudioLines: ha,
          LucideAudioWaveform: da,
          LucideAward: oa,
          LucideAxe: ya,
          LucideAxis3D: P,
          LucideAxis3d: P,
          LucideBaby: ia,
          LucideBackpack: na,
          LucideBadge: Ca,
          LucideBadgeAlert: ra,
          LucideBadgeCent: ka,
          LucideBadgeCheck: F,
          LucideBadgeDollarSign: pa,
          LucideBadgeEuro: la,
          LucideBadgeHelp: sa,
          LucideBadgeIndianRupee: ua,
          LucideBadgeInfo: Ma,
          LucideBadgeJapaneseYen: va,
          LucideBadgeMinus: ma,
          LucideBadgePercent: xa,
          LucideBadgePlus: ga,
          LucideBadgePoundSterling: La,
          LucideBadgeRussianRuble: fa,
          LucideBadgeSwissFranc: wa,
          LucideBadgeX: Ia,
          LucideBaggageClaim: ba,
          LucideBan: Sa,
          LucideBanana: qa,
          LucideBanknote: Ha,
          LucideBarChart: Ba,
          LucideBarChart2: za,
          LucideBarChart3: Aa,
          LucideBarChart4: ja,
          LucideBarChartBig: Va,
          LucideBarChartHorizontal: Fa,
          LucideBarChartHorizontalBig: Pa,
          LucideBarcode: Da,
          LucideBaseline: Ra,
          LucideBath: Ta,
          LucideBattery: Wa,
          LucideBatteryCharging: Ua,
          LucideBatteryFull: Za,
          LucideBatteryLow: Oa,
          LucideBatteryMedium: Ga,
          LucideBatteryWarning: Ea,
          LucideBeaker: Na,
          LucideBean: Ka,
          LucideBeanOff: Xa,
          LucideBed: Qa,
          LucideBedDouble: _a,
          LucideBedSingle: Ja,
          LucideBeef: Ya,
          LucideBeer: $a,
          LucideBell: o0,
          LucideBellDot: e0,
          LucideBellElectric: a0,
          LucideBellMinus: t0,
          LucideBellOff: c0,
          LucideBellPlus: h0,
          LucideBellRing: d0,
          LucideBetweenHorizonalEnd: B,
          LucideBetweenHorizonalStart: D,
          LucideBetweenHorizontalEnd: B,
          LucideBetweenHorizontalStart: D,
          LucideBetweenVerticalEnd: y0,
          LucideBetweenVerticalStart: i0,
          LucideBike: n0,
          LucideBinary: r0,
          LucideBiohazard: k0,
          LucideBird: p0,
          LucideBitcoin: l0,
          LucideBlend: s0,
          LucideBlinds: u0,
          LucideBlocks: M0,
          LucideBluetooth: g0,
          LucideBluetoothConnected: v0,
          LucideBluetoothOff: m0,
          LucideBluetoothSearching: x0,
          LucideBold: L0,
          LucideBolt: f0,
          LucideBomb: w0,
          LucideBone: I0,
          LucideBook: X0,
          LucideBookA: C0,
          LucideBookAudio: b0,
          LucideBookCheck: S0,
          LucideBookCopy: q0,
          LucideBookDashed: R,
          LucideBookDown: H0,
          LucideBookHeadphones: z0,
          LucideBookHeart: A0,
          LucideBookImage: j0,
          LucideBookKey: V0,
          LucideBookLock: P0,
          LucideBookMarked: F0,
          LucideBookMinus: B0,
          LucideBookOpen: T0,
          LucideBookOpenCheck: D0,
          LucideBookOpenText: R0,
          LucideBookPlus: U0,
          LucideBookTemplate: R,
          LucideBookText: Z0,
          LucideBookType: O0,
          LucideBookUp: E0,
          LucideBookUp2: G0,
          LucideBookUser: W0,
          LucideBookX: N0,
          LucideBookmark: Y0,
          LucideBookmarkCheck: K0,
          LucideBookmarkMinus: _0,
          LucideBookmarkPlus: J0,
          LucideBookmarkX: Q0,
          LucideBoomBox: $0,
          LucideBot: at,
          LucideBotMessageSquare: et,
          LucideBox: ct,
          LucideBoxSelect: tt,
          LucideBoxes: ht,
          LucideBraces: T,
          LucideBrackets: dt,
          LucideBrain: it,
          LucideBrainCircuit: ot,
          LucideBrainCog: yt,
          LucideBrickWall: nt,
          LucideBriefcase: rt,
          LucideBringToFront: kt,
          LucideBrush: pt,
          LucideBug: ut,
          LucideBugOff: lt,
          LucideBugPlay: st,
          LucideBuilding: vt,
          LucideBuilding2: Mt,
          LucideBus: xt,
          LucideBusFront: mt,
          LucideCable: Lt,
          LucideCableCar: gt,
          LucideCake: wt,
          LucideCakeSlice: ft,
          LucideCalculator: It,
          LucideCalendar: Ut,
          LucideCalendarCheck: bt,
          LucideCalendarCheck2: Ct,
          LucideCalendarClock: St,
          LucideCalendarDays: qt,
          LucideCalendarFold: Ht,
          LucideCalendarHeart: zt,
          LucideCalendarMinus: jt,
          LucideCalendarMinus2: At,
          LucideCalendarOff: Vt,
          LucideCalendarPlus: Ft,
          LucideCalendarPlus2: Pt,
          LucideCalendarRange: Bt,
          LucideCalendarSearch: Dt,
          LucideCalendarX: Tt,
          LucideCalendarX2: Rt,
          LucideCamera: Ot,
          LucideCameraOff: Zt,
          LucideCandlestickChart: Gt,
          LucideCandy: Nt,
          LucideCandyCane: Et,
          LucideCandyOff: Wt,
          LucideCaptions: U,
          LucideCaptionsOff: Xt,
          LucideCar: Jt,
          LucideCarFront: Kt,
          LucideCarTaxiFront: _t,
          LucideCaravan: Qt,
          LucideCarrot: Yt,
          LucideCaseLower: $t,
          LucideCaseSensitive: ec,
          LucideCaseUpper: ac,
          LucideCassetteTape: tc,
          LucideCast: cc,
          LucideCastle: hc,
          LucideCat: dc,
          LucideCctv: oc,
          LucideCheck: kc,
          LucideCheckCheck: yc,
          LucideCheckCircle: Z1,
          LucideCheckCircle2: ic,
          LucideCheckSquare: rc,
          LucideCheckSquare2: nc,
          LucideChefHat: pc,
          LucideCherry: lc,
          LucideChevronDown: Mc,
          LucideChevronDownCircle: sc,
          LucideChevronDownSquare: uc,
          LucideChevronFirst: vc,
          LucideChevronLast: mc,
          LucideChevronLeft: Lc,
          LucideChevronLeftCircle: xc,
          LucideChevronLeftSquare: gc,
          LucideChevronRight: Ic,
          LucideChevronRightCircle: fc,
          LucideChevronRightSquare: wc,
          LucideChevronUp: Sc,
          LucideChevronUpCircle: Cc,
          LucideChevronUpSquare: bc,
          LucideChevronsDown: Hc,
          LucideChevronsDownUp: qc,
          LucideChevronsLeft: Ac,
          LucideChevronsLeftRight: zc,
          LucideChevronsRight: Vc,
          LucideChevronsRightLeft: jc,
          LucideChevronsUp: Fc,
          LucideChevronsUpDown: Pc,
          LucideChrome: Bc,
          LucideChurch: Dc,
          LucideCigarette: Tc,
          LucideCigaretteOff: Rc,
          LucideCircle: _c,
          LucideCircleDashed: Uc,
          LucideCircleDollarSign: Zc,
          LucideCircleDot: Gc,
          LucideCircleDotDashed: Oc,
          LucideCircleEllipsis: Ec,
          LucideCircleEqual: Wc,
          LucideCircleFadingPlus: Nc,
          LucideCircleOff: Xc,
          LucideCircleSlash: Kc,
          LucideCircleSlash2: Z,
          LucideCircleSlashed: Z,
          LucideCircleUser: G,
          LucideCircleUserRound: O,
          LucideCircuitBoard: Jc,
          LucideCitrus: Qc,
          LucideClapperboard: Yc,
          LucideClipboard: yh,
          LucideClipboardCheck: $c,
          LucideClipboardCopy: eh,
          LucideClipboardEdit: W,
          LucideClipboardList: ah,
          LucideClipboardMinus: th,
          LucideClipboardPaste: ch,
          LucideClipboardPen: W,
          LucideClipboardPenLine: E,
          LucideClipboardPlus: hh,
          LucideClipboardSignature: E,
          LucideClipboardType: dh,
          LucideClipboardX: oh,
          LucideClock: gh,
          LucideClock1: ih,
          LucideClock10: nh,
          LucideClock11: rh,
          LucideClock12: kh,
          LucideClock2: ph,
          LucideClock3: lh,
          LucideClock4: sh,
          LucideClock5: uh,
          LucideClock6: Mh,
          LucideClock7: vh,
          LucideClock8: mh,
          LucideClock9: xh,
          LucideCloud: Ph,
          LucideCloudCog: Lh,
          LucideCloudDrizzle: fh,
          LucideCloudFog: wh,
          LucideCloudHail: Ih,
          LucideCloudLightning: Ch,
          LucideCloudMoon: Sh,
          LucideCloudMoonRain: bh,
          LucideCloudOff: qh,
          LucideCloudRain: zh,
          LucideCloudRainWind: Hh,
          LucideCloudSnow: Ah,
          LucideCloudSun: Vh,
          LucideCloudSunRain: jh,
          LucideCloudy: Fh,
          LucideClover: Bh,
          LucideClub: Dh,
          LucideCode: Th,
          LucideCode2: Rh,
          LucideCodeSquare: N,
          LucideCodepen: Uh,
          LucideCodesandbox: Zh,
          LucideCoffee: Oh,
          LucideCog: Gh,
          LucideCoins: Eh,
          LucideColumns: X,
          LucideColumns2: X,
          LucideColumns3: K,
          LucideColumns4: Wh,
          LucideCombine: Nh,
          LucideCommand: Xh,
          LucideCompass: Kh,
          LucideComponent: _h,
          LucideComputer: Jh,
          LucideConciergeBell: Qh,
          LucideCone: Yh,
          LucideConstruction: $h,
          LucideContact: ad,
          LucideContact2: ed,
          LucideContainer: td,
          LucideContrast: cd,
          LucideCookie: hd,
          LucideCookingPot: dd,
          LucideCopy: kd,
          LucideCopyCheck: od,
          LucideCopyMinus: yd,
          LucideCopyPlus: id,
          LucideCopySlash: nd,
          LucideCopyX: rd,
          LucideCopyleft: pd,
          LucideCopyright: ld,
          LucideCornerDownLeft: sd,
          LucideCornerDownRight: ud,
          LucideCornerLeftDown: Md,
          LucideCornerLeftUp: vd,
          LucideCornerRightDown: md,
          LucideCornerRightUp: xd,
          LucideCornerUpLeft: gd,
          LucideCornerUpRight: Ld,
          LucideCpu: fd,
          LucideCreativeCommons: wd,
          LucideCreditCard: Id,
          LucideCroissant: Cd,
          LucideCrop: bd,
          LucideCross: Sd,
          LucideCrosshair: qd,
          LucideCrown: Hd,
          LucideCuboid: zd,
          LucideCupSoda: Ad,
          LucideCurlyBraces: T,
          LucideCurrency: jd,
          LucideCylinder: Vd,
          LucideDatabase: Bd,
          LucideDatabaseBackup: Pd,
          LucideDatabaseZap: Fd,
          LucideDelete: Dd,
          LucideDessert: Rd,
          LucideDiameter: Td,
          LucideDiamond: Ud,
          LucideDice1: Zd,
          LucideDice2: Od,
          LucideDice3: Gd,
          LucideDice4: Ed,
          LucideDice5: Wd,
          LucideDice6: Nd,
          LucideDices: Xd,
          LucideDiff: Kd,
          LucideDisc: Yd,
          LucideDisc2: _d,
          LucideDisc3: Jd,
          LucideDiscAlbum: Qd,
          LucideDivide: ao,
          LucideDivideCircle: $d,
          LucideDivideSquare: eo,
          LucideDna: co,
          LucideDnaOff: to,
          LucideDog: ho,
          LucideDollarSign: oo,
          LucideDonut: yo,
          LucideDoorClosed: io,
          LucideDoorOpen: no,
          LucideDot: ro,
          LucideDotSquare: _,
          LucideDownload: po,
          LucideDownloadCloud: ko,
          LucideDraftingCompass: lo,
          LucideDrama: so,
          LucideDribbble: uo,
          LucideDrill: Mo,
          LucideDroplet: vo,
          LucideDroplets: mo,
          LucideDrum: xo,
          LucideDrumstick: go,
          LucideDumbbell: Lo,
          LucideEar: wo,
          LucideEarOff: fo,
          LucideEarth: J,
          LucideEarthLock: Io,
          LucideEclipse: Co,
          LucideEdit: k,
          LucideEdit2: g1,
          LucideEdit3: x1,
          LucideEgg: qo,
          LucideEggFried: bo,
          LucideEggOff: So,
          LucideEqual: zo,
          LucideEqualNot: Ho,
          LucideEqualSquare: Q,
          LucideEraser: Ao,
          LucideEuro: jo,
          LucideExpand: Vo,
          LucideExternalLink: Po,
          LucideEye: Bo,
          LucideEyeOff: Fo,
          LucideFacebook: Do,
          LucideFactory: Ro,
          LucideFan: To,
          LucideFastForward: Uo,
          LucideFeather: Zo,
          LucideFence: Oo,
          LucideFerrisWheel: Go,
          LucideFigma: Eo,
          LucideFile: Ey,
          LucideFileArchive: Wo,
          LucideFileAudio: Xo,
          LucideFileAudio2: No,
          LucideFileAxis3D: Y,
          LucideFileAxis3d: Y,
          LucideFileBadge: _o,
          LucideFileBadge2: Ko,
          LucideFileBarChart: Qo,
          LucideFileBarChart2: Jo,
          LucideFileBox: Yo,
          LucideFileCheck: ey,
          LucideFileCheck2: $o,
          LucideFileClock: ay,
          LucideFileCode: cy,
          LucideFileCode2: ty,
          LucideFileCog: $,
          LucideFileCog2: $,
          LucideFileDiff: hy,
          LucideFileDigit: dy,
          LucideFileDown: oy,
          LucideFileEdit: a1,
          LucideFileHeart: yy,
          LucideFileImage: iy,
          LucideFileInput: ny,
          LucideFileJson: ky,
          LucideFileJson2: ry,
          LucideFileKey: ly,
          LucideFileKey2: py,
          LucideFileLineChart: sy,
          LucideFileLock: My,
          LucideFileLock2: uy,
          LucideFileMinus: my,
          LucideFileMinus2: vy,
          LucideFileMusic: xy,
          LucideFileOutput: gy,
          LucideFilePen: a1,
          LucideFilePenLine: e1,
          LucideFilePieChart: Ly,
          LucideFilePlus: wy,
          LucideFilePlus2: fy,
          LucideFileQuestion: Iy,
          LucideFileScan: Cy,
          LucideFileSearch: Sy,
          LucideFileSearch2: by,
          LucideFileSignature: e1,
          LucideFileSliders: qy,
          LucideFileSpreadsheet: Hy,
          LucideFileStack: zy,
          LucideFileSymlink: Ay,
          LucideFileTerminal: jy,
          LucideFileText: Vy,
          LucideFileType: Fy,
          LucideFileType2: Py,
          LucideFileUp: By,
          LucideFileVideo: Ry,
          LucideFileVideo2: Dy,
          LucideFileVolume: Uy,
          LucideFileVolume2: Ty,
          LucideFileWarning: Zy,
          LucideFileX: Gy,
          LucideFileX2: Oy,
          LucideFiles: Wy,
          LucideFilm: Ny,
          LucideFilter: Ky,
          LucideFilterX: Xy,
          LucideFingerprint: _y,
          LucideFireExtinguisher: Jy,
          LucideFish: $y,
          LucideFishOff: Qy,
          LucideFishSymbol: Yy,
          LucideFlag: ci,
          LucideFlagOff: ei,
          LucideFlagTriangleLeft: ai,
          LucideFlagTriangleRight: ti,
          LucideFlame: di,
          LucideFlameKindling: hi,
          LucideFlashlight: yi,
          LucideFlashlightOff: oi,
          LucideFlaskConical: ni,
          LucideFlaskConicalOff: ii,
          LucideFlaskRound: ri,
          LucideFlipHorizontal: pi,
          LucideFlipHorizontal2: ki,
          LucideFlipVertical: si,
          LucideFlipVertical2: li,
          LucideFlower: Mi,
          LucideFlower2: ui,
          LucideFocus: vi,
          LucideFoldHorizontal: mi,
          LucideFoldVertical: xi,
          LucideFolder: Ni,
          LucideFolderArchive: gi,
          LucideFolderCheck: Li,
          LucideFolderClock: fi,
          LucideFolderClosed: wi,
          LucideFolderCog: t1,
          LucideFolderCog2: t1,
          LucideFolderDot: Ii,
          LucideFolderDown: Ci,
          LucideFolderEdit: c1,
          LucideFolderGit: Si,
          LucideFolderGit2: bi,
          LucideFolderHeart: qi,
          LucideFolderInput: Hi,
          LucideFolderKanban: zi,
          LucideFolderKey: Ai,
          LucideFolderLock: ji,
          LucideFolderMinus: Vi,
          LucideFolderOpen: Fi,
          LucideFolderOpenDot: Pi,
          LucideFolderOutput: Bi,
          LucideFolderPen: c1,
          LucideFolderPlus: Di,
          LucideFolderRoot: Ri,
          LucideFolderSearch: Ui,
          LucideFolderSearch2: Ti,
          LucideFolderSymlink: Zi,
          LucideFolderSync: Oi,
          LucideFolderTree: Gi,
          LucideFolderUp: Ei,
          LucideFolderX: Wi,
          LucideFolders: Xi,
          LucideFootprints: Ki,
          LucideForklift: _i,
          LucideFormInput: Ji,
          LucideForward: Qi,
          LucideFrame: Yi,
          LucideFramer: $i,
          LucideFrown: en,
          LucideFuel: an,
          LucideFullscreen: tn,
          LucideFunctionSquare: cn,
          LucideGalleryHorizontal: dn,
          LucideGalleryHorizontalEnd: hn,
          LucideGalleryThumbnails: on,
          LucideGalleryVertical: nn,
          LucideGalleryVerticalEnd: yn,
          LucideGamepad: kn,
          LucideGamepad2: rn,
          LucideGanttChart: pn,
          LucideGanttChartSquare: v,
          LucideGanttSquare: v,
          LucideGauge: sn,
          LucideGaugeCircle: ln,
          LucideGavel: un,
          LucideGem: Mn,
          LucideGhost: vn,
          LucideGift: mn,
          LucideGitBranch: gn,
          LucideGitBranchPlus: xn,
          LucideGitCommit: h1,
          LucideGitCommitHorizontal: h1,
          LucideGitCommitVertical: Ln,
          LucideGitCompare: wn,
          LucideGitCompareArrows: fn,
          LucideGitFork: In,
          LucideGitGraph: Cn,
          LucideGitMerge: bn,
          LucideGitPullRequest: jn,
          LucideGitPullRequestArrow: Sn,
          LucideGitPullRequestClosed: qn,
          LucideGitPullRequestCreate: zn,
          LucideGitPullRequestCreateArrow: Hn,
          LucideGitPullRequestDraft: An,
          LucideGithub: Vn,
          LucideGitlab: Pn,
          LucideGlassWater: Fn,
          LucideGlasses: Bn,
          LucideGlobe: Rn,
          LucideGlobe2: J,
          LucideGlobeLock: Dn,
          LucideGoal: Tn,
          LucideGrab: Un,
          LucideGraduationCap: Zn,
          LucideGrape: On,
          LucideGrid: m,
          LucideGrid2X2: d1,
          LucideGrid2x2: d1,
          LucideGrid3X3: m,
          LucideGrid3x3: m,
          LucideGrip: Wn,
          LucideGripHorizontal: Gn,
          LucideGripVertical: En,
          LucideGroup: Nn,
          LucideGuitar: Xn,
          LucideHammer: Kn,
          LucideHand: $n,
          LucideHandCoins: _n,
          LucideHandHeart: Jn,
          LucideHandHelping: o1,
          LucideHandMetal: Qn,
          LucideHandPlatter: Yn,
          LucideHandshake: er,
          LucideHardDrive: cr,
          LucideHardDriveDownload: ar,
          LucideHardDriveUpload: tr,
          LucideHardHat: hr,
          LucideHash: dr,
          LucideHaze: or,
          LucideHdmiPort: yr,
          LucideHeading: sr,
          LucideHeading1: ir,
          LucideHeading2: nr,
          LucideHeading3: rr,
          LucideHeading4: kr,
          LucideHeading5: pr,
          LucideHeading6: lr,
          LucideHeadphones: ur,
          LucideHeadset: Mr,
          LucideHeart: Lr,
          LucideHeartCrack: vr,
          LucideHeartHandshake: mr,
          LucideHeartOff: xr,
          LucideHeartPulse: gr,
          LucideHeater: fr,
          LucideHelpCircle: wr,
          LucideHelpingHand: o1,
          LucideHexagon: Ir,
          LucideHighlighter: Cr,
          LucideHistory: br,
          LucideHome: Sr,
          LucideHop: Hr,
          LucideHopOff: qr,
          LucideHotel: zr,
          LucideHourglass: Ar,
          LucideIceCream: Vr,
          LucideIceCream2: jr,
          LucideImage: Tr,
          LucideImageDown: Pr,
          LucideImageMinus: Fr,
          LucideImageOff: Br,
          LucideImagePlus: Dr,
          LucideImageUp: Rr,
          LucideImages: Ur,
          LucideImport: Zr,
          LucideInbox: Or,
          LucideIndent: Gr,
          LucideIndianRupee: Er,
          LucideInfinity: Wr,
          LucideInfo: Nr,
          LucideInspect: n1,
          LucideInspectionPanel: Xr,
          LucideInstagram: Kr,
          LucideItalic: _r,
          LucideIterationCcw: Jr,
          LucideIterationCw: Qr,
          LucideJapaneseYen: Yr,
          LucideJoystick: $r,
          LucideKanban: ek,
          LucideKanbanSquare: i1,
          LucideKanbanSquareDashed: y1,
          LucideKey: ck,
          LucideKeyRound: ak,
          LucideKeySquare: tk,
          LucideKeyboard: dk,
          LucideKeyboardMusic: hk,
          LucideLamp: kk,
          LucideLampCeiling: ok,
          LucideLampDesk: yk,
          LucideLampFloor: ik,
          LucideLampWallDown: nk,
          LucideLampWallUp: rk,
          LucideLandPlot: pk,
          LucideLandmark: lk,
          LucideLanguages: sk,
          LucideLaptop: Mk,
          LucideLaptop2: uk,
          LucideLasso: mk,
          LucideLassoSelect: vk,
          LucideLaugh: xk,
          LucideLayers: fk,
          LucideLayers2: gk,
          LucideLayers3: Lk,
          LucideLayout: m1,
          LucideLayoutDashboard: wk,
          LucideLayoutGrid: Ik,
          LucideLayoutList: Ck,
          LucideLayoutPanelLeft: bk,
          LucideLayoutPanelTop: Sk,
          LucideLayoutTemplate: qk,
          LucideLeaf: Hk,
          LucideLeafyGreen: zk,
          LucideLibrary: Vk,
          LucideLibraryBig: Ak,
          LucideLibrarySquare: jk,
          LucideLifeBuoy: Pk,
          LucideLigature: Fk,
          LucideLightbulb: Dk,
          LucideLightbulbOff: Bk,
          LucideLineChart: Rk,
          LucideLink: Zk,
          LucideLink2: Uk,
          LucideLink2Off: Tk,
          LucideLinkedin: Ok,
          LucideList: c4,
          LucideListChecks: Gk,
          LucideListCollapse: Ek,
          LucideListEnd: Wk,
          LucideListFilter: Nk,
          LucideListMinus: Xk,
          LucideListMusic: Kk,
          LucideListOrdered: _k,
          LucideListPlus: Jk,
          LucideListRestart: Qk,
          LucideListStart: Yk,
          LucideListTodo: $k,
          LucideListTree: e4,
          LucideListVideo: a4,
          LucideListX: t4,
          LucideLoader: d4,
          LucideLoader2: h4,
          LucideLocate: i4,
          LucideLocateFixed: o4,
          LucideLocateOff: y4,
          LucideLock: r4,
          LucideLockKeyhole: n4,
          LucideLogIn: k4,
          LucideLogOut: p4,
          LucideLollipop: l4,
          LucideLuggage: s4,
          LucideMSquare: u4,
          LucideMagnet: M4,
          LucideMail: E1,
          LucideMailCheck: v4,
          LucideMailMinus: m4,
          LucideMailOpen: x4,
          LucideMailPlus: g4,
          LucideMailQuestion: L4,
          LucideMailSearch: f4,
          LucideMailWarning: w4,
          LucideMailX: I4,
          LucideMailbox: C4,
          LucideMails: b4,
          LucideMap: z4,
          LucideMapPin: q4,
          LucideMapPinOff: S4,
          LucideMapPinned: H4,
          LucideMartini: A4,
          LucideMaximize: V4,
          LucideMaximize2: j4,
          LucideMedal: P4,
          LucideMegaphone: B4,
          LucideMegaphoneOff: F4,
          LucideMeh: D4,
          LucideMemoryStick: R4,
          LucideMenu: U4,
          LucideMenuSquare: T4,
          LucideMerge: Z4,
          LucideMessageCircle: Y4,
          LucideMessageCircleCode: O4,
          LucideMessageCircleDashed: G4,
          LucideMessageCircleHeart: E4,
          LucideMessageCircleMore: W4,
          LucideMessageCircleOff: N4,
          LucideMessageCirclePlus: X4,
          LucideMessageCircleQuestion: K4,
          LucideMessageCircleReply: _4,
          LucideMessageCircleWarning: J4,
          LucideMessageCircleX: Q4,
          LucideMessageSquare: lp,
          LucideMessageSquareCode: $4,
          LucideMessageSquareDashed: ep,
          LucideMessageSquareDiff: ap,
          LucideMessageSquareDot: tp,
          LucideMessageSquareHeart: cp,
          LucideMessageSquareMore: hp,
          LucideMessageSquareOff: dp,
          LucideMessageSquarePlus: op,
          LucideMessageSquareQuote: yp,
          LucideMessageSquareReply: ip,
          LucideMessageSquareShare: np,
          LucideMessageSquareText: rp,
          LucideMessageSquareWarning: kp,
          LucideMessageSquareX: pp,
          LucideMessagesSquare: sp,
          LucideMic: vp,
          LucideMic2: up,
          LucideMicOff: Mp,
          LucideMicroscope: mp,
          LucideMicrowave: xp,
          LucideMilestone: gp,
          LucideMilk: fp,
          LucideMilkOff: Lp,
          LucideMinimize: Ip,
          LucideMinimize2: wp,
          LucideMinus: Sp,
          LucideMinusCircle: Cp,
          LucideMinusSquare: bp,
          LucideMonitor: Tp,
          LucideMonitorCheck: qp,
          LucideMonitorDot: Hp,
          LucideMonitorDown: zp,
          LucideMonitorOff: Ap,
          LucideMonitorPause: jp,
          LucideMonitorPlay: Vp,
          LucideMonitorSmartphone: Pp,
          LucideMonitorSpeaker: Fp,
          LucideMonitorStop: Bp,
          LucideMonitorUp: Dp,
          LucideMonitorX: Rp,
          LucideMoon: Zp,
          LucideMoonStar: Up,
          LucideMoreHorizontal: Op,
          LucideMoreVertical: Gp,
          LucideMountain: Wp,
          LucideMountainSnow: Ep,
          LucideMouse: Jp,
          LucideMousePointer: _p,
          LucideMousePointer2: Np,
          LucideMousePointerClick: Xp,
          LucideMousePointerSquare: n1,
          LucideMousePointerSquareDashed: Kp,
          LucideMove: nl,
          LucideMove3D: r1,
          LucideMove3d: r1,
          LucideMoveDiagonal: Yp,
          LucideMoveDiagonal2: Qp,
          LucideMoveDown: al,
          LucideMoveDownLeft: $p,
          LucideMoveDownRight: el,
          LucideMoveHorizontal: tl,
          LucideMoveLeft: cl,
          LucideMoveRight: hl,
          LucideMoveUp: yl,
          LucideMoveUpLeft: dl,
          LucideMoveUpRight: ol,
          LucideMoveVertical: il,
          LucideMusic: ll,
          LucideMusic2: rl,
          LucideMusic3: kl,
          LucideMusic4: pl,
          LucideNavigation: vl,
          LucideNavigation2: ul,
          LucideNavigation2Off: sl,
          LucideNavigationOff: Ml,
          LucideNetwork: ml,
          LucideNewspaper: xl,
          LucideNfc: gl,
          LucideNotebook: Il,
          LucideNotebookPen: Ll,
          LucideNotebookTabs: fl,
          LucideNotebookText: wl,
          LucideNotepadText: bl,
          LucideNotepadTextDashed: Cl,
          LucideNut: ql,
          LucideNutOff: Sl,
          LucideOctagon: Hl,
          LucideOption: zl,
          LucideOrbit: Al,
          LucideOutdent: jl,
          LucidePackage: Ul,
          LucidePackage2: Vl,
          LucidePackageCheck: Pl,
          LucidePackageMinus: Fl,
          LucidePackageOpen: Bl,
          LucidePackagePlus: Dl,
          LucidePackageSearch: Rl,
          LucidePackageX: Tl,
          LucidePaintBucket: Zl,
          LucidePaintRoller: Ol,
          LucidePaintbrush: El,
          LucidePaintbrush2: Gl,
          LucidePalette: Wl,
          LucidePalmtree: Nl,
          LucidePanelBottom: _l,
          LucidePanelBottomClose: Xl,
          LucidePanelBottomDashed: k1,
          LucidePanelBottomInactive: k1,
          LucidePanelBottomOpen: Kl,
          LucidePanelLeft: u1,
          LucidePanelLeftClose: p1,
          LucidePanelLeftDashed: l1,
          LucidePanelLeftInactive: l1,
          LucidePanelLeftOpen: s1,
          LucidePanelRight: Yl,
          LucidePanelRightClose: Jl,
          LucidePanelRightDashed: M1,
          LucidePanelRightInactive: M1,
          LucidePanelRightOpen: Ql,
          LucidePanelTop: a5,
          LucidePanelTopClose: $l,
          LucidePanelTopDashed: v1,
          LucidePanelTopInactive: v1,
          LucidePanelTopOpen: e5,
          LucidePanelsLeftBottom: t5,
          LucidePanelsLeftRight: K,
          LucidePanelsRightBottom: c5,
          LucidePanelsTopBottom: w1,
          LucidePanelsTopLeft: m1,
          LucidePaperclip: h5,
          LucideParentheses: d5,
          LucideParkingCircle: y5,
          LucideParkingCircleOff: o5,
          LucideParkingMeter: i5,
          LucideParkingSquare: r5,
          LucideParkingSquareOff: n5,
          LucidePartyPopper: k5,
          LucidePause: s5,
          LucidePauseCircle: p5,
          LucidePauseOctagon: l5,
          LucidePawPrint: u5,
          LucidePcCase: M5,
          LucidePen: g1,
          LucidePenBox: k,
          LucidePenLine: x1,
          LucidePenSquare: k,
          LucidePenTool: v5,
          LucidePencil: g5,
          LucidePencilLine: m5,
          LucidePencilRuler: x5,
          LucidePentagon: L5,
          LucidePercent: C5,
          LucidePercentCircle: f5,
          LucidePercentDiamond: w5,
          LucidePercentSquare: I5,
          LucidePersonStanding: b5,
          LucidePhone: V5,
          LucidePhoneCall: S5,
          LucidePhoneForwarded: q5,
          LucidePhoneIncoming: H5,
          LucidePhoneMissed: z5,
          LucidePhoneOff: A5,
          LucidePhoneOutgoing: j5,
          LucidePi: F5,
          LucidePiSquare: P5,
          LucidePiano: B5,
          LucidePickaxe: D5,
          LucidePictureInPicture: T5,
          LucidePictureInPicture2: R5,
          LucidePieChart: U5,
          LucidePiggyBank: Z5,
          LucidePilcrow: G5,
          LucidePilcrowSquare: O5,
          LucidePill: E5,
          LucidePin: N5,
          LucidePinOff: W5,
          LucidePipette: X5,
          LucidePizza: K5,
          LucidePlane: Q5,
          LucidePlaneLanding: _5,
          LucidePlaneTakeoff: J5,
          LucidePlay: e3,
          LucidePlayCircle: Y5,
          LucidePlaySquare: $5,
          LucidePlug: h3,
          LucidePlug2: a3,
          LucidePlugZap: c3,
          LucidePlugZap2: t3,
          LucidePlus: y3,
          LucidePlusCircle: d3,
          LucidePlusSquare: o3,
          LucidePocket: n3,
          LucidePocketKnife: i3,
          LucidePodcast: r3,
          LucidePointer: p3,
          LucidePointerOff: k3,
          LucidePopcorn: l3,
          LucidePopsicle: s3,
          LucidePoundSterling: u3,
          LucidePower: x3,
          LucidePowerCircle: M3,
          LucidePowerOff: v3,
          LucidePowerSquare: m3,
          LucidePresentation: g3,
          LucidePrinter: L3,
          LucideProjector: f3,
          LucidePuzzle: w3,
          LucidePyramid: I3,
          LucideQrCode: C3,
          LucideQuote: b3,
          LucideRabbit: S3,
          LucideRadar: q3,
          LucideRadiation: H3,
          LucideRadical: z3,
          LucideRadio: V3,
          LucideRadioReceiver: A3,
          LucideRadioTower: j3,
          LucideRadius: P3,
          LucideRailSymbol: F3,
          LucideRainbow: B3,
          LucideRat: D3,
          LucideRatio: R3,
          LucideReceipt: X3,
          LucideReceiptCent: T3,
          LucideReceiptEuro: U3,
          LucideReceiptIndianRupee: Z3,
          LucideReceiptJapaneseYen: O3,
          LucideReceiptPoundSterling: G3,
          LucideReceiptRussianRuble: E3,
          LucideReceiptSwissFranc: W3,
          LucideReceiptText: N3,
          LucideRectangleHorizontal: K3,
          LucideRectangleVertical: _3,
          LucideRecycle: J3,
          LucideRedo: $3,
          LucideRedo2: Q3,
          LucideRedoDot: Y3,
          LucideRefreshCcw: a6,
          LucideRefreshCcwDot: e6,
          LucideRefreshCw: c6,
          LucideRefreshCwOff: t6,
          LucideRefrigerator: h6,
          LucideRegex: d6,
          LucideRemoveFormatting: o6,
          LucideRepeat: n6,
          LucideRepeat1: y6,
          LucideRepeat2: i6,
          LucideReplace: k6,
          LucideReplaceAll: r6,
          LucideReply: l6,
          LucideReplyAll: p6,
          LucideRewind: s6,
          LucideRibbon: u6,
          LucideRocket: M6,
          LucideRockingChair: v6,
          LucideRollerCoaster: m6,
          LucideRotate3D: L1,
          LucideRotate3d: L1,
          LucideRotateCcw: W1,
          LucideRotateCw: x6,
          LucideRoute: L6,
          LucideRouteOff: g6,
          LucideRouter: f6,
          LucideRows: f1,
          LucideRows2: f1,
          LucideRows3: w1,
          LucideRows4: w6,
          LucideRss: I6,
          LucideRuler: C6,
          LucideRussianRuble: b6,
          LucideSailboat: S6,
          LucideSalad: q6,
          LucideSandwich: H6,
          LucideSatellite: A6,
          LucideSatelliteDish: z6,
          LucideSave: V6,
          LucideSaveAll: j6,
          LucideScale: P6,
          LucideScale3D: I1,
          LucideScale3d: I1,
          LucideScaling: F6,
          LucideScan: O6,
          LucideScanBarcode: B6,
          LucideScanEye: D6,
          LucideScanFace: R6,
          LucideScanLine: T6,
          LucideScanSearch: U6,
          LucideScanText: Z6,
          LucideScatterChart: G6,
          LucideSchool: W6,
          LucideSchool2: E6,
          LucideScissors: _6,
          LucideScissorsLineDashed: N6,
          LucideScissorsSquare: K6,
          LucideScissorsSquareDashedBottom: X6,
          LucideScreenShare: Q6,
          LucideScreenShareOff: J6,
          LucideScroll: $6,
          LucideScrollText: Y6,
          LucideSearch: hs,
          LucideSearchCheck: es,
          LucideSearchCode: as,
          LucideSearchSlash: ts,
          LucideSearchX: cs,
          LucideSend: os,
          LucideSendHorizonal: C1,
          LucideSendHorizontal: C1,
          LucideSendToBack: ds,
          LucideSeparatorHorizontal: ys,
          LucideSeparatorVertical: is,
          LucideServer: ps,
          LucideServerCog: ns,
          LucideServerCrash: rs,
          LucideServerOff: ks,
          LucideSettings: ss,
          LucideSettings2: ls,
          LucideShapes: us,
          LucideShare: vs,
          LucideShare2: Ms,
          LucideSheet: ms,
          LucideShell: xs,
          LucideShield: Hs,
          LucideShieldAlert: gs,
          LucideShieldBan: Ls,
          LucideShieldCheck: fs,
          LucideShieldClose: b1,
          LucideShieldEllipsis: ws,
          LucideShieldHalf: Is,
          LucideShieldMinus: Cs,
          LucideShieldOff: bs,
          LucideShieldPlus: Ss,
          LucideShieldQuestion: qs,
          LucideShieldX: b1,
          LucideShip: As,
          LucideShipWheel: zs,
          LucideShirt: js,
          LucideShoppingBag: Vs,
          LucideShoppingBasket: Ps,
          LucideShoppingCart: Fs,
          LucideShovel: Bs,
          LucideShowerHead: Ds,
          LucideShrink: Rs,
          LucideShrub: Ts,
          LucideShuffle: Us,
          LucideSidebar: u1,
          LucideSidebarClose: p1,
          LucideSidebarOpen: s1,
          LucideSigma: Os,
          LucideSigmaSquare: Zs,
          LucideSignal: Xs,
          LucideSignalHigh: Gs,
          LucideSignalLow: Es,
          LucideSignalMedium: Ws,
          LucideSignalZero: Ns,
          LucideSignpost: _s,
          LucideSignpostBig: Ks,
          LucideSiren: Js,
          LucideSkipBack: Qs,
          LucideSkipForward: Ys,
          LucideSkull: $s,
          LucideSlack: e8,
          LucideSlash: a8,
          LucideSlashSquare: S1,
          LucideSlice: t8,
          LucideSliders: h8,
          LucideSlidersHorizontal: c8,
          LucideSmartphone: y8,
          LucideSmartphoneCharging: d8,
          LucideSmartphoneNfc: o8,
          LucideSmile: n8,
          LucideSmilePlus: i8,
          LucideSnail: r8,
          LucideSnowflake: k8,
          LucideSofa: p8,
          LucideSortAsc: A,
          LucideSortDesc: q,
          LucideSoup: l8,
          LucideSpace: s8,
          LucideSpade: u8,
          LucideSparkle: M8,
          LucideSparkles: q1,
          LucideSpeaker: v8,
          LucideSpeech: m8,
          LucideSpellCheck: g8,
          LucideSpellCheck2: x8,
          LucideSpline: L8,
          LucideSplit: I8,
          LucideSplitSquareHorizontal: f8,
          LucideSplitSquareVertical: w8,
          LucideSprayCan: C8,
          LucideSprout: b8,
          LucideSquare: A8,
          LucideSquareAsterisk: V,
          LucideSquareCode: N,
          LucideSquareDashedBottom: q8,
          LucideSquareDashedBottomCode: S8,
          LucideSquareDot: _,
          LucideSquareEqual: Q,
          LucideSquareGantt: v,
          LucideSquareKanban: i1,
          LucideSquareKanbanDashed: y1,
          LucideSquarePen: k,
          LucideSquareRadical: H8,
          LucideSquareSlash: S1,
          LucideSquareStack: z8,
          LucideSquareUser: z1,
          LucideSquareUserRound: H1,
          LucideSquircle: j8,
          LucideSquirrel: V8,
          LucideStamp: P8,
          LucideStar: D8,
          LucideStarHalf: F8,
          LucideStarOff: B8,
          LucideStars: q1,
          LucideStepBack: R8,
          LucideStepForward: T8,
          LucideStethoscope: U8,
          LucideSticker: Z8,
          LucideStickyNote: O8,
          LucideStopCircle: G8,
          LucideStore: E8,
          LucideStretchHorizontal: W8,
          LucideStretchVertical: N8,
          LucideStrikethrough: X8,
          LucideSubscript: K8,
          LucideSubtitles: U,
          LucideSun: $8,
          LucideSunDim: _8,
          LucideSunMedium: J8,
          LucideSunMoon: Q8,
          LucideSunSnow: Y8,
          LucideSunrise: e7,
          LucideSunset: a7,
          LucideSuperscript: t7,
          LucideSwatchBook: c7,
          LucideSwissFranc: h7,
          LucideSwitchCamera: d7,
          LucideSword: o7,
          LucideSwords: y7,
          LucideSyringe: i7,
          LucideTable: u7,
          LucideTable2: n7,
          LucideTableCellsMerge: r7,
          LucideTableCellsSplit: k7,
          LucideTableColumnsSplit: p7,
          LucideTableProperties: l7,
          LucideTableRowsSplit: s7,
          LucideTablet: v7,
          LucideTabletSmartphone: M7,
          LucideTablets: m7,
          LucideTag: x7,
          LucideTags: g7,
          LucideTally1: L7,
          LucideTally2: f7,
          LucideTally3: w7,
          LucideTally4: I7,
          LucideTally5: C7,
          LucideTangent: b7,
          LucideTarget: S7,
          LucideTelescope: q7,
          LucideTent: z7,
          LucideTentTree: H7,
          LucideTerminal: j7,
          LucideTerminalSquare: A7,
          LucideTestTube: P7,
          LucideTestTube2: V7,
          LucideTestTubes: F7,
          LucideText: U7,
          LucideTextCursor: D7,
          LucideTextCursorInput: B7,
          LucideTextQuote: R7,
          LucideTextSearch: T7,
          LucideTextSelect: A1,
          LucideTextSelection: A1,
          LucideTheater: Z7,
          LucideThermometer: E7,
          LucideThermometerSnowflake: O7,
          LucideThermometerSun: G7,
          LucideThumbsDown: W7,
          LucideThumbsUp: N7,
          LucideTicket: $7,
          LucideTicketCheck: X7,
          LucideTicketMinus: K7,
          LucideTicketPercent: _7,
          LucideTicketPlus: J7,
          LucideTicketSlash: Q7,
          LucideTicketX: Y7,
          LucideTimer: tu,
          LucideTimerOff: eu,
          LucideTimerReset: au,
          LucideToggleLeft: cu,
          LucideToggleRight: hu,
          LucideTornado: du,
          LucideTorus: ou,
          LucideTouchpad: iu,
          LucideTouchpadOff: yu,
          LucideTowerControl: nu,
          LucideToyBrick: ru,
          LucideTractor: ku,
          LucideTrafficCone: pu,
          LucideTrain: j1,
          LucideTrainFront: su,
          LucideTrainFrontTunnel: lu,
          LucideTrainTrack: uu,
          LucideTramFront: j1,
          LucideTrash: vu,
          LucideTrash2: Mu,
          LucideTreeDeciduous: mu,
          LucideTreePine: xu,
          LucideTrees: gu,
          LucideTrello: Lu,
          LucideTrendingDown: fu,
          LucideTrendingUp: wu,
          LucideTriangle: Cu,
          LucideTriangleRight: Iu,
          LucideTrophy: bu,
          LucideTruck: Su,
          LucideTurtle: qu,
          LucideTv: zu,
          LucideTv2: Hu,
          LucideTwitch: Au,
          LucideTwitter: ju,
          LucideType: Vu,
          LucideUmbrella: Fu,
          LucideUmbrellaOff: Pu,
          LucideUnderline: Bu,
          LucideUndo: Tu,
          LucideUndo2: Du,
          LucideUndoDot: Ru,
          LucideUnfoldHorizontal: Uu,
          LucideUnfoldVertical: Zu,
          LucideUngroup: Ou,
          LucideUnlink: Eu,
          LucideUnlink2: Gu,
          LucideUnlock: Nu,
          LucideUnlockKeyhole: Wu,
          LucideUnplug: Xu,
          LucideUpload: _u,
          LucideUploadCloud: Ku,
          LucideUsb: Ju,
          LucideUser: h9,
          LucideUser2: R1,
          LucideUserCheck: Qu,
          LucideUserCheck2: V1,
          LucideUserCircle: G,
          LucideUserCircle2: O,
          LucideUserCog: Yu,
          LucideUserCog2: P1,
          LucideUserMinus: $u,
          LucideUserMinus2: F1,
          LucideUserPlus: e9,
          LucideUserPlus2: B1,
          LucideUserRound: R1,
          LucideUserRoundCheck: V1,
          LucideUserRoundCog: P1,
          LucideUserRoundMinus: F1,
          LucideUserRoundPlus: B1,
          LucideUserRoundSearch: a9,
          LucideUserRoundX: D1,
          LucideUserSearch: t9,
          LucideUserSquare: z1,
          LucideUserSquare2: H1,
          LucideUserX: c9,
          LucideUserX2: D1,
          LucideUsers: d9,
          LucideUsers2: T1,
          LucideUsersRound: T1,
          LucideUtensils: y9,
          LucideUtensilsCrossed: o9,
          LucideUtilityPole: i9,
          LucideVariable: n9,
          LucideVault: r9,
          LucideVegan: k9,
          LucideVenetianMask: p9,
          LucideVerified: F,
          LucideVibrate: s9,
          LucideVibrateOff: l9,
          LucideVideo: M9,
          LucideVideoOff: u9,
          LucideVideotape: v9,
          LucideView: m9,
          LucideVoicemail: x9,
          LucideVolume: w9,
          LucideVolume1: g9,
          LucideVolume2: L9,
          LucideVolumeX: f9,
          LucideVote: I9,
          LucideWallet: S9,
          LucideWallet2: C9,
          LucideWalletCards: b9,
          LucideWallpaper: q9,
          LucideWand: z9,
          LucideWand2: H9,
          LucideWarehouse: A9,
          LucideWashingMachine: j9,
          LucideWatch: V9,
          LucideWaves: P9,
          LucideWaypoints: F9,
          LucideWebcam: B9,
          LucideWebhook: R9,
          LucideWebhookOff: D9,
          LucideWeight: T9,
          LucideWheat: Z9,
          LucideWheatOff: U9,
          LucideWholeWord: O9,
          LucideWifi: E9,
          LucideWifiOff: G9,
          LucideWind: W9,
          LucideWine: X9,
          LucideWineOff: N9,
          LucideWorkflow: K9,
          LucideWrapText: _9,
          LucideWrench: J9,
          LucideX: N1,
          LucideXCircle: Q9,
          LucideXOctagon: Y9,
          LucideXSquare: $9,
          LucideYoutube: eM,
          LucideZap: tM,
          LucideZapOff: aM,
          LucideZoomIn: cM,
          LucideZoomOut: hM,
          Luggage: s4,
          LuggageIcon: s4,
          MSquare: u4,
          MSquareIcon: u4,
          Magnet: M4,
          MagnetIcon: M4,
          Mail: E1,
          MailCheck: v4,
          MailCheckIcon: v4,
          MailIcon: E1,
          MailMinus: m4,
          MailMinusIcon: m4,
          MailOpen: x4,
          MailOpenIcon: x4,
          MailPlus: g4,
          MailPlusIcon: g4,
          MailQuestion: L4,
          MailQuestionIcon: L4,
          MailSearch: f4,
          MailSearchIcon: f4,
          MailWarning: w4,
          MailWarningIcon: w4,
          MailX: I4,
          MailXIcon: I4,
          Mailbox: C4,
          MailboxIcon: C4,
          Mails: b4,
          MailsIcon: b4,
          Map: z4,
          MapIcon: z4,
          MapPin: q4,
          MapPinIcon: q4,
          MapPinOff: S4,
          MapPinOffIcon: S4,
          MapPinned: H4,
          MapPinnedIcon: H4,
          Martini: A4,
          MartiniIcon: A4,
          Maximize: V4,
          Maximize2: j4,
          Maximize2Icon: j4,
          MaximizeIcon: V4,
          Medal: P4,
          MedalIcon: P4,
          Megaphone: B4,
          MegaphoneIcon: B4,
          MegaphoneOff: F4,
          MegaphoneOffIcon: F4,
          Meh: D4,
          MehIcon: D4,
          MemoryStick: R4,
          MemoryStickIcon: R4,
          Menu: U4,
          MenuIcon: U4,
          MenuSquare: T4,
          MenuSquareIcon: T4,
          Merge: Z4,
          MergeIcon: Z4,
          MessageCircle: Y4,
          MessageCircleCode: O4,
          MessageCircleCodeIcon: O4,
          MessageCircleDashed: G4,
          MessageCircleDashedIcon: G4,
          MessageCircleHeart: E4,
          MessageCircleHeartIcon: E4,
          MessageCircleIcon: Y4,
          MessageCircleMore: W4,
          MessageCircleMoreIcon: W4,
          MessageCircleOff: N4,
          MessageCircleOffIcon: N4,
          MessageCirclePlus: X4,
          MessageCirclePlusIcon: X4,
          MessageCircleQuestion: K4,
          MessageCircleQuestionIcon: K4,
          MessageCircleReply: _4,
          MessageCircleReplyIcon: _4,
          MessageCircleWarning: J4,
          MessageCircleWarningIcon: J4,
          MessageCircleX: Q4,
          MessageCircleXIcon: Q4,
          MessageSquare: lp,
          MessageSquareCode: $4,
          MessageSquareCodeIcon: $4,
          MessageSquareDashed: ep,
          MessageSquareDashedIcon: ep,
          MessageSquareDiff: ap,
          MessageSquareDiffIcon: ap,
          MessageSquareDot: tp,
          MessageSquareDotIcon: tp,
          MessageSquareHeart: cp,
          MessageSquareHeartIcon: cp,
          MessageSquareIcon: lp,
          MessageSquareMore: hp,
          MessageSquareMoreIcon: hp,
          MessageSquareOff: dp,
          MessageSquareOffIcon: dp,
          MessageSquarePlus: op,
          MessageSquarePlusIcon: op,
          MessageSquareQuote: yp,
          MessageSquareQuoteIcon: yp,
          MessageSquareReply: ip,
          MessageSquareReplyIcon: ip,
          MessageSquareShare: np,
          MessageSquareShareIcon: np,
          MessageSquareText: rp,
          MessageSquareTextIcon: rp,
          MessageSquareWarning: kp,
          MessageSquareWarningIcon: kp,
          MessageSquareX: pp,
          MessageSquareXIcon: pp,
          MessagesSquare: sp,
          MessagesSquareIcon: sp,
          Mic: vp,
          Mic2: up,
          Mic2Icon: up,
          MicIcon: vp,
          MicOff: Mp,
          MicOffIcon: Mp,
          Microscope: mp,
          MicroscopeIcon: mp,
          Microwave: xp,
          MicrowaveIcon: xp,
          Milestone: gp,
          MilestoneIcon: gp,
          Milk: fp,
          MilkIcon: fp,
          MilkOff: Lp,
          MilkOffIcon: Lp,
          Minimize: Ip,
          Minimize2: wp,
          Minimize2Icon: wp,
          MinimizeIcon: Ip,
          Minus: Sp,
          MinusCircle: Cp,
          MinusCircleIcon: Cp,
          MinusIcon: Sp,
          MinusSquare: bp,
          MinusSquareIcon: bp,
          Monitor: Tp,
          MonitorCheck: qp,
          MonitorCheckIcon: qp,
          MonitorDot: Hp,
          MonitorDotIcon: Hp,
          MonitorDown: zp,
          MonitorDownIcon: zp,
          MonitorIcon: Tp,
          MonitorOff: Ap,
          MonitorOffIcon: Ap,
          MonitorPause: jp,
          MonitorPauseIcon: jp,
          MonitorPlay: Vp,
          MonitorPlayIcon: Vp,
          MonitorSmartphone: Pp,
          MonitorSmartphoneIcon: Pp,
          MonitorSpeaker: Fp,
          MonitorSpeakerIcon: Fp,
          MonitorStop: Bp,
          MonitorStopIcon: Bp,
          MonitorUp: Dp,
          MonitorUpIcon: Dp,
          MonitorX: Rp,
          MonitorXIcon: Rp,
          Moon: Zp,
          MoonIcon: Zp,
          MoonStar: Up,
          MoonStarIcon: Up,
          MoreHorizontal: Op,
          MoreHorizontalIcon: Op,
          MoreVertical: Gp,
          MoreVerticalIcon: Gp,
          Mountain: Wp,
          MountainIcon: Wp,
          MountainSnow: Ep,
          MountainSnowIcon: Ep,
          Mouse: Jp,
          MouseIcon: Jp,
          MousePointer: _p,
          MousePointer2: Np,
          MousePointer2Icon: Np,
          MousePointerClick: Xp,
          MousePointerClickIcon: Xp,
          MousePointerIcon: _p,
          MousePointerSquare: n1,
          MousePointerSquareDashed: Kp,
          MousePointerSquareDashedIcon: Kp,
          MousePointerSquareIcon: n1,
          Move: nl,
          Move3D: r1,
          Move3DIcon: r1,
          Move3d: r1,
          Move3dIcon: r1,
          MoveDiagonal: Yp,
          MoveDiagonal2: Qp,
          MoveDiagonal2Icon: Qp,
          MoveDiagonalIcon: Yp,
          MoveDown: al,
          MoveDownIcon: al,
          MoveDownLeft: $p,
          MoveDownLeftIcon: $p,
          MoveDownRight: el,
          MoveDownRightIcon: el,
          MoveHorizontal: tl,
          MoveHorizontalIcon: tl,
          MoveIcon: nl,
          MoveLeft: cl,
          MoveLeftIcon: cl,
          MoveRight: hl,
          MoveRightIcon: hl,
          MoveUp: yl,
          MoveUpIcon: yl,
          MoveUpLeft: dl,
          MoveUpLeftIcon: dl,
          MoveUpRight: ol,
          MoveUpRightIcon: ol,
          MoveVertical: il,
          MoveVerticalIcon: il,
          Music: ll,
          Music2: rl,
          Music2Icon: rl,
          Music3: kl,
          Music3Icon: kl,
          Music4: pl,
          Music4Icon: pl,
          MusicIcon: ll,
          Navigation: vl,
          Navigation2: ul,
          Navigation2Icon: ul,
          Navigation2Off: sl,
          Navigation2OffIcon: sl,
          NavigationIcon: vl,
          NavigationOff: Ml,
          NavigationOffIcon: Ml,
          Network: ml,
          NetworkIcon: ml,
          Newspaper: xl,
          NewspaperIcon: xl,
          Nfc: gl,
          NfcIcon: gl,
          Notebook: Il,
          NotebookIcon: Il,
          NotebookPen: Ll,
          NotebookPenIcon: Ll,
          NotebookTabs: fl,
          NotebookTabsIcon: fl,
          NotebookText: wl,
          NotebookTextIcon: wl,
          NotepadText: bl,
          NotepadTextDashed: Cl,
          NotepadTextDashedIcon: Cl,
          NotepadTextIcon: bl,
          Nut: ql,
          NutIcon: ql,
          NutOff: Sl,
          NutOffIcon: Sl,
          Octagon: Hl,
          OctagonIcon: Hl,
          Option: zl,
          OptionIcon: zl,
          Orbit: Al,
          OrbitIcon: Al,
          Outdent: jl,
          OutdentIcon: jl,
          Package: Ul,
          Package2: Vl,
          Package2Icon: Vl,
          PackageCheck: Pl,
          PackageCheckIcon: Pl,
          PackageIcon: Ul,
          PackageMinus: Fl,
          PackageMinusIcon: Fl,
          PackageOpen: Bl,
          PackageOpenIcon: Bl,
          PackagePlus: Dl,
          PackagePlusIcon: Dl,
          PackageSearch: Rl,
          PackageSearchIcon: Rl,
          PackageX: Tl,
          PackageXIcon: Tl,
          PaintBucket: Zl,
          PaintBucketIcon: Zl,
          PaintRoller: Ol,
          PaintRollerIcon: Ol,
          Paintbrush: El,
          Paintbrush2: Gl,
          Paintbrush2Icon: Gl,
          PaintbrushIcon: El,
          Palette: Wl,
          PaletteIcon: Wl,
          Palmtree: Nl,
          PalmtreeIcon: Nl,
          PanelBottom: _l,
          PanelBottomClose: Xl,
          PanelBottomCloseIcon: Xl,
          PanelBottomDashed: k1,
          PanelBottomDashedIcon: k1,
          PanelBottomIcon: _l,
          PanelBottomInactive: k1,
          PanelBottomInactiveIcon: k1,
          PanelBottomOpen: Kl,
          PanelBottomOpenIcon: Kl,
          PanelLeft: u1,
          PanelLeftClose: p1,
          PanelLeftCloseIcon: p1,
          PanelLeftDashed: l1,
          PanelLeftDashedIcon: l1,
          PanelLeftIcon: u1,
          PanelLeftInactive: l1,
          PanelLeftInactiveIcon: l1,
          PanelLeftOpen: s1,
          PanelLeftOpenIcon: s1,
          PanelRight: Yl,
          PanelRightClose: Jl,
          PanelRightCloseIcon: Jl,
          PanelRightDashed: M1,
          PanelRightDashedIcon: M1,
          PanelRightIcon: Yl,
          PanelRightInactive: M1,
          PanelRightInactiveIcon: M1,
          PanelRightOpen: Ql,
          PanelRightOpenIcon: Ql,
          PanelTop: a5,
          PanelTopClose: $l,
          PanelTopCloseIcon: $l,
          PanelTopDashed: v1,
          PanelTopDashedIcon: v1,
          PanelTopIcon: a5,
          PanelTopInactive: v1,
          PanelTopInactiveIcon: v1,
          PanelTopOpen: e5,
          PanelTopOpenIcon: e5,
          PanelsLeftBottom: t5,
          PanelsLeftBottomIcon: t5,
          PanelsLeftRight: K,
          PanelsLeftRightIcon: K,
          PanelsRightBottom: c5,
          PanelsRightBottomIcon: c5,
          PanelsTopBottom: w1,
          PanelsTopBottomIcon: w1,
          PanelsTopLeft: m1,
          PanelsTopLeftIcon: m1,
          Paperclip: h5,
          PaperclipIcon: h5,
          Parentheses: d5,
          ParenthesesIcon: d5,
          ParkingCircle: y5,
          ParkingCircleIcon: y5,
          ParkingCircleOff: o5,
          ParkingCircleOffIcon: o5,
          ParkingMeter: i5,
          ParkingMeterIcon: i5,
          ParkingSquare: r5,
          ParkingSquareIcon: r5,
          ParkingSquareOff: n5,
          ParkingSquareOffIcon: n5,
          PartyPopper: k5,
          PartyPopperIcon: k5,
          Pause: s5,
          PauseCircle: p5,
          PauseCircleIcon: p5,
          PauseIcon: s5,
          PauseOctagon: l5,
          PauseOctagonIcon: l5,
          PawPrint: u5,
          PawPrintIcon: u5,
          PcCase: M5,
          PcCaseIcon: M5,
          Pen: g1,
          PenBox: k,
          PenBoxIcon: k,
          PenIcon: g1,
          PenLine: x1,
          PenLineIcon: x1,
          PenSquare: k,
          PenSquareIcon: k,
          PenTool: v5,
          PenToolIcon: v5,
          Pencil: g5,
          PencilIcon: g5,
          PencilLine: m5,
          PencilLineIcon: m5,
          PencilRuler: x5,
          PencilRulerIcon: x5,
          Pentagon: L5,
          PentagonIcon: L5,
          Percent: C5,
          PercentCircle: f5,
          PercentCircleIcon: f5,
          PercentDiamond: w5,
          PercentDiamondIcon: w5,
          PercentIcon: C5,
          PercentSquare: I5,
          PercentSquareIcon: I5,
          PersonStanding: b5,
          PersonStandingIcon: b5,
          Phone: V5,
          PhoneCall: S5,
          PhoneCallIcon: S5,
          PhoneForwarded: q5,
          PhoneForwardedIcon: q5,
          PhoneIcon: V5,
          PhoneIncoming: H5,
          PhoneIncomingIcon: H5,
          PhoneMissed: z5,
          PhoneMissedIcon: z5,
          PhoneOff: A5,
          PhoneOffIcon: A5,
          PhoneOutgoing: j5,
          PhoneOutgoingIcon: j5,
          Pi: F5,
          PiIcon: F5,
          PiSquare: P5,
          PiSquareIcon: P5,
          Piano: B5,
          PianoIcon: B5,
          Pickaxe: D5,
          PickaxeIcon: D5,
          PictureInPicture: T5,
          PictureInPicture2: R5,
          PictureInPicture2Icon: R5,
          PictureInPictureIcon: T5,
          PieChart: U5,
          PieChartIcon: U5,
          PiggyBank: Z5,
          PiggyBankIcon: Z5,
          Pilcrow: G5,
          PilcrowIcon: G5,
          PilcrowSquare: O5,
          PilcrowSquareIcon: O5,
          Pill: E5,
          PillIcon: E5,
          Pin: N5,
          PinIcon: N5,
          PinOff: W5,
          PinOffIcon: W5,
          Pipette: X5,
          PipetteIcon: X5,
          Pizza: K5,
          PizzaIcon: K5,
          Plane: Q5,
          PlaneIcon: Q5,
          PlaneLanding: _5,
          PlaneLandingIcon: _5,
          PlaneTakeoff: J5,
          PlaneTakeoffIcon: J5,
          Play: e3,
          PlayCircle: Y5,
          PlayCircleIcon: Y5,
          PlayIcon: e3,
          PlaySquare: $5,
          PlaySquareIcon: $5,
          Plug: h3,
          Plug2: a3,
          Plug2Icon: a3,
          PlugIcon: h3,
          PlugZap: c3,
          PlugZap2: t3,
          PlugZap2Icon: t3,
          PlugZapIcon: c3,
          Plus: y3,
          PlusCircle: d3,
          PlusCircleIcon: d3,
          PlusIcon: y3,
          PlusSquare: o3,
          PlusSquareIcon: o3,
          Pocket: n3,
          PocketIcon: n3,
          PocketKnife: i3,
          PocketKnifeIcon: i3,
          Podcast: r3,
          PodcastIcon: r3,
          Pointer: p3,
          PointerIcon: p3,
          PointerOff: k3,
          PointerOffIcon: k3,
          Popcorn: l3,
          PopcornIcon: l3,
          Popsicle: s3,
          PopsicleIcon: s3,
          PoundSterling: u3,
          PoundSterlingIcon: u3,
          Power: x3,
          PowerCircle: M3,
          PowerCircleIcon: M3,
          PowerIcon: x3,
          PowerOff: v3,
          PowerOffIcon: v3,
          PowerSquare: m3,
          PowerSquareIcon: m3,
          Presentation: g3,
          PresentationIcon: g3,
          Printer: L3,
          PrinterIcon: L3,
          Projector: f3,
          ProjectorIcon: f3,
          Puzzle: w3,
          PuzzleIcon: w3,
          Pyramid: I3,
          PyramidIcon: I3,
          QrCode: C3,
          QrCodeIcon: C3,
          Quote: b3,
          QuoteIcon: b3,
          Rabbit: S3,
          RabbitIcon: S3,
          Radar: q3,
          RadarIcon: q3,
          Radiation: H3,
          RadiationIcon: H3,
          Radical: z3,
          RadicalIcon: z3,
          Radio: V3,
          RadioIcon: V3,
          RadioReceiver: A3,
          RadioReceiverIcon: A3,
          RadioTower: j3,
          RadioTowerIcon: j3,
          Radius: P3,
          RadiusIcon: P3,
          RailSymbol: F3,
          RailSymbolIcon: F3,
          Rainbow: B3,
          RainbowIcon: B3,
          Rat: D3,
          RatIcon: D3,
          Ratio: R3,
          RatioIcon: R3,
          Receipt: X3,
          ReceiptCent: T3,
          ReceiptCentIcon: T3,
          ReceiptEuro: U3,
          ReceiptEuroIcon: U3,
          ReceiptIcon: X3,
          ReceiptIndianRupee: Z3,
          ReceiptIndianRupeeIcon: Z3,
          ReceiptJapaneseYen: O3,
          ReceiptJapaneseYenIcon: O3,
          ReceiptPoundSterling: G3,
          ReceiptPoundSterlingIcon: G3,
          ReceiptRussianRuble: E3,
          ReceiptRussianRubleIcon: E3,
          ReceiptSwissFranc: W3,
          ReceiptSwissFrancIcon: W3,
          ReceiptText: N3,
          ReceiptTextIcon: N3,
          RectangleHorizontal: K3,
          RectangleHorizontalIcon: K3,
          RectangleVertical: _3,
          RectangleVerticalIcon: _3,
          Recycle: J3,
          RecycleIcon: J3,
          Redo: $3,
          Redo2: Q3,
          Redo2Icon: Q3,
          RedoDot: Y3,
          RedoDotIcon: Y3,
          RedoIcon: $3,
          RefreshCcw: a6,
          RefreshCcwDot: e6,
          RefreshCcwDotIcon: e6,
          RefreshCcwIcon: a6,
          RefreshCw: c6,
          RefreshCwIcon: c6,
          RefreshCwOff: t6,
          RefreshCwOffIcon: t6,
          Refrigerator: h6,
          RefrigeratorIcon: h6,
          Regex: d6,
          RegexIcon: d6,
          RemoveFormatting: o6,
          RemoveFormattingIcon: o6,
          Repeat: n6,
          Repeat1: y6,
          Repeat1Icon: y6,
          Repeat2: i6,
          Repeat2Icon: i6,
          RepeatIcon: n6,
          Replace: k6,
          ReplaceAll: r6,
          ReplaceAllIcon: r6,
          ReplaceIcon: k6,
          Reply: l6,
          ReplyAll: p6,
          ReplyAllIcon: p6,
          ReplyIcon: l6,
          Rewind: s6,
          RewindIcon: s6,
          Ribbon: u6,
          RibbonIcon: u6,
          Rocket: M6,
          RocketIcon: M6,
          RockingChair: v6,
          RockingChairIcon: v6,
          RollerCoaster: m6,
          RollerCoasterIcon: m6,
          Rotate3D: L1,
          Rotate3DIcon: L1,
          Rotate3d: L1,
          Rotate3dIcon: L1,
          RotateCcw: W1,
          RotateCcwIcon: W1,
          RotateCw: x6,
          RotateCwIcon: x6,
          Route: L6,
          RouteIcon: L6,
          RouteOff: g6,
          RouteOffIcon: g6,
          Router: f6,
          RouterIcon: f6,
          Rows: f1,
          Rows2: f1,
          Rows2Icon: f1,
          Rows3: w1,
          Rows3Icon: w1,
          Rows4: w6,
          Rows4Icon: w6,
          RowsIcon: f1,
          Rss: I6,
          RssIcon: I6,
          Ruler: C6,
          RulerIcon: C6,
          RussianRuble: b6,
          RussianRubleIcon: b6,
          Sailboat: S6,
          SailboatIcon: S6,
          Salad: q6,
          SaladIcon: q6,
          Sandwich: H6,
          SandwichIcon: H6,
          Satellite: A6,
          SatelliteDish: z6,
          SatelliteDishIcon: z6,
          SatelliteIcon: A6,
          Save: V6,
          SaveAll: j6,
          SaveAllIcon: j6,
          SaveIcon: V6,
          Scale: P6,
          Scale3D: I1,
          Scale3DIcon: I1,
          Scale3d: I1,
          Scale3dIcon: I1,
          ScaleIcon: P6,
          Scaling: F6,
          ScalingIcon: F6,
          Scan: O6,
          ScanBarcode: B6,
          ScanBarcodeIcon: B6,
          ScanEye: D6,
          ScanEyeIcon: D6,
          ScanFace: R6,
          ScanFaceIcon: R6,
          ScanIcon: O6,
          ScanLine: T6,
          ScanLineIcon: T6,
          ScanSearch: U6,
          ScanSearchIcon: U6,
          ScanText: Z6,
          ScanTextIcon: Z6,
          ScatterChart: G6,
          ScatterChartIcon: G6,
          School: W6,
          School2: E6,
          School2Icon: E6,
          SchoolIcon: W6,
          Scissors: _6,
          ScissorsIcon: _6,
          ScissorsLineDashed: N6,
          ScissorsLineDashedIcon: N6,
          ScissorsSquare: K6,
          ScissorsSquareDashedBottom: X6,
          ScissorsSquareDashedBottomIcon: X6,
          ScissorsSquareIcon: K6,
          ScreenShare: Q6,
          ScreenShareIcon: Q6,
          ScreenShareOff: J6,
          ScreenShareOffIcon: J6,
          Scroll: $6,
          ScrollIcon: $6,
          ScrollText: Y6,
          ScrollTextIcon: Y6,
          Search: hs,
          SearchCheck: es,
          SearchCheckIcon: es,
          SearchCode: as,
          SearchCodeIcon: as,
          SearchIcon: hs,
          SearchSlash: ts,
          SearchSlashIcon: ts,
          SearchX: cs,
          SearchXIcon: cs,
          Send: os,
          SendHorizonal: C1,
          SendHorizonalIcon: C1,
          SendHorizontal: C1,
          SendHorizontalIcon: C1,
          SendIcon: os,
          SendToBack: ds,
          SendToBackIcon: ds,
          SeparatorHorizontal: ys,
          SeparatorHorizontalIcon: ys,
          SeparatorVertical: is,
          SeparatorVerticalIcon: is,
          Server: ps,
          ServerCog: ns,
          ServerCogIcon: ns,
          ServerCrash: rs,
          ServerCrashIcon: rs,
          ServerIcon: ps,
          ServerOff: ks,
          ServerOffIcon: ks,
          Settings: ss,
          Settings2: ls,
          Settings2Icon: ls,
          SettingsIcon: ss,
          Shapes: us,
          ShapesIcon: us,
          Share: vs,
          Share2: Ms,
          Share2Icon: Ms,
          ShareIcon: vs,
          Sheet: ms,
          SheetIcon: ms,
          Shell: xs,
          ShellIcon: xs,
          Shield: Hs,
          ShieldAlert: gs,
          ShieldAlertIcon: gs,
          ShieldBan: Ls,
          ShieldBanIcon: Ls,
          ShieldCheck: fs,
          ShieldCheckIcon: fs,
          ShieldClose: b1,
          ShieldCloseIcon: b1,
          ShieldEllipsis: ws,
          ShieldEllipsisIcon: ws,
          ShieldHalf: Is,
          ShieldHalfIcon: Is,
          ShieldIcon: Hs,
          ShieldMinus: Cs,
          ShieldMinusIcon: Cs,
          ShieldOff: bs,
          ShieldOffIcon: bs,
          ShieldPlus: Ss,
          ShieldPlusIcon: Ss,
          ShieldQuestion: qs,
          ShieldQuestionIcon: qs,
          ShieldX: b1,
          ShieldXIcon: b1,
          Ship: As,
          ShipIcon: As,
          ShipWheel: zs,
          ShipWheelIcon: zs,
          Shirt: js,
          ShirtIcon: js,
          ShoppingBag: Vs,
          ShoppingBagIcon: Vs,
          ShoppingBasket: Ps,
          ShoppingBasketIcon: Ps,
          ShoppingCart: Fs,
          ShoppingCartIcon: Fs,
          Shovel: Bs,
          ShovelIcon: Bs,
          ShowerHead: Ds,
          ShowerHeadIcon: Ds,
          Shrink: Rs,
          ShrinkIcon: Rs,
          Shrub: Ts,
          ShrubIcon: Ts,
          Shuffle: Us,
          ShuffleIcon: Us,
          Sidebar: u1,
          SidebarClose: p1,
          SidebarCloseIcon: p1,
          SidebarIcon: u1,
          SidebarOpen: s1,
          SidebarOpenIcon: s1,
          Sigma: Os,
          SigmaIcon: Os,
          SigmaSquare: Zs,
          SigmaSquareIcon: Zs,
          Signal: Xs,
          SignalHigh: Gs,
          SignalHighIcon: Gs,
          SignalIcon: Xs,
          SignalLow: Es,
          SignalLowIcon: Es,
          SignalMedium: Ws,
          SignalMediumIcon: Ws,
          SignalZero: Ns,
          SignalZeroIcon: Ns,
          Signpost: _s,
          SignpostBig: Ks,
          SignpostBigIcon: Ks,
          SignpostIcon: _s,
          Siren: Js,
          SirenIcon: Js,
          SkipBack: Qs,
          SkipBackIcon: Qs,
          SkipForward: Ys,
          SkipForwardIcon: Ys,
          Skull: $s,
          SkullIcon: $s,
          Slack: e8,
          SlackIcon: e8,
          Slash: a8,
          SlashIcon: a8,
          SlashSquare: S1,
          SlashSquareIcon: S1,
          Slice: t8,
          SliceIcon: t8,
          Sliders: h8,
          SlidersHorizontal: c8,
          SlidersHorizontalIcon: c8,
          SlidersIcon: h8,
          Smartphone: y8,
          SmartphoneCharging: d8,
          SmartphoneChargingIcon: d8,
          SmartphoneIcon: y8,
          SmartphoneNfc: o8,
          SmartphoneNfcIcon: o8,
          Smile: n8,
          SmileIcon: n8,
          SmilePlus: i8,
          SmilePlusIcon: i8,
          Snail: r8,
          SnailIcon: r8,
          Snowflake: k8,
          SnowflakeIcon: k8,
          Sofa: p8,
          SofaIcon: p8,
          SortAsc: A,
          SortAscIcon: A,
          SortDesc: q,
          SortDescIcon: q,
          Soup: l8,
          SoupIcon: l8,
          Space: s8,
          SpaceIcon: s8,
          Spade: u8,
          SpadeIcon: u8,
          Sparkle: M8,
          SparkleIcon: M8,
          Sparkles: q1,
          SparklesIcon: q1,
          Speaker: v8,
          SpeakerIcon: v8,
          Speech: m8,
          SpeechIcon: m8,
          SpellCheck: g8,
          SpellCheck2: x8,
          SpellCheck2Icon: x8,
          SpellCheckIcon: g8,
          Spline: L8,
          SplineIcon: L8,
          Split: I8,
          SplitIcon: I8,
          SplitSquareHorizontal: f8,
          SplitSquareHorizontalIcon: f8,
          SplitSquareVertical: w8,
          SplitSquareVerticalIcon: w8,
          SprayCan: C8,
          SprayCanIcon: C8,
          Sprout: b8,
          SproutIcon: b8,
          Square: A8,
          SquareAsterisk: V,
          SquareAsteriskIcon: V,
          SquareCode: N,
          SquareCodeIcon: N,
          SquareDashedBottom: q8,
          SquareDashedBottomCode: S8,
          SquareDashedBottomCodeIcon: S8,
          SquareDashedBottomIcon: q8,
          SquareDot: _,
          SquareDotIcon: _,
          SquareEqual: Q,
          SquareEqualIcon: Q,
          SquareGantt: v,
          SquareGanttIcon: v,
          SquareIcon: A8,
          SquareKanban: i1,
          SquareKanbanDashed: y1,
          SquareKanbanDashedIcon: y1,
          SquareKanbanIcon: i1,
          SquarePen: k,
          SquarePenIcon: k,
          SquareRadical: H8,
          SquareRadicalIcon: H8,
          SquareSlash: S1,
          SquareSlashIcon: S1,
          SquareStack: z8,
          SquareStackIcon: z8,
          SquareUser: z1,
          SquareUserIcon: z1,
          SquareUserRound: H1,
          SquareUserRoundIcon: H1,
          Squircle: j8,
          SquircleIcon: j8,
          Squirrel: V8,
          SquirrelIcon: V8,
          Stamp: P8,
          StampIcon: P8,
          Star: D8,
          StarHalf: F8,
          StarHalfIcon: F8,
          StarIcon: D8,
          StarOff: B8,
          StarOffIcon: B8,
          Stars: q1,
          StarsIcon: q1,
          StepBack: R8,
          StepBackIcon: R8,
          StepForward: T8,
          StepForwardIcon: T8,
          Stethoscope: U8,
          StethoscopeIcon: U8,
          Sticker: Z8,
          StickerIcon: Z8,
          StickyNote: O8,
          StickyNoteIcon: O8,
          StopCircle: G8,
          StopCircleIcon: G8,
          Store: E8,
          StoreIcon: E8,
          StretchHorizontal: W8,
          StretchHorizontalIcon: W8,
          StretchVertical: N8,
          StretchVerticalIcon: N8,
          Strikethrough: X8,
          StrikethroughIcon: X8,
          Subscript: K8,
          SubscriptIcon: K8,
          Subtitles: U,
          SubtitlesIcon: U,
          Sun: $8,
          SunDim: _8,
          SunDimIcon: _8,
          SunIcon: $8,
          SunMedium: J8,
          SunMediumIcon: J8,
          SunMoon: Q8,
          SunMoonIcon: Q8,
          SunSnow: Y8,
          SunSnowIcon: Y8,
          Sunrise: e7,
          SunriseIcon: e7,
          Sunset: a7,
          SunsetIcon: a7,
          Superscript: t7,
          SuperscriptIcon: t7,
          SwatchBook: c7,
          SwatchBookIcon: c7,
          SwissFranc: h7,
          SwissFrancIcon: h7,
          SwitchCamera: d7,
          SwitchCameraIcon: d7,
          Sword: o7,
          SwordIcon: o7,
          Swords: y7,
          SwordsIcon: y7,
          Syringe: i7,
          SyringeIcon: i7,
          Table: u7,
          Table2: n7,
          Table2Icon: n7,
          TableCellsMerge: r7,
          TableCellsMergeIcon: r7,
          TableCellsSplit: k7,
          TableCellsSplitIcon: k7,
          TableColumnsSplit: p7,
          TableColumnsSplitIcon: p7,
          TableIcon: u7,
          TableProperties: l7,
          TablePropertiesIcon: l7,
          TableRowsSplit: s7,
          TableRowsSplitIcon: s7,
          Tablet: v7,
          TabletIcon: v7,
          TabletSmartphone: M7,
          TabletSmartphoneIcon: M7,
          Tablets: m7,
          TabletsIcon: m7,
          Tag: x7,
          TagIcon: x7,
          Tags: g7,
          TagsIcon: g7,
          Tally1: L7,
          Tally1Icon: L7,
          Tally2: f7,
          Tally2Icon: f7,
          Tally3: w7,
          Tally3Icon: w7,
          Tally4: I7,
          Tally4Icon: I7,
          Tally5: C7,
          Tally5Icon: C7,
          Tangent: b7,
          TangentIcon: b7,
          Target: S7,
          TargetIcon: S7,
          Telescope: q7,
          TelescopeIcon: q7,
          Tent: z7,
          TentIcon: z7,
          TentTree: H7,
          TentTreeIcon: H7,
          Terminal: j7,
          TerminalIcon: j7,
          TerminalSquare: A7,
          TerminalSquareIcon: A7,
          TestTube: P7,
          TestTube2: V7,
          TestTube2Icon: V7,
          TestTubeIcon: P7,
          TestTubes: F7,
          TestTubesIcon: F7,
          Text: U7,
          TextCursor: D7,
          TextCursorIcon: D7,
          TextCursorInput: B7,
          TextCursorInputIcon: B7,
          TextIcon: U7,
          TextQuote: R7,
          TextQuoteIcon: R7,
          TextSearch: T7,
          TextSearchIcon: T7,
          TextSelect: A1,
          TextSelectIcon: A1,
          TextSelection: A1,
          TextSelectionIcon: A1,
          Theater: Z7,
          TheaterIcon: Z7,
          Thermometer: E7,
          ThermometerIcon: E7,
          ThermometerSnowflake: O7,
          ThermometerSnowflakeIcon: O7,
          ThermometerSun: G7,
          ThermometerSunIcon: G7,
          ThumbsDown: W7,
          ThumbsDownIcon: W7,
          ThumbsUp: N7,
          ThumbsUpIcon: N7,
          Ticket: $7,
          TicketCheck: X7,
          TicketCheckIcon: X7,
          TicketIcon: $7,
          TicketMinus: K7,
          TicketMinusIcon: K7,
          TicketPercent: _7,
          TicketPercentIcon: _7,
          TicketPlus: J7,
          TicketPlusIcon: J7,
          TicketSlash: Q7,
          TicketSlashIcon: Q7,
          TicketX: Y7,
          TicketXIcon: Y7,
          Timer: tu,
          TimerIcon: tu,
          TimerOff: eu,
          TimerOffIcon: eu,
          TimerReset: au,
          TimerResetIcon: au,
          ToggleLeft: cu,
          ToggleLeftIcon: cu,
          ToggleRight: hu,
          ToggleRightIcon: hu,
          Tornado: du,
          TornadoIcon: du,
          Torus: ou,
          TorusIcon: ou,
          Touchpad: iu,
          TouchpadIcon: iu,
          TouchpadOff: yu,
          TouchpadOffIcon: yu,
          TowerControl: nu,
          TowerControlIcon: nu,
          ToyBrick: ru,
          ToyBrickIcon: ru,
          Tractor: ku,
          TractorIcon: ku,
          TrafficCone: pu,
          TrafficConeIcon: pu,
          Train: j1,
          TrainFront: su,
          TrainFrontIcon: su,
          TrainFrontTunnel: lu,
          TrainFrontTunnelIcon: lu,
          TrainIcon: j1,
          TrainTrack: uu,
          TrainTrackIcon: uu,
          TramFront: j1,
          TramFrontIcon: j1,
          Trash: vu,
          Trash2: Mu,
          Trash2Icon: Mu,
          TrashIcon: vu,
          TreeDeciduous: mu,
          TreeDeciduousIcon: mu,
          TreePine: xu,
          TreePineIcon: xu,
          Trees: gu,
          TreesIcon: gu,
          Trello: Lu,
          TrelloIcon: Lu,
          TrendingDown: fu,
          TrendingDownIcon: fu,
          TrendingUp: wu,
          TrendingUpIcon: wu,
          Triangle: Cu,
          TriangleIcon: Cu,
          TriangleRight: Iu,
          TriangleRightIcon: Iu,
          Trophy: bu,
          TrophyIcon: bu,
          Truck: Su,
          TruckIcon: Su,
          Turtle: qu,
          TurtleIcon: qu,
          Tv: zu,
          Tv2: Hu,
          Tv2Icon: Hu,
          TvIcon: zu,
          Twitch: Au,
          TwitchIcon: Au,
          Twitter: ju,
          TwitterIcon: ju,
          Type: Vu,
          TypeIcon: Vu,
          Umbrella: Fu,
          UmbrellaIcon: Fu,
          UmbrellaOff: Pu,
          UmbrellaOffIcon: Pu,
          Underline: Bu,
          UnderlineIcon: Bu,
          Undo: Tu,
          Undo2: Du,
          Undo2Icon: Du,
          UndoDot: Ru,
          UndoDotIcon: Ru,
          UndoIcon: Tu,
          UnfoldHorizontal: Uu,
          UnfoldHorizontalIcon: Uu,
          UnfoldVertical: Zu,
          UnfoldVerticalIcon: Zu,
          Ungroup: Ou,
          UngroupIcon: Ou,
          Unlink: Eu,
          Unlink2: Gu,
          Unlink2Icon: Gu,
          UnlinkIcon: Eu,
          Unlock: Nu,
          UnlockIcon: Nu,
          UnlockKeyhole: Wu,
          UnlockKeyholeIcon: Wu,
          Unplug: Xu,
          UnplugIcon: Xu,
          Upload: _u,
          UploadCloud: Ku,
          UploadCloudIcon: Ku,
          UploadIcon: _u,
          Usb: Ju,
          UsbIcon: Ju,
          User: h9,
          User2: R1,
          User2Icon: R1,
          UserCheck: Qu,
          UserCheck2: V1,
          UserCheck2Icon: V1,
          UserCheckIcon: Qu,
          UserCircle: G,
          UserCircle2: O,
          UserCircle2Icon: O,
          UserCircleIcon: G,
          UserCog: Yu,
          UserCog2: P1,
          UserCog2Icon: P1,
          UserCogIcon: Yu,
          UserIcon: h9,
          UserMinus: $u,
          UserMinus2: F1,
          UserMinus2Icon: F1,
          UserMinusIcon: $u,
          UserPlus: e9,
          UserPlus2: B1,
          UserPlus2Icon: B1,
          UserPlusIcon: e9,
          UserRound: R1,
          UserRoundCheck: V1,
          UserRoundCheckIcon: V1,
          UserRoundCog: P1,
          UserRoundCogIcon: P1,
          UserRoundIcon: R1,
          UserRoundMinus: F1,
          UserRoundMinusIcon: F1,
          UserRoundPlus: B1,
          UserRoundPlusIcon: B1,
          UserRoundSearch: a9,
          UserRoundSearchIcon: a9,
          UserRoundX: D1,
          UserRoundXIcon: D1,
          UserSearch: t9,
          UserSearchIcon: t9,
          UserSquare: z1,
          UserSquare2: H1,
          UserSquare2Icon: H1,
          UserSquareIcon: z1,
          UserX: c9,
          UserX2: D1,
          UserX2Icon: D1,
          UserXIcon: c9,
          Users: d9,
          Users2: T1,
          Users2Icon: T1,
          UsersIcon: d9,
          UsersRound: T1,
          UsersRoundIcon: T1,
          Utensils: y9,
          UtensilsCrossed: o9,
          UtensilsCrossedIcon: o9,
          UtensilsIcon: y9,
          UtilityPole: i9,
          UtilityPoleIcon: i9,
          Variable: n9,
          VariableIcon: n9,
          Vault: r9,
          VaultIcon: r9,
          Vegan: k9,
          VeganIcon: k9,
          VenetianMask: p9,
          VenetianMaskIcon: p9,
          Verified: F,
          VerifiedIcon: F,
          Vibrate: s9,
          VibrateIcon: s9,
          VibrateOff: l9,
          VibrateOffIcon: l9,
          Video: M9,
          VideoIcon: M9,
          VideoOff: u9,
          VideoOffIcon: u9,
          Videotape: v9,
          VideotapeIcon: v9,
          View: m9,
          ViewIcon: m9,
          Voicemail: x9,
          VoicemailIcon: x9,
          Volume: w9,
          Volume1: g9,
          Volume1Icon: g9,
          Volume2: L9,
          Volume2Icon: L9,
          VolumeIcon: w9,
          VolumeX: f9,
          VolumeXIcon: f9,
          Vote: I9,
          VoteIcon: I9,
          Wallet: S9,
          Wallet2: C9,
          Wallet2Icon: C9,
          WalletCards: b9,
          WalletCardsIcon: b9,
          WalletIcon: S9,
          Wallpaper: q9,
          WallpaperIcon: q9,
          Wand: z9,
          Wand2: H9,
          Wand2Icon: H9,
          WandIcon: z9,
          Warehouse: A9,
          WarehouseIcon: A9,
          WashingMachine: j9,
          WashingMachineIcon: j9,
          Watch: V9,
          WatchIcon: V9,
          Waves: P9,
          WavesIcon: P9,
          Waypoints: F9,
          WaypointsIcon: F9,
          Webcam: B9,
          WebcamIcon: B9,
          Webhook: R9,
          WebhookIcon: R9,
          WebhookOff: D9,
          WebhookOffIcon: D9,
          Weight: T9,
          WeightIcon: T9,
          Wheat: Z9,
          WheatIcon: Z9,
          WheatOff: U9,
          WheatOffIcon: U9,
          WholeWord: O9,
          WholeWordIcon: O9,
          Wifi: E9,
          WifiIcon: E9,
          WifiOff: G9,
          WifiOffIcon: G9,
          Wind: W9,
          WindIcon: W9,
          Wine: X9,
          WineIcon: X9,
          WineOff: N9,
          WineOffIcon: N9,
          Workflow: K9,
          WorkflowIcon: K9,
          WrapText: _9,
          WrapTextIcon: _9,
          Wrench: J9,
          WrenchIcon: J9,
          X: N1,
          XCircle: Q9,
          XCircleIcon: Q9,
          XIcon: N1,
          XOctagon: Y9,
          XOctagonIcon: Y9,
          XSquare: $9,
          XSquareIcon: $9,
          Youtube: eM,
          YoutubeIcon: eM,
          Zap: tM,
          ZapIcon: tM,
          ZapOff: aM,
          ZapOffIcon: aM,
          ZoomIn: cM,
          ZoomInIcon: cM,
          ZoomOut: hM,
          ZoomOutIcon: hM,
          createLucideIcon: e,
          icons: HM,
        },
        Symbol.toStringTag,
        { value: "Module" }
      )
    ),
    O1 = [
      {
        id: 1,
        question: "What is your primary patient population?",
        //description: "This helps us match you with the right device",
        type: "single",
        field: "primary_use",
        options: [
          { value: "neonates", label: "Neonates (0-8 weeks)", icon: "Baby" },
          {
            value: "pediatric",
            label: "Pediatric (0-17 years)",
            icon: "Users",
          },
          { value: "adult", label: "Adult Patients", icon: "User" },
          { value: "mixed", label: "Mixed Population", icon: "Users" },
          { value: "research", label: "Animal Research", icon: "FlaskConical" },
        ],
      },
      {
        id: 2,
        question: "What is your specialty or setting?",
        //description: "Where will you primarily use the device?",
        type: "single",
        field: "environment",
        options: [
          {
            value: "emergency",
            label: "Emergency/First Responder",
            icon: "Ambulance",
          },
          { value: "pediatric_nicu", label: "Pediatric/NICU", icon: "Heart" },
          {
            value: "sclerotherapy",
            label: "Sclerotherapy/Phlebology",
            icon: "Activity",
          },
          {
            value: "clinical_dental",
            label: "Clinical/Dental",
            icon: "Building2",
          },
          { value: "research", label: "Research/Lab", icon: "Microscope" },
        ],
      },
      {
        id: 3,
        question:
          "Enter your email address to receive your device recommendation",
        description: "We'll send you detailed product information and pricing",
        type: "email",
        field: "email",
      },
    ],
    s = [
      {
        id: "veinlite-led-plus",
        name: "Veinlite LED+",
        tagline: "Most versatile device for clinical and dental use",
        image:
          "/cdn/shop/files/veinlite-led-plus-lights-on.webp?v=1762138346&width=600",
        features: [
          "Suitable for adults and children",
          "Includes pediatric adapter and light shield",
          "Perfect for general clinical use",
          "Excellent for dental procedures",
        ],
        primaryUses: ["adult", "mixed"],
        environments: ["clinical", "dental"],
      },
      {
        id: "veinlite-ems-pro",
        name: "Veinlite EMS PRO",
        tagline: "Designed for emergency medicine and first responders",
        image:
          "/cdn/shop/files/veinlite-ems-pro-lights-on.webp?v=1762492459&width=600",
        features: [
          "One-button operation for speed",
          "Replaceable batteries for extended field use",
          "MOLLE case for readiness",
          "Includes pediatric adapter and light shield",
        ],
        primaryUses: ["emergency", "adult", "mixed"],
        environments: ["emergency"],
      },
      {
        id: "veinlite-ledx",
        name: "Veinlite LEDX",
        tagline: "Specialized for sclerotherapy and vein treatment",
        image:
          "/cdn/shop/files/veinlite-ledx-lights-on.webp?v=1762492459&width=600",
        features: [
          "Optimized for vein visualization",
          "Ideal for sclerotherapy procedures",
          "Perfect for phlebology practices",
          "Enhanced illumination for vein mapping",
        ],
        primaryUses: ["adult"],
        environments: ["sclerotherapy"],
      },
      {
        id: "veinlite-pedi2",
        name: "Veinlite PEDI2",
        tagline: "Purpose-built for pediatric patients (0-17 years)",
        image:
          "/cdn/shop/files/veinlite-pedi2-lights-on.webp?v=1762492459&width=600",
        features: [
          "Specifically designed for children",
          "Optimized for children's anatomy",
          "Reduces anxiety and improves success rates",
          "Lightweight and easy to handle",
        ],
        primaryUses: ["pediatric"],
        environments: ["clinical", "emergency"],
      },
      {
        id: "veinlite-neo",
        name: "Veinlite NEO",
        tagline: "Specialized for neonates and NICU (0-8 weeks)",
        image:
          "/cdn/shop/files/veinlite-neo-orange-light.webp?v=1762530522&width=600",
        features: [
          "Optimized for NICU environments",
          "Gentle illumination for delicate skin",
          "Arterial or venous access",
          "Essential for neonatal care",
        ],
        primaryUses: ["neonates"],
        environments: ["nicu"],
      },
      {
        id: "veinlite-r",
        name: "Veinlite R",
        tagline: "Built for animal research with mice and rats",
        image:
          "/cdn/shop/files/veinlite-r-orange-light.webp?v=1762525369&width=600",
        features: [
          "Specifically designed for research",
          "Optimized for mice and rat vasculature",
          "Detects arteries and veins",
          "Essential research tool",
        ],
        primaryUses: ["research"],
        environments: ["research"],
      },
    ]
  function mM(t) {
    const a = []
    if (t.environment === "emergency") {
      const c = s.find((d) => d.id === "veinlite-ems-pro")
      c && a.push(c)
    }
    if (t.environment === "pediatric_nicu")
      if (t.primary_use === "neonates") {
        const c = s.find((d) => d.id === "veinlite-neo")
        c && a.push(c)
      } else {
        const c = s.find((y) => y.id === "veinlite-pedi2")
        c && a.push(c)
        const d = s.find((y) => y.id === "veinlite-neo")
        d && a.length < 2 && a.push(d)
      }
    if (t.environment === "sclerotherapy") {
      const c = s.find((d) => d.id === "veinlite-ledx")
      c && a.push(c)
    }
    if (t.environment === "clinical_dental") {
      const c = s.find((d) => d.id === "veinlite-led-plus")
      c && a.push(c)
    }
    if (t.environment === "research" || t.primary_use === "research") {
      const c = s.find((d) => d.id === "veinlite-r")
      c && a.push(c)
    }
    if (t.primary_use === "mixed" && a.length === 0) {
      const c = s.find((i) => i.id === "veinlite-led-plus"),
        d = s.find((i) => i.id === "veinlite-ems-pro"),
        y = s.find((i) => i.id === "veinlite-pedi2")
      c && a.push(c),
        y && a.length < 3 && a.push(y),
        d && a.length < 3 && t.environment === "emergency" && a.push(d)
    }
    if (a.length === 0) {
      const c = s.find((d) => d.id === "veinlite-led-plus")
      c && a.push(c)
    }
    return a.slice(0, 3).map((c, d) => ({ ...c, matchScore: 100 - d * 5 }))
  }
  function AM() {
    return `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`
  }
  class jM {
    constructor() {
      ;(this.publicKey = null), (this.listId = null), (this.klaviyoLoaded = !1)
    }
    init(a) {
      ;(this.publicKey = a.publicKey || null),
        (this.listId = a.listId || null),
        !this.klaviyoLoaded && typeof window < "u" && this.loadKlaviyoScript()
    }
    loadKlaviyoScript() {
      if (typeof window > "u" || window._learnq) {
        this.klaviyoLoaded = !0
        return
      }
      const a = document.createElement("script")
      ;(a.async = !0),
        (a.src = "https://static.klaviyo.com/onsite/js/klaviyo.js"),
        (a.onload = () => {
          this.klaviyoLoaded = !0
        }),
        document.head.appendChild(a)
    }
    async identifyUser(a, c) {
      if (typeof window > "u") return
      await this.waitForKlaviyo()
      const d = window._learnq
      if (!d) {
        console.warn("Klaviyo not loaded")
        return
      }
      // Identify user in Klaviyo (subscription is handled server-side via email endpoint)
      d.push(["identify", { $email: a, ...c }])
      // Removed addToList call - subscription is now handled server-side
      // This prevents CORS errors and ensures proper subscription via Klaviyo API
    }
    async addToList(a) {
      if (!(!this.publicKey || !this.listId))
        try {
          const c = await fetch(
            `https://a.klaviyo.com/api/v2/list/${this.listId}/subscribe`,
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ api_key: this.publicKey, email: a }),
            }
          )
          if (!c.ok) throw new Error(`Klaviyo API error: ${c.statusText}`)
        } catch (c) {
          console.error("Error subscribing to Klaviyo list:", c)
        }
    }
    async trackQuizCompleted(a) {
      if (typeof window > "u") return
      await this.waitForKlaviyo()
      const c = window._learnq
      if (!c) {
        console.warn("Klaviyo not loaded")
        return
      }
      c.push([
        "track",
        "Quiz Completed",
        {
          Email: a.email,
          Primary_Use: a.primary_use || "",
          Environment: a.environment || "",
          Recommended_Devices: a.recommended_devices.join(", "),
          Top_Recommendation: a.recommended_devices[0] || "",
          Session_ID: a.session_id,
          Quiz_Type: "Product Recommendation",
        },
      ]),
        await this.identifyUser(a.email, {
          Primary_Use: a.primary_use,
          Environment: a.environment,
          Recommended_Devices: a.recommended_devices,
          Top_Recommendation: a.recommended_devices[0],
          Last_Quiz_Completion: new Date().toISOString(),
        })
      // Send email with quiz results and pricing
      if (
        a.email &&
        a.recommended_devices &&
        a.recommended_devices.length > 0
      ) {
        try {
          await this.sendQuizResultsEmail(a)
        } catch (y) {
          console.error("Error sending quiz results email:", y)
        }
      }
    }
    async sendQuizResultsEmail(a) {
      try {
        // Get product handles from device IDs
        const productHandles = a.recommended_devices.map((deviceId) => {
          const mapping = window.veinliteQuizConfig?.productMapping?.[deviceId]
          return mapping?.handle || deviceId
        })
        // Fetch product pricing data using Shopify AJAX API
        const productData = await this.fetchProductPricing(productHandles)

        // Add features and tagline from product mapping to each product
        // Product features lookup - matches the product data structure
        const productFeaturesLookup = {
          "veinlite-led-plus": {
            features: [
              "Suitable for adults and children",
              "Includes pediatric adapter and light shield",
              "Perfect for general clinical use",
              "Excellent for dental procedures",
            ],
            tagline: "Most versatile device for clinical and dental use",
          },
          "veinlite-ems-pro": {
            features: [
              "One-button operation for speed",
              "Replaceable batteries for extended field use",
              "MOLLE case for readiness",
              "Includes pediatric adapter and light shield",
            ],
            tagline: "Designed for emergency medicine and first responders",
          },
          "veinlite-ledx": {
            features: [
              "Optimized for vein visualization",
              "Ideal for sclerotherapy procedures",
              "Perfect for phlebology practices",
              "Enhanced illumination for vein mapping",
            ],
            tagline: "Specialized for sclerotherapy and vein treatment",
          },
          "veinlite-pedi2": {
            features: [
              "Specifically designed for children",
              "Optimized for children's anatomy",
              "Reduces anxiety and improves success rates",
              "Lightweight and easy to handle",
            ],
            tagline: "Purpose-built for pediatric patients (0-17 years)",
          },
          "veinlite-neo": {
            features: [
              "Optimized for NICU environments",
              "Gentle illumination for delicate skin",
              "Arterial or venous access",
              "Essential for neonatal care",
            ],
            tagline: "Specialized for neonates and NICU (0-8 weeks)",
          },
          "veinlite-r": {
            features: [
              "Specifically designed for research",
              "Optimized for mice and rat vasculature",
              "Detects arteries and veins",
              "Essential research tool",
            ],
            tagline: "Built for animal research with mice and rats",
          },
        }

        const enrichedProductData = productData.map((product) => {
          // Find the device ID that matches this product handle
          const deviceId = Object.keys(
            window.veinliteQuizConfig?.productMapping || {}
          ).find(
            (id) =>
              window.veinliteQuizConfig.productMapping[id]?.handle ===
              product.handle
          )

          if (deviceId && productFeaturesLookup[deviceId]) {
            const productInfo = productFeaturesLookup[deviceId]
            return {
              ...product,
              features: productInfo.features || [],
              tagline: productInfo.tagline || "",
            }
          }
          return product
        })

        // Send email via Klaviyo transactional API (requires serverless function with private API key)
        const shopDomain =
          window.veinliteQuizConfig?.shopifyDomain || window.Shopify?.shop || ""
        const emailEndpoint =
          window.veinliteQuizConfig?.emailEndpoint ||
          "/apps/klaviyo-quiz-email/send"
        console.log(
          "Sending quiz results email to:",
          a.email,
          "via:",
          emailEndpoint
        )
        console.log("Product data:", enrichedProductData)
        const response = await fetch(emailEndpoint, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: a.email,
            primary_use: a.primary_use,
            environment: a.environment,
            recommended_devices: a.recommended_devices,
            product_data: enrichedProductData,
            session_id: a.session_id,
            shop_domain: shopDomain,
          }),
        })
        const responseText = await response.text()
        console.log("Email API response:", response.status, responseText)
        if (!response.ok) {
          throw new Error(
            `Email API error: ${response.status} - ${responseText}`
          )
        }
      } catch (c) {
        console.error("Error in sendQuizResultsEmail:", c)
        // Don't throw - allow quiz to complete even if email fails
      }
    }
    async fetchProductPricing(productHandles) {
      try {
        const productPromises = productHandles.map(async (handle) => {
          try {
            const response = await fetch(`/products/${handle}.js`)
            if (!response.ok) {
              console.warn(`Product ${handle} not found`)
              return null
            }
            const product = await response.json()
            // Get the first available variant
            const variant =
              product.variants && product.variants.length > 0
                ? product.variants[0]
                : null
            // Check for sale expiration date in metafields
            let sale_expiration_date = null
            if (product.metafields) {
              const saleExpirationMetafield = product.metafields.find(
                (mf) =>
                  mf.namespace === "custom" && mf.key === "sale_expiration_date"
              )
              if (saleExpirationMetafield) {
                sale_expiration_date = saleExpirationMetafield.value
              }
            }
            // Also check variant metafields
            if (!sale_expiration_date && variant?.metafields) {
              const saleExpirationMetafield = variant.metafields.find(
                (mf) =>
                  mf.namespace === "custom" && mf.key === "sale_expiration_date"
              )
              if (saleExpirationMetafield) {
                sale_expiration_date = saleExpirationMetafield.value
              }
            }
            // Get product image URL (featured image or first image)
            let imageUrl = null
            if (product.featured_image) {
              imageUrl = product.featured_image
            } else if (product.images && product.images.length > 0) {
              imageUrl = product.images[0]
            }

            return {
              id: product.id,
              title: product.title,
              handle: product.handle,
              url: product.url,
              image: imageUrl,
              price: variant?.price ? (variant.price / 100).toFixed(2) : null,
              compare_at_price: variant?.compare_at_price
                ? (variant.compare_at_price / 100).toFixed(2)
                : null,
              on_sale:
                variant?.compare_at_price &&
                variant?.price &&
                variant.compare_at_price > variant.price,
              sale_expiration_date: sale_expiration_date,
              currency: product.variants?.[0]?.price ? "USD" : null,
            }
          } catch (error) {
            console.error(`Error fetching product ${handle}:`, error)
            return null
          }
        })
        const products = await Promise.all(productPromises)
        return products.filter((p) => p !== null)
      } catch (c) {
        console.error("Error fetching product pricing:", c)
        return []
      }
    }
    trackProductRecommendation(a, c) {
      if (typeof window > "u") return
      const d = window._learnq
      d &&
        d.push([
          "track",
          "Product Recommendation Viewed",
          { Product_ID: a, Product_Name: c },
        ])
    }
    waitForKlaviyo() {
      return new Promise((a) => {
        if (window._learnq) {
          a()
          return
        }
        let c = 0
        const d = 50,
          y = setInterval(() => {
            c++, (window._learnq || c >= d) && (clearInterval(y), a())
          }, 100)
      })
    }
  }
  const iM = new jM()
  function VM({ step: t, answer: a, onAnswer: c }) {
    var yM
    const [d, y] = r.useState(Array.isArray(a) ? a : []),
      [i, p] = r.useState(typeof a == "string" ? a : ""),
      [u, o] = r.useState(""),
      M = (n) => {
        c(t.field, n)
      },
      w = (n) => {
        const g = d.includes(n) ? d.filter((L) => L !== n) : [...d, n]
        y(g)
      },
      U1 = () => {
        d.length > 0 && c(t.field, d)
      },
      K1 = (n) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(n),
      oM = () => {
        if (!i.trim()) {
          o("Please enter your email address")
          return
        }
        if (!K1(i)) {
          o("Please enter a valid email address")
          return
        }
        o(""), c(t.field, i)
      }
    return t.type === "email"
      ? h.jsxs("div", {
          className: "animate-fadeIn",
          children: [
            h.jsx("h3", {
              className: "text-xl md:text-2xl font-bold text-gray-800 mb-2",
              children: t.question,
            }),
            t.description &&
              h.jsx("p", {
                className: "text-sm md:text-base text-gray-600 mb-6",
                children: t.description,
              }),
            h.jsxs("div", {
              className: "space-y-4",
              children: [
                h.jsxs("div", {
                  className: "relative",
                  children: [
                    h.jsx(E1, {
                      className:
                        "absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400",
                      size: 20,
                    }),
                    h.jsx("input", {
                      type: "email",
                      value: i,
                      onChange: (n) => {
                        p(n.target.value), o("")
                      },
                      onKeyDown: (n) => {
                        n.key === "Enter" && oM()
                      },
                      placeholder: "your.email@example.com",
                      className: `w-full pl-12 pr-4 py-4 text-base md:text-lg border-2 rounded-xl transition-all duration-200 ${
                        u
                          ? "border-red-500 focus:border-red-500"
                          : "border-gray-200 focus:border-blue-600"
                      } focus:outline-none focus:ring-2 focus:ring-blue-100`,
                    }),
                  ],
                }),
                u &&
                  h.jsx("p", {
                    className: "text-red-600 text-sm",
                    children: u,
                  }),
                h.jsx("button", {
                  onClick: oM,
                  className:
                    "w-full bg-gradient-to-r from-blue-600 to-cyan-500 text-white py-4 px-6 rounded-xl font-semibold hover:shadow-lg transition-all duration-200 text-base md:text-lg",
                  children: "Get My Recommendation",
                }),
              ],
            }),
          ],
        })
      : h.jsxs("div", {
          className: "animate-fadeIn",
          children: [
            h.jsx("h3", {
              className: "text-xl md:text-2xl font-bold text-gray-800 mb-2",
              children: t.question,
            }),
            t.description &&
              h.jsx("p", {
                className: "text-sm md:text-base text-gray-600 mb-6",
                children: t.description,
              }),
            h.jsx("div", {
              className: "responses space-y-3",
              children:
                (yM = t.options) == null
                  ? void 0
                  : yM.map((n) => {
                      const g = n.icon ? zM[n.icon] : null,
                        L =
                          t.type === "single"
                            ? a === n.value
                            : d.includes(n.value)
                      return h.jsxs(
                        "button",
                        {
                          onClick: () =>
                            t.type === "single" ? M(n.value) : w(n.value),
                          className: `response w-full p-3 md:p-4 rounded-xl border-2 transition-all duration-200 flex items-center gap-3 md:gap-4 ${
                            L
                              ? "border-blue-600 bg-blue-50 shadow-md"
                              : "border-gray-200 hover:border-blue-300 hover:bg-gray-50"
                          }`,
                          children: [
                            g &&
                              h.jsx("div", {
                                className: `p-2 md:p-3 rounded-lg ${
                                  L
                                    ? "bg-blue-600 text-white"
                                    : "bg-gray-100 text-gray-600"
                                }`,
                                children: h.jsx(g, {
                                  size: 20,
                                  className: "md:w-6 md:h-6",
                                }),
                              }),
                            h.jsx("span", {
                              className: `font-medium text-left text-sm md:text-base ${
                                L ? "text-blue-900" : "text-gray-700"
                              }`,
                              children: n.label,
                            }),
                          ],
                        },
                        n.value
                      )
                    }),
            }),
            t.type === "multiple" &&
              h.jsx("button", {
                onClick: U1,
                disabled: d.length === 0,
                className:
                  "mt-6 w-full bg-gradient-to-r from-blue-600 to-cyan-500 text-white py-3 px-6 rounded-xl font-semibold hover:shadow-lg transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed",
                children: "Continue",
              }),
          ],
        })
  }
  const PM = {
    "veinlite-led-plus": { handle: "veinlite-led-plus" },
    "veinlite-ems-pro": { handle: "veinlite-ems-pro" },
    "veinlite-ledx": { handle: "veinlite-ledx" },
    "veinlite-pedi2": { handle: "veinlite-pedi2" },
    "veinlite-neo": { handle: "veinlite-neo" },
    "veinlite-r": { handle: "veinlite-r" },
  }
  function FM(t, a = PM, c) {
    const d = a[t]
    return d
      ? d.url
        ? d.url
        : d.handle
        ? c
          ? `https://${c}/products/${d.handle}`
          : `/products/${d.handle}`
        : "#"
      : "#"
  }
  function BM({
    devices: t,
    onRestart: a,
    shopifyDomain: c,
    productMapping: d,
  }) {
    var p, u
    const [productPrices, setProductPrices] = r.useState({}),
      [loadingPrices, setLoadingPrices] = r.useState(true)
    r.useEffect(() => {
      const fetchPrices = async () => {
        try {
          const pricePromises = t.map(async (device) => {
            const mapping = d[device.id]
            const handle = mapping?.handle || device.id
            try {
              const response = await fetch(`/products/${handle}.js`)
              if (!response.ok) return { id: device.id, price: null }
              const product = await response.json()
              const variant =
                product.variants && product.variants.length > 0
                  ? product.variants[0]
                  : null
              return {
                id: device.id,
                price: variant?.price ? (variant.price / 100).toFixed(2) : null,
                compare_at_price: variant?.compare_at_price
                  ? (variant.compare_at_price / 100).toFixed(2)
                  : null,
                on_sale:
                  variant?.compare_at_price &&
                  variant?.price &&
                  variant.compare_at_price > variant.price,
              }
            } catch (error) {
              console.error(`Error fetching price for ${handle}:`, error)
              return { id: device.id, price: null }
            }
          })
          const prices = await Promise.all(pricePromises)
          const priceMap = {}
          prices.forEach((p) => {
            if (p.id) priceMap[p.id] = p
          })
          setProductPrices(priceMap)
        } catch (error) {
          console.error("Error fetching product prices:", error)
        } finally {
          setLoadingPrices(false)
        }
      }
      fetchPrices()
    }, [t, d])
    const y =
        t.length > 1 &&
        t.some(
          (o) =>
            o.id === "veinlite-pedi2" ||
            o.id === "veinlite-led-plus" ||
            o.id === "veinlite-ems-pro"
        ),
      i = (o) => {
        iM.trackProductRecommendation(o.id, o.name)
        const M = FM(o.id, d, c)
        M && M !== "#" && (window.location.href = M)
      }
    const formatPrice = (deviceId) => {
      const priceData = productPrices[deviceId]
      if (!priceData || !priceData.price) return null
      if (priceData.on_sale && priceData.compare_at_price) {
        return h.jsxs("span", {
          className: "text-gray-600 font-normal",
          children: [
            h.jsx("span", {
              style: {
                textDecoration: "line-through",
                marginRight: "8px",
                color: "#999",
              },
              children: `$${priceData.compare_at_price}`,
            }),
            h.jsx("span", {
              style: { color: "#d32f2f", fontWeight: "600" },
              children: `$${priceData.price}`,
            }),
          ],
        })
      }
      return h.jsx("span", {
        className: "text-gray-600 font-normal",
        children: `$${priceData.price}`,
      })
    }
    return h.jsxs("div", {
      className: "animate-fadeIn",
      children: [
        h.jsxs("div", {
          className: "text-center mb-6 md:mb-8",
          children: [
            h.jsx("div", {
              className:
                "inline-flex items-center justify-center w-12 h-12 md:w-16 md:h-16 bg-green-100 rounded-full mb-3 md:mb-4",
              children: h.jsx(Z1, { className: "text-green-600", size: 24 }),
            }),
            h.jsx("h3", {
              className: "text-xl md:text-2xl font-bold text-gray-800 mb-2",
              children:
                t.length === 1
                  ? "Your Perfect Match"
                  : "Recommended for Your Needs",
            }),
            h.jsx("p", {
              className: "text-sm md:text-base text-gray-600",
              children:
                t.length === 1
                  ? "Based on your requirements, this is the ideal device"
                  : "Based on your mixed population, consider these options",
            }),
          ],
        }),
        y &&
          t.length > 1 &&
          h.jsx("div", {
            className:
              "bg-blue-50 border border-blue-200 rounded-lg p-3 md:p-4 mb-4 md:mb-6",
            children: h.jsxs("p", {
              className: "text-xs md:text-sm text-blue-900",
              children: [
                h.jsx("strong", { children: "For mixed populations:" }),
                " Consider combining LED+ for adults and PEDI2 for pediatric patients.",
                // t[0].name,
                // " for adults with ",
                // ((p = t.find((o) => o.id === "veinlite-pedi2")) == null
                //   ? void 0
                //   : p.name) || "PEDI2",
                // " for pediatric patients, or choose a versatile option like ",
                // (u = t.find(
                //   (o) =>
                //     o.id === "veinlite-led-plus" || o.id === "veinlite-ems-pro"
                // )) == null
                //   ? void 0
                //   : u.name,
                // " that includes pediatric adapters.",
              ],
            }),
          }),
        h.jsx("div", {
          className: "space-y-4 md:space-y-6 mb-6 md:mb-8",
          children: t.map((o, M) =>
            h.jsxs(
              "div",
              {
                className:
                  "border-2 border-gray-200 rounded-xl p-4 md:p-6 hover:border-blue-400 transition-all duration-200",
                children: [
                  h.jsxs("div", {
                    className: "flex items-start gap-4 mb-3",
                    children: [
                      o.image &&
                        h.jsx("img", {
                          src: o.image.startsWith("http")
                            ? o.image
                            : o.image.startsWith("/")
                            ? o.image
                            : `/${o.image}`,
                          alt: o.name,
                          className: "flex-shrink-0 object-cover rounded-lg",
                          style: {
                            width: "120px",
                            height: "120px",
                            minWidth: "120px",
                          },
                        }),
                      h.jsxs("div", {
                        className:
                          "flex-1 flex items-start justify-between gap-3",
                        children: [
                          h.jsxs("div", {
                            className: "flex-1",
                            children: [
                              M === 0 &&
                                h.jsx("span", {
                                  className:
                                    "inline-block bg-blue-600 text-white text-xs font-bold px-2 md:px-3 py-1 rounded-full mb-2",
                                  children:
                                    t.length === 1
                                      ? "PERFECT MATCH"
                                      : "TOP RECOMMENDATION",
                                }),
                              h.jsxs("div", {
                                className:
                                  "flex items-baseline gap-2 flex-wrap",
                                children: [
                                  h.jsx("h4", {
                                    className:
                                      "text-lg md:text-xl font-bold text-gray-800",
                                    children: o.name,
                                  }),
                                  !loadingPrices &&
                                    formatPrice(o.id) &&
                                    h.jsx("span", {
                                      className: "text-base",
                                      children: formatPrice(o.id),
                                    }),
                                ],
                              }),
                              h.jsx("p", {
                                className:
                                  "text-sm md:text-base text-gray-600 mt-1",
                                children: o.tagline,
                              }),
                            ],
                          }),
                          o.matchScore &&
                            h.jsxs("div", {
                              className: "text-right flex-shrink-0",
                              children: [
                                h.jsxs("div", {
                                  className:
                                    "pct-score text-2xl md:text-3xl font-bold text-blue-600",
                                  children: [o.matchScore, "%"],
                                }),
                                h.jsx("div", {
                                  className: "pct-text text-xs text-gray-500",
                                  children: "Match",
                                }),
                              ],
                            }),
                        ],
                      }),
                    ],
                  }),
                  h.jsx("div", {
                    className: "space-y-2 mb-4",
                    children: o.features.map((w, U1) =>
                      h.jsxs(
                        "div",
                        {
                          className: "flex items-start gap-2",
                          children: [
                            h.jsx(Z1, {
                              className: "text-green-500 flex-shrink-0 mt-0.5",
                              size: 16,
                            }),
                            h.jsx("span", {
                              className: "text-xs md:text-sm text-gray-700",
                              children: w,
                            }),
                          ],
                        },
                        U1
                      )
                    ),
                  }),
                  h.jsxs("button", {
                    onClick: () => i(o),
                    className:
                      "w-full bg-gradient-to-r from-blue-600 to-cyan-500 text-white py-3 px-4 md:px-6 rounded-lg font-semibold hover:shadow-lg transition-all duration-200 flex items-center justify-center gap-2 text-sm md:text-base",
                    children: [
                      "View Product Details",
                      h.jsx(G1, { size: 16, className: "md:w-5 md:h-5" }),
                    ],
                  }),
                ],
              },
              o.id
            )
          ),
        }),
        h.jsx("div", {
          className: "flex justify-center",
          children: h.jsxs("button", {
            onClick: a,
            className:
              "border-2 border-gray-300 text-gray-700 py-3 px-4 md:px-6 rounded-lg font-semibold hover:bg-gray-50 transition-colors flex items-center justify-center gap-2 text-sm md:text-base",
            children: [
              h.jsx(W1, { size: 16, className: "md:w-5 md:h-5" }),
              "Retake Quiz",
            ],
          }),
        }),
      ],
    })
  }
  function DM({ config: t = {}, onClose: a }) {
    const [c, d] = r.useState(0),
      [y, i] = r.useState({}),
      [p, u] = r.useState(!1),
      [o] = r.useState(() => AM()),
      [M, w] = r.useState(t.autoShow || !1)
    r.useEffect(() => {
      w(t.autoShow || !1)
    }, [t.autoShow]),
      r.useEffect(() => {
        t.klaviyoPublicKey &&
          iM.init({ publicKey: t.klaviyoPublicKey, listId: t.klaviyoListId })
      }, [t.klaviyoPublicKey, t.klaviyoListId]),
      r.useEffect(() => {
        if (t.triggerSelector) {
          const g = document.querySelectorAll(t.triggerSelector),
            L = () => w(!0)
          return (
            g.forEach((f) => {
              f.addEventListener("click", L)
            }),
            () => {
              g.forEach((f) => {
                f.removeEventListener("click", L)
              })
            }
          )
        }
      }, [t.triggerSelector])
    const U1 = (g, L) => {
        const f = { ...y, [g]: L }
        i(f),
          c < O1.length - 1
            ? setTimeout(() => d(c + 1), 300)
            : setTimeout(async () => {
                const RM = mM(f)
                if (f.email && t.klaviyoPublicKey) {
                  const TM = {
                    email: f.email,
                    primary_use: f.primary_use,
                    environment: f.environment,
                    recommended_devices: RM.map((UM) => UM.id),
                    session_id: o,
                  }
                  await iM.trackQuizCompleted(TM)
                }
                u(!0)
              }, 300)
      },
      K1 = () => {
        c > 0 && d(c - 1)
      },
      oM = () => {
        d(0), i({}), u(!1)
      },
      yM = () => {
        w(!1), a && a()
      },
      n = p ? mM(y) : []
    return M
      ? h.jsx("div", {
          className:
            "veinlite-quiz-widget fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-[999999] overflow-y-auto",
          children: h.jsxs("div", {
            className: "bg-white rounded-2xl shadow-2xl max-w-2xl w-full my-8",
            children: [
              h.jsxs("div", {
                className:
                  "quizheader relative bg-gradient-to-r from-blue-600 to-cyan-500 text-white p-4 md:p-6",
                children: [
                  t.showCloseButton !== !1 &&
                    h.jsx("button", {
                      onClick: yM,
                      className:
                        "absolute top-3 right-3 md:top-4 md:right-4 p-2 hover:bg-white/20 rounded-full transition-colors",
                      "aria-label": "Close quiz",
                      children: h.jsx(N1, {
                        size: 20,
                        className: "md:w-6 md:h-6",
                      }),
                    }),
                  h.jsx("h2", {
                    className:
                      "text-xl md:text-2xl font-bold mb-1 md:mb-2 pr-10",
                    children: "Find Your Perfect Veinlite",
                  }),
                  // h.jsx("p", {
                  //   className: "text-sm md:text-base text-blue-50",
                  //   children:
                  //     "Answer a few questions to get personalized device recommendations",
                  // }),
                ],
              }),
              h.jsx("div", {
                className:
                  "p-4 md:p-8 max-h-[calc(90vh-120px)] overflow-y-auto",
                children: p
                  ? h.jsx(BM, {
                      devices: n,
                      onRestart: oM,
                      shopifyDomain: t.shopifyDomain,
                      productMapping: t.productMapping,
                    })
                  : h.jsxs(h.Fragment, {
                      children: [
                        h.jsxs("div", {
                          className: "mb-8",
                          children: [
                            h.jsxs("div", {
                              className:
                                "flex justify-between items-center mb-2",
                              children: [
                                h.jsxs("span", {
                                  className:
                                    "text-sm font-medium text-gray-600",
                                  children: [
                                    "Question ",
                                    c + 1,
                                    " of ",
                                    O1.length,
                                  ],
                                }),
                                h.jsxs("span", {
                                  className:
                                    "text-sm font-medium text-blue-600",
                                  children: [
                                    Math.round(((c + 0) / O1.length) * 100),
                                    "%",
                                  ],
                                }),
                              ],
                            }),
                            h.jsx("div", {
                              className: "progressbar w-full rounded-full h-2",
                              children: h.jsx("div", {
                                className:
                                  "progressbar-fill h-2 rounded-full transition-all duration-300",
                                style: {
                                  width: `${((c + 0) / O1.length) * 100}%`,
                                },
                              }),
                            }),
                          ],
                        }),
                        h.jsx(VM, {
                          step: O1[c],
                          answer: y[O1[c].field],
                          onAnswer: U1,
                        }),
                        c > 0 &&
                          h.jsx("button", {
                            onClick: K1,
                            className:
                              "mt-6 px-4 py-2 text-gray-600 hover:text-gray-800 font-medium transition-colors",
                            children: "\u2190" + "Back",
                          }),
                      ],
                    }),
              }),
            ],
          }),
        })
      : null
  }
  let dM = null,
    x = null,
    nM = {}
  function X1(t = {}) {
    ;(nM = t),
      pM(),
      (x = document.createElement("div")),
      (x.id = "veinlite-quiz-container"),
      document.body.appendChild(x),
      (dM = MM(x)),
      rM(t.autoShow || !1),
      t.autoShow
  }
  function rM(t) {
    dM &&
      dM.render(
        h.jsx(r.StrictMode, {
          children: h.jsx(DM, { config: { ...nM, autoShow: t }, onClose: kM }),
        })
      )
  }
  function xM() {
    x || X1(nM), rM(!0)
  }
  function kM() {
    rM(!1)
  }
  function pM() {
    x && x.parentNode && (x.parentNode.removeChild(x), (x = null)), (dM = null)
  }
  typeof window < "u" &&
    (window.VeinliteQuiz = { init: X1, show: xM, hide: kM, destroy: pM })
  function lM() {
    window.location.hash === "#show-quiz" &&
      window.VeinliteQuiz &&
      (window.VeinliteQuiz.show(),
      history.replaceState
        ? history.replaceState(
            null,
            "",
            window.location.pathname + window.location.search
          )
        : (window.location.hash = ""))
  }
  if (typeof document < "u") {
    const t = () => {
      if (typeof window.React > "u" || typeof window.ReactDOM > "u") {
        setTimeout(t, 100)
        return
      }
      if (window.veinliteQuizConfig) {
        const c = window.veinliteQuizConfig
        window.location.hash === "#show-quiz" && (c.autoShow = !0),
          X1(c),
          setTimeout(lM, 100)
        return
      }
      const a = document.querySelector("script[data-veinlite-quiz]")
      if (a) {
        const c = a.getAttribute("data-klaviyo-key") || void 0,
          d = a.getAttribute("data-klaviyo-list") || void 0,
          y =
            a.getAttribute("data-auto-show") === "true" ||
            window.location.hash === "#show-quiz",
          i = a.getAttribute("data-trigger-selector") || void 0
        X1({
          klaviyoPublicKey: c,
          klaviyoListId: d,
          autoShow: y,
          triggerSelector: i,
        }),
          setTimeout(lM, 100)
      }
    }
    document.readyState === "loading"
      ? document.addEventListener("DOMContentLoaded", t)
      : setTimeout(t, 0),
      window.addEventListener("hashchange", lM)
  }
  ;(l.destroy = pM),
    (l.hide = kM),
    (l.init = X1),
    (l.show = xM),
    Object.defineProperty(l, Symbol.toStringTag, { value: "Module" })
})
//# sourceMappingURL=veinlite-quiz-widget.umd.js.map
